var $fZLIC$reactjsxruntime = require("react/jsx-runtime");
var $fZLIC$react = require("react");
var $fZLIC$reactquery = require("react-query");
var $fZLIC$reactrouterdom = require("react-router-dom");
var $fZLIC$styledcomponents = require("styled-components");
var $fZLIC$stylednormalize = require("styled-normalize");
var $fZLIC$muimaterialstyles = require("@mui/material/styles");
var $fZLIC$muixdatepickersAdapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var $fZLIC$muixdatepickersLocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var $fZLIC$reacti18next = require("react-i18next");
var $fZLIC$i18next = require("i18next");
var $fZLIC$icontainersdesignsystemdisttheme = require("@icontainers/design-system/dist/theme");
var $fZLIC$swchelperslib_object_spreadjs = require("@swc/helpers/lib/_object_spread.js");
var $fZLIC$swchelperslib_object_spread_propsjs = require("@swc/helpers/lib/_object_spread_props.js");
var $fZLIC$swchelperslib_async_to_generatorjs = require("@swc/helpers/lib/_async_to_generator.js");
var $fZLIC$swchelperslib_object_without_propertiesjs = require("@swc/helpers/lib/_object_without_properties.js");
var $fZLIC$swchelperslib_sliced_to_arrayjs = require("@swc/helpers/lib/_sliced_to_array.js");
var $fZLIC$swchelperslib_ts_generatorjs = require("@swc/helpers/lib/_ts_generator.js");
var $fZLIC$lodashdebounce = require("lodash.debounce");
var $fZLIC$reacthookform = require("react-hook-form");
var $fZLIC$icontainersdesignsystemdistatomsGrid = require("@icontainers/design-system/dist/atoms/Grid");
var $fZLIC$icontainersdesignsystemdistmoleculesLoading = require("@icontainers/design-system/dist/molecules/Loading");
var $fZLIC$icontainersdesignsystemdistmoleculesInputWithIcon = require("@icontainers/design-system/dist/molecules/InputWithIcon");
var $fZLIC$icontainersdesignsystemdistatomsIcons = require("@icontainers/design-system/dist/atoms/Icons");
var $fZLIC$lodashcapitalize = require("lodash.capitalize");
var $fZLIC$icontainersdesignsystemdistorganismsRecentSearches = require("@icontainers/design-system/dist/organisms/RecentSearches");
var $fZLIC$reactdom = require("react-dom");
var $fZLIC$mixpanelbrowser = require("mixpanel-browser");
var $fZLIC$axios = require("axios");
var $fZLIC$icontainersdesignsystemdistatomsBox = require("@icontainers/design-system/dist/atoms/Box");
var $fZLIC$icontainersdesignsystemdistmoleculesInput = require("@icontainers/design-system/dist/molecules/Input");
var $fZLIC$icontainersdesignsystemdistutils = require("@icontainers/design-system/dist/utils");
var $fZLIC$reacthookresizeobserver = require("@react-hook/resize-observer");
var $fZLIC$muimaterialBackdrop = require("@mui/material/Backdrop");
var $fZLIC$icontainersdesignsystemdistmoleculesCheckbox = require("@icontainers/design-system/dist/molecules/Checkbox");
var $fZLIC$icontainersdesignsystemdistmoleculesRadioButtons = require("@icontainers/design-system/dist/molecules/RadioButtons");
var $fZLIC$icontainersdesignsystemdistmoleculesSelect = require("@icontainers/design-system/dist/molecules/Select");
var $fZLIC$icontainersdesignsystemdistmoleculesButton = require("@icontainers/design-system/dist/molecules/Button");
var $fZLIC$icontainersdesignsystemdistorganismsModal = require("@icontainers/design-system/dist/organisms/Modal");
var $fZLIC$icontainersdesignsystemdistatomsLink = require("@icontainers/design-system/dist/atoms/Link");
var $fZLIC$icontainersdesignsystemdistorganismsSlideOut = require("@icontainers/design-system/dist/organisms/SlideOut");
var $fZLIC$icontainersdesignsystemdistmoleculesDatePicker = require("@icontainers/design-system/dist/molecules/DatePicker");
var $fZLIC$icontainersdesignsystemdistmoleculesComboInput = require("@icontainers/design-system/dist/molecules/ComboInput");
var $fZLIC$icontainersdesignsystemdistmoleculesNote = require("@icontainers/design-system/dist/molecules/Note");
var $fZLIC$icontainersdesignsystemdistorganismsDropdownMenu = require("@icontainers/design-system/dist/organisms/DropdownMenu");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "AppProviders", function () { return $c306d505cc65bf12$export$6c4743022ef2c318; });
$parcel$export(module.exports, "calculateCBM", function () { return $8835a976e07ba158$export$69689a083948606a; });
$parcel$export(module.exports, "calculateChargeableWeight", function () { return $8835a976e07ba158$export$f95008ecd39314c3; });
$parcel$export(module.exports, "calculateVolumetricWeight", function () { return $8835a976e07ba158$export$c270fa9d208f385; });
$parcel$export(module.exports, "AIR_CHARGEABLE_WEIGHT_FACTOR", function () { return $eaa2f94cbeae9674$export$bd9343c0e70bb103; });
$parcel$export(module.exports, "LocationField", function () { return $6f8dba4147330b62$export$f8f9ea2bcdb95c32; });
$parcel$export(module.exports, "getCityName", function () { return $8c9f42573c05ba5d$export$252be1df97fdbc2d; });
$parcel$export(module.exports, "Widget", function () { return $b9961f6ec706fd95$export$a829527ff4e4114a; });
$parcel$export(module.exports, "isAirport", function () { return $3180d1e7f238f266$export$1fb21e0e5ee2e8a3; });
$parcel$export(module.exports, "isCity", function () { return $3180d1e7f238f266$export$a9044a10e5a81ea2; });
$parcel$export(module.exports, "isPort", function () { return $3180d1e7f238f266$export$bf27ad191565d194; });
$parcel$export(module.exports, "isPostalCode", function () { return $3180d1e7f238f266$export$a955beec2ab2c25; });









/* eslint-disable @typescript-eslint/naming-convention */ /* eslint-disable import/no-default-export */ 


var $b7c2b2533192bbf6$export$d0d68bb9ed2c643d = {
    en: "en",
    es: "es",
    pt: "pt"
};


var $b4bf9dc2003270e6$exports = {};
$b4bf9dc2003270e6$exports = JSON.parse('{"quoteForm":{"origin":"Origin","destination":"Destination","placeholder":{"OCEAN":"Seaport, City or Zip Code","AIR":"Airport, City or Zip Code"},"cargo":"Select an option","submit":"Quote","postalCode":"Zip Code","searchRates":"Search Rates"},"location":"Location","cargoDetails":{"fcl":"FCL","lcl":"LCL","pc":"pc","pc_plural":"pcs","quantity":"Qty.","weight":"Weight","unit":"Unit","unit_plural":"Units","length":"Length","width":"Width","height":"Height","searchRates":"Search Rates","totalWeight":"Total Weight","totalVolume":"Total Volume","totalChargeableVolume":"Total Chargeable Volume","chargeableWeight":"Chargeable Weight","chargeableVolume":"Chargeable Volume","chargWt":"Charg. Wt.","multipleTotalChargeableWt":"Multiple; Total Charg. Wt.","cbm":"CBM","containerType":"Container Type","containerTypes":{"DV20":"20 ft. Container","DV40":"40 ft. Container","DV40HC":"40 HC Container"},"containerTypesShortName":{"DV20":"20ft","DV40":"40ft","DV40HC":"40hc"},"weightUnit":{"KG":"KG","LB":"LB"},"lengthUnit":{"CM":"CM","IN":"IN"},"volumeUnit":{"CBM":"CBM","CFT":"CFT","CIN":"CIN"},"remove":"Remove","addMore":"Add More","addMoreCargo":"Add more cargo","fullContainer":"Full Container","sharedContainer":"Shared Container","cargo":"Cargo","cargoDetails":"Cargo Details","enterTotalVolumeCheckLabel":"Enter total weight and total volume","usingTotalVolumeNoteMessage":"Using the total volume for calculations is less precise and may result in extra charges. To obtain more accurate pricing, kindly provide the shipment\'s dimensions.","entitySendingGoods":"The entity sending the goods is a known shipper.","whoIsKnownShipper":"Who is a Known Shipper?","knownShipperModal":{"title":"Who is a Known Shipper?","description":"A Known Shipper, particularly in air freight, refers to an individual or organization that has been pre-screened and approved by a carrier or government agency as being a low-risk shipment source.<1>The known shipper designation allows the individual or organization to ship goods without additional security screenings on passenger and cargo planes.</1>Please note that <3>you don’t need to be a Known Shipper to book through our platform.</3>","button":"Ok"},"multiple":"Multiple"},"seaport":"Sea port","city":"City","airport":"Airport","recentSearches":"Your recent searches","includesPickup":"(Includes pickup)","includesDelivery":"(Includes delivery)","doesntIncludePickup":"(Does not include pickup)","doesntIncludeDelivery":"(Does not include delivery)","cannotFindWarningMessage":"Sorry, we could not find any <1>city</1> or <3>port</3> matching your input. Please check and try again.","ocean":"Ocean","air":"Air","oceanFCL":"Ocean FCL","oceanLCL":"Ocean LCL","roadLTL":"Road LTL","cargoReadyDate":"Cargo Ready Date","new":"New","airFreight":"Air Freight","commoditySelectLabel":"Commodity","commodity":{"regularCargo":{"label":"Dry or General Cargo","description":"Non-liquid goods transported in boxes, pallets, or containers."},"householdGoods":{"label":"Personal or Household Goods","description":"Items belonging to individuals or families for relocation purposes only."},"hazardousMaterial":{"label":"Hazardous Material","description":"Substances posing risks to health, safety, environment or property during transportation."},"freshProduct":{"label":"Perishable or Fresh Food Items","description":"Fresh fruits, vegetables and other non-canned items."},"tempControlled":{"label":"Temperature Controlled Cargo","description":"Goods needing specific temperatures for preservation during transit."},"usedItems":{"label":"Used items, scrap or waste material","description":"Previously owned goods or materials for recycling or disposal purposes only."},"liveAnimals":{"label":"Livestock, plants and animals","description":"Pets, cattle, houseplants etc."}},"locations":"locations","advanceWidget":{"origin":"Pickup Port/Terminal in US","destination":"Delivery Location in US"},"containerNotes_DV20":"Overweight charges apply if weight exceeds 38,000 LBS.","containerNotes_DV40":"Overweight charges apply if weight exceeds 44,000 LBS.","containerNotes_DV40HC":"Overweight charges apply if weight exceeds 44,000 LBS.","additionalServices":"Additional Services","note":"Note","enterPort":"Enter Port/Terminal Location","enterLocation":"Enter Location","additionalServicesField":{"importCustomsClearance":{"label":"Import Customs Clearance","tooltip":"All goods for import require documented, formal authorization to pass into a country."},"customBonds":{"label":"Custom Bonds","tooltip":"A customs bond is a legal contract between a principal (importer or shipper), a surety company, and Customs & Border Protection agency (CBP) that guarantees the importer complies with customs regulations and that CBP is paid for applicable import duties, taxes, fines and penalties."},"residencyDelivery":{"label":"Residential Delivery","tooltip":"Surcharge for delivery in a residential area or at facility without a loading ramp"},"liftGateAtDestination":{"label":"Lift Gate at Destination","tooltip":"Lift gate surcharges, when a lift gate is needed to deliver or pick up cargo from the ground."},"customBondsField":{"cargoValue":"Cargo Value","singleBond":{"label":"Single bond","tooltip":"A single entry bond is a type of surety bond used in shipping and customs processes that covers a single shipment or entry into a country. This is applicable when the importer does not have a continuous bond. For Ocean Freight only, by selecting this we automatically include the ISF Bond."},"aContinuousBond":{"label":"Continuous bond","tooltip":"A continuous bond in shipping is a type of surety bond that covers multiple shipments over a specific period, typically one year, rather than requiring a separate bond for each shipment. This type of bond is beneficial for recurrent importers that ship more than two shipments a year with high value commodities"}}},"pickupLocationUS":"Pickup Location in US","deliveryLocationUS":"Delivery Location in US","freightClass":"Freight Class","dontKnow":"I don\'t know"}');


var $560ac84b907fbe4f$exports = {};
$560ac84b907fbe4f$exports = JSON.parse('{"required":"Required","location":{"maxLength":"{{label}} should not be more than {{count}} characters","origin":"Origin","destination":"Destination"},"origin":{"required":"Please select the origin location","zipcode":"Please enter the origin zip code","invalidZipcode":"Please enter a valid origin zip code"},"destination":{"required":"Please select the destination location","zipcode":"Please enter the origin zip code","invalidZipcode":"Please enter a valid destination zip code"},"cargo":{"required":"Please enter the cargo details","limitExceeded":"Limit Exceeded","containerLimit":"Sorry, we can only provide quotes for a maximum of {{quantityLimit}} containers. Please adjust your cargo details and try again.","cargoLimit":"Sorry, we can only provide quotes for a maximum of {{volumeLimit}} {{volumeUnit}} or {{weightLimit}} {{weightUnit}}, not exceeding {{lengthLimit}} {{lengthUnit}} (L) x {{widthLimit}} {{lengthUnit}} (W) x {{heightLimit}} {{lengthUnit}} (H). For higher volumes than this we recommend to get an FCL quote.","minimumVolumeLimit":"Sorry, we can only provide quotes for a minimum of {{volumeLimit}} {{volumeUnit}}","minimumVolumeLimitShort":"Minimum Volume {{volumeLimit}} {{volumeUnit}}","densityLimit":"Please check the weight and volume inputs. The density (weight/volume ratio) cannot be greater than 22590 KG/CBM.","invalidCommodity":"Please enter a valid commodity","commodityNotAccepted":"Sorry, this commodity is either prohibited from international trade and/or we are unable to handle it at the moment.","ltlCargoLimit":"Sorry, we can only provide quotes for a maximum of {{volumeLimit}} {{volumeUnit}} or {{weightLimit}} {{weightUnit}}, not exceeding {{lengthLimit}} {{lengthUnit}} (L) x {{widthLimit}} {{lengthUnit}} (W) x {{heightLimit}} {{lengthUnit}} (H)."},"customBonds":{"maxLimit":"For cargo valued at ${{maxLimit}} or more, a continuous bond should be selected","maxLimit_EUR":"For cargo valued at €{{maxLimit}} or more, a continuous bond should be selected"}}');


var $534b169383ab0762$exports = {};
$534b169383ab0762$exports = JSON.parse('{"quoteForm":{"origin":"Origen","destination":"Destino","placeholder":{"OCEAN":"Puerto, ciudad o c\xf3digo postal","AIR":"Aeropuerto, ciudad o c\xf3digo postal"},"cargo":"Selecciona una opci\xf3n","submit":"Cotizar","postalCode":"C\xf3digo postal","searchRates":"Buscar tarifas"},"location":"Localizaci\xf3n","cargoDetails":{"fcl":"FCL","lcl":"LCL","pc":"pza","pc_plural":"pzas","quantity":"Cantidad","weight":"Peso","unit":"Unidad","unit_plural":"Unidades","length":"Longitud","width":"Ancho","height":"Alto","searchRates":"Buscar tarifas","totalWeight":"Peso total","totalVolume":"Volumen total","totalChargeableVolume":"Volumen total tasable","chargeableWeight":"Peso tasable","chargeableVolume":"Volumen tasable","chargWt":"Peso tasable","multipleTotalChargeableWt":"M\xfaltiple; peso total tasable","cbm":"Metros c\xfabicos","containerType":"Tipo de contenedor","containerTypes":{"DV20":"Contenedor de 20 pies","DV40":"Contenedor de 40 pies","DV40HC":"Contenedor 40HC"},"containerTypesShortName":{"DV20":"20 pies","DV40":"40 pies","DV40HC":"40hc"},"weightUnit":{"KG":"KG","LB":"Libras"},"lengthUnit":{"CM":"CM","IN":"Pulgadas"},"volumeUnit":{"CBM":"Metros c\xfabicos","CFT":"Pies c\xfabicos","CIN":"Pulgadas c\xfabicas"},"remove":"Eliminar","addMore":"A\xf1adir m\xe1s","addMoreCargo":"A\xf1adir m\xe1s carga","fullContainer":"Contenedor completo","sharedContainer":"Contenedor compartido","cargo":"Carga","cargoDetails":"Detalles de la carga","enterTotalVolumeCheckLabel":"Introduce el peso total y el volumen total","usingTotalVolumeNoteMessage":"Usar el volumen total para c\xe1lculos es menos preciso y puede resultar en costes extra. Para obtener una tarifa m\xe1s precisa, por favor, proporciona las dimensiones del env\xedo.","entitySendingGoods":"La compa\xf1\xeda que env\xeda los bienes es un transportista conocido.","whoIsKnownShipper":"\xbfQui\xe9n es un Transportista Conocido?","knownShipperModal":{"title":"\xbfQui\xe9n es un Transportista Conocido?","description":"Un Transportista Conocido, particularmente en transporte a\xe9reo, se refiere a un individuo u organizaci\xf3n que ha sido examinado y aprobado por una agencia de transporte o una agencia del gobierno como proveedor de bajo riesgo. <1>La designaci\xf3n de remitente conocido permite que el individuo u organizaci\xf3n env\xede mercanc\xedas sin controles de seguridad adicionales en aviones de pasajeros y de carga.</1>Tenga en cuenta que <3>no necesita ser un Remitente Conocido para reservar a trav\xe9s de nuestra plataforma.</3>","button":"Ok"},"multiple":"M\xfaltiple"},"seaport":"Puerto Mar\xedtimo","city":"Ciudad","airport":"Aeropuerto","recentSearches":"B\xfasquedas recientes","includesPickup":"(Incluye recogida)","includesDelivery":"(Incluye entrega)","doesntIncludePickup":"(No incluye recogida)","doesntIncludeDelivery":"(No invluye entrega)","cannotFindWarningMessage":"Lo sentimos, no pudimos encontrar <1>city</1> or<3>port</3> respecto a tu petici\xf3n. Por favor, prueba de nuevo.","ocean":"Mar\xedtimo","air":"A\xe9reo","oceanFCL":"FCL Mar\xedtimo","oceanLCL":"LCL Mar\xedtimo","roadLTL":"LTL","cargoReadyDate":"Fecha de carga lista","new":"Nuevo","airFreight":"Flete a\xe9reo","commoditySelectLabel":"Tipo de mercanc\xeda","commodity":{"regularCargo":{"label":"Carga Seca o General","description":"Bienes no l\xedquidos transportados en cajas, palets o contenedores."},"householdGoods":{"label":"Bienes personales o dom\xe9sticos","description":"Art\xedculos pertenecientes a particulares o familias \xfanicamente para fines de mudanza."},"hazardousMaterial":{"label":"Material peligroso","description":"Sustancias que representen riesgos para la salud, la seguridad, el medio ambiente o la propiedad durante el transporte."},"freshProduct":{"label":"Art\xedculos perecederos o frescos","description":"Frutas y verduras frescas y otros art\xedculos no enlatados."},"tempControlled":{"label":"Carga con control de temperatura","description":"Bienes que requieran temperaturas espec\xedficas para su conservaci\xf3n durante el transporte."},"usedItems":{"label":"Art\xedculos usados, chatarra o material de desecho","description":"Bienes o materiales de segunda mano \xfanicamente para fines de reciclaje o descarte."},"liveAnimals":{"label":"Ganado, plantas y animales","description":"Mascotas, ganado, plantas del hogar, etc."}},"locations":"localizaciones","advanceWidget":{"origin":"Puerto/Terminal de recogida en Estados Unidos","destination":"Localizaci\xf3n de entrega en Estados Unidos"},"containerNotes_DV20":"Se aplican cargos por sobrepeso si el peso excede las 38.000 libras.","containerNotes_DV40":"Se aplican cargos por sobrepeso si el peso excede las 44.000 libras.","containerNotes_DV40HC":"Se aplican cargos por sobrepeso si el peso excede las 44.000 libras.","additionalServices":"Servicios adicionales","note":"Nota","enterPort":"Insertar Puerto/Terminal","enterLocation":"Insertar localizaci\xf3n","additionalServicesField":{"importCustomsClearance":{"label":"Despacho aduanero de importaci\xf3n","tooltip":"Todos los bienes para la importaci\xf3n requieren una autorizaci\xf3n formal documentada para ingresar en un pa\xeds."},"customBonds":{"label":"Fianzas aduaneras","tooltip":"Una fianza aduanera es un contrato legal entre un principal (importador o embarcador), una compa\xf1\xeda de fianzas y la agencia de Aduanas y Protecci\xf3n Fronteriza (CBP) que garantiza que el importador cumple con las regulaciones aduaneras y que el CBP recibe el pago de los aranceles, impuestos, multas y sanciones correspondientes."},"residencyDelivery":{"label":"Entrega residencial","tooltip":"Recargo por entrega en zona residencial o en establecimiento sin rampa de carga"},"liftGateAtDestination":{"label":"Plataforma elevadora en destino","tooltip":"Recargos por plataforma elevadora, cuando se necesita una para entregar o recoger carga del suelo."},"customBondsField":{"cargoValue":"Valor de la carga","singleBond":{"label":"Fianza de entrada \xfanica","tooltip":"Una fianza de entrada \xfanica es un tipo de fianza de garant\xeda utilizada en los procesos de transporte y aduanas que cubre un solo env\xedo o entrada a un pa\xeds. Esta fianza aplica cuando el importador no tiene una fianza continua. En transporte mar\xedtimo, seleccionando este servicio se incluye autom\xe1ticamente la garant\xeda ISF."},"aContinuousBond":{"label":"Fianza continua","tooltip":"En log\xedstica, una fianza continua es un tipo de fianza de garant\xeda que cubre m\xfaltiples env\xedos durante un per\xedodo espec\xedfico, generalmente un a\xf1o, en lugar de requerir una fianza separada para cada env\xedo. Este tipo de fianza es beneficioso para importadores recurrentes que realizan m\xe1s de dos env\xedos al a\xf1o con mercanc\xedas de alto valor"}}},"pickupLocationUS":"Lugar de recogida en los Estados Unidos","deliveryLocationUS":"Lugar de entrega en los Estados Unidos","freightClass":"Clase de flete","dontKnow":"No lo s\xe9"}');


var $ec16e48e98dbc1f9$exports = {};
$ec16e48e98dbc1f9$exports = JSON.parse('{"required":"Necesario","location":{"maxLength":"{{label}} no debe tener m\xe1s de {{count}} caracteres","origin":"Origen","destination":"Destino"},"origin":{"required":"Por favor selecciona el origen","zipcode":"Por favor a\xf1ade el c\xf3digo postal de origen","invalidZipcode":"Por favor a\xf1ade un c\xf3digo postal de origen v\xe1lido"},"destination":{"required":"Por favor selecciona el destino","zipcode":"Por favor a\xf1ade el c\xf3digo postal de origen","invalidZipcode":"Por favor a\xf1ade un c\xf3digo postal de destino v\xe1lido"},"cargo":{"required":"Por favor a\xf1ade los detalles de la carga","limitExceeded":"L\xedmite sobrepasado","containerLimit":"\xa1Lo sentimos! Solo podemos proporcionar cotizaciones para un m\xe1ximo de {{quantityLimit}} contenedores. Por favor, modifica los detalles del env\xedo y pru\xe9balo otra vez.","cargoLimit":"\xa1Lo sentimos! Solo podemos proporcionar cotizaciones con un m\xe1ximo de {{volumeLimit}} {{volumeUnit}} o {{weightLimit}} {{weightUnit}}, que no sobrepasen {{lengthLimit}} {{lengthUnit}} (Largo) x {{widthLimit}} {{lengthUnit}} (Ancho) x {{heightLimit}} {{lengthUnit}} (Alto). Para vol\xfamenes superiores te recomendamos cotizar un env\xedo FCL.","minimumVolumeLimit":"\xa1Lo sentimos! Solo podemos proporcionar cotizaciones con un m\xednimo de {{volumeLimit}} {{volumeUnit}}","minimumVolumeLimitShort":"Volumen m\xednimo {{volumeLimit}} {{volumeUnit}}","densityLimit":"Por favor revisa el peso y el volumen. La densidad (ratio entre el peso y el volumen) no puede superar los 22590 KG/Metro c\xfabico.","invalidCommodity":"Por favor, introduce un tipo de mercanc\xeda v\xe1lida","commodityNotAccepted":"\xa1Lo sentimos! Este tipo de mercanc\xeda est\xe1 prohibida en el comercio internacional y/o no podemos manejarla en este momento.","ltlCargoLimit":"\xa1Lo sentimos! Solo podemos proporcionar cotizaciones con un m\xe1ximo de {{volumeLimit}} {{volumeUnit}} o {{weightLimit}} {{weightUnit}}, que no sobrepasen {{lengthLimit}} {{lengthUnit}} (Largo) x {{widthLimit}} {{lengthUnit}} (Ancho) x {{heightLimit}} {{lengthUnit}} (Alto)."},"customBonds":{"maxLimit":"Para cargas valoradas en ${{maxLimit}} o m\xe1s, se debe seleccionar una fianza continua","maxLimit_EUR":"Para cargas valoradas en €{{maxLimit}} o m\xe1s, se debe seleccionar una fianza continua"}}');


var $7a45d728c0939548$exports = {};
$7a45d728c0939548$exports = JSON.parse('{"quoteForm":{"origin":"Origin","destination":"Destination","placeholder":{"OCEAN":"Seaport, City or Zip Code","AIR":"Airport, City or Zip Code"},"cargo":"Select an option","submit":"Quote","postalCode":"Zip Code","searchRates":"Search Rates"},"location":"Location","cargoDetails":{"fcl":"FCL","lcl":"LCL","pc":"pc","pc_plural":"pcs","quantity":"Qty.","weight":"Weight","unit":"Unit","unit_plural":"Units","length":"Length","width":"Width","height":"Height","searchRates":"Search Rates","totalWeight":"Total Weight","totalVolume":"Total Volume","totalChargeableVolume":"Total Chargeable Volume","chargeableWeight":"Chargeable Weight","chargeableVolume":"Chargeable Volume","chargWt":"Charg. Wt.","multipleTotalChargeableWt":"Multiple; Total Charg. Wt.","cbm":"CBM","containerType":"Container Type","containerTypes":{"DV20":"20 ft. Container","DV40":"40 ft. Container","DV40HC":"40 HC Container"},"containerTypesShortName":{"DV20":"20ft","DV40":"40ft","DV40HC":"40hc"},"weightUnit":{"KG":"KG","LB":"LB"},"lengthUnit":{"CM":"CM","IN":"IN"},"volumeUnit":{"CBM":"CBM","CFT":"CFT","CIN":"CIN"},"remove":"Remove","addMore":"Add More","addMoreCargo":"Add more cargo","fullContainer":"Full Container","sharedContainer":"Shared Container","cargo":"Cargo","cargoDetails":"Cargo Details","enterTotalVolumeCheckLabel":"Enter total weight and total volume","usingTotalVolumeNoteMessage":"Using the total volume for calculations is less precise and may result in extra charges. To obtain more accurate pricing, kindly provide the shipment\'s dimensions.","entitySendingGoods":"The entity sending the goods is a known shipper.","whoIsKnownShipper":"Who is a Known Shipper?","knownShipperModal":{"title":"Who is a Known Shipper?","description":"A Known Shipper, particularly in air freight, refers to an individual or organization that has been pre-screened and approved by a carrier or government agency as being a low-risk shipment source.<1>The known shipper designation allows the individual or organization to ship goods without additional security screenings on passenger and cargo planes.</1>Please note that <3>you don’t need to be a Known Shipper to book through our platform.</3>","button":"Ok"},"multiple":"Multiple"},"seaport":"Sea port","city":"City","airport":"Airport","recentSearches":"Your recent searches","includesPickup":"(Includes pickup)","includesDelivery":"(Includes delivery)","doesntIncludePickup":"(Does not include pickup)","doesntIncludeDelivery":"(Does not include delivery)","cannotFindWarningMessage":"Sorry, we could not find any <1>city</1> or <3>port</3> matching your input. Please check and try again.","ocean":"Ocean","air":"Air","oceanFCL":"Ocean FCL","oceanLCL":"Ocean LCL","roadLTL":"Road LTL","cargoReadyDate":"Cargo Ready Date","new":"New","airFreight":"Air Freight","commoditySelectLabel":"Commodity","commodity":{"regularCargo":{"label":"Dry or General Cargo","description":"Non-liquid goods transported in boxes, pallets, or containers."},"householdGoods":{"label":"Personal or Household Goods","description":"Items belonging to individuals or families for relocation purposes only."},"hazardousMaterial":{"label":"Hazardous Material","description":"Substances posing risks to health, safety, environment or property during transportation."},"freshProduct":{"label":"Perishable or Fresh Food Items","description":"Fresh fruits, vegetables and other non-canned items."},"tempControlled":{"label":"Temperature Controlled Cargo","description":"Goods needing specific temperatures for preservation during transit."},"usedItems":{"label":"Used items, scrap or waste material","description":"Previously owned goods or materials for recycling or disposal purposes only."},"liveAnimals":{"label":"Livestock, plants and animals","description":"Pets, cattle, houseplants etc."}},"locations":"locations","advanceWidget":{"origin":"Pickup Port/Terminal in US","destination":"Delivery Location in US"},"containerNotes_DV20":"Overweight charges apply if weight exceeds 38,000 LBS.","containerNotes_DV40":"Overweight charges apply if weight exceeds 44,000 LBS.","containerNotes_DV40HC":"Overweight charges apply if weight exceeds 44,000 LBS.","additionalServices":"Additional Services","note":"Note","enterPort":"Enter Port/Terminal Location","enterLocation":"Enter Location","additionalServicesField":{"importCustomsClearance":{"label":"Import Customs Clearance","tooltip":"All goods for import require documented, formal authorization to pass into a country."},"customBonds":{"label":"Custom Bonds","tooltip":"A customs bond is a legal contract between a principal (importer or shipper), a surety company, and Customs & Border Protection agency (CBP) that guarantees the importer complies with customs regulations and that CBP is paid for applicable import duties, taxes, fines and penalties."},"residencyDelivery":{"label":"Residential Delivery","tooltip":"Surcharge for delivery in a residential area or at facility without a loading ramp"},"liftGateAtDestination":{"label":"Lift Gate at Destination","tooltip":"Lift gate surcharges, when a lift gate is needed to deliver or pick up cargo from the ground."},"customBondsField":{"cargoValue":"Cargo Value","singleBond":{"label":"Single bond","tooltip":"A single entry bond is a type of surety bond used in shipping and customs processes that covers a single shipment or entry into a country. This is applicable when the importer does not have a continuous bond. For Ocean Freight only, by selecting this we automatically include the ISF Bond."},"aContinuousBond":{"label":"Continuous bond","tooltip":"A continuous bond in shipping is a type of surety bond that covers multiple shipments over a specific period, typically one year, rather than requiring a separate bond for each shipment. This type of bond is beneficial for recurrent importers that ship more than two shipments a year with high value commodities"}}},"pickupLocationUS":"Pickup Location in US","deliveryLocationUS":"Delivery Location in US","freightClass":"Freight Class","dontKnow":"I don\'t know"}');


var $91aa22286ab4ecf8$exports = {};
$91aa22286ab4ecf8$exports = JSON.parse('{"required":"Required","location":{"maxLength":"{{label}} should not be more than {{count}} characters","origin":"Origin","destination":"Destination"},"origin":{"required":"Please select the origin location","zipcode":"Please enter the origin zip code","invalidZipcode":"Please enter a valid origin zip code"},"destination":{"required":"Please select the destination location","zipcode":"Please enter the origin zip code","invalidZipcode":"Please enter a valid destination zip code"},"cargo":{"required":"Please enter the cargo details","limitExceeded":"Limit Exceeded","containerLimit":"Sorry, we can only provide quotes for a maximum of {{quantityLimit}} containers. Please adjust your cargo details and try again.","cargoLimit":"Sorry, we can only provide quotes for a maximum of {{volumeLimit}} {{volumeUnit}} or {{weightLimit}} {{weightUnit}}, not exceeding {{lengthLimit}} {{lengthUnit}} (L) x {{widthLimit}} {{lengthUnit}} (W) x {{heightLimit}} {{lengthUnit}} (H). For higher volumes than this we recommend to get an FCL quote.","minimumVolumeLimit":"Sorry, we can only provide quotes for a minimum of {{volumeLimit}} {{volumeUnit}}","minimumVolumeLimitShort":"Minimum Volume {{volumeLimit}} {{volumeUnit}}","densityLimit":"Please check the weight and volume inputs. The density (weight/volume ratio) cannot be greater than 22590 KG/CBM.","invalidCommodity":"Please enter a valid commodity","commodityNotAccepted":"Sorry, this commodity is either prohibited from international trade and/or we are unable to handle it at the moment.","ltlCargoLimit":"Sorry, we can only provide quotes for a maximum of {{volumeLimit}} {{volumeUnit}} or {{weightLimit}} {{weightUnit}}, not exceeding {{lengthLimit}} {{lengthUnit}} (L) x {{widthLimit}} {{lengthUnit}} (W) x {{heightLimit}} {{lengthUnit}} (H)."},"customBonds":{"maxLimit":"For cargo valued at ${{maxLimit}} or more, a continuous bond should be selected","maxLimit_EUR":"For cargo valued at €{{maxLimit}} or more, a continuous bond should be selected"}}');


var $d098941732565489$var$resources = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($b4bf9dc2003270e6$exports))),
        validation: (0, (/*@__PURE__*/$parcel$interopDefault($560ac84b907fbe4f$exports)))
    },
    es: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($534b169383ab0762$exports))),
        validation: (0, (/*@__PURE__*/$parcel$interopDefault($ec16e48e98dbc1f9$exports)))
    },
    pt: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($7a45d728c0939548$exports))),
        validation: (0, (/*@__PURE__*/$parcel$interopDefault($91aa22286ab4ecf8$exports)))
    }
};
var $d098941732565489$export$d6e727ec91bc0731 = function(language) {
    return {
        lng: language,
        fallbackLng: "en",
        supportedLngs: Object.values((0, $b7c2b2533192bbf6$export$d0d68bb9ed2c643d)),
        ns: [
            "translation",
            "validation"
        ],
        resources: $d098941732565489$var$resources,
        interpolation: {
            //  https://www.i18next.com/translation-function/interpolation#unescape
            escapeValue: false
        },
        /*
   * i18next 21, t function can return null, this behaviour is set by default,
   * https://www.i18next.com/overview/typescript#argument-of-type-defaulttfuncreturn-is-not-assignable-to-parameter-of-type-xyz
   */ returnNull: false,
        /*
   * fixed pluralization translation in upgraded i18next 21.
   * TODO update json of plural translation with v4 and remove this property
   * https://www.i18next.com/misc/migration-guide#json-format-v4-pluralization
   */ compatibilityJSON: "v3"
    };
};


var $12e046acd71f8b2f$export$920091e3d72d80ee = function(language) {
    var instance = (0, $fZLIC$i18next.createInstance)();
    var options = (0, $d098941732565489$export$d6e727ec91bc0731)(language);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    instance.use((0, $fZLIC$reacti18next.initReactI18next)).init(options);
    return instance;
};



// parcel doesnt allow for re-exporting anything from external library because they will reference to variable which doesnt exists like e.g $fZLIC$exports
var $88150c5c731a6db0$export$9fc83ad70ead8663 = (0, $fZLIC$reacti18next.useTranslation);
var $88150c5c731a6db0$export$8d6a9236f2e3f2ce = (0, $fZLIC$reacti18next.Trans);
var $88150c5c731a6db0$export$1325e8699caa160f = (0, $fZLIC$reacti18next.I18nextProvider);




var $d67da66eb750e130$export$bca14c5b3b88a9c9 = (0, $fZLIC$muimaterialstyles.createTheme)({}, (0, $fZLIC$icontainersdesignsystemdisttheme.Theme));


var $c306d505cc65bf12$var$_Normalize;
var $c306d505cc65bf12$export$6c4743022ef2c318 = function(param) {
    var children = param.children, _param_theme = param.theme, theme = _param_theme === void 0 ? (0, $d67da66eb750e130$export$bca14c5b3b88a9c9) : _param_theme;
    var i18n = (0, $12e046acd71f8b2f$export$920091e3d72d80ee)("en");
    var queryClient = new (0, $fZLIC$reactquery.QueryClient)({
        defaultOptions: {
            queries: {
            }
        }
    });
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$reactquery.QueryClientProvider), {
        client: queryClient,
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $88150c5c731a6db0$export$1325e8699caa160f), {
            i18n: i18n,
            children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$muimaterialstyles.StyledEngineProvider), {
                injectFirst: true,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$styledcomponents.ThemeProvider), {
                    theme: theme,
                    children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$muimaterialstyles.ThemeProvider), {
                        theme: theme,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$muixdatepickersLocalizationProvider.LocalizationProvider), {
                            dateAdapter: (0, $fZLIC$muixdatepickersAdapterDateFns.AdapterDateFns),
                            children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$reactrouterdom.BrowserRouter), {
                                children: [
                                    $c306d505cc65bf12$var$_Normalize || ($c306d505cc65bf12$var$_Normalize = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$stylednormalize.Normalize), {})),
                                    children
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};




var $f9f89a5c82b78d91$export$f56c1bb712b9ef86 = 3;
var $f9f89a5c82b78d91$export$f237b4fe6260e0a4 = {
    KG: 10000,
    LB: 22046
};
var $f9f89a5c82b78d91$export$35a1e7e6818ec128 = {
    KG: 20000,
    LB: 44092
};
var $f9f89a5c82b78d91$export$72b57fb2b65ee7b5 = {
    KG: 4535.92,
    LB: 10000
};
var $f9f89a5c82b78d91$export$6c279875ca1a9388 = {
    CBM: 11.33,
    CFT: 400,
    CIN: 691200
};
var $f9f89a5c82b78d91$export$dabdc168ed3d84c6 = {
    CM: {
        length: 317,
        width: 241,
        height: 297
    },
    IN: {
        length: 124.803,
        width: 94.881,
        height: 116.929
    }
};
var $f9f89a5c82b78d91$export$a3e86abff5ed10b6 = {
    CM: {
        length: 590,
        width: 230,
        height: 230
    },
    IN: {
        length: 232,
        width: 90,
        height: 90
    }
};
var $f9f89a5c82b78d91$export$a104d8d48668662d = {
    CM: {
        length: 243.84,
        width: 121.92,
        height: 121.92
    },
    IN: {
        length: 96,
        width: 48,
        height: 48
    }
};
var $f9f89a5c82b78d91$export$40659df21aafb739 = 400;
var $f9f89a5c82b78d91$export$3704da88d06f7184 = 22590;
var $f9f89a5c82b78d91$export$76bdc0f2d52759a6 = {
    USD: 78000,
    EUR: 74000
};


var $a2ac72463a01043f$export$d8be081e48e76d62 = function(number) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
};
var $a2ac72463a01043f$export$5117522f5154dce2 = function(number) {
    return Math.ceil(number * 2) / 2;
};


var $aacba40b3ef80b2e$export$ba9f926cfed2060e = function(valueInLb) {
    return valueInLb * 0.45359237;
};
var $aacba40b3ef80b2e$export$398c29ddaf73939d = function(valueInInches) {
    return valueInInches * 2.54;
};
var $aacba40b3ef80b2e$export$da5effc1351c84f7 = function(valueInCft) {
    return valueInCft * 0.0283168;
};
var $aacba40b3ef80b2e$export$6b1ac9a7a2184942 = function(valueInCin) {
    return valueInCin * 0.0000163871;
};


var $453cff6f0a91fd89$export$3586f5d4ea79c22a = function(eventPayload) {
    var _window_dataLayer;
    ((_window_dataLayer = window.dataLayer) !== null && _window_dataLayer !== void 0 ? _window_dataLayer : []).push(eventPayload);
};


var $ceb0c600e8f2a76d$export$ffb13fd23f6ed1ca = function(param) {
    var location = param.location, type = param.type;
    (0, $453cff6f0a91fd89$export$3586f5d4ea79c22a)({
        event_name: type === "pickup" ? "origin_no_results_shown" : "destination_no_results_shown",
        searched_location: location,
        event: "ga4Event"
    });
};
var $ceb0c600e8f2a76d$export$273319d78db9f18d = function(param) {
    var location = param.location, type = param.type, places = param.places;
    (0, $453cff6f0a91fd89$export$3586f5d4ea79c22a)({
        event_name: type === "pickup" ? "origin_not_selected" : "destination_not_selected",
        searched_location: location,
        results_displayed: JSON.stringify(places),
        event: "ga4Event"
    });
};
var $ceb0c600e8f2a76d$export$580e28c747656cad = function(param) {
    var action = param.action, cargoType = param.cargoType;
    (0, $453cff6f0a91fd89$export$3586f5d4ea79c22a)({
        event: "ga4Event",
        event_name: "add_remove_item",
        event_action: action,
        cargo_type: cargoType
    });
};


var $8835a976e07ba158$export$fb9705de59d96855 = function(param) {
    var append = param.append, cargoType = param.cargoType;
    return function() {
        append({
            quantity: 1,
            weight: "",
            weightUnit: {
                label: "KG",
                value: "KG"
            },
            length: "",
            width: "",
            height: "",
            lengthUnit: {
                label: "CM",
                value: "CM"
            }
        });
        (0, $ceb0c600e8f2a76d$export$580e28c747656cad)({
            action: "add",
            cargoType: cargoType
        });
    };
};
var $8835a976e07ba158$export$fe2d9b4e03920b4c = function(param) {
    var index = param.index, remove = param.remove, cargoType = param.cargoType;
    return function() {
        remove(index);
        (0, $ceb0c600e8f2a76d$export$580e28c747656cad)({
            action: "remove",
            cargoType: cargoType
        });
    };
};
var $8835a976e07ba158$export$69689a083948606a = function(param) {
    var quantity = param.quantity, length = param.length, width = param.width, height = param.height, unit = param.unit, _param_withRound = param.withRound, withRound = _param_withRound === void 0 ? true : _param_withRound;
    var volumeConvertor = unit === "IN" ? 61023.842 : 1000000;
    var volume = +length * +width * +height / volumeConvertor;
    if (withRound) {
        var volumeRounded = (0, $a2ac72463a01043f$export$d8be081e48e76d62)(volume, 3);
        return (0, $a2ac72463a01043f$export$d8be081e48e76d62)(+quantity * volumeRounded, 3);
    }
    return +quantity * volume;
};
var $8835a976e07ba158$export$c270fa9d208f385 = function(param) {
    var quantity = param.quantity, length = param.length, width = param.width, height = param.height, unit = param.unit, chargeableWeightFactor = param.chargeableWeightFactor;
    var lengthInCm = unit === "IN" ? (0, $aacba40b3ef80b2e$export$398c29ddaf73939d)(length) : length;
    var widthInCm = unit === "IN" ? (0, $aacba40b3ef80b2e$export$398c29ddaf73939d)(width) : width;
    var heightInCm = unit === "IN" ? (0, $aacba40b3ef80b2e$export$398c29ddaf73939d)(height) : height;
    var volumetricWeight = (0, $a2ac72463a01043f$export$5117522f5154dce2)(+lengthInCm * +widthInCm * +heightInCm / chargeableWeightFactor);
    return (0, $a2ac72463a01043f$export$5117522f5154dce2)(+quantity * volumetricWeight);
};
var $8835a976e07ba158$export$f95008ecd39314c3 = function(param) {
    var items = param.items, chargeableWeightFactor = param.chargeableWeightFactor;
    var volumetricWeight = items.reduce(function(sum, item) {
        var weight = $8835a976e07ba158$export$c270fa9d208f385({
            quantity: item.quantity,
            length: item.length,
            width: item.width,
            height: item.height,
            unit: item.lengthUnit,
            chargeableWeightFactor: chargeableWeightFactor
        });
        return sum + weight;
    }, 0);
    var totalWeight = items.reduce(function(sum, item) {
        var weight = item.quantity * (item.weightUnit === "LB" ? (0, $aacba40b3ef80b2e$export$ba9f926cfed2060e)(item.weight) : item.weight);
        return sum + weight;
    }, 0);
    var chargeableWeight = Math.max(volumetricWeight, totalWeight);
    return (0, $a2ac72463a01043f$export$d8be081e48e76d62)(chargeableWeight, 2);
};
var $8835a976e07ba158$export$1166235716d57e64 = function(param) {
    var items = param.items, chargeableWeightFactor = param.chargeableWeightFactor;
    var mapItemsWithCargoItems = items.map(function(item) {
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, item), {
            weightUnit: item.weightUnit.value,
            lengthUnit: item.lengthUnit.value
        });
    });
    return $8835a976e07ba158$export$f95008ecd39314c3({
        items: mapItemsWithCargoItems,
        chargeableWeightFactor: chargeableWeightFactor
    });
};
var $8835a976e07ba158$export$b47858ac3291eb2a = function(items) {
    return items.reduce(function(sum, item) {
        return sum + Number(item.quantity);
    }, 0);
};
var $8835a976e07ba158$export$a22775fa5e2eebd9 = function(param) {
    var value = param.value, density = param.density, t = param.t, limit = param.limit, error = param.error;
    var _error_root;
    if ((error === null || error === void 0 ? void 0 : error.type) === "dimensions" || (error === null || error === void 0 ? void 0 : (_error_root = error.root) === null || _error_root === void 0 ? void 0 : _error_root.type) === "dimensions") {
        if (value === 0) return {
            message: t("validation:required")
        };
        if (isFinite(density) && density > (0, $f9f89a5c82b78d91$export$3704da88d06f7184)) return {
            message: ""
        };
    }
    if (limit && value > limit) return {
        message: t("validation:cargo.limitExceeded")
    };
    return undefined;
};
var $8835a976e07ba158$export$167ceafb15c3e7b4 = function(items) {
    var totalWeight = items.reduce(function(sum, item) {
        var weight = item.quantity * (item.weightUnit.value === "LB" ? (0, $aacba40b3ef80b2e$export$ba9f926cfed2060e)(item.weight) : item.weight);
        return sum + weight;
    }, 0);
    return (0, $a2ac72463a01043f$export$d8be081e48e76d62)(totalWeight, 2);
};
var $8835a976e07ba158$export$4ca74356a41f3701 = function(items) {
    var totalVolume = items.reduce(function(sum, item) {
        var cbm = $8835a976e07ba158$export$69689a083948606a({
            quantity: item.quantity,
            length: item.length,
            width: item.width,
            height: item.height,
            unit: item.lengthUnit.value
        });
        return sum + cbm;
    }, 0);
    return (0, $a2ac72463a01043f$export$d8be081e48e76d62)(totalVolume, 2);
};


var $eaa2f94cbeae9674$export$e4abac893f36ee97 = [
    {
        label: "cargoDetails.containerTypes.DV20",
        value: "DV20"
    },
    {
        label: "cargoDetails.containerTypes.DV40",
        value: "DV40"
    },
    {
        label: "cargoDetails.containerTypes.DV40HC",
        value: "DV40HC"
    }
];
var $eaa2f94cbeae9674$export$5d7643758adab567 = {
    DV20: "cargoDetails.containerTypesShortName.DV20",
    DV40: "cargoDetails.containerTypesShortName.DV40",
    DV40HC: "cargoDetails.containerTypesShortName.DV40HC"
};
var $eaa2f94cbeae9674$export$aff720a9602337cd = [
    {
        label: "cargoDetails.lengthUnit.CM",
        value: "CM"
    },
    {
        label: "cargoDetails.lengthUnit.IN",
        value: "IN"
    }
];
var $eaa2f94cbeae9674$export$5e5167c0772daa2 = [
    {
        label: "cargoDetails.weightUnit.KG",
        value: "KG"
    },
    {
        label: "cargoDetails.weightUnit.LB",
        value: "LB"
    }
];
var $eaa2f94cbeae9674$export$d3af23ed5f3d6d3e = [
    {
        label: "cargoDetails.volumeUnit.CBM",
        value: "CBM"
    },
    {
        label: "cargoDetails.volumeUnit.CFT",
        value: "CFT"
    },
    {
        label: "cargoDetails.volumeUnit.CIN",
        value: "CIN"
    }
];
var $eaa2f94cbeae9674$export$4a688500daf09f17 = 100;
var $eaa2f94cbeae9674$export$733799f508d9fb2f = {
    CBM: 20,
    CFT: 706,
    CIN: 1220474
};
var $eaa2f94cbeae9674$export$f3b7d0d07fb5286c = {
    CBM: 0.01,
    CFT: 0.36,
    CIN: 610.24
};
var $eaa2f94cbeae9674$export$8e337a6e8017f90f = {
    KG: 20000,
    LB: 44092
};
var $eaa2f94cbeae9674$export$d03ca40afb5afa22 = 5;
var $eaa2f94cbeae9674$export$bd9343c0e70bb103 = 6000;
var $eaa2f94cbeae9674$export$a93556c404966303 = 3;
















var $639d1ffa47c33698$export$5a9669dc14be119 = {
    Default: "Default",
    Circular: "Circular"
};
var $639d1ffa47c33698$export$62c84cc33d8ed735 = {
    Regular: "Regular",
    Advance: "Advance"
};


var $652e5e6e582599e2$export$1d04a355e3a12077 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesInputWithIcon.InputWithIcon)).withConfig({
    displayName: "InputWithIconstyled__InputWithIcon",
    componentId: "sc-100kryz-0"
})([
    "width:100%;border-radius:",
    ";background:",
    ";.InputLabel-root{",
    ";color:",
    ";",
    ";margin-left:15px;&.Mui-disabled{color:",
    ";path{fill:",
    ";}}&.MuiInputLabel-filled{transform:translate(10px,14px) scale(1);}&.MuiInputLabel-filled.MuiInputLabel-shrink{transform:translate(10px,15px) scale(0.75);}.MuiFilledInput-adornedStart{padding-left:10px;}}& label.Mui-focused,&.focused label{color:",
    ";path{fill:",
    ";}}.Input-root{",
    ";background:",
    ";",
    ";border-radius:",
    ";&.Mui-focused,&:hover{background:",
    ";}margin-top:0px;height:73px;border:0px;padding-left:25px;&.Mui-disabled{background-color:",
    ";color:",
    ";}input{&::placeholder{color:",
    ";opacity:1;}}}"
], function(props) {
    return props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance ? "7px" : "0px";
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.color.g600;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.fontWeight.regular;
}, function(props) {
    return props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance ? "7px" : "0px";
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g300;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.color.g500;
});











var $8386a560313a79fd$var$_path, $8386a560313a79fd$var$_path2, $8386a560313a79fd$var$_path3, $8386a560313a79fd$var$_path4, $8386a560313a79fd$var$_path5;
var $8386a560313a79fd$export$ce7fcac6feb8c2f4 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        width: "13",
        height: "15",
        viewBox: "0 0 13 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            $8386a560313a79fd$var$_path || ($8386a560313a79fd$var$_path = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.67438 1.875C4.67438 0.891243 5.47187 0.09375 6.45563 0.09375C7.43938 0.09375 8.23688 0.891243 8.23688 1.875C8.23688 2.85876 7.43938 3.65625 6.45563 3.65625C5.47187 3.65625 4.67438 2.85876 4.67438 1.875ZM6.45563 0.84375C5.88608 0.84375 5.42438 1.30546 5.42438 1.875C5.42438 2.44454 5.88608 2.90625 6.45563 2.90625C7.02517 2.90625 7.48688 2.44454 7.48688 1.875C7.48688 1.30546 7.02517 0.84375 6.45563 0.84375Z",
                fill: "black"
            })),
            $8386a560313a79fd$var$_path2 || ($8386a560313a79fd$var$_path2 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.45563 2.90625C6.66273 2.90625 6.83063 3.07414 6.83063 3.28125V14.5312C6.83063 14.7384 6.66273 14.9062 6.45563 14.9062C6.24852 14.9062 6.08063 14.7384 6.08063 14.5312V3.28125C6.08063 3.07414 6.24852 2.90625 6.45563 2.90625Z",
                fill: "black"
            })),
            $8386a560313a79fd$var$_path3 || ($8386a560313a79fd$var$_path3 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.73688 6.09375C3.73688 5.88664 3.90477 5.71875 4.11188 5.71875H8.79938C9.00648 5.71875 9.17438 5.88664 9.17438 6.09375C9.17438 6.30086 9.00648 6.46875 8.79938 6.46875H4.11188C3.90477 6.46875 3.73688 6.30086 3.73688 6.09375Z",
                fill: "black"
            })),
            $8386a560313a79fd$var$_path4 || ($8386a560313a79fd$var$_path4 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.03124 8.53125C1.03125 8.53125 1.03124 8.53125 1.03124 8.53125H2.23684C2.44395 8.53125 2.61184 8.69914 2.61184 8.90625C2.61184 9.11336 2.44395 9.28125 2.23684 9.28125H1.03122C0.998109 9.28125 0.967428 9.29871 0.950544 9.32719C0.93366 9.35568 0.933052 9.39095 0.948945 9.42L0.951752 9.42513C2.02844 11.4679 4.1468 12.7476 6.45599 12.75C6.66309 12.7502 6.83081 12.9183 6.83059 13.1254C6.83038 13.3325 6.66231 13.5002 6.4552 13.5C3.86884 13.4973 1.4961 12.0646 0.289411 9.77709C0.147998 9.51623 0.153987 9.20014 0.305382 8.94475C0.457335 8.68841 0.733256 8.53124 1.03124 8.53125Z",
                fill: "black"
            })),
            $8386a560313a79fd$var$_path5 || ($8386a560313a79fd$var$_path5 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.2994 8.90625C10.2994 8.69914 10.4673 8.53125 10.6744 8.53125H11.88C11.88 8.53125 11.88 8.53125 11.88 8.53125C12.178 8.53124 12.4539 8.68841 12.6058 8.94475C12.7572 9.20013 12.7632 9.51621 12.6218 9.77707C11.4151 12.0645 9.04239 13.4973 6.45602 13.5C6.24891 13.5002 6.08084 13.3325 6.08063 13.1254C6.08041 12.9183 6.24813 12.7502 6.45524 12.75C8.76443 12.7476 10.8828 11.468 11.9595 9.42515L11.9622 9.41998C11.9781 9.39093 11.9776 9.35568 11.9607 9.32719C11.9438 9.29871 11.9131 9.28125 11.88 9.28125H10.6744C10.4673 9.28125 10.2994 9.11336 10.2994 8.90625Z",
                fill: "black"
            }))
        ]
    });
};



var $c4b8262dcd5e257a$var$_path, $c4b8262dcd5e257a$var$_path2, $c4b8262dcd5e257a$var$_path3, $c4b8262dcd5e257a$var$_path4, $c4b8262dcd5e257a$var$_path5, $c4b8262dcd5e257a$var$_path6, $c4b8262dcd5e257a$var$_path7, $c4b8262dcd5e257a$var$_path8, $c4b8262dcd5e257a$var$_path9;
var $c4b8262dcd5e257a$export$bed63554a210ca03 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        width: "9",
        height: "15",
        viewBox: "0 0 9 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            $c4b8262dcd5e257a$var$_path || ($c4b8262dcd5e257a$var$_path = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.5625 3.46252V13.6375H7.5V3.46252H1.5625ZM0.9375 3.45002C0.9375 3.09985 1.22947 2.83752 1.5625 2.83752H7.5C7.83303 2.83752 8.125 3.09985 8.125 3.45002V13.95C8.125 14.1226 7.98509 14.2625 7.8125 14.2625H1.25C1.07741 14.2625 0.9375 14.1226 0.9375 13.95V3.45002Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path2 || ($c4b8262dcd5e257a$var$_path2 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.4375 1.66248V2.83748H5.625V1.66248H3.4375ZM2.8125 1.64998C2.8125 1.2998 3.10447 1.03748 3.4375 1.03748H5.625C5.95803 1.03748 6.25 1.2998 6.25 1.64998V3.14998C6.25 3.32256 6.11009 3.46248 5.9375 3.46248H3.125C2.95241 3.46248 2.8125 3.32256 2.8125 3.14998V1.64998Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path3 || ($c4b8262dcd5e257a$var$_path3 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 4.94995C2.8125 4.77736 2.95241 4.63745 3.125 4.63745H5.9375C6.11009 4.63745 6.25 4.77736 6.25 4.94995C6.25 5.12254 6.11009 5.26245 5.9375 5.26245H3.125C2.95241 5.26245 2.8125 5.12254 2.8125 4.94995Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path4 || ($c4b8262dcd5e257a$var$_path4 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 6.74988C2.8125 6.57729 2.95241 6.43738 3.125 6.43738H5.9375C6.11009 6.43738 6.25 6.57729 6.25 6.74988C6.25 6.92247 6.11009 7.06238 5.9375 7.06238H3.125C2.95241 7.06238 2.8125 6.92247 2.8125 6.74988Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path5 || ($c4b8262dcd5e257a$var$_path5 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 8.54993C2.8125 8.37734 2.95241 8.23743 3.125 8.23743H5.9375C6.11009 8.23743 6.25 8.37734 6.25 8.54993C6.25 8.72252 6.11009 8.86243 5.9375 8.86243H3.125C2.95241 8.86243 2.8125 8.72252 2.8125 8.54993Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path6 || ($c4b8262dcd5e257a$var$_path6 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 10.35C2.8125 10.1774 2.95241 10.0375 3.125 10.0375H5.9375C6.11009 10.0375 6.25 10.1774 6.25 10.35C6.25 10.5226 6.11009 10.6625 5.9375 10.6625H3.125C2.95241 10.6625 2.8125 10.5226 2.8125 10.35Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path7 || ($c4b8262dcd5e257a$var$_path7 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 12.15C2.8125 11.9774 2.95241 11.8375 3.125 11.8375H5.9375C6.11009 11.8375 6.25 11.9774 6.25 12.15C6.25 12.3226 6.11009 12.4625 5.9375 12.4625H3.125C2.95241 12.4625 2.8125 12.3226 2.8125 12.15Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path8 || ($c4b8262dcd5e257a$var$_path8 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.5 0C4.77614 0 5 0.18349 5 0.409836V1.59016C5 1.81651 4.77614 1.5 4.5 1.5C4.22386 1.5 4 1.81651 4 1.59016V0.409836C4 0.18349 4.22386 0 4.5 0Z",
                fill: "black"
            })),
            $c4b8262dcd5e257a$var$_path9 || ($c4b8262dcd5e257a$var$_path9 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 13.95C0 13.7774 0.0857327 13.6375 0.191489 13.6375H8.80851C8.91427 13.6375 9 13.7774 9 13.95C9 14.1225 8.91427 14.2625 8.80851 14.2625H0.191489C0.0857327 14.2625 0 14.1225 0 13.95Z",
                fill: "black"
            }))
        ]
    });
};




var $88e36859d8fa0f7f$export$e9fd8dbbd0edb147 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 16 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var strokeColor = fill !== null && fill !== void 0 ? fill : theme.color.black;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.03125 10.5C9.58455 10.5 10.8438 9.2408 10.8438 7.6875C10.8438 6.1342 9.58455 4.875 8.03125 4.875C6.47795 4.875 5.21875 6.1342 5.21875 7.6875C5.21875 9.2408 6.47795 10.5 8.03125 10.5Z",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M7.09375 6.75H8.96875",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M8.03125 4.875V3",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M1 8.15625L5.21875 7.6875",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M2.875 7.94824V9.09387",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.875 10.9688C3.39277 10.9688 3.8125 10.549 3.8125 10.0312C3.8125 9.51348 3.39277 9.09375 2.875 9.09375C2.35723 9.09375 1.9375 9.51348 1.9375 10.0312C1.9375 10.549 2.35723 10.9688 2.875 10.9688Z",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M15.0625 8.15625L10.8438 7.6875",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M13.1875 7.94824V9.09387",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.1875 10.9688C13.7053 10.9688 14.125 10.549 14.125 10.0312C14.125 9.51348 13.7053 9.09375 13.1875 9.09375C12.6697 9.09375 12.25 9.51348 12.25 10.0312C12.25 10.549 12.6697 10.9688 13.1875 10.9688Z",
                stroke: strokeColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


var $7e5b7b03c63d2fcf$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationItemComponentstyled__Wrapper",
    componentId: "sc-18iagei-0"
})([
    "cursor:pointer;padding:5px 0px;&.selected,&:hover{background-color:",
    ";margin-left:-15px;margin-right:-15px;padding-left:15px;padding-right:15px;width:auto;}"
], function(props) {
    return props.theme.color.g100;
});
var $7e5b7b03c63d2fcf$export$be58b4326e23250f = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationItemComponentstyled__IconWrapper",
    componentId: "sc-18iagei-1"
})([
    "width:15px;padding-top:3px;display:flex;"
]);
var $7e5b7b03c63d2fcf$export$de5e039aa1ca6b9d = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $8386a560313a79fd$export$ce7fcac6feb8c2f4)).withConfig({
    displayName: "LocationItemComponentstyled__PortIcon",
    componentId: "sc-18iagei-2"
})([
    "display:inline-block;"
]);
var $7e5b7b03c63d2fcf$export$51350e40f7f9c1b6 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $c4b8262dcd5e257a$export$bed63554a210ca03)).withConfig({
    displayName: "LocationItemComponentstyled__CityIcon",
    componentId: "sc-18iagei-3"
})([
    "display:inline-block;"
]);
var $7e5b7b03c63d2fcf$export$910fb762caf56293 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $88e36859d8fa0f7f$export$e9fd8dbbd0edb147)).withConfig({
    displayName: "LocationItemComponentstyled__AirIcon",
    componentId: "sc-18iagei-4"
})([
    "display:inline-block;"
]);
var $7e5b7b03c63d2fcf$export$c7bd411105e2dec3 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationItemComponentstyled__Name",
    componentId: "sc-18iagei-5"
})([
    "",
    ";color:",
    ";"
], function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.color.black;
});
var $7e5b7b03c63d2fcf$export$393edc798c47379d = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationItemComponentstyled__Description",
    componentId: "sc-18iagei-6"
})([
    "",
    ";color:",
    ";line-height:13px;"
], function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.color.g500;
});
var $7e5b7b03c63d2fcf$export$7c3018f441722857 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationItemComponentstyled__TextWrapper",
    componentId: "sc-18iagei-7"
})([
    "flex-grow:1;padding:0px 3px;font-size:0px;"
]);
var $7e5b7b03c63d2fcf$export$2f8a82f9bac44423 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationItemComponentstyled__FlagWrapper",
    componentId: "sc-18iagei-8"
})([
    "display:flex;align-items:center;"
]);


var $caa3cc008f64b2ed$var$TYPE_TO_ICON_MAP = {
    CITY: (0, $7e5b7b03c63d2fcf$export$51350e40f7f9c1b6),
    PORT: (0, $7e5b7b03c63d2fcf$export$de5e039aa1ca6b9d),
    POSTAL_CODE: (0, $7e5b7b03c63d2fcf$export$51350e40f7f9c1b6),
    AIRPORT: (0, $7e5b7b03c63d2fcf$export$910fb762caf56293)
};
var $caa3cc008f64b2ed$export$7e815f6e4a51d515 = function(props) {
    var type = props.type, name = props.name, description = props.description, countryCode = props.countryCode, onClick = props.onClick, selected = props.selected, cursorRef = props.cursorRef;
    var className = props.className;
    // TODO: `innerRef` is deprecated
    var cursorProps = {};
    var Icon = $caa3cc008f64b2ed$var$TYPE_TO_ICON_MAP[type];
    if (selected) {
        className += " selected";
        cursorProps.innerRef = cursorRef;
    }
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({
        component: (0, $7e5b7b03c63d2fcf$export$e6dfd72ab29f8598),
        container: true,
        className: className,
        onClick: onClick,
        wrap: "nowrap"
    }, cursorProps), {
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                item: true,
                component: (0, $7e5b7b03c63d2fcf$export$be58b4326e23250f),
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                item: true,
                component: (0, $7e5b7b03c63d2fcf$export$7c3018f441722857),
                children: [
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $7e5b7b03c63d2fcf$export$c7bd411105e2dec3), {
                        children: name
                    }),
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $7e5b7b03c63d2fcf$export$393edc798c47379d), {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                item: true,
                component: (0, $7e5b7b03c63d2fcf$export$2f8a82f9bac44423),
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsIcons.FlagIcon), {
                    size: 20,
                    code: countryCode.toLowerCase()
                })
            })
        ]
    }));
};


var $920835c8da1b7c21$export$69bc41ee738923ec = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationDropdownComponentstyled__SectionTitle",
    componentId: "sc-1e52qdm-0"
})([
    "",
    ";color:",
    ";span{",
    ";text-transform:uppercase;}"
], function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.color.a500;
}, function(props) {
    return props.theme.fontWeight.bold;
});
var $920835c8da1b7c21$export$7e815f6e4a51d515 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $caa3cc008f64b2ed$export$7e815f6e4a51d515)).withConfig({
    displayName: "LocationDropdownComponentstyled__LocationItemComponent",
    componentId: "sc-1e52qdm-1"
})([
    "margin:5px 0px;"
]);



var $175d32ef213a5811$export$da1ec1d734312f9f = function(input) {
    return input ? input.replace(RegExp("[\\p{L}']+", "gu"), (0, ($parcel$interopDefault($fZLIC$lodashcapitalize)))) : "";
};



var $1e7ae8cd38d66488$export$c6422dd10de433e5 = function(props) {
    var cursor = props.cursor, _props_ports = props.ports, ports = _props_ports === void 0 ? [] : _props_ports, _props_cities = props.cities, cities = _props_cities === void 0 ? [] : _props_cities, _props_postalCodes = props.postalCodes, postalCodes = _props_postalCodes === void 0 ? [] : _props_postalCodes, _props_airports = props.airports, airports = _props_airports === void 0 ? [] : _props_airports, onSelect = props.onSelect, cursorRef = props.cursorRef, type = props.type;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var hasPorts = Boolean(ports.length);
    var hasCities = Boolean(cities.length);
    var hasPostalCodes = Boolean(postalCodes.length);
    var hasAirports = Boolean(airports.length);
    var portsCount = ports.length;
    var airportCount = airports.length;
    var citiesCount = cities.length;
    var doesNotDoorServiceLabel = type === "pickup" ? "doesntIncludePickup" : "doesntIncludeDelivery";
    var cityLabel = type === "pickup" ? "includesPickup" : "includesDelivery";
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$reactjsxruntime.Fragment), {
        children: [
            hasPorts && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$reactjsxruntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $920835c8da1b7c21$export$69bc41ee738923ec), {
                        children: [
                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("span", {
                                children: t("seaport")
                            }),
                            " ",
                            t(doesNotDoorServiceLabel)
                        ]
                    }),
                    ports.map(function(port, i) {
                        return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $920835c8da1b7c21$export$7e815f6e4a51d515), {
                            description: port.country.display_name,
                            type: port.type,
                            name: "".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(port.name), " (").concat(port.portIsoCode, ")"),
                            countryCode: port.country.iso_code,
                            onClick: function() {
                                return onSelect(port);
                            },
                            selected: i + 1 === cursor,
                            cursorRef: cursorRef
                        }, "port-".concat(i));
                    })
                ]
            }),
            (hasCities || hasPostalCodes) && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $920835c8da1b7c21$export$69bc41ee738923ec), {
                children: [
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("span", {
                        children: t("city")
                    }),
                    " ",
                    t(cityLabel)
                ]
            }),
            hasCities && cities.map(function(city, i) {
                return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $920835c8da1b7c21$export$7e815f6e4a51d515), {
                    description: city.country.display_name,
                    type: city.type,
                    name: (0, $175d32ef213a5811$export$da1ec1d734312f9f)(city.state ? "".concat(city.name, ", ").concat(city.state) : "".concat(city.name)),
                    countryCode: city.country.iso_code,
                    onClick: function() {
                        return onSelect(city);
                    },
                    selected: airportCount + portsCount + i + 1 === cursor,
                    cursorRef: cursorRef
                }, "city-".concat(i));
            }),
            hasPostalCodes && postalCodes.map(function(postalCode, i) {
                return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $920835c8da1b7c21$export$7e815f6e4a51d515), {
                    description: postalCode.country.display_name,
                    type: postalCode.type,
                    name: "".concat(postalCode.postalCode, ", ").concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(postalCode.city)),
                    countryCode: postalCode.country.iso_code,
                    onClick: function() {
                        return onSelect(postalCode);
                    },
                    selected: citiesCount + airportCount + portsCount + i + 1 === cursor,
                    cursorRef: cursorRef
                }, "postalCode-".concat(i));
            }),
            hasAirports && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$reactjsxruntime.Fragment), {
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $920835c8da1b7c21$export$69bc41ee738923ec), {
                    children: [
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("span", {
                            children: t("airport")
                        }),
                        " ",
                        t(doesNotDoorServiceLabel),
                        airports.map(function(airport, i) {
                            return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $920835c8da1b7c21$export$7e815f6e4a51d515), {
                                description: airport.country.display_name,
                                type: airport.type,
                                name: "".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(airport.name), " (").concat(airport.iata, ")"),
                                countryCode: airport.country.iso_code,
                                onClick: function() {
                                    return onSelect(airport);
                                },
                                selected: portsCount + i + 1 === cursor,
                                cursorRef: cursorRef
                            }, "airport-".concat(i));
                        })
                    ]
                })
            })
        ]
    });
};




var $11a84144ac774e8c$var$_path, $11a84144ac774e8c$var$_path2, $11a84144ac774e8c$var$_path3;
var $11a84144ac774e8c$export$f7dc499a72baa103 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        width: "23",
        height: "20",
        viewBox: "0 0 23 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            $11a84144ac774e8c$var$_path || ($11a84144ac774e8c$var$_path = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M11.4999 14.5002C11.8623 14.5002 12.1561 14.7521 12.1561 15.0627C12.1561 15.3734 11.8623 15.6252 11.4999 15.6252C11.1375 15.6252 10.8438 15.3734 10.8438 15.0627C10.8438 14.7521 11.1375 14.5002 11.4999 14.5002",
                stroke: "#7B7B8E",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })),
            $11a84144ac774e8c$var$_path2 || ($11a84144ac774e8c$var$_path2 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M11.5 11.1252V6.62524",
                stroke: "#7B7B8E",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })),
            $11a84144ac774e8c$var$_path3 || ($11a84144ac774e8c$var$_path3 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.6717 15.1481C22.1534 15.9731 22.1022 16.9531 21.5364 17.7379C20.9706 18.5227 19.971 19.0003 18.8947 19H4.10525C3.029 19.0003 2.02935 18.5227 1.46356 17.7379C0.897768 16.9531 0.846578 15.9731 1.32828 15.1481L8.72303 2.4718C9.24866 1.56984 10.3238 1 11.5 1C12.6762 1 13.7513 1.56984 14.277 2.4718L21.6717 15.1481Z",
                stroke: "#7B7B8E",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
        ]
    });
};




var $eeb906448e06f827$export$e71c4d32a2263218 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "NoResultMessageComponentstyled__Box",
    componentId: "sc-4wf9r1-0"
})([
    "padding:20px;display:flex;flex-direction:row;background-color:",
    ";border-radius:7px;flex-wrap:nowrap;"
], function(props) {
    return props.theme.color.white;
});
var $eeb906448e06f827$export$be58b4326e23250f = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "NoResultMessageComponentstyled__IconWrapper",
    componentId: "sc-4wf9r1-1"
})([
    "padding-top:4px;"
]);
var $eeb906448e06f827$export$fbbf1dbfdbfcef12 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "NoResultMessageComponentstyled__WarningMessage",
    componentId: "sc-4wf9r1-2"
})([
    "padding-left:8px;color:",
    ";",
    " ",
    ""
], function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.fontWeight.regular;
}, function(props) {
    return props.theme.typo.bodyM;
});


var $9723e2a86792968c$var$_Box;
var $9723e2a86792968c$export$815e2e8c28f75841 = function() {
    return $9723e2a86792968c$var$_Box || ($9723e2a86792968c$var$_Box = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $eeb906448e06f827$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $eeb906448e06f827$export$be58b4326e23250f), {
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $11a84144ac774e8c$export$f7dc499a72baa103), {})
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $eeb906448e06f827$export$fbbf1dbfdbfcef12), {
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $88150c5c731a6db0$export$8d6a9236f2e3f2ce), {
                    i18nKey: "cannotFindWarningMessage",
                    children: [
                        "Sorry, we could not find any ",
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("b", {
                            children: "city"
                        }),
                        " or ",
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("b", {
                            children: "port"
                        }),
                        " matching your input. Please check and try again."
                    ]
                })
            })
        ]
    }));
};






var $ba1bc30d9d4ec77f$export$69bc41ee738923ec = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "RecentSearchComponentstyled__SectionTitle",
    componentId: "sc-1q0jirg-0"
})([
    "",
    ";color:",
    ";padding:0px 16px 8px 16px;span{",
    ";text-transform:uppercase;}"
], function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.color.a500;
}, function(props) {
    return props.theme.fontWeight.medium;
});
var $ba1bc30d9d4ec77f$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "RecentSearchComponentstyled__Wrapper",
    componentId: "sc-1q0jirg-1"
})([
    "background-color:",
    ";width:100%;border-radius:7px;padding-top:16px;padding-bottom:8px;.route-item{.route-item-locations{justify-content:start;.route-item-origin{margin-right:16px;width:calc((100% - 24px) / 2);}.route-item-destination{margin-left:16px;width:calc((100% - 24px) / 2);}}padding:8px 16px 0px 16px;& > *{span{",
    ";}}&:hover{background-color:",
    ";}"
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.color.g100;
});


var $2e9411555558609a$export$a494855209d0fee3 = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var className = props.className, recentSearchItems = props.recentSearchItems;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $ba1bc30d9d4ec77f$export$e6dfd72ab29f8598), {
        className: className,
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $ba1bc30d9d4ec77f$export$69bc41ee738923ec), {
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("span", {
                    children: t("recentSearches")
                })
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistorganismsRecentSearches.RecentSearches), {
                routeItemClassName: "route-item",
                routeItemClasses: {
                    locations: "route-item-locations",
                    origin: "route-item-origin",
                    destination: "route-item-destination"
                },
                actionItem: null,
                routeItems: recentSearchItems
            })
        ]
    });
};














var $d7c647944443c879$var$_path, $d7c647944443c879$var$_path2, $d7c647944443c879$var$_path3, $d7c647944443c879$var$_path4, $d7c647944443c879$var$_path5, $d7c647944443c879$var$_path6, $d7c647944443c879$var$_path7, $d7c647944443c879$var$_path8, $d7c647944443c879$var$_path9;
var $d7c647944443c879$export$51350e40f7f9c1b6 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        width: "9",
        height: "15",
        viewBox: "0 0 9 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            $d7c647944443c879$var$_path || ($d7c647944443c879$var$_path = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.5625 3.46252V13.6375H7.5V3.46252H1.5625ZM0.9375 3.45002C0.9375 3.09985 1.22947 2.83752 1.5625 2.83752H7.5C7.83303 2.83752 8.125 3.09985 8.125 3.45002V13.95C8.125 14.1226 7.98509 14.2625 7.8125 14.2625H1.25C1.07741 14.2625 0.9375 14.1226 0.9375 13.95V3.45002Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path2 || ($d7c647944443c879$var$_path2 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.4375 1.66248V2.83748H5.625V1.66248H3.4375ZM2.8125 1.64998C2.8125 1.2998 3.10447 1.03748 3.4375 1.03748H5.625C5.95803 1.03748 6.25 1.2998 6.25 1.64998V3.14998C6.25 3.32256 6.11009 3.46248 5.9375 3.46248H3.125C2.95241 3.46248 2.8125 3.32256 2.8125 3.14998V1.64998Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path3 || ($d7c647944443c879$var$_path3 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 4.94995C2.8125 4.77736 2.95241 4.63745 3.125 4.63745H5.9375C6.11009 4.63745 6.25 4.77736 6.25 4.94995C6.25 5.12254 6.11009 5.26245 5.9375 5.26245H3.125C2.95241 5.26245 2.8125 5.12254 2.8125 4.94995Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path4 || ($d7c647944443c879$var$_path4 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 6.74988C2.8125 6.57729 2.95241 6.43738 3.125 6.43738H5.9375C6.11009 6.43738 6.25 6.57729 6.25 6.74988C6.25 6.92247 6.11009 7.06238 5.9375 7.06238H3.125C2.95241 7.06238 2.8125 6.92247 2.8125 6.74988Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path5 || ($d7c647944443c879$var$_path5 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 8.54993C2.8125 8.37734 2.95241 8.23743 3.125 8.23743H5.9375C6.11009 8.23743 6.25 8.37734 6.25 8.54993C6.25 8.72252 6.11009 8.86243 5.9375 8.86243H3.125C2.95241 8.86243 2.8125 8.72252 2.8125 8.54993Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path6 || ($d7c647944443c879$var$_path6 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 10.35C2.8125 10.1774 2.95241 10.0375 3.125 10.0375H5.9375C6.11009 10.0375 6.25 10.1774 6.25 10.35C6.25 10.5226 6.11009 10.6625 5.9375 10.6625H3.125C2.95241 10.6625 2.8125 10.5226 2.8125 10.35Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path7 || ($d7c647944443c879$var$_path7 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.8125 12.15C2.8125 11.9774 2.95241 11.8375 3.125 11.8375H5.9375C6.11009 11.8375 6.25 11.9774 6.25 12.15C6.25 12.3226 6.11009 12.4625 5.9375 12.4625H3.125C2.95241 12.4625 2.8125 12.3226 2.8125 12.15Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path8 || ($d7c647944443c879$var$_path8 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.5 0C4.77614 0 5 0.18349 5 0.409836V1.59016C5 1.81651 4.77614 1.5 4.5 1.5C4.22386 1.5 4 1.81651 4 1.59016V0.409836C4 0.18349 4.22386 0 4.5 0Z",
                fill: "black"
            })),
            $d7c647944443c879$var$_path9 || ($d7c647944443c879$var$_path9 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 13.95C0 13.7774 0.0857327 13.6375 0.191489 13.6375H8.80851C8.91427 13.6375 9 13.7774 9 13.95C9 14.1225 8.91427 14.2625 8.80851 14.2625H0.191489C0.0857327 14.2625 0 14.1225 0 13.95Z",
                fill: "black"
            }))
        ]
    });
};





var $562de9c9463b2423$export$f4ef0608819d0751 = function(param) {
    var _param_width = param.width, width = _param_width === void 0 ? 20 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, className = param.className, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.g200;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 20 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M20 1.95625H0V1.29308C0 1.10266 0.154414 0.948242 0.344843 0.948242H19.6552C19.8456 0.948242 20 1.10266 20 1.29308L20 1.95625Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M20 4.97998H0V5.98795H20V4.97998Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M20 2.96411H0V3.97208H20V2.96411Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M20 8.0041H0.344843C0.154414 8.0041 0 7.84968 0 7.65925V6.99609H20V8.0041Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M20 11.0281H0V12.036H20V11.0281Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M19.6551 14.0517H0.344843C0.154414 14.0517 0 13.8973 0 13.7068V13.0437H20V13.7069C20 13.8973 19.8455 14.0517 19.6551 14.0517Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M20 9.01221H0V10.0202H20V9.01221Z",
                fill: fillColor
            })
        ]
    });
};


var $c67fa240a623ebf6$export$ae058946ac683245 = {
    LCL: "LCL",
    FCL: "FCL"
};


var $dc0baf21ad530e3b$export$296c865296deffa2 = {
    FCL: "FCL",
    LCL: "LCL",
    AIR: "AIR",
    LTL: "LTL"
};


var $84c96a688242bcfe$export$3aedd69106b8865b = function(shipmentType) {
    return shipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).LCL;
};
var $84c96a688242bcfe$export$ad6da18d1d7ff65 = function(shipmentType) {
    return shipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).FCL;
};
var $84c96a688242bcfe$export$589f9843ee7a4481 = function(mode) {
    return mode === (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR;
};
var $84c96a688242bcfe$export$5f03b9f28d71ed92 = function(item) {
    return "totalWeight" in item || "volumeUnit" in item;
};
var $84c96a688242bcfe$export$119f999c288cff04 = function(item) {
    return "type" in item;
};
var $84c96a688242bcfe$export$32aa3057966bf054 = function(item) {
    return "length" in item;
};
var $84c96a688242bcfe$export$42c27cf9b4e901fd = function(shipmentType) {
    return shipmentType in (0, $c67fa240a623ebf6$export$ae058946ac683245);
};
var $84c96a688242bcfe$export$119990892388fa74 = function(shipmentType) {
    return shipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).LTL;
};


var $3180d1e7f238f266$export$a9044a10e5a81ea2 = function(item) {
    return item.type === "CITY";
};
var $3180d1e7f238f266$export$bf27ad191565d194 = function(item) {
    return item.type === "PORT";
};
var $3180d1e7f238f266$export$a955beec2ab2c25 = function(item) {
    return item.type === "POSTAL_CODE";
};
var $3180d1e7f238f266$export$1fb21e0e5ee2e8a3 = function(item) {
    return item.type === "AIRPORT";
};






var $572732a31feb62d3$export$264024307842c62 = function(sendMixpanelEvents) {
    return function() {
        $572732a31feb62d3$export$553848366fc135e2(sendMixpanelEvents);
    };
};
var $572732a31feb62d3$export$e614f62ab9abde9d = function(sendMixpanelEvents, mixpanelKey) {
    if (mixpanelKey) (0, ($parcel$interopDefault($fZLIC$mixpanelbrowser))).init(mixpanelKey, {
        opt_out_tracking_by_default: true,
        opt_out_persistence_by_default: true,
        loaded: $572732a31feb62d3$export$264024307842c62(sendMixpanelEvents)
    });
};
var $572732a31feb62d3$export$553848366fc135e2 = function(sendMixpanelEvents) {
    if (sendMixpanelEvents) {
        (0, ($parcel$interopDefault($fZLIC$mixpanelbrowser))).opt_in_tracking();
        (0, ($parcel$interopDefault($fZLIC$mixpanelbrowser))).track_pageview();
    }
};
var $572732a31feb62d3$export$68bd84518a10ae79 = function() {
    try {
        return (0, ($parcel$interopDefault($fZLIC$mixpanelbrowser))).has_opted_in_tracking();
    } catch (e) {
        return false;
    }
};
var $572732a31feb62d3$export$65e5b62a4c490288 = function(id) {
    if ($572732a31feb62d3$export$68bd84518a10ae79()) (0, ($parcel$interopDefault($fZLIC$mixpanelbrowser))).identify(id);
};
var $572732a31feb62d3$export$8de3e08801b34e5a = function(id) {
    if ($572732a31feb62d3$export$68bd84518a10ae79()) (0, ($parcel$interopDefault($fZLIC$mixpanelbrowser))).alias(id);
};
var $572732a31feb62d3$export$5cd3adc60bf17ecb = function(props) {
    if ($572732a31feb62d3$export$68bd84518a10ae79()) {
        var eventName = props.eventName, rest = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(props, [
            "eventName"
        ]);
        (0, ($parcel$interopDefault($fZLIC$mixpanelbrowser))).track(eventName, rest);
    }
};




var $f8b2885ce9151c3b$export$14680262b426b127 = function(location) {
    if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(location)) return location.portIsoCode;
    if ((0, $3180d1e7f238f266$export$a9044a10e5a81ea2)(location)) return location.defaultPostalCode;
    if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(location)) return location.postalCode;
    if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(location)) return location.iata;
    return "";
};
var $f8b2885ce9151c3b$export$ccdaf44865697709 = function(data) {
    if (data.cargoFclDetail) return (0, $c67fa240a623ebf6$export$ae058946ac683245).FCL;
    if (data.cargoLclDetail) return (0, $c67fa240a623ebf6$export$ae058946ac683245).LCL;
    else return undefined;
};
var $f8b2885ce9151c3b$export$2f8145256df4fdee = function(data) {
    if (data.cargoAirDetail) return "Air";
    if (data.cargoLtlDetail) return "Road LTL";
    return "Ocean";
};


var $068a6aa0fda9c13f$export$e4848c75307210a3 = function(param) {
    var sendGA4Events = param.sendGA4Events, location = param.location, userType = param.userType, sendMixpanelEvents = param.sendMixpanelEvents;
    if (sendGA4Events) {
        var selectOriginGa4Event = {
            event_name: "select_origin",
            origin_country: location.country.display_name,
            origin_port: (0, $f8b2885ce9151c3b$export$14680262b426b127)(location),
            user_type: userType,
            event: "ga4Event"
        };
        (0, $453cff6f0a91fd89$export$3586f5d4ea79c22a)(selectOriginGa4Event);
    }
    if (sendMixpanelEvents) {
        var selectOriginMixpanelEvent = {
            eventName: "selectOrigin",
            originCountry: location.country.display_name,
            originPort: (0, $f8b2885ce9151c3b$export$14680262b426b127)(location)
        };
        (0, $572732a31feb62d3$export$5cd3adc60bf17ecb)(selectOriginMixpanelEvent);
    }
};
var $068a6aa0fda9c13f$export$d57c8e53ae8e0980 = function(param) {
    var sendGA4Events = param.sendGA4Events, location = param.location, userType = param.userType, sendMixpanelEvents = param.sendMixpanelEvents;
    if (sendGA4Events) {
        var selectDestinationGa4Event = {
            event_name: "select_destination",
            destination_country: location.country.display_name,
            destination_port: (0, $f8b2885ce9151c3b$export$14680262b426b127)(location),
            user_type: userType,
            event: "ga4Event"
        };
        (0, $453cff6f0a91fd89$export$3586f5d4ea79c22a)(selectDestinationGa4Event);
    }
    if (sendMixpanelEvents) {
        var selectDestinationMixpanelEvent = {
            eventName: "selectDestination",
            destinationCountry: location.country.display_name,
            destinationPort: (0, $f8b2885ce9151c3b$export$14680262b426b127)(location)
        };
        (0, $572732a31feb62d3$export$5cd3adc60bf17ecb)(selectDestinationMixpanelEvent);
    }
};
var $068a6aa0fda9c13f$export$3e822338bed59a9a = function(params) {
    var data = params.data, userType = params.userType, sendGA4Events = params.sendGA4Events;
    var origin = data.origin, destination = data.destination;
    if (!origin || !destination) return;
    if (sendGA4Events) {
        var quoteSearchGa4Event = {
            event_name: "search_quote",
            origin_country: origin.location.country.display_name,
            origin_port: (0, $f8b2885ce9151c3b$export$14680262b426b127)(origin.location),
            freight_type: (0, $f8b2885ce9151c3b$export$2f8145256df4fdee)(data),
            destination_country: destination.location.country.display_name,
            destination_port: (0, $f8b2885ce9151c3b$export$14680262b426b127)(destination.location),
            cargo_type: (0, $f8b2885ce9151c3b$export$ccdaf44865697709)(data),
            user_type: userType,
            event: "ga4Event"
        };
        (0, $453cff6f0a91fd89$export$3586f5d4ea79c22a)(quoteSearchGa4Event);
    }
};
var $068a6aa0fda9c13f$export$5cc8059eba5fa908 = function(params) {
    var sendMixpanelEvents = params.sendMixpanelEvents, mode = params.mode;
    if (sendMixpanelEvents) {
        var sendModeChangeEventToMixpanel = {
            eventName: "modeChange",
            mode: mode
        };
        (0, $572732a31feb62d3$export$5cd3adc60bf17ecb)(sendModeChangeEventToMixpanel);
    }
};
var $068a6aa0fda9c13f$export$141ac067c0f2cc6c = function(params) {
    var sendMixpanelEvents = params.sendMixpanelEvents;
    if (sendMixpanelEvents) {
        var event = {
            eventName: "RecentSearchSelectedInQuoteFrom"
        };
        (0, $572732a31feb62d3$export$5cd3adc60bf17ecb)(event);
    }
};
var $068a6aa0fda9c13f$export$8b9ed055bf3cbcae = function(params) {
    var sendMixpanelEvents = params.sendMixpanelEvents;
    if (sendMixpanelEvents) {
        var event = {
            eventName: "RecentSearchDisplayedInQuoteFrom"
        };
        (0, $572732a31feb62d3$export$5cd3adc60bf17ecb)(event);
    }
};


var $682e17d971f7dc71$var$_CityIcon, $682e17d971f7dc71$var$_AnchorIcon, $682e17d971f7dc71$var$_PlaneFrontIcon, $682e17d971f7dc71$var$_RectangleIcon;
var $682e17d971f7dc71$export$52ef8eaf754b08e5 = function(param) {
    var data = param.data, fieldValue = param.fieldValue, setLocation = param.setLocation, onChange = param.onChange, postalCode = param.postalCode, clearInvalidZipcodeError = param.clearInvalidZipcodeError, setInvalidZipcodeError = param.setInvalidZipcodeError, fieldName = param.fieldName;
    return function() {
        var location = data === null || data === void 0 ? void 0 : data[0];
        if (location && fieldValue) {
            clearInvalidZipcodeError(fieldName);
            if ((0, $3180d1e7f238f266$export$a9044a10e5a81ea2)(fieldValue.location)) {
                if (location.city.toLowerCase() !== fieldValue.location.name.toLowerCase()) {
                    setLocation(location.city);
                    onChange({
                        location: (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, fieldValue.location), {
                            name: location.city
                        }),
                        postalCode: postalCode
                    });
                }
            }
            if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(fieldValue.location)) {
                if (location.city.toLowerCase() !== fieldValue.location.city.toLowerCase()) {
                    setLocation(location.city);
                    onChange({
                        location: (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, fieldValue.location), {
                            city: location.city
                        }),
                        postalCode: postalCode
                    });
                }
            }
        } else fieldValue && data && data.length === 0 && fieldValue.postalCode && setInvalidZipcodeError(fieldName);
    };
};
var $682e17d971f7dc71$export$fde68238b73b126f = function(location) {
    if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(location)) return "".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name), " (").concat(location.portIsoCode, ")");
    if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(location)) return "".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name), " (").concat(location.iata, ")");
    if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(location)) return (0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.city);
    return (0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name);
};
var $682e17d971f7dc71$export$9ffb3d100090b01d = function(param) {
    var fieldValue = param.fieldValue, sendLocationNotSelectedEvent = param.sendLocationNotSelectedEvent, setLocation = param.setLocation, setShowDropdown = param.setShowDropdown;
    return function() {
        var location = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.location;
        setShowDropdown(false);
        if (!location) {
            sendLocationNotSelectedEvent();
            return;
        }
        if ((0, $3180d1e7f238f266$export$a9044a10e5a81ea2)(location)) setLocation((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name));
        if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(location)) setLocation("".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name), " (").concat(location.portIsoCode, ")"));
        if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(location)) setLocation((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.city));
        if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(location)) setLocation("".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name), " (").concat(location.iata, ")"));
    };
};
var $682e17d971f7dc71$export$99b607fb5fc7a93e = function(param) {
    var onChange = param.onChange, setLocation = param.setLocation, setPostalCode = param.setPostalCode, setShowDropdown = param.setShowDropdown, setFocusPostalCode = param.setFocusPostalCode, onSelect = param.onSelect, onBackdropClick = param.onBackdropClick;
    return function(location) {
        setShowDropdown(false);
        onBackdropClick && onBackdropClick();
        if ((0, $3180d1e7f238f266$export$a9044a10e5a81ea2)(location)) {
            onChange({
                location: location,
                postalCode: location.defaultPostalCode
            });
            setLocation((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name));
            setPostalCode(location.defaultPostalCode);
            setFocusPostalCode(true);
        }
        if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(location)) {
            onChange({
                location: location
            });
            setLocation("".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name), " (").concat(location.portIsoCode, ")"));
            setFocusPostalCode(false);
        }
        if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(location)) {
            onChange({
                location: location,
                postalCode: location.postalCode
            });
            setLocation((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.city));
            setPostalCode(location.postalCode);
            setFocusPostalCode(true);
        }
        if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(location)) {
            onChange({
                location: location
            });
            setLocation("".concat((0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name), " (").concat(location.iata, ")"));
            setFocusPostalCode(false);
        }
        onSelect && onSelect(location); // call parent component method
    };
};
var $682e17d971f7dc71$export$ac888553f852f1c3 = function(param) {
    var setLocation = param.setLocation, setShowDropdown = param.setShowDropdown, getPlaces = param.getPlaces, setIsLoading = param.setIsLoading, onChange = param.onChange, setBackdropVisible = param.setBackdropVisible, setLengthError = param.setLengthError, clearLengthErrors = param.clearLengthErrors, lengthField = param.lengthField;
    return function(e) {
        if (e.target.value.length > (0, $f9f89a5c82b78d91$export$40659df21aafb739)) {
            setIsLoading(false);
            setShowDropdown(false);
            setLocation(e.target.value);
            setLengthError && setLengthError(lengthField);
        } else if (e.target.value.length >= (0, $f9f89a5c82b78d91$export$f56c1bb712b9ef86)) {
            clearLengthErrors && clearLengthErrors(lengthField);
            setIsLoading(true);
            setLocation(e.target.value);
            getPlaces();
            setShowDropdown(true);
            setBackdropVisible && setBackdropVisible(true);
        } else {
            setLocation(e.target.value);
            onChange(null);
            setIsLoading(false);
            setShowDropdown(false);
        }
    };
};
var $682e17d971f7dc71$export$1b994d97209f817a = function(param) {
    var setPostalCode = param.setPostalCode, onChange = param.onChange, fieldValue = param.fieldValue;
    return function(e) {
        setPostalCode(e.target.value);
        onChange((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, fieldValue), {
            postalCode: e.target.value
        }));
    };
};
var $682e17d971f7dc71$export$c7d04a37f614b150 = function(param) {
    var getPostalCodes = param.getPostalCodes;
    return function() {
        getPostalCodes();
    };
};
var $682e17d971f7dc71$export$718afa7caf055a42 = function(param) {
    var onFieldBlur = param.onFieldBlur, setLocation = param.setLocation, setShowDropdown = param.setShowDropdown, noResults = param.noResults, setBackdropVisible = param.setBackdropVisible, onBlur = param.onBlur;
    return function(e) {
        if (noResults) {
            setLocation("");
            setShowDropdown(false);
            setBackdropVisible && setBackdropVisible(false);
        }
        onFieldBlur();
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
};
var $682e17d971f7dc71$export$5e446bc31724fca4 = function(param) {
    var wrapperRef = param.wrapperRef, setFocus = param.setFocus;
    return function(e) {
        var _wrapperRef_current;
        if (!((_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.contains(e.relatedTarget))) setFocus(false);
    };
};
var $682e17d971f7dc71$export$de8e1b1372cdb41b = function(param) {
    var cursor = param.cursor, totalItems = param.totalItems, cursorRef = param.cursorRef, setCursor = param.setCursor;
    return function(e) {
        switch(e.code){
            case "ArrowUp":
                setCursor(cursor <= 1 ? totalItems : cursor - 1);
                break;
            case "ArrowDown":
                setCursor((cursor > totalItems - 1 ? 0 : cursor) + 1);
                break;
            case "Enter":
                cursorRef.current && cursorRef.current.click();
                break;
        }
    };
};
var $682e17d971f7dc71$export$53a0910f038337bd = function(param) {
    var cursorRef = param.cursorRef;
    return function() {
        // eslint-disable-next-line react/no-find-dom-node
        var node = (0, $fZLIC$reactdom.findDOMNode)(cursorRef.current);
        if (cursorRef.current) node.scrollIntoView({
            block: "start",
            behavior: "smooth"
        });
    };
};
var $682e17d971f7dc71$export$6283f5953ff9dfce = function(location) {
    var index = location.indexOf("(");
    return index > 0 ? location.slice(0, index) : location;
};
var $682e17d971f7dc71$export$67e9d748682b70c7 = function(param) {
    var location = param.location, filterData = param.filterData;
    return function(data) {
        var isPostalCodesSearch = !isNaN(Number(location));
        if (isPostalCodesSearch) {
            var portFilteredData = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, data), {
                ports: []
            });
            return filterData ? filterData(portFilteredData) : portFilteredData;
        }
        return filterData ? filterData(data) : data;
    };
};
var $682e17d971f7dc71$export$16b26cd5e98d9100 = function(param) {
    var fieldValue = param.fieldValue, defaultIcon = param.defaultIcon;
    if (!fieldValue) return defaultIcon;
    var location = fieldValue.location;
    if ((0, $3180d1e7f238f266$export$a9044a10e5a81ea2)(location) || (0, $3180d1e7f238f266$export$a955beec2ab2c25)(location)) return $682e17d971f7dc71$var$_CityIcon || ($682e17d971f7dc71$var$_CityIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $d7c647944443c879$export$51350e40f7f9c1b6), {}));
    if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(location)) return $682e17d971f7dc71$var$_AnchorIcon || ($682e17d971f7dc71$var$_AnchorIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $8386a560313a79fd$export$ce7fcac6feb8c2f4), {}));
    if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(location)) return $682e17d971f7dc71$var$_PlaneFrontIcon || ($682e17d971f7dc71$var$_PlaneFrontIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $88e36859d8fa0f7f$export$e9fd8dbbd0edb147), {}));
    return defaultIcon;
};
var $682e17d971f7dc71$export$fd5d2cd02be3d52a = function(param) {
    var location = param.location, showDropdown = param.showDropdown;
    return location ? !showDropdown ? /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsIcons.FlagIcon), {
        size: 20,
        code: location.country.iso_code.toLowerCase()
    }) : $682e17d971f7dc71$var$_RectangleIcon || ($682e17d971f7dc71$var$_RectangleIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $562de9c9463b2423$export$f4ef0608819d0751), {})) : undefined;
};
var $682e17d971f7dc71$export$532f543aea3ddcec = function(data) {
    var _data_ports, _data_cities, _data_postalCodes;
    return ((data === null || data === void 0 ? void 0 : (_data_ports = data.ports) === null || _data_ports === void 0 ? void 0 : _data_ports.length) || 0) + ((data === null || data === void 0 ? void 0 : (_data_cities = data.cities) === null || _data_cities === void 0 ? void 0 : _data_cities.length) || 0) + ((data === null || data === void 0 ? void 0 : (_data_postalCodes = data.postalCodes) === null || _data_postalCodes === void 0 ? void 0 : _data_postalCodes.length) || 0);
};
var $682e17d971f7dc71$export$ed312a418caf9500 = function(data) {
    var _data_airports, _data_cities, _data_postalCodes;
    return ((data === null || data === void 0 ? void 0 : (_data_airports = data.airports) === null || _data_airports === void 0 ? void 0 : _data_airports.length) || 0) + ((data === null || data === void 0 ? void 0 : (_data_cities = data.cities) === null || _data_cities === void 0 ? void 0 : _data_cities.length) || 0) + ((data === null || data === void 0 ? void 0 : (_data_postalCodes = data.postalCodes) === null || _data_postalCodes === void 0 ? void 0 : _data_postalCodes.length) || 0);
};
var $682e17d971f7dc71$export$d7475e926d4007d7 = function(param) {
    var shipmentType = param.shipmentType, getPlacesIsLoading = param.getPlacesIsLoading, airData = param.airData, oceanData = param.oceanData, inlandData = param.inlandData;
    var _airData_cities, _airData_postalCodes, _airData_airports, _inlandData_cities, _inlandData_postalCodes, _inlandData_ports, _oceanData_cities, _oceanData_postalCodes, _oceanData_ports;
    var hasResultsAir = !getPlacesIsLoading && (Boolean(airData === null || airData === void 0 ? void 0 : (_airData_cities = airData.cities) === null || _airData_cities === void 0 ? void 0 : _airData_cities.length) || Boolean(airData === null || airData === void 0 ? void 0 : (_airData_postalCodes = airData.postalCodes) === null || _airData_postalCodes === void 0 ? void 0 : _airData_postalCodes.length) || Boolean(airData === null || airData === void 0 ? void 0 : (_airData_airports = airData.airports) === null || _airData_airports === void 0 ? void 0 : _airData_airports.length));
    var hasResultsInland = !getPlacesIsLoading && (Boolean(inlandData === null || inlandData === void 0 ? void 0 : (_inlandData_cities = inlandData.cities) === null || _inlandData_cities === void 0 ? void 0 : _inlandData_cities.length) || Boolean(inlandData === null || inlandData === void 0 ? void 0 : (_inlandData_postalCodes = inlandData.postalCodes) === null || _inlandData_postalCodes === void 0 ? void 0 : _inlandData_postalCodes.length) || Boolean(inlandData === null || inlandData === void 0 ? void 0 : (_inlandData_ports = inlandData.ports) === null || _inlandData_ports === void 0 ? void 0 : _inlandData_ports.length));
    var hasResultsOcean = !getPlacesIsLoading && (Boolean(oceanData === null || oceanData === void 0 ? void 0 : (_oceanData_cities = oceanData.cities) === null || _oceanData_cities === void 0 ? void 0 : _oceanData_cities.length) || Boolean(oceanData === null || oceanData === void 0 ? void 0 : (_oceanData_postalCodes = oceanData.postalCodes) === null || _oceanData_postalCodes === void 0 ? void 0 : _oceanData_postalCodes.length) || Boolean(oceanData === null || oceanData === void 0 ? void 0 : (_oceanData_ports = oceanData.ports) === null || _oceanData_ports === void 0 ? void 0 : _oceanData_ports.length));
    if ((0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType)) return hasResultsAir;
    if ((0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType)) return hasResultsOcean;
    return hasResultsInland;
};
var $682e17d971f7dc71$export$3e1bb248c97deb14 = function(param) {
    var location = param.location, shipmentType = param.shipmentType, getPlacesIsLoading = param.getPlacesIsLoading, airData = param.airData, oceanData = param.oceanData, inlandData = param.inlandData;
    var _airData_cities, _airData_postalCodes, _airData_airports, _oceanData_cities, _oceanData_postalCodes, _oceanData_ports, _inlandData_cities, _inlandData_postalCodes, _inlandData_ports;
    var noResultsAir = location.length >= (0, $f9f89a5c82b78d91$export$f56c1bb712b9ef86) && !getPlacesIsLoading && !(airData === null || airData === void 0 ? void 0 : (_airData_cities = airData.cities) === null || _airData_cities === void 0 ? void 0 : _airData_cities.length) && !(airData === null || airData === void 0 ? void 0 : (_airData_postalCodes = airData.postalCodes) === null || _airData_postalCodes === void 0 ? void 0 : _airData_postalCodes.length) && !(airData === null || airData === void 0 ? void 0 : (_airData_airports = airData.airports) === null || _airData_airports === void 0 ? void 0 : _airData_airports.length);
    var noResultsOcean = location.length >= (0, $f9f89a5c82b78d91$export$f56c1bb712b9ef86) && !getPlacesIsLoading && !(oceanData === null || oceanData === void 0 ? void 0 : (_oceanData_cities = oceanData.cities) === null || _oceanData_cities === void 0 ? void 0 : _oceanData_cities.length) && !(oceanData === null || oceanData === void 0 ? void 0 : (_oceanData_postalCodes = oceanData.postalCodes) === null || _oceanData_postalCodes === void 0 ? void 0 : _oceanData_postalCodes.length) && !(oceanData === null || oceanData === void 0 ? void 0 : (_oceanData_ports = oceanData.ports) === null || _oceanData_ports === void 0 ? void 0 : _oceanData_ports.length);
    var noResultsInland = location.length >= (0, $f9f89a5c82b78d91$export$f56c1bb712b9ef86) && !getPlacesIsLoading && !(inlandData === null || inlandData === void 0 ? void 0 : (_inlandData_cities = inlandData.cities) === null || _inlandData_cities === void 0 ? void 0 : _inlandData_cities.length) && !(inlandData === null || inlandData === void 0 ? void 0 : (_inlandData_postalCodes = inlandData.postalCodes) === null || _inlandData_postalCodes === void 0 ? void 0 : _inlandData_postalCodes.length) && !(inlandData === null || inlandData === void 0 ? void 0 : (_inlandData_ports = inlandData.ports) === null || _inlandData_ports === void 0 ? void 0 : _inlandData_ports.length);
    if ((0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType)) return noResultsAir;
    if ((0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType)) return noResultsOcean;
    return noResultsInland;
};
var $682e17d971f7dc71$export$9d21764db6a10cc5 = function(location) {
    if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(location)) return location.iata;
    if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(location)) return location.portIsoCode;
    return location.postalCode;
};
var $682e17d971f7dc71$var$getLocationName = function(location) {
    return (0, $3180d1e7f238f266$export$a955beec2ab2c25)(location) ? (0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.city) : (0, $175d32ef213a5811$export$da1ec1d734312f9f)(location.name);
};
var $682e17d971f7dc71$export$4b95bdce9530e08f = function(location) {
    return [
        $682e17d971f7dc71$export$28847e597a13c9f6(location),
        location.country.iso_code.toUpperCase()
    ].filter(Boolean).join(", ");
};
var $682e17d971f7dc71$export$28847e597a13c9f6 = function(location) {
    return [
        $682e17d971f7dc71$export$9d21764db6a10cc5(location),
        $682e17d971f7dc71$var$getLocationName(location)
    ].filter(Boolean).join(", ");
};
var $682e17d971f7dc71$export$ed9c6b84996f05c7 = function(location) {
    return {
        displayName: $682e17d971f7dc71$export$28847e597a13c9f6(location),
        fullName: $682e17d971f7dc71$export$4b95bdce9530e08f(location),
        countryCode: location.country.iso_code,
        showTooltip: false
    };
};
var $682e17d971f7dc71$export$9329d42ccc5a0797 = function(item, t) {
    if ((0, $84c96a688242bcfe$export$32aa3057966bf054)(item)) return [
        {
            label: "".concat(item.quantity).concat(t("cargoDetails.pc", {
                count: item.quantity
            }), ", ").concat(item.length, "x").concat(item.width, "x").concat(item.height, " ").concat(item.lengthUnit, ", ").concat(item.weight, " ").concat(item.weightUnit)
        }
    ];
    if ((0, $84c96a688242bcfe$export$5f03b9f28d71ed92)(item)) return [
        {
            label: "".concat(item.totalWeight, " ").concat(item.weightUnit)
        },
        {
            label: "".concat(item.totalVolume, " ").concat(item.volumeUnit)
        }
    ];
    if (item.type) {
        var label = t("cargoDetails.containerTypes.".concat(item.type));
        return [
            {
                label: "".concat(item.quantity, "x").concat(label)
            }
        ];
    }
    return [];
};
var $682e17d971f7dc71$export$ec0b3085240c08d1 = function(param) {
    var items = param.items, t = param.t, setRecentSearch = param.setRecentSearch;
    return items.map(function(item, index) {
        var tags = [];
        tags.push({
            label: item.shipmentType
        });
        if (item.items.length > 1) tags.push({
            label: t("cargoDetails.multiple")
        });
        if (item.items.length === 1) {
            var _item_items = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))(item.items, 1), i = _item_items[0];
            var cargoItems = $682e17d971f7dc71$export$9329d42ccc5a0797(i, t);
            cargoItems.forEach(function(item) {
                return tags.push(item);
            });
        }
        return {
            id: "recent-search-item-".concat(index),
            origin: $682e17d971f7dc71$export$ed9c6b84996f05c7(item.origin),
            destination: $682e17d971f7dc71$export$ed9c6b84996f05c7(item.destination),
            tags: tags,
            onClick: setRecentSearch(index, item.shipmentType)
        };
    });
};
var $682e17d971f7dc71$export$db9c6222aaa5f276 = function(inputRef) {
    var _inputRef_current;
    (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
};
var $682e17d971f7dc71$export$26950cde0cfb976c = function(showRecentSearches, sendMixpanelEvents) {
    return function() {
        if (showRecentSearches) (0, $068a6aa0fda9c13f$export$8b9ed055bf3cbcae)({
            sendMixpanelEvents: sendMixpanelEvents
        });
    };
};
var $682e17d971f7dc71$export$6725683ce026c4e6 = function(param) {
    var mostSearched = param.mostSearched, allowRecentsDropdown = param.allowRecentsDropdown, focus = param.focus, isMobile = param.isMobile, location = param.location, setRecentSearch = param.setRecentSearch;
    return Boolean(allowRecentsDropdown && (focus || isMobile) && location.length === 0 && mostSearched && Boolean(mostSearched.quotedTradelines.length) && setRecentSearch);
};
var $682e17d971f7dc71$export$688fd50b712eda4a = function(location) {
    return Boolean(location && [
        "CITY",
        "POSTAL_CODE"
    ].includes(location.type) && location.country.iso_code !== "AE");
};





var $cdcff8464a500c71$export$679d5a433bde0204 = function(param) {
    var hasResults = param.hasResults, fieldValue = param.fieldValue, location = param.location, type = param.type, places = param.places, sendGA4Events = param.sendGA4Events;
    return function() {
        if (hasResults && !fieldValue && location.length > 0) {
            if (sendGA4Events) (0, $ceb0c600e8f2a76d$export$273319d78db9f18d)({
                location: location,
                type: type,
                places: places
            });
        }
    };
};


var $401ce97109e5a696$export$dc4e317433c6fe09 = function(param) {
    var shipmentType = param.shipmentType, getPlacesIsLoading = param.getPlacesIsLoading, location = param.location, type = param.type, airData = param.airData, oceanData = param.oceanData, sendGA4Events = param.sendGA4Events, fieldValue = param.fieldValue, hasResults = param.hasResults, inlandData = param.inlandData;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(""), 2), longestLocation = _useState[0], setLongestLocation = _useState[1];
    var _useState1 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), airDataForLongestLocation = _useState1[0], setAirDataForLongestLocation = _useState1[1];
    var _useState2 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), oceanDataForLongestLocation = _useState2[0], setOceanDataForLongestLocation = _useState2[1];
    var _useState3 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), inlandDataForLongestLocation = _useState3[0], setInlandDataForLongestLocation = _useState3[1];
    var hasResultsForLongestLocation = (0, $682e17d971f7dc71$export$d7475e926d4007d7)({
        shipmentType: shipmentType,
        getPlacesIsLoading: getPlacesIsLoading,
        airData: airDataForLongestLocation,
        oceanData: oceanDataForLongestLocation,
        inlandData: inlandDataForLongestLocation
    });
    (0, $fZLIC$react.useEffect)(function() {
        if (longestLocation.length <= location.length) setLongestLocation(location);
    }, [
        longestLocation,
        location
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        if (longestLocation.length === location.length && (0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType)) setAirDataForLongestLocation(airData);
        if (longestLocation.length === location.length && (0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType)) setOceanDataForLongestLocation(oceanData);
        if (longestLocation.length === location.length && (0, $84c96a688242bcfe$export$119990892388fa74)(shipmentType)) setInlandDataForLongestLocation(inlandData);
    }, [
        airData,
        shipmentType,
        location.length,
        longestLocation.length,
        oceanData,
        inlandData
    ]);
    // send event in case user enters a text, then the dropdown is shown with data for longest location
    // and finally user removes the text until the string is empty
    (0, $fZLIC$react.useEffect)(function() {
        if (location.length === 0 && longestLocation.length > 0 && hasResultsForLongestLocation) {
            if (sendGA4Events) {
                var places;
                if ((0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType)) places = airDataForLongestLocation;
                if ((0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType)) places = oceanDataForLongestLocation;
                if ((0, $84c96a688242bcfe$export$119990892388fa74)(shipmentType)) places = inlandDataForLongestLocation;
                (0, $ceb0c600e8f2a76d$export$273319d78db9f18d)({
                    location: longestLocation,
                    type: type,
                    places: places
                });
            }
            setLongestLocation("");
        }
    }, [
        airDataForLongestLocation,
        hasResultsForLongestLocation,
        shipmentType,
        location.length,
        longestLocation,
        oceanDataForLongestLocation,
        sendGA4Events,
        type
    ]);
    // send event in case user searches and then closes page without selecting anything
    (0, $fZLIC$react.useEffect)(function() {
        var unloadCallback = (0, $cdcff8464a500c71$export$679d5a433bde0204)({
            hasResults: hasResults,
            fieldValue: fieldValue,
            location: location,
            type: type,
            places: (0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType) ? airData : oceanData,
            sendGA4Events: sendGA4Events
        });
        window.addEventListener("beforeunload", unloadCallback);
        return function() {
            return window.removeEventListener("beforeunload", unloadCallback);
        };
    }, [
        airData,
        fieldValue,
        hasResults,
        shipmentType,
        location,
        oceanData,
        sendGA4Events,
        type
    ]);
    var sendLocationNotSelectedEvent = (0, $fZLIC$react.useCallback)(function() {
        var places;
        if ((0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType)) places = airData;
        if ((0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType)) places = oceanData;
        if ((0, $84c96a688242bcfe$export$119990892388fa74)(shipmentType)) places = inlandData;
        return (0, $cdcff8464a500c71$export$679d5a433bde0204)({
            hasResults: hasResults,
            fieldValue: fieldValue,
            location: location,
            type: type,
            places: places,
            sendGA4Events: sendGA4Events
        })();
    }, [
        airData,
        fieldValue,
        hasResults,
        shipmentType,
        location,
        oceanData,
        sendGA4Events,
        type
    ]);
    return {
        sendLocationNotSelectedEvent: sendLocationNotSelectedEvent,
        setLongestLocation: setLongestLocation
    };
};













var $34bfc6d8ae80c5eb$export$4d78c43b7fa734a7 = [
    {
        iso_code: "AX",
        display_name: "AALAND ISLANDS",
        phone_code: null
    },
    {
        iso_code: "AF",
        display_name: "AFGHANISTAN, ISLAMIC STATE OF",
        phone_code: 93
    },
    {
        iso_code: "AL",
        display_name: "ALBANIA",
        phone_code: 355
    },
    {
        iso_code: "DZ",
        display_name: "ALGERIA",
        phone_code: 213
    },
    {
        iso_code: "AS",
        display_name: "AMERICAN SAMOA",
        phone_code: null
    },
    {
        iso_code: "AD",
        display_name: "ANDORRA",
        phone_code: 376
    },
    {
        iso_code: "AO",
        display_name: "ANGOLA",
        phone_code: 244
    },
    {
        iso_code: "AI",
        display_name: "ANGUILLA",
        phone_code: null
    },
    {
        iso_code: "AQ",
        display_name: "ANTARCTICA",
        phone_code: null
    },
    {
        iso_code: "AG",
        display_name: "ANTIGUA AND BARBUDA",
        phone_code: null
    },
    {
        iso_code: "AR",
        display_name: "ARGENTINA",
        phone_code: 54
    },
    {
        iso_code: "AM",
        display_name: "ARMENIA",
        phone_code: 374
    },
    {
        iso_code: "AW",
        display_name: "ARUBA",
        phone_code: 297
    },
    {
        iso_code: "AU",
        display_name: "AUSTRALIA",
        phone_code: 61
    },
    {
        iso_code: "AT",
        display_name: "AUSTRIA",
        phone_code: 43
    },
    {
        iso_code: "AZ",
        display_name: "AZERBAIDJAN",
        phone_code: 994
    },
    {
        iso_code: "BS",
        display_name: "BAHAMAS",
        phone_code: null
    },
    {
        iso_code: "BH",
        display_name: "BAHRAIN",
        phone_code: 973
    },
    {
        iso_code: "BD",
        display_name: "BANGLADESH",
        phone_code: 880
    },
    {
        iso_code: "BB",
        display_name: "BARBADOS",
        phone_code: null
    },
    {
        iso_code: "BY",
        display_name: "BELARUS",
        phone_code: 375
    },
    {
        iso_code: "BE",
        display_name: "BELGIUM",
        phone_code: 32
    },
    {
        iso_code: "BZ",
        display_name: "BELIZE",
        phone_code: 501
    },
    {
        iso_code: "BJ",
        display_name: "BENIN",
        phone_code: 229
    },
    {
        iso_code: "BM",
        display_name: "BERMUDA",
        phone_code: null
    },
    {
        iso_code: "BT",
        display_name: "BHUTAN",
        phone_code: 975
    },
    {
        iso_code: "BO",
        display_name: "BOLIVIA",
        phone_code: 591
    },
    {
        iso_code: "BQ",
        display_name: "BONAIRE, SAINT EUSTATIUS AND SABA ",
        phone_code: 599
    },
    {
        iso_code: "BA",
        display_name: "BOSNIA-HERZEGOVINA",
        phone_code: 387
    },
    {
        iso_code: "BW",
        display_name: "BOTSWANA",
        phone_code: 267
    },
    {
        iso_code: "BV",
        display_name: "BOUVET ISLAND",
        phone_code: null
    },
    {
        iso_code: "BR",
        display_name: "BRAZIL",
        phone_code: 55
    },
    {
        iso_code: "IO",
        display_name: "BRITISH INDIAN OCEAN TERRITOR",
        phone_code: 246
    },
    {
        iso_code: "BN",
        display_name: "BRUNEI DARUSSALAM",
        phone_code: 673
    },
    {
        iso_code: "BG",
        display_name: "BULGARIA",
        phone_code: 359
    },
    {
        iso_code: "BF",
        display_name: "BURKINA FASO",
        phone_code: 226
    },
    {
        iso_code: "BI",
        display_name: "BURUNDI",
        phone_code: 257
    },
    {
        iso_code: "KH",
        display_name: "CAMBODIA, KINGDOM OF",
        phone_code: 855
    },
    {
        iso_code: "CM",
        display_name: "CAMEROON",
        phone_code: 237
    },
    {
        iso_code: "CA",
        display_name: "CANADA",
        phone_code: 1
    },
    {
        iso_code: "CV",
        display_name: "CAPE VERDE",
        phone_code: 238
    },
    {
        iso_code: "KY",
        display_name: "CAYMAN ISLANDS",
        phone_code: null
    },
    {
        iso_code: "CF",
        display_name: "CENTRAL AFRICAN REPUBLIC",
        phone_code: 236
    },
    {
        iso_code: "TD",
        display_name: "CHAD",
        phone_code: 235
    },
    {
        iso_code: "CL",
        display_name: "CHILE",
        phone_code: 56
    },
    {
        iso_code: "CN",
        display_name: "CHINA",
        phone_code: 86
    },
    {
        iso_code: "CX",
        display_name: "CHRISTMAS ISLAND",
        phone_code: 61
    },
    {
        iso_code: "CC",
        display_name: "COCOS (KEELING) ISLANDS",
        phone_code: 61
    },
    {
        iso_code: "CO",
        display_name: "COLOMBIA",
        phone_code: 57
    },
    {
        iso_code: "KM",
        display_name: "COMOROS",
        phone_code: 269
    },
    {
        iso_code: "CG",
        display_name: "CONGO",
        phone_code: 242
    },
    {
        iso_code: "CK",
        display_name: "COOK ISLANDS",
        phone_code: 682
    },
    {
        iso_code: "CR",
        display_name: "COSTA RICA",
        phone_code: 506
    },
    {
        iso_code: "HR",
        display_name: "CROATIA",
        phone_code: 385
    },
    {
        iso_code: "CU",
        display_name: "CUBA",
        phone_code: 53
    },
    {
        iso_code: "CW",
        display_name: "CURACAO",
        phone_code: 599
    },
    {
        iso_code: "CY",
        display_name: "CYPRUS",
        phone_code: 357
    },
    {
        iso_code: "CZ",
        display_name: "CZECH REPUBLIC",
        phone_code: 420
    },
    {
        iso_code: "CD",
        display_name: "DEMOCRATIC REPUBLIC OF CONGO",
        phone_code: 243
    },
    {
        iso_code: "DK",
        display_name: "DENMARK",
        phone_code: 45
    },
    {
        iso_code: "DJ",
        display_name: "DJIBOUTI",
        phone_code: 253
    },
    {
        iso_code: "DM",
        display_name: "DOMINICA",
        phone_code: null
    },
    {
        iso_code: "DO",
        display_name: "DOMINICAN REPUBLIC",
        phone_code: 1
    },
    {
        iso_code: "TP",
        display_name: "EAST TIMOR",
        phone_code: null
    },
    {
        iso_code: "TL",
        display_name: "EAST TIMOR",
        phone_code: 670
    },
    {
        iso_code: "EC",
        display_name: "ECUADOR",
        phone_code: 593
    },
    {
        iso_code: "EG",
        display_name: "EGYPT",
        phone_code: 20
    },
    {
        iso_code: "SV",
        display_name: "EL SALVADOR",
        phone_code: 503
    },
    {
        iso_code: "GQ",
        display_name: "EQUATORIAL GUINEA",
        phone_code: 240
    },
    {
        iso_code: "ER",
        display_name: "ERITREA",
        phone_code: 291
    },
    {
        iso_code: "EE",
        display_name: "ESTONIA",
        phone_code: 372
    },
    {
        iso_code: "ET",
        display_name: "ETHIOPIA",
        phone_code: 251
    },
    {
        iso_code: "FK",
        display_name: "FALKLAND ISLANDS",
        phone_code: 500
    },
    {
        iso_code: "FO",
        display_name: "FAROE ISLANDS",
        phone_code: 298
    },
    {
        iso_code: "FJ",
        display_name: "FIJI ISLANDS",
        phone_code: 679
    },
    {
        iso_code: "FI",
        display_name: "FINLAND",
        phone_code: 358
    },
    {
        iso_code: "CS",
        display_name: "FORMER CZECHOSLOVAKIA",
        phone_code: 381
    },
    {
        iso_code: "SU",
        display_name: "FORMER USSR",
        phone_code: null
    },
    {
        iso_code: "FR",
        display_name: "FRANCE",
        phone_code: 33
    },
    {
        iso_code: "GF",
        display_name: "FRENCH GUYANA",
        phone_code: 594
    },
    {
        iso_code: "TF",
        display_name: "FRENCH SOUTHERN TERRITORIES",
        phone_code: null
    },
    {
        iso_code: "GA",
        display_name: "GABON",
        phone_code: 241
    },
    {
        iso_code: "GM",
        display_name: "GAMBIA",
        phone_code: 220
    },
    {
        iso_code: "GE",
        display_name: "GEORGIA",
        phone_code: 995
    },
    {
        iso_code: "DE",
        display_name: "GERMANY",
        phone_code: 49
    },
    {
        iso_code: "GH",
        display_name: "GHANA",
        phone_code: 233
    },
    {
        iso_code: "GI",
        display_name: "GIBRALTAR",
        phone_code: 350
    },
    {
        iso_code: "GR",
        display_name: "GREECE",
        phone_code: 30
    },
    {
        iso_code: "GL",
        display_name: "GREENLAND",
        phone_code: 299
    },
    {
        iso_code: "GD",
        display_name: "GRENADA",
        phone_code: null
    },
    {
        iso_code: "GP",
        display_name: "GUADELOUPE (FRENCH)",
        phone_code: 590
    },
    {
        iso_code: "GU",
        display_name: "GUAM (USA)",
        phone_code: null
    },
    {
        iso_code: "GT",
        display_name: "GUATEMALA",
        phone_code: 502
    },
    {
        iso_code: "GN",
        display_name: "GUINEA",
        phone_code: 224
    },
    {
        iso_code: "GW",
        display_name: "GUINEA BISSAU",
        phone_code: 245
    },
    {
        iso_code: "GY",
        display_name: "GUYANA",
        phone_code: 592
    },
    {
        iso_code: "HT",
        display_name: "HAITI",
        phone_code: 509
    },
    {
        iso_code: "HM",
        display_name: "HEARD AND MCDONALD ISLANDS",
        phone_code: null
    },
    {
        iso_code: "VA",
        display_name: "HOLY SEE (VATICAN CITY STATE)",
        phone_code: 379
    },
    {
        iso_code: "HN",
        display_name: "HONDURAS",
        phone_code: 504
    },
    {
        iso_code: "HK",
        display_name: "HONG KONG",
        phone_code: 852
    },
    {
        iso_code: "HU",
        display_name: "HUNGARY",
        phone_code: 36
    },
    {
        iso_code: "IS",
        display_name: "ICELAND",
        phone_code: 354
    },
    {
        iso_code: "IN",
        display_name: "INDIA",
        phone_code: 91
    },
    {
        iso_code: "ID",
        display_name: "INDONESIA",
        phone_code: 62
    },
    {
        iso_code: "IR",
        display_name: "IRAN",
        phone_code: 98
    },
    {
        iso_code: "IQ",
        display_name: "IRAQ",
        phone_code: 964
    },
    {
        iso_code: "IE",
        display_name: "IRELAND",
        phone_code: 353
    },
    {
        iso_code: "IL",
        display_name: "ISRAEL",
        phone_code: 972
    },
    {
        iso_code: "IT",
        display_name: "ITALY",
        phone_code: 39
    },
    {
        iso_code: "CI",
        display_name: "IVORY COAST",
        phone_code: 225
    },
    {
        iso_code: "JM",
        display_name: "JAMAICA",
        phone_code: null
    },
    {
        iso_code: "JP",
        display_name: "JAPAN",
        phone_code: 81
    },
    {
        iso_code: "JO",
        display_name: "JORDAN",
        phone_code: 962
    },
    {
        iso_code: "KZ",
        display_name: "KAZAKHSTAN",
        phone_code: 7
    },
    {
        iso_code: "KE",
        display_name: "KENYA",
        phone_code: 254
    },
    {
        iso_code: "KI",
        display_name: "KIRIBATI",
        phone_code: 686
    },
    {
        iso_code: "KW",
        display_name: "KUWAIT",
        phone_code: 965
    },
    {
        iso_code: "KG",
        display_name: "KYRGYZ REPUBLIC (KYRGYZSTAN)",
        phone_code: 996
    },
    {
        iso_code: "LA",
        display_name: "LAOS",
        phone_code: 856
    },
    {
        iso_code: "LV",
        display_name: "LATVIA",
        phone_code: 371
    },
    {
        iso_code: "LB",
        display_name: "LEBANON",
        phone_code: 961
    },
    {
        iso_code: "LS",
        display_name: "LESOTHO",
        phone_code: 266
    },
    {
        iso_code: "LR",
        display_name: "LIBERIA",
        phone_code: 231
    },
    {
        iso_code: "LY",
        display_name: "LIBYA",
        phone_code: 218
    },
    {
        iso_code: "LI",
        display_name: "LIECHTENSTEIN",
        phone_code: 423
    },
    {
        iso_code: "LT",
        display_name: "LITHUANIA",
        phone_code: 370
    },
    {
        iso_code: "LU",
        display_name: "LUXEMBOURG",
        phone_code: 352
    },
    {
        iso_code: "MO",
        display_name: "MACAU",
        phone_code: 853
    },
    {
        iso_code: "MK",
        display_name: "MACEDONIA",
        phone_code: 389
    },
    {
        iso_code: "MG",
        display_name: "MADAGASCAR",
        phone_code: 261
    },
    {
        iso_code: "MW",
        display_name: "MALAWI",
        phone_code: 265
    },
    {
        iso_code: "MY",
        display_name: "MALAYSIA",
        phone_code: 60
    },
    {
        iso_code: "MV",
        display_name: "MALDIVES",
        phone_code: 960
    },
    {
        iso_code: "ML",
        display_name: "MALI",
        phone_code: 223
    },
    {
        iso_code: "MT",
        display_name: "MALTA",
        phone_code: 356
    },
    {
        iso_code: "MH",
        display_name: "MARSHALL ISLANDS",
        phone_code: 692
    },
    {
        iso_code: "MQ",
        display_name: "MARTINIQUE (FRENCH)",
        phone_code: 596
    },
    {
        iso_code: "MR",
        display_name: "MAURITANIA",
        phone_code: 222
    },
    {
        iso_code: "MU",
        display_name: "MAURITIUS",
        phone_code: 230
    },
    {
        iso_code: "YT",
        display_name: "MAYOTTE",
        phone_code: 262
    },
    {
        iso_code: "MX",
        display_name: "MEXICO",
        phone_code: 52
    },
    {
        iso_code: "FM",
        display_name: "MICRONESIA",
        phone_code: 691
    },
    {
        iso_code: "MD",
        display_name: "MOLDAVIA",
        phone_code: 373
    },
    {
        iso_code: "MC",
        display_name: "MONACO",
        phone_code: 377
    },
    {
        iso_code: "MN",
        display_name: "MONGOLIA",
        phone_code: 976
    },
    {
        iso_code: "ME",
        display_name: "MONTENEGRO",
        phone_code: 382
    },
    {
        iso_code: "MS",
        display_name: "MONTSERRAT",
        phone_code: null
    },
    {
        iso_code: "MA",
        display_name: "MOROCCO",
        phone_code: 212
    },
    {
        iso_code: "MZ",
        display_name: "MOZAMBIQUE",
        phone_code: 258
    },
    {
        iso_code: "MM",
        display_name: "MYANMAR",
        phone_code: 95
    },
    {
        iso_code: "NA",
        display_name: "NAMIBIA",
        phone_code: 264
    },
    {
        iso_code: "NR",
        display_name: "NAURU",
        phone_code: 674
    },
    {
        iso_code: "NP",
        display_name: "NEPAL",
        phone_code: 977
    },
    {
        iso_code: "NL",
        display_name: "NETHERLANDS",
        phone_code: 31
    },
    {
        iso_code: "AN",
        display_name: "NETHERLANDS ANTILLES",
        phone_code: 599
    },
    {
        iso_code: "NT",
        display_name: "NEUTRAL ZONE",
        phone_code: null
    },
    {
        iso_code: "NC",
        display_name: "NEW CALEDONIA (FRENCH)",
        phone_code: 687
    },
    {
        iso_code: "NZ",
        display_name: "NEW ZEALAND",
        phone_code: 64
    },
    {
        iso_code: "NI",
        display_name: "NICARAGUA",
        phone_code: 505
    },
    {
        iso_code: "NE",
        display_name: "NIGER",
        phone_code: 227
    },
    {
        iso_code: "NG",
        display_name: "NIGERIA",
        phone_code: 234
    },
    {
        iso_code: "NU",
        display_name: "NIUE",
        phone_code: 683
    },
    {
        iso_code: "UN",
        display_name: "NIUE ISLAND",
        phone_code: null
    },
    {
        iso_code: "NF",
        display_name: "NORFOLK ISLAND",
        phone_code: 672
    },
    {
        iso_code: "MP",
        display_name: "NORTHERN MARIANA ISLANDS",
        phone_code: null
    },
    {
        iso_code: "KP",
        display_name: "NORTH KOREA",
        phone_code: 850
    },
    {
        iso_code: "NO",
        display_name: "NORWAY",
        phone_code: 47
    },
    {
        iso_code: "OM",
        display_name: "OMAN",
        phone_code: 968
    },
    {
        iso_code: "PK",
        display_name: "PAKISTAN",
        phone_code: 92
    },
    {
        iso_code: "PW",
        display_name: "PALAU",
        phone_code: 680
    },
    {
        iso_code: "PS",
        display_name: "PALESTINIAN TERRITORY",
        phone_code: 970
    },
    {
        iso_code: "PA",
        display_name: "PANAMA",
        phone_code: 507
    },
    {
        iso_code: "PG",
        display_name: "PAPUA NEW GUINEA",
        phone_code: 675
    },
    {
        iso_code: "PY",
        display_name: "PARAGUAY",
        phone_code: 595
    },
    {
        iso_code: "PE",
        display_name: "PERU",
        phone_code: 51
    },
    {
        iso_code: "PH",
        display_name: "PHILIPPINES",
        phone_code: 63
    },
    {
        iso_code: "PN",
        display_name: "PITCAIRN ISLAND",
        phone_code: 870
    },
    {
        iso_code: "PL",
        display_name: "POLAND",
        phone_code: 48
    },
    {
        iso_code: "PF",
        display_name: "POLYNESIA (FRENCH)",
        phone_code: 689
    },
    {
        iso_code: "PT",
        display_name: "PORTUGAL",
        phone_code: 351
    },
    {
        iso_code: "PR",
        display_name: "PUERTO RICO",
        phone_code: null
    },
    {
        iso_code: "QA",
        display_name: "QATAR",
        phone_code: 974
    },
    {
        iso_code: "RE",
        display_name: "REUNION",
        phone_code: 262
    },
    {
        iso_code: "RI",
        display_name: "REUNION ISLAND",
        phone_code: 262
    },
    {
        iso_code: "RO",
        display_name: "ROMANIA",
        phone_code: 40
    },
    {
        iso_code: "RU",
        display_name: "RUSSIAN FEDERATION",
        phone_code: 7
    },
    {
        iso_code: "RW",
        display_name: "RWANDA",
        phone_code: 250
    },
    {
        iso_code: "SH",
        display_name: "SAINT HELENA",
        phone_code: 290
    },
    {
        iso_code: "KN",
        display_name: "SAINT KITTS & NEVIS ANGUILLA",
        phone_code: null
    },
    {
        iso_code: "LC",
        display_name: "SAINT LUCIA",
        phone_code: null
    },
    {
        iso_code: "PM",
        display_name: "SAINT PIERRE AND MIQUELON",
        phone_code: 508
    },
    {
        iso_code: "ST",
        display_name: "SAINT TOME",
        phone_code: 239
    },
    {
        iso_code: "VC",
        display_name: "SAINT VINCENT & GRENADINES",
        phone_code: null
    },
    {
        iso_code: "WS",
        display_name: "SAMOA",
        phone_code: 685
    },
    {
        iso_code: "SM",
        display_name: "SAN MARINO",
        phone_code: 378
    },
    {
        iso_code: "SA",
        display_name: "SAUDI ARABIA",
        phone_code: 966
    },
    {
        iso_code: "SN",
        display_name: "SENEGAL",
        phone_code: 221
    },
    {
        iso_code: "RS",
        display_name: "SERBIA",
        phone_code: 381
    },
    {
        iso_code: "SC",
        display_name: "SEYCHELLES",
        phone_code: 248
    },
    {
        iso_code: "GS",
        display_name: "S. GEORGIA & S. SANDWICH ISLS",
        phone_code: null
    },
    {
        iso_code: "SL",
        display_name: "SIERRA LEONE",
        phone_code: 232
    },
    {
        iso_code: "SG",
        display_name: "SINGAPORE",
        phone_code: 65
    },
    {
        iso_code: "SX",
        display_name: "SINT MAARTEN",
        phone_code: 599
    },
    {
        iso_code: "SK",
        display_name: "SLOVAK REPUBLIC",
        phone_code: 421
    },
    {
        iso_code: "SI",
        display_name: "SLOVENIA",
        phone_code: 386
    },
    {
        iso_code: "SB",
        display_name: "SOLOMON ISLANDS",
        phone_code: 677
    },
    {
        iso_code: "SO",
        display_name: "SOMALIA",
        phone_code: 252
    },
    {
        iso_code: "ZA",
        display_name: "SOUTH AFRICA",
        phone_code: 27
    },
    {
        iso_code: "KR",
        display_name: "SOUTH KOREA",
        phone_code: 82
    },
    {
        iso_code: "ES",
        display_name: "SPAIN",
        phone_code: 34
    },
    {
        iso_code: "LK",
        display_name: "SRI LANKA",
        phone_code: 94
    },
    {
        iso_code: "SD",
        display_name: "SUDAN",
        phone_code: 249
    },
    {
        iso_code: "SR",
        display_name: "SURINAME",
        phone_code: 597
    },
    {
        iso_code: "SJ",
        display_name: "SVALBARD AND JAN MAYEN ISLAND",
        phone_code: 47
    },
    {
        iso_code: "SZ",
        display_name: "SWAZILAND",
        phone_code: 268
    },
    {
        iso_code: "SE",
        display_name: "SWEDEN",
        phone_code: 46
    },
    {
        iso_code: "CH",
        display_name: "SWITZERLAND",
        phone_code: 41
    },
    {
        iso_code: "SY",
        display_name: "SYRIA",
        phone_code: 963
    },
    {
        iso_code: "TJ",
        display_name: "TADJIKISTAN",
        phone_code: 992
    },
    {
        iso_code: "TW",
        display_name: "TAIWAN",
        phone_code: 886
    },
    {
        iso_code: "TZ",
        display_name: "TANZANIA",
        phone_code: 255
    },
    {
        iso_code: "XX",
        display_name: "TENIENTE R MARSH",
        phone_code: null
    },
    {
        iso_code: "TH",
        display_name: "THAILAND",
        phone_code: 66
    },
    {
        iso_code: "TG",
        display_name: "TOGO",
        phone_code: 228
    },
    {
        iso_code: "TK",
        display_name: "TOKELAU",
        phone_code: 690
    },
    {
        iso_code: "TO",
        display_name: "TONGA",
        phone_code: 676
    },
    {
        iso_code: "TT",
        display_name: "TRINIDAD AND TOBAGO",
        phone_code: null
    },
    {
        iso_code: "TN",
        display_name: "TUNISIA",
        phone_code: 216
    },
    {
        iso_code: "TR",
        display_name: "TURKEY",
        phone_code: 90
    },
    {
        iso_code: "TM",
        display_name: "TURKMENISTAN",
        phone_code: 993
    },
    {
        iso_code: "TC",
        display_name: "TURKS AND CAICOS ISLANDS",
        phone_code: null
    },
    {
        iso_code: "TV",
        display_name: "TUVALU",
        phone_code: 688
    },
    {
        iso_code: "UG",
        display_name: "UGANDA",
        phone_code: 256
    },
    {
        iso_code: "UA",
        display_name: "UKRAINE",
        phone_code: 380
    },
    {
        iso_code: "AE",
        display_name: "UNITED ARAB EMIRATES",
        phone_code: 971
    },
    {
        iso_code: "GB",
        display_name: "UNITED KINGDOM",
        phone_code: 44
    },
    {
        iso_code: "US",
        display_name: "UNITED STATES",
        phone_code: 1
    },
    {
        iso_code: "UY",
        display_name: "URUGUAY",
        phone_code: 598
    },
    {
        iso_code: "UM",
        display_name: "USA MINOR OUTLYING ISLANDS",
        phone_code: 1
    },
    {
        iso_code: "UZ",
        display_name: "UZBEKISTAN",
        phone_code: 998
    },
    {
        iso_code: "VU",
        display_name: "VANUATU",
        phone_code: 678
    },
    {
        iso_code: "VE",
        display_name: "VENEZUELA",
        phone_code: 58
    },
    {
        iso_code: "VN",
        display_name: "VIETNAM",
        phone_code: 84
    },
    {
        iso_code: "VG",
        display_name: "VIRGIN ISLANDS (BRITISH)",
        phone_code: null
    },
    {
        iso_code: "VI",
        display_name: "VIRGIN ISLANDS (USA)",
        phone_code: null
    },
    {
        iso_code: "WF",
        display_name: "WALLIS AND FUTUNA ISLANDS",
        phone_code: 681
    },
    {
        iso_code: "EH",
        display_name: "WESTERN SAHARA",
        phone_code: 212
    },
    {
        iso_code: "YE",
        display_name: "YEMEN",
        phone_code: 967
    },
    {
        iso_code: "YU",
        display_name: "YUGOSLAVIA",
        phone_code: null
    },
    {
        iso_code: "ZR",
        display_name: "ZAIRE",
        phone_code: null
    },
    {
        iso_code: "ZM",
        display_name: "ZAMBIA",
        phone_code: 260
    },
    {
        iso_code: "ZW",
        display_name: "ZIMBABWE",
        phone_code: 263
    },
    {
        iso_code: "SS",
        display_name: "SOUTH SUDAN",
        phone_code: null
    },
    {
        iso_code: "MF",
        display_name: "SAINT MARTIN (FRENCH PART)",
        phone_code: null
    },
    {
        iso_code: "BL",
        display_name: "SAINT BARTH\xc9LEMY",
        phone_code: null
    },
    {
        iso_code: "JE",
        display_name: "JERSEY",
        phone_code: null
    },
    {
        iso_code: "IM",
        display_name: "ISLE OF MAN",
        phone_code: null
    },
    {
        iso_code: "XZ",
        display_name: "INSTALLATIONS IN INTERNATIONAL WATERS",
        phone_code: null
    },
    {
        iso_code: "GG",
        display_name: "GUERNSEY",
        phone_code: null
    }
];


var $ad706ddcbbca281c$export$1a7ee011f5f36179 = function(country) {
    return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, country), {
        country: (0, $34bfc6d8ae80c5eb$export$4d78c43b7fa734a7).find(function(c) {
            return c.iso_code.toLowerCase() === country.country.toLowerCase();
        })
    });
};
var $ad706ddcbbca281c$export$7d2c7e4e3be0c527 = function(data) {
    return (data === null || data === void 0 ? void 0 : data.map(function(d) {
        return $ad706ddcbbca281c$export$1a7ee011f5f36179(d);
    }).filter(function(item) {
        return !!item.country;
    })) || [];
};



var $cc89fd61cf30bca7$export$4be65e66cfa2648a = function(name) {
    var nameEQ = "".concat(encodeURIComponent(name), "=");
    var cookies = document.cookie.split("; ");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cookie = _step.value;
            if (cookie.startsWith(nameEQ) && cookie.substring(nameEQ.length) !== null) return decodeURIComponent(cookie.substring(nameEQ.length));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
};
var $cc89fd61cf30bca7$export$110700823644f4a6 = function(name, value) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var cookieString = "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value), ";");
    if (options.expires) {
        var expiresDate = typeof options.expires === "number" ? new Date(Date.now() + options.expires * 86400000) : options.expires;
        cookieString += "expires=".concat(expiresDate.toUTCString(), ";");
    }
    if (options.path) cookieString += "path=".concat(options.path, ";");
    if (options.domain) cookieString += "domain=".concat(options.domain, ";");
    if (options.secure) cookieString += "secure;";
    document.cookie = cookieString;
};
var $cc89fd61cf30bca7$export$6a874b7a74007875 = function(name, path, domain) {
    $cc89fd61cf30bca7$export$110700823644f4a6(name, "", {
        expires: -1,
        path: path,
        domain: domain
    });
};


var $97441b62ecb6ed2c$export$11a51455c5740ca6 = function(authCookieName) {
    var token = authCookieName && (0, $cc89fd61cf30bca7$export$4be65e66cfa2648a)(authCookieName);
    return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, token ? {
        Authorization: "Bearer ".concat(token)
    } : {});
};
var $97441b62ecb6ed2c$export$f672acd9fd097e11 = function(params) {
    var term = params.term, source = params.source, customerType = params.customerType, countryIsoCode = params.countryIsoCode, shipmentType = params.shipmentType;
    // eslint-disable-next-line compat/compat
    var urlSearchParams = new URLSearchParams();
    urlSearchParams.append("term", term);
    urlSearchParams.append("source", source);
    if (shipmentType) urlSearchParams.append("shipment_type", shipmentType);
    if (customerType === "B2C") urlSearchParams.append("customer_type", "B2C");
    if (countryIsoCode) urlSearchParams.append("country_iso_code", countryIsoCode);
    return urlSearchParams.toString();
};


var $08e412b69b47010f$export$c6c960c39e37e610 = {
    422: "INVALID_PAYLOAD",
    500: "INTERNAL_ERROR"
};
var $08e412b69b47010f$export$85f4e47cbf319e2c = function() {
    var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function(params) {
        var name, source, customerType, countryIsoCode, queryParams, _ref, data, status, _MAP_STATUS_TO_ERROR_CODE_status, code, e;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    name = params.name, source = params.source, customerType = params.customerType, countryIsoCode = params.countryIsoCode;
                    queryParams = (0, $97441b62ecb6ed2c$export$f672acd9fd097e11)({
                        term: name,
                        source: source,
                        customerType: customerType,
                        countryIsoCode: countryIsoCode
                    });
                    return [
                        4,
                        (0, ($parcel$interopDefault($fZLIC$axios))).get("/api/v2/locations/aerial/places?".concat(queryParams))
                    ];
                case 1:
                    _ref = _state.sent(), data = _ref.data, status = _ref.status;
                    if (status != 200) {
                        ;
                        code = (_MAP_STATUS_TO_ERROR_CODE_status = $08e412b69b47010f$export$c6c960c39e37e610[status]) !== null && _MAP_STATUS_TO_ERROR_CODE_status !== void 0 ? _MAP_STATUS_TO_ERROR_CODE_status : "UNKNOWN_ERROR";
                        return [
                            2,
                            {
                                errors: [
                                    {
                                        code: code
                                    }
                                ]
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: {
                                cities: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.cities),
                                airports: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.airports),
                                postalCodes: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.postalCodes)
                            }
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            errors: [
                                {
                                    code: "UNKNOWN_ERROR"
                                }
                            ]
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAerialPlaces(params) {
        return _ref.apply(this, arguments);
    };
}();


var $06c905d67e0a0a24$var$_params_countryIsoCode;
var $06c905d67e0a0a24$export$a1e71db47116efb0 = function(params) {
    return "aerial-places-".concat(params.context, "-").concat(params.name, "-").concat(($06c905d67e0a0a24$var$_params_countryIsoCode = params.countryIsoCode) !== null && $06c905d67e0a0a24$var$_params_countryIsoCode !== void 0 ? $06c905d67e0a0a24$var$_params_countryIsoCode : "UNKNOWN_COUNTRY");
};
var $06c905d67e0a0a24$export$77240c5f1f1a6a96 = function(params) {
    return /*#__PURE__*/ (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function() {
        var result;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    /*
    this condition is for extra security.
   * when some user type 4 char and immediately just hold black slack and blank search input.
   * so in that case before app call this Param is set blank. so prevent this issue added condition
   */ if (params.name.length < (0, $f9f89a5c82b78d91$export$f56c1bb712b9ef86)) return [
                        2,
                        {
                            cities: [],
                            postalCodes: [],
                            airports: []
                        }
                    ];
                    return [
                        4,
                        (0, $08e412b69b47010f$export$85f4e47cbf319e2c)(params)
                    ];
                case 1:
                    result = _state.sent();
                    if ("errors" in result) throw new Error(result.errors[0].code);
                    return [
                        2,
                        params.filterData ? params.filterData(result.data) : result.data
                    ];
            }
        });
    });
};
var $06c905d67e0a0a24$export$6326b64eef1a3bba = function(param) {
    return (0, $fZLIC$reactquery.useQuery)({
        queryFn: $06c905d67e0a0a24$export$77240c5f1f1a6a96(param),
        enabled: false,
        cacheTime: 0,
        queryKey: $06c905d67e0a0a24$export$a1e71db47116efb0(param)
    });
};










var $d7cfe90fca727fdc$export$c6c960c39e37e610 = {
    422: "INVALID_PAYLOAD",
    500: "INTERNAL_ERROR"
};
var $d7cfe90fca727fdc$export$b4f23f7e0e0673c2 = function() {
    var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function(params) {
        var name, _ref, data, status, _MAP_STATUS_TO_ERROR_CODE_status, code, e;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    name = params.name;
                    return [
                        4,
                        (0, ($parcel$interopDefault($fZLIC$axios))).get("/api/v2/locations/inland/places?term=".concat(name))
                    ];
                case 1:
                    _ref = _state.sent(), data = _ref.data, status = _ref.status;
                    if (status != 200) {
                        ;
                        code = (_MAP_STATUS_TO_ERROR_CODE_status = $d7cfe90fca727fdc$export$c6c960c39e37e610[status]) !== null && _MAP_STATUS_TO_ERROR_CODE_status !== void 0 ? _MAP_STATUS_TO_ERROR_CODE_status : "UNKNOWN_ERROR";
                        return [
                            2,
                            {
                                errors: [
                                    {
                                        code: code
                                    }
                                ]
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: {
                                cities: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.cities),
                                ports: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.ports),
                                postalCodes: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.postalCodes)
                            }
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            errors: [
                                {
                                    code: "UNKNOWN_ERROR"
                                }
                            ]
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getInlandPlaces(params) {
        return _ref.apply(this, arguments);
    };
}();


var $1b4b2ddcfd0a2258$export$a1e71db47116efb0 = function(params) {
    return "inland-places-".concat(params.context, "-").concat(params.name);
};
var $1b4b2ddcfd0a2258$export$77240c5f1f1a6a96 = function(params) {
    return /*#__PURE__*/ (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function() {
        var result;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    /*
    this condition is for extra security.
   * when some user type 4 char and immediately just hold black slack and blank search input.
   * so in that case before app call this Param is set blank. so prevent this issue added condition
   */ if (params.name.length < (0, $f9f89a5c82b78d91$export$f56c1bb712b9ef86)) return [
                        2,
                        {
                            cities: [],
                            postalCodes: [],
                            ports: []
                        }
                    ];
                    return [
                        4,
                        (0, $d7cfe90fca727fdc$export$b4f23f7e0e0673c2)(params)
                    ];
                case 1:
                    result = _state.sent();
                    if ("errors" in result) throw new Error(result.errors[0].code);
                    return [
                        2,
                        params.filterData ? params.filterData(result.data) : result.data
                    ];
            }
        });
    });
};
var $1b4b2ddcfd0a2258$export$880d25f907fb7e37 = function(param) {
    return (0, $fZLIC$reactquery.useQuery)({
        queryFn: $1b4b2ddcfd0a2258$export$77240c5f1f1a6a96(param),
        enabled: false,
        cacheTime: 0,
        queryKey: $1b4b2ddcfd0a2258$export$a1e71db47116efb0(param)
    });
};









var $7653a902bf34afca$export$47894d67348bf018 = {
    M3: "CBM",
    FT3: "CFT",
    IN3: "CIN"
};


var $704b9cc98acb121c$export$83aea862f27ff7f2 = function(item) {
    return "type" in item;
};
var $704b9cc98acb121c$export$18859cd1285c89ec = function(item) {
    return "dimensionUnit" in item;
};


var $45d0a6ded97f1d77$export$e562cb5e2aea7ca = function(items) {
    if (!items) return [];
    return items.map(function(item) {
        if ((0, $704b9cc98acb121c$export$18859cd1285c89ec)(item)) return {
            quantity: item.quantity,
            weight: item.weight,
            weightUnit: item.weightUnit.toUpperCase(),
            length: item.length,
            width: item.width,
            height: item.height,
            lengthUnit: item.dimensionUnit.toUpperCase()
        };
        if ((0, $704b9cc98acb121c$export$83aea862f27ff7f2)(item)) return {
            type: item.type,
            quantity: item.quantity
        };
        return {
            totalWeight: item.weight,
            weightUnit: item.weightUnit.toUpperCase(),
            totalVolume: item.volume,
            volumeUnit: (0, $7653a902bf34afca$export$47894d67348bf018)[item.volumeUnit.toUpperCase()]
        };
    });
};


var $df49c7a218936dae$export$c6c960c39e37e610 = {
    422: "INVALID_PAYLOAD",
    500: "INTERNAL_ERROR"
};
var $df49c7a218936dae$export$1e2a0d3e0b2fb165 = function() {
    var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function(param) {
        var shipmentTypes, args, _ref, data, status, _MAP_STATUS_TO_ERROR_CODE_status, code, e;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    shipmentTypes = param.shipmentTypes;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    args = shipmentTypes.map(function(type) {
                        return "shipmentTypes[]=".concat(type);
                    });
                    return [
                        4,
                        (0, ($parcel$interopDefault($fZLIC$axios))).get("/api/v2/locations/most-searched?".concat(args.join("&")))
                    ];
                case 2:
                    _ref = _state.sent(), data = _ref.data, status = _ref.status;
                    if (status !== 200) {
                        ;
                        code = (_MAP_STATUS_TO_ERROR_CODE_status = $df49c7a218936dae$export$c6c960c39e37e610[status]) !== null && _MAP_STATUS_TO_ERROR_CODE_status !== void 0 ? _MAP_STATUS_TO_ERROR_CODE_status : "UNKNOWN_ERROR";
                        return [
                            2,
                            {
                                errors: [
                                    {
                                        code: code
                                    }
                                ]
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: {
                                quotedTradelines: data.data.quotedTradelines.map(function(tradelane) {
                                    return {
                                        origin: (0, $ad706ddcbbca281c$export$1a7ee011f5f36179)(tradelane.origin),
                                        destination: (0, $ad706ddcbbca281c$export$1a7ee011f5f36179)(tradelane.destination),
                                        items: (0, $45d0a6ded97f1d77$export$e562cb5e2aea7ca)(tradelane.items),
                                        shipmentType: tradelane.shipmentType
                                    };
                                }),
                                popularTradelines: data.data.popularTradelines.map(function(tradelane) {
                                    return {
                                        origin: (0, $ad706ddcbbca281c$export$1a7ee011f5f36179)(tradelane.origin),
                                        destination: (0, $ad706ddcbbca281c$export$1a7ee011f5f36179)(tradelane.destination)
                                    };
                                })
                            }
                        }
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            errors: [
                                {
                                    code: "UNKNOWN_ERROR"
                                }
                            ]
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getMostSearched(_) {
        return _ref.apply(this, arguments);
    };
}();


var $a400a5bb921004af$export$77240c5f1f1a6a96 = function(params) {
    return /*#__PURE__*/ (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function() {
        var result;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (params.shipmentTypes.length === 0) throw new Error("useGetMostSearched: no shipment types");
                    return [
                        4,
                        (0, $df49c7a218936dae$export$1e2a0d3e0b2fb165)(params)
                    ];
                case 1:
                    result = _state.sent();
                    if ("errors" in result) throw new Error(result.errors[0].code);
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
};
var $a400a5bb921004af$export$e6dd8427ffae5df2 = function(params) {
    return (0, $fZLIC$reactquery.useQuery)({
        queryFn: $a400a5bb921004af$export$77240c5f1f1a6a96(params),
        enabled: false,
        queryKey: "most-searched"
    });
};












var $a1e94d9fec2866b6$export$379cd4df70fc0514 = function() {
    var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function(params) {
        var name, source, shipmentType, countryIsoCode, customerType, queryParams, _ref, data, status, e;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    name = params.name, source = params.source, shipmentType = params.shipmentType, countryIsoCode = params.countryIsoCode, customerType = params.customerType;
                    queryParams = (0, $97441b62ecb6ed2c$export$f672acd9fd097e11)({
                        term: name,
                        source: source,
                        customerType: customerType,
                        countryIsoCode: countryIsoCode,
                        shipmentType: shipmentType
                    });
                    return [
                        4,
                        (0, ($parcel$interopDefault($fZLIC$axios))).get("/api/v2/locations/maritime/places?".concat(queryParams))
                    ];
                case 1:
                    _ref = _state.sent(), data = _ref.data, status = _ref.status;
                    if (status != 200) return [
                        2,
                        {
                            errors: [
                                {
                                    code: "INTERNAL_ERROR"
                                }
                            ]
                        }
                    ];
                    return [
                        2,
                        {
                            data: {
                                cities: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.cities),
                                ports: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.ports),
                                postalCodes: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data.postalCodes)
                            }
                        }
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        {
                            errors: [
                                {
                                    code: "UNKNOWN_ERROR"
                                }
                            ]
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getOceanPlaces(params) {
        return _ref.apply(this, arguments);
    };
}();


var $2bf6ddfb6520c220$var$_param_countryIsoCode;
var $2bf6ddfb6520c220$export$a1e71db47116efb0 = function(param) {
    return "ocean-places-".concat(param.context, "-").concat(param.name, "-").concat(($2bf6ddfb6520c220$var$_param_countryIsoCode = param.countryIsoCode) !== null && $2bf6ddfb6520c220$var$_param_countryIsoCode !== void 0 ? $2bf6ddfb6520c220$var$_param_countryIsoCode : "UNKNOWN_COUNTRY");
};
var $2bf6ddfb6520c220$export$77240c5f1f1a6a96 = function(param) {
    var name = param.name, shipmentType = param.shipmentType, context = param.context, filterData = param.filterData, source = param.source, customerType = param.customerType, countryIsoCode = param.countryIsoCode;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function() {
        var result;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    /*
  this condition is for extra security.
  * when some user type 4 char and immediately just hold black slack and blank search input.
  * so in that case before app call this Param is set blank. so prevent this issue added condition
  */ if (name.length < (0, $f9f89a5c82b78d91$export$f56c1bb712b9ef86)) return [
                        2,
                        {
                            cities: [],
                            postalCodes: [],
                            ports: []
                        }
                    ];
                    if (!(0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType)) throw new Error("useGetOceanPlaces: invalid shipment type");
                    return [
                        4,
                        (0, $a1e94d9fec2866b6$export$379cd4df70fc0514)({
                            name: name,
                            shipmentType: shipmentType,
                            context: context,
                            filterData: filterData,
                            source: source,
                            customerType: customerType,
                            countryIsoCode: countryIsoCode
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("errors" in result) throw new Error(result.errors[0].code);
                    return [
                        2,
                        filterData ? filterData(result.data) : result.data
                    ];
            }
        });
    });
};
var $2bf6ddfb6520c220$export$10ed7ad36718be02 = function(param) {
    return (0, $fZLIC$reactquery.useQuery)({
        queryFn: $2bf6ddfb6520c220$export$77240c5f1f1a6a96(param),
        enabled: false,
        cacheTime: 0,
        queryKey: $2bf6ddfb6520c220$export$a1e71db47116efb0(param)
    });
};









var $2f59ed0a15c64884$export$c76d6338c83a6344 = function() {
    var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function(param) {
        var country, term, _ref, data, status, e;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    country = param.country, term = param.term;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, ($parcel$interopDefault($fZLIC$axios))).get("/api/v2/locations/country/".concat(country.iso_code, "/postal-codes?q=").concat(term))
                    ];
                case 2:
                    _ref = _state.sent(), data = _ref.data, status = _ref.status;
                    if (status != 200) return [
                        2,
                        {
                            errors: [
                                {
                                    code: "INTERNAL_ERROR"
                                }
                            ]
                        }
                    ];
                    return [
                        2,
                        {
                            data: {
                                data: (0, $ad706ddcbbca281c$export$7d2c7e4e3be0c527)(data.data)
                            }
                        }
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            errors: [
                                {
                                    code: "UNKNOWN_ERROR"
                                }
                            ]
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPostalCodes(_) {
        return _ref.apply(this, arguments);
    };
}();


var $16314276090ccdfc$export$77240c5f1f1a6a96 = function(params) {
    return /*#__PURE__*/ (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function() {
        var result;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (params.term === "") throw new Error("useGetPostalCodes: invalid postal code");
                    return [
                        4,
                        (0, $2f59ed0a15c64884$export$c76d6338c83a6344)(params)
                    ];
                case 1:
                    result = _state.sent();
                    if ("errors" in result) throw new Error(result.errors[0].code);
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
};
var $16314276090ccdfc$export$47ed568571403a18 = function(params) {
    return (0, $fZLIC$reactquery.useQuery)({
        queryFn: $16314276090ccdfc$export$77240c5f1f1a6a96(params),
        enabled: false,
        queryKey: "postal-codes-".concat(params.context)
    });
};





var $48a0275552d0228c$var$initialValue = {
    showDimensionsInLCL: true,
    inIframe: false,
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    sendMixpanelEvents: false,
    showCommodity: false,
    showCargoReadyDateForOcean: false,
    showCargoReadyDateForAir: false,
    showCargoReadyDateForLTL: false,
    showKnownShipper: false,
    customerType: null,
    type: (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Regular
};
var $48a0275552d0228c$export$a0936c9989b92d74 = /*#__PURE__*/ (0, $fZLIC$react.createContext)($48a0275552d0228c$var$initialValue);











var $626787f2265604a2$export$e71c4d32a2263218 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistatomsBox.Box)).attrs(function(props) {
    return {
        className: [
            props.className,
            "-box"
        ].join("")
    };
}).withConfig({
    displayName: "LocationFieldstyled__Box",
    componentId: "sc-1ostbc0-0"
})([
    "background-color:",
    ";border-radius:7px;",
    " max-height:380px;max-width:300px;width:100%;overflow:auto;box-sizing:border-box;z-index:1;@media ",
    "{max-width:100%;}",
    ""
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return !props.$inIframe && "position: absolute;";
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance ? "max-width: 100%;" : "";
});
var $626787f2265604a2$export$3088a504c76ee8c8 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))($626787f2265604a2$export$e71c4d32a2263218).withConfig({
    displayName: "LocationFieldstyled__BoxMostSearched",
    componentId: "sc-1ostbc0-1"
})([
    "max-width:450px;padding:0;"
]);
var $626787f2265604a2$export$f214bf1b88c3ea24 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationFieldstyled__LocationInputWrapper",
    componentId: "sc-1ostbc0-2"
})([
    "background:",
    ";border:1px solid ",
    ";&:focus-within,&:hover{border:1px solid ",
    ";.Input-root{border-radius:7px;}}.error{.Input-root{background-color:",
    ";border:1px solid ",
    ";border-radius:0px;}}"
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g200;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.color.e100;
}, function(props) {
    return props.theme.color.e300;
});
var $626787f2265604a2$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.attrs(function(props) {
    return {
        className: [
            props.className,
            "-wrapper"
        ].join("")
    };
}).withConfig({
    displayName: "LocationFieldstyled__Wrapper",
    componentId: "sc-1ostbc0-3"
})([
    "max-width:300px;width:100%;@media ",
    "{max-width:100%;}",
    " ",
    ""
], function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance ? "max-width: 100%;" : "";
}, function(props) {
    return props.$showDropdown ? "z-index: 10;" : "";
});
var $626787f2265604a2$export$fb9f58ebe9de6283 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.attrs(function(props) {
    return {
        className: [
            props.className,
            "-input-wrapper"
        ].join("")
    };
}).withConfig({
    displayName: "LocationFieldstyled__InputWrapper",
    componentId: "sc-1ostbc0-4"
})([
    "background-color:",
    ";",
    ""
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return !props.$inIframe && "\n        @media ".concat(props.theme.query.mobile, " {\n          background-color: transparent;\n        }\n    ");
});
var $626787f2265604a2$export$f5b8910cec6cf069 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesInput.Input)).withConfig({
    displayName: "LocationFieldstyled__Input",
    componentId: "sc-1ostbc0-5"
})([
    ".InputLabel-root{color:",
    ";&.MuiInputLabel-filled.MuiInputLabel-shrink{transform:translate(10px,15px) scale(0.75);}}.Input-root{border:none;background:none;height:73px;&.Mui-focused,&:hover{background:none;}",
    " ",
    " &:after,&:before{display:none;}}"
], function(props) {
    return props.theme.color.g600;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.fontWeight.regular;
});
var $626787f2265604a2$export$de5e039aa1ca6b9d = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $8386a560313a79fd$export$ce7fcac6feb8c2f4)).withConfig({
    displayName: "LocationFieldstyled__PortIcon",
    componentId: "sc-1ostbc0-6"
})([
    "display:inline-block;"
]);
var $626787f2265604a2$export$51350e40f7f9c1b6 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $c4b8262dcd5e257a$export$bed63554a210ca03)).withConfig({
    displayName: "LocationFieldstyled__CityIcon",
    componentId: "sc-1ostbc0-7"
})([
    "display:inline-block;"
]);
var $626787f2265604a2$export$915e9e7bd4f0f96d = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LocationFieldstyled__ErrorMessage",
    componentId: "sc-1ostbc0-8"
})([
    "background-color:",
    ";color:",
    ";padding:4px 9px;",
    ";",
    ";"
], function(props) {
    return props.theme.color.e100;
}, function(props) {
    return props.theme.color.e400;
}, function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.fontWeight.medium;
});



var $6f8dba4147330b62$var$_Loading, $6f8dba4147330b62$var$_NoResultMessageCompo;
var $6f8dba4147330b62$export$65a13b30121193f0 = function(props, ref) {
    var _castFieldValue_location, _data_shipmentType, _data_shipmentType1, _data_shipmentType2;
    var onSelect = props.onSelect, error = props.error, setInvalidZipcodeError = props.setInvalidZipcodeError, clearInvalidZipcodeError = props.clearInvalidZipcodeError, setBackdropVisible = props.setBackdropVisible, backdropVisible = props.backdropVisible, setLoading = props.setLoading, filterData = props.filterData, isVertical = props.isVertical, _props_type = props.type, type = _props_type === void 0 ? "pickup" : _props_type, shipmentType = props.shipmentType, initialShipmentType = props.initialShipmentType, sendGA4Events = props.sendGA4Events, onBackdropClick = props.onBackdropClick, allowRecentsDropdown = props.allowRecentsDropdown, setLengthError = props.setLengthError, clearLengthErrors = props.clearLengthErrors, source = props.source, setRecentSearch = props.setRecentSearch, sendMixpanelEvents = props.sendMixpanelEvents, filterLocationCountryIsoCode = props.filterLocationCountryIsoCode, inputProps = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(props, [
        "onSelect",
        "error",
        "setInvalidZipcodeError",
        "clearInvalidZipcodeError",
        "setBackdropVisible",
        "backdropVisible",
        "setLoading",
        "filterData",
        "isVertical",
        "type",
        "shipmentType",
        "initialShipmentType",
        "sendGA4Events",
        "onBackdropClick",
        "allowRecentsDropdown",
        "setLengthError",
        "clearLengthErrors",
        "source",
        "setRecentSearch",
        "sendMixpanelEvents",
        "filterLocationCountryIsoCode"
    ]);
    var className = inputProps.className, label = inputProps.label, icon = inputProps.icon, onFocus = inputProps.onFocus, _inputProps_autoFocus = inputProps.autoFocus, autoFocus = _inputProps_autoFocus === void 0 ? false : _inputProps_autoFocus, controllerProps = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(inputProps, [
        "className",
        "label",
        "icon",
        "onFocus",
        "autoFocus"
    ]);
    var isAir = (0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType);
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), inIframe = _useContext.inIframe, isMobile = _useContext.isMobile, customerType = _useContext.customerType, widgetType = _useContext.type;
    var inputRef = (0, $fZLIC$react.useRef)(null);
    var cursorRef = (0, $fZLIC$react.useRef)(null);
    var wrapperRef = (0, $fZLIC$react.useRef)(null);
    var postalCodeRef = (0, $fZLIC$react.useRef)(null);
    var field = (0, $fZLIC$reacthookform.useController)(controllerProps).field;
    // react-hook-form doesnt allow for defining types for generic component values
    // https://github.com/react-hook-form/react-hook-form/pull/6753#issuecomment-939222107
    var castFieldValue = field.value;
    var castFieldName = field.name;
    var fieldOnChange = field.onChange;
    var fieldOnBlur = field.onBlur;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), getPlacesIsLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(""), 2), location = _useState1[0], setLocation = _useState1[1];
    var _useState2 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(""), 2), postalCode = _useState2[0], setPostalCode = _useState2[1];
    var _useState3 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(autoFocus), 2), focus = _useState3[0], setFocus = _useState3[1];
    var _useState4 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(0), 2), cursor = _useState4[0], setCursor = _useState4[1];
    var _useState5 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)({
        quotedTradelines: [],
        popularTradelines: []
    }), 2), mostSearched = _useState5[0], setMostSearched = _useState5[1];
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var _useGetOceanPlaces = (0, $2bf6ddfb6520c220$export$10ed7ad36718be02)({
        name: (0, $682e17d971f7dc71$export$6283f5953ff9dfce)(location),
        context: castFieldName,
        filterData: (0, $682e17d971f7dc71$export$67e9d748682b70c7)({
            location: location,
            filterData: filterData
        }),
        shipmentType: shipmentType,
        source: source,
        customerType: customerType,
        countryIsoCode: filterLocationCountryIsoCode
    }), getOceanPlaces = _useGetOceanPlaces.refetch, oceanData = _useGetOceanPlaces.data, isFetchedOceanPlaces = _useGetOceanPlaces.isFetched;
    var _useGetAerialPlaces = (0, $06c905d67e0a0a24$export$6326b64eef1a3bba)({
        name: (0, $682e17d971f7dc71$export$6283f5953ff9dfce)(location),
        context: castFieldName,
        source: source,
        customerType: customerType,
        filterData: filterData,
        countryIsoCode: filterLocationCountryIsoCode
    }), getAerialPlaces = _useGetAerialPlaces.refetch, airData = _useGetAerialPlaces.data, isFetchedAerialPlaces = _useGetAerialPlaces.isFetched;
    var _useGetInlandPlaces = (0, $1b4b2ddcfd0a2258$export$880d25f907fb7e37)({
        name: (0, $682e17d971f7dc71$export$6283f5953ff9dfce)(location),
        context: castFieldName,
        filterData: filterData
    }), getInlandPlaces = _useGetInlandPlaces.refetch, inlandData = _useGetInlandPlaces.data, isFetchedInlandPlaces = _useGetInlandPlaces.isFetched;
    var _useGetMostSearched = (0, $a400a5bb921004af$export$e6dd8427ffae5df2)({
        shipmentTypes: [
            "FCL",
            "LCL",
            "AIR",
            "LTL"
        ]
    }), getMostSearched = _useGetMostSearched.refetch;
    (0, $fZLIC$react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function() {
                var data, quotedTradelines, popularTradelines;
                return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getMostSearched()
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) {
                                quotedTradelines = data.quotedTradelines, popularTradelines = data.popularTradelines;
                                setMostSearched({
                                    quotedTradelines: quotedTradelines,
                                    popularTradelines: popularTradelines
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchData();
    }, [
        getMostSearched
    ]);
    var hasResults = (0, $682e17d971f7dc71$export$d7475e926d4007d7)({
        shipmentType: shipmentType,
        getPlacesIsLoading: getPlacesIsLoading,
        airData: airData,
        oceanData: oceanData,
        inlandData: inlandData
    });
    var noResults = (0, $682e17d971f7dc71$export$3e1bb248c97deb14)({
        location: location,
        shipmentType: shipmentType,
        getPlacesIsLoading: getPlacesIsLoading,
        airData: airData,
        oceanData: oceanData,
        inlandData: inlandData
    });
    var _useSendLocationNotSelectedEvent = (0, $401ce97109e5a696$export$dc4e317433c6fe09)({
        shipmentType: shipmentType,
        getPlacesIsLoading: getPlacesIsLoading,
        location: location,
        fieldValue: castFieldValue,
        type: type,
        airData: airData,
        sendGA4Events: sendGA4Events,
        oceanData: oceanData,
        inlandData: inlandData,
        hasResults: hasResults
    }), sendLocationNotSelectedEvent = _useSendLocationNotSelectedEvent.sendLocationNotSelectedEvent, setLongestLocation = _useSendLocationNotSelectedEvent.setLongestLocation;
    (0, $fZLIC$react.useEffect)(function() {
        if (backdropVisible === false) (0, $682e17d971f7dc71$export$9ffb3d100090b01d)({
            fieldValue: castFieldValue,
            sendLocationNotSelectedEvent: sendLocationNotSelectedEvent,
            setLocation: setLocation,
            setShowDropdown: setShowDropdown
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        backdropVisible
    ]);
    (0, $fZLIC$react.useImperativeHandle)(ref, function() {
        return {
            closePopup: function() {
                setShowDropdown(false);
            },
            focusInput: function() {
                (0, $682e17d971f7dc71$export$db9c6222aaa5f276)(inputRef);
            }
        };
    });
    (0, $fZLIC$react.useEffect)(function() {
        if ((0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType) && isFetchedOceanPlaces) setIsLoading(false);
        if ((0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType) && isFetchedAerialPlaces) setIsLoading(false);
        if ((0, $84c96a688242bcfe$export$119990892388fa74)(shipmentType) && isFetchedInlandPlaces) setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFetchedOceanPlaces,
        isFetchedAerialPlaces,
        isFetchedInlandPlaces,
        shipmentType
    ]);
    var _useState6 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), showDropdown = _useState6[0], setShowDropdown = _useState6[1];
    var _useState7 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), focusPostalCode = _useState7[0], setFocusPostalCode = _useState7[1];
    var showPostalCode = (0, $682e17d971f7dc71$export$688fd50b712eda4a)(castFieldValue === null || castFieldValue === void 0 ? void 0 : castFieldValue.location);
    (0, $fZLIC$react.useEffect)(function() {
        if (showPostalCode && focusPostalCode) {
            var current = postalCodeRef.current;
            current.focus();
        }
    }, [
        focusPostalCode,
        showPostalCode
    ]);
    var _useGetPostalCodes = (0, $16314276090ccdfc$export$47ed568571403a18)({
        term: postalCode,
        country: castFieldValue === null || castFieldValue === void 0 ? void 0 : (_castFieldValue_location = castFieldValue.location) === null || _castFieldValue_location === void 0 ? void 0 : _castFieldValue_location.country,
        context: castFieldName
    }), getPostalCodes = _useGetPostalCodes.refetch, postalCodeIsLoading = _useGetPostalCodes.isLoading, postalCodeData = _useGetPostalCodes.data;
    // update location name in case postal code has changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fZLIC$react.useEffect)((0, $682e17d971f7dc71$export$52ef8eaf754b08e5)({
        data: postalCodeData === null || postalCodeData === void 0 ? void 0 : postalCodeData.data,
        fieldValue: castFieldValue,
        onChange: fieldOnChange,
        setLocation: setLocation,
        postalCode: postalCode,
        clearInvalidZipcodeError: clearInvalidZipcodeError,
        setInvalidZipcodeError: setInvalidZipcodeError,
        fieldName: castFieldName
    }), [
        postalCodeData
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        setLoading === null || setLoading === void 0 ? void 0 : setLoading(postalCodeIsLoading || getPlacesIsLoading);
    }, [
        postalCodeIsLoading,
        getPlacesIsLoading,
        setLoading
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fZLIC$react.useEffect)((0, $682e17d971f7dc71$export$53a0910f038337bd)({
        cursorRef: cursorRef
    }), [
        cursor
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        if (castFieldValue === null || castFieldValue === void 0 ? void 0 : castFieldValue.location) setLocation((0, $682e17d971f7dc71$export$fde68238b73b126f)(castFieldValue.location));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        castFieldValue === null || castFieldValue === void 0 ? void 0 : castFieldValue.location
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        if (initialShipmentType !== shipmentType) {
            setLocation("");
            setLongestLocation("");
            setShowDropdown(false);
        }
    }, [
        shipmentType
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        if (castFieldValue === null || castFieldValue === void 0 ? void 0 : castFieldValue.postalCode) setPostalCode(castFieldValue.postalCode);
    }, [
        castFieldValue === null || castFieldValue === void 0 ? void 0 : castFieldValue.postalCode
    ]);
    //after invalid zipcode, and set port again
    (0, $fZLIC$react.useEffect)(function() {
        castFieldValue && error && error.type === "invalidZipcode" && (0, $3180d1e7f238f266$export$bf27ad191565d194)(castFieldValue.location) && clearInvalidZipcodeError(castFieldName);
    }, [
        castFieldValue,
        castFieldName,
        error,
        clearInvalidZipcodeError
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        if (noResults && !castFieldValue) {
            if (sendGA4Events) (0, $ceb0c600e8f2a76d$export$ffb13fd23f6ed1ca)({
                location: location,
                type: type
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        noResults
    ]);
    var showRecentSearches = (0, $682e17d971f7dc71$export$6725683ce026c4e6)({
        mostSearched: mostSearched,
        allowRecentsDropdown: allowRecentsDropdown,
        focus: focus,
        isMobile: isMobile,
        location: location,
        setRecentSearch: setRecentSearch
    });
    (0, $fZLIC$react.useEffect)((0, $682e17d971f7dc71$export$26950cde0cfb976c)(showRecentSearches, Boolean(sendMixpanelEvents)), [
        showRecentSearches
    ]);
    var countryFlag = (0, $682e17d971f7dc71$export$fd5d2cd02be3d52a)({
        location: castFieldValue === null || castFieldValue === void 0 ? void 0 : castFieldValue.location,
        showDropdown: showDropdown
    });
    var totalItems = 0;
    if ((0, $84c96a688242bcfe$export$589f9843ee7a4481)(shipmentType)) totalItems = (0, $682e17d971f7dc71$export$ed312a418caf9500)(airData);
    if ((0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType)) totalItems = (0, $682e17d971f7dc71$export$532f543aea3ddcec)(oceanData);
    if ((0, $84c96a688242bcfe$export$119990892388fa74)(shipmentType)) totalItems = (0, $682e17d971f7dc71$export$532f543aea3ddcec)(inlandData);
    var data = {
        AIR: airData,
        LCL: oceanData,
        FCL: oceanData,
        LTL: inlandData
    };
    var debounceMap = {
        AIR: getAerialPlaces,
        LCL: getOceanPlaces,
        FCL: getOceanPlaces,
        LTL: getInlandPlaces
    };
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $626787f2265604a2$export$e6dfd72ab29f8598), {
        ref: wrapperRef,
        className: className,
        $isVertical: isVertical,
        $type: widgetType,
        $showDropdown: showDropdown,
        onKeyDown: (0, $682e17d971f7dc71$export$de8e1b1372cdb41b)({
            cursor: cursor,
            totalItems: totalItems,
            cursorRef: cursorRef,
            setCursor: setCursor
        }),
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $626787f2265604a2$export$fb9f58ebe9de6283), {
                className: className,
                $inIframe: inIframe,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                    component: (0, $626787f2265604a2$export$f214bf1b88c3ea24),
                    container: true,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                            item: true,
                            xs: showPostalCode ? 8 : 12,
                            children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $652e5e6e582599e2$export$1d04a355e3a12077), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, inputProps), {
                                ref: inputRef,
                                label: label,
                                icon: (0, $682e17d971f7dc71$export$16b26cd5e98d9100)({
                                    fieldValue: castFieldValue,
                                    defaultIcon: icon
                                }),
                                onChange: (0, $682e17d971f7dc71$export$ac888553f852f1c3)({
                                    setLocation: setLocation,
                                    setShowDropdown: setShowDropdown,
                                    getPlaces: (0, ($parcel$interopDefault($fZLIC$lodashdebounce)))(debounceMap[shipmentType], 500),
                                    setIsLoading: setIsLoading,
                                    onChange: fieldOnChange,
                                    setBackdropVisible: setBackdropVisible,
                                    setLengthError: setLengthError,
                                    clearLengthErrors: clearLengthErrors,
                                    lengthField: castFieldName
                                }),
                                onBlur: (0, $682e17d971f7dc71$export$718afa7caf055a42)({
                                    onFieldBlur: fieldOnBlur,
                                    setLocation: setLocation,
                                    setShowDropdown: setShowDropdown,
                                    noResults: noResults && showDropdown,
                                    setBackdropVisible: setBackdropVisible,
                                    onBlur: (0, $682e17d971f7dc71$export$5e446bc31724fca4)({
                                        wrapperRef: wrapperRef,
                                        setFocus: setFocus
                                    })
                                }),
                                autoFocus: autoFocus,
                                onFocus: function() {
                                    onFocus === null || onFocus === void 0 ? void 0 : onFocus();
                                    setFocus(true);
                                },
                                value: location,
                                name: "".concat(castFieldName, "Location"),
                                prefix: countryFlag,
                                className: (error === null || error === void 0 ? void 0 : error.type) === "required" ? "error" : "",
                                $isVertical: isVertical || isMobile,
                                $inIframe: inIframe,
                                $type: widgetType
                            }))
                        }),
                        showPostalCode && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                            item: true,
                            xs: 4,
                            children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $626787f2265604a2$export$f5b8910cec6cf069), {
                                name: "".concat(castFieldName, "PostalCode"),
                                value: postalCode,
                                label: t("quoteForm.postalCode"),
                                optional: true,
                                onChange: (0, $682e17d971f7dc71$export$1b994d97209f817a)({
                                    setPostalCode: setPostalCode,
                                    onChange: fieldOnChange,
                                    fieldValue: castFieldValue
                                }),
                                onBlur: (0, $682e17d971f7dc71$export$c7d04a37f614b150)({
                                    getPostalCodes: getPostalCodes
                                }),
                                InputLabelProps: {
                                    shrink: true
                                },
                                className: (error === null || error === void 0 ? void 0 : error.type) === "zipcode" || (error === null || error === void 0 ? void 0 : error.type) === "invalidZipcode" ? "error" : "",
                                error: (error === null || error === void 0 ? void 0 : error.type) === "zipcode" || (error === null || error === void 0 ? void 0 : error.type) === "invalidZipcode",
                                ref: postalCodeRef
                            })
                        })
                    ]
                })
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $626787f2265604a2$export$915e9e7bd4f0f96d), {
                children: error.message
            }),
            showDropdown && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $626787f2265604a2$export$e71c4d32a2263218), {
                className: className,
                $isVertical: isVertical,
                $inIframe: inIframe,
                $type: widgetType,
                children: [
                    getPlacesIsLoading && ($6f8dba4147330b62$var$_Loading || ($6f8dba4147330b62$var$_Loading = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesLoading.Loading), {}))),
                    noResults && ($6f8dba4147330b62$var$_NoResultMessageCompo || ($6f8dba4147330b62$var$_NoResultMessageCompo = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $9723e2a86792968c$export$815e2e8c28f75841), {}))),
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $1e7ae8cd38d66488$export$c6422dd10de433e5), {
                        type: type,
                        cursorRef: cursorRef,
                        cursor: cursor,
                        ports: (0, $84c96a688242bcfe$export$42c27cf9b4e901fd)(shipmentType) || (0, $84c96a688242bcfe$export$119990892388fa74)(shipmentType) ? (_data_shipmentType = data[shipmentType]) === null || _data_shipmentType === void 0 ? void 0 : _data_shipmentType.ports : [],
                        cities: (_data_shipmentType1 = data[shipmentType]) === null || _data_shipmentType1 === void 0 ? void 0 : _data_shipmentType1.cities,
                        postalCodes: (_data_shipmentType2 = data[shipmentType]) === null || _data_shipmentType2 === void 0 ? void 0 : _data_shipmentType2.postalCodes,
                        airports: isAir ? airData === null || airData === void 0 ? void 0 : airData.airports : [],
                        onSelect: (0, $682e17d971f7dc71$export$99b607fb5fc7a93e)({
                            onChange: fieldOnChange,
                            setLocation: setLocation,
                            setPostalCode: setPostalCode,
                            setShowDropdown: setShowDropdown,
                            onSelect: onSelect,
                            setFocusPostalCode: setFocusPostalCode,
                            onBackdropClick: onBackdropClick
                        })
                    })
                ]
            }),
            showRecentSearches && setRecentSearch && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $626787f2265604a2$export$3088a504c76ee8c8), {
                className: className,
                $isVertical: isVertical,
                $inIframe: inIframe,
                tabIndex: 0,
                $type: widgetType,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $2e9411555558609a$export$a494855209d0fee3), {
                    recentSearchItems: (0, $682e17d971f7dc71$export$ec0b3085240c08d1)({
                        items: mostSearched.quotedTradelines,
                        t: t,
                        setRecentSearch: setRecentSearch(mostSearched.quotedTradelines)
                    })
                })
            })
        ]
    });
};
var $6f8dba4147330b62$export$f8f9ea2bcdb95c32 = /*#__PURE__*/ (0, $fZLIC$react.forwardRef)($6f8dba4147330b62$export$65a13b30121193f0);



var $8c9f42573c05ba5d$export$f57fa9a373c251fe = function(locationDetail) {
    if ((0, $3180d1e7f238f266$export$a9044a10e5a81ea2)(locationDetail.location)) return locationDetail.postalCode || "";
    if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(locationDetail.location)) return locationDetail.postalCode || "";
    if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(locationDetail.location)) return locationDetail.location.portIsoCode;
    if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(locationDetail.location)) return locationDetail.location.portIsoCode;
    return "";
};
var $8c9f42573c05ba5d$export$6801e921945a0207 = function(locationDetail) {
    if ((0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(locationDetail.location)) return locationDetail.location.iata;
    if ((0, $3180d1e7f238f266$export$a9044a10e5a81ea2)(locationDetail.location)) return locationDetail.postalCode || "";
    if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(locationDetail.location)) return locationDetail.postalCode || "";
    if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(locationDetail.location)) return locationDetail.location.portIsoCode;
    return "";
};
var $8c9f42573c05ba5d$export$252be1df97fdbc2d = function(location) {
    if ((0, $3180d1e7f238f266$export$a955beec2ab2c25)(location)) return location.city;
    return location.name;
};













var $c7dc6b12feb87c0b$export$8665abbc450bac22 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, ($parcel$interopDefault($fZLIC$muimaterialBackdrop)))).withConfig({
    displayName: "Backdropstyled__MuiBackdrop",
    componentId: "sc-1csgpbg-0"
})([
    "&.MuiBackdrop-root{z-index:",
    ";}"
], function(props) {
    return props.$layerIndex;
});


var $88abc1f36ada2e72$export$698223c589197ab7 = function(param) {
    var backdropVisible = param.backdropVisible, setBackdropVisible = param.setBackdropVisible, layerIndex = param.layerIndex, wrapperRef = param.wrapperRef, isVertical = param.isVertical, activeElement = param.activeElement, onBackdropClick = param.onBackdropClick;
    var isMobile = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)).isMobile;
    (0, $fZLIC$react.useEffect)(function() {
        var current = wrapperRef.current;
        var visible = Boolean(current === null || current === void 0 ? void 0 : current.contains(activeElement));
        var isDatePaper = activeElement === null || activeElement === void 0 ? void 0 : activeElement.classList.contains("paper-date-field");
        if ((activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName.toLowerCase()) !== "button" && (activeElement === null || activeElement === void 0 ? void 0 : activeElement.id) !== "request-quote-tabs" && !isDatePaper && !isVertical && !isMobile) setBackdropVisible(visible);
    }, [
        activeElement,
        isVertical,
        isMobile,
        wrapperRef
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $c7dc6b12feb87c0b$export$8665abbc450bac22), {
        "data-testid": "backdrop",
        onClick: onBackdropClick,
        open: backdropVisible,
        $layerIndex: layerIndex
    });
};




var $bd9423605f23f1cc$export$df0d1bc998a4783b = function(elements) {
    return function() {
        if (elements === null || elements === void 0 ? void 0 : elements.length) {
            var _document_body = document.body, width = _document_body.clientWidth, clientHeight = _document_body.clientHeight;
            var height = clientHeight;
            elements.forEach(function(el) {
                var bottom = el.getBoundingClientRect().bottom;
                height = Math.max(height, bottom);
            });
            window.parent.postMessage({
                type: "size",
                width: width,
                height: height
            }, "*");
        }
    };
};
var $bd9423605f23f1cc$export$8ecdcf3bb089e9cd = function() {
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), elements = _useState[0], setElements = _useState[1];
    (0, $fZLIC$react.useEffect)($bd9423605f23f1cc$export$df0d1bc998a4783b(elements), [
        elements
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        var domObserver = new MutationObserver(function() {
            var paperRoots = document.querySelectorAll(".MuiPaper-root");
            setElements(paperRoots);
        });
        domObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
        return function() {
            return domObserver.disconnect();
        };
    }, []);
};


var $26f8e683f710da3a$export$d3c1860ee66f291a = function() {
    (0, $bd9423605f23f1cc$export$8ecdcf3bb089e9cd)();
    return null;
};























var $03dedb3d82d4da43$export$6cb1578e30bfa58d = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesCheckbox.CheckboxWithLabel)).withConfig({
    displayName: "CheckboxFieldstyled__CheckboxWithLabel",
    componentId: "sc-1se2bx7-0"
})([
    "label.root{margin-right:4px;}"
]);


var $f5ef803507eb3797$export$94195a47b94ed396 = function(props) {
    var name = props.name, defaultValue = props.defaultValue, control = props.control, rules = props.rules, label = props.label, error = props.error, tooltip = props.tooltip;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$reacthookform.Controller), {
        name: name,
        defaultValue: defaultValue,
        control: control,
        rules: rules,
        render: function(_param) {
            var _param_field = _param.field, ref = _param_field.ref, value = _param_field.value, field = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(_param.field, [
                "ref",
                "value"
            ]);
            return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $03dedb3d82d4da43$export$6cb1578e30bfa58d), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, field), {
                checked: value,
                label: label,
                error: !!error,
                errorText: error === null || error === void 0 ? void 0 : error.message,
                tooltip: tooltip
            }));
        }
    });
};








var $9e333e2d715c0570$export$6be2e8bf8b1f51ed = function(props) {
    var name = props.name, defaultValue = props.defaultValue, control = props.control, rules = props.rules, label = props.label, fieldValue = props.value, tooltip = props.tooltip;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$reacthookform.Controller), {
        name: name,
        defaultValue: defaultValue,
        control: control,
        rules: rules,
        render: function(_param) {
            var _param_field = _param.field, ref = _param_field.ref, value = _param_field.value, field = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(_param.field, [
                "ref",
                "value"
            ]);
            return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesRadioButtons.RadioButton), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, field), {
                checked: value === fieldValue,
                value: fieldValue,
                label: label,
                tooltip: tooltip
            }));
        }
    });
};










var $dc8297a289248390$export$dd2171e2b7d3bc5b = function(props) {
    var name = props.name, defaultValue = props.defaultValue, control = props.control, rules = props.rules, label = props.label, type = props.type, error = props.error, prefix = props.prefix, _props_optional = props.optional, optional = _props_optional === void 0 ? false : _props_optional, className = props.className;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$reacthookform.Controller), {
        name: name,
        defaultValue: defaultValue,
        control: control,
        rules: rules,
        render: function(_param) {
            var ref = _param.field.ref, field = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(_param.field, [
                "ref"
            ]);
            return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesInput.Input), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, field), {
                label: label,
                type: type,
                error: !!error,
                errorText: error === null || error === void 0 ? void 0 : error.message,
                ref: ref,
                prefix: prefix,
                optional: optional,
                className: className
            }));
        }
    });
};


var $f6ff4336f8e71b26$export$9c63d5f99621b74f = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "AdditionalServicesstyled__CustomBondSection",
    componentId: "sc-s66erk-0"
})([
    "padding-left:20px;"
]);
var $f6ff4336f8e71b26$export$7f714e6c560938e5 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).span.withConfig({
    displayName: "AdditionalServicesstyled__ErrorText",
    componentId: "sc-s66erk-1"
})([
    "",
    ";",
    ";color:",
    ";"
], function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.e400;
});
var $f6ff4336f8e71b26$export$dd2171e2b7d3bc5b = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $dc8297a289248390$export$dd2171e2b7d3bc5b)).withConfig({
    displayName: "AdditionalServicesstyled__InputField",
    componentId: "sc-s66erk-2"
})([
    "margin-left:20px;max-width:180px;margin-bottom:10px;display:block;"
]);



var $cc63c10aa22f3fc9$export$9114fa93825a83c4 = function(param) {
    var isChecked = param.isChecked, t = param.t;
    return {
        value: isChecked,
        message: t("validation:required")
    };
};
var $cc63c10aa22f3fc9$export$412cb0cf6752ffce = function(param) {
    var cargoValueCurrency = param.cargoValueCurrency, t = param.t;
    return function(value) {
        var currency = cargoValueCurrency !== null && cargoValueCurrency !== void 0 ? cargoValueCurrency : "USD";
        return Number(value) < (0, $f9f89a5c82b78d91$export$76bdc0f2d52759a6)[currency] ? true : t("validation:customBonds.maxLimit", {
            context: currency,
            maxLimit: (0, $f9f89a5c82b78d91$export$76bdc0f2d52759a6)[currency].toLocaleString("en-EN")
        });
    };
};


var $15e851c9bf86d900$export$293fdcc611d2e8e2 = function(props) {
    var _values_additionalServices, _errors_additionalServices, _errors_additionalServices1;
    var control = props.control, additionalServices = props.additionalServices, errors = props.errors, _props_showLiftGate = props.showLiftGate, showLiftGate = _props_showLiftGate === void 0 ? true : _props_showLiftGate;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(Boolean(additionalServices === null || additionalServices === void 0 ? void 0 : additionalServices.customBond)), 2), checkedCustomBonds = _useState[0], setCheckedCustomBonds = _useState[1];
    var values = (0, $fZLIC$reacthookform.useWatch)({
        control: control
    });
    var customBondValue = (_values_additionalServices = values.additionalServices) === null || _values_additionalServices === void 0 ? void 0 : _values_additionalServices.customBond;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
        container: true,
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f5ef803507eb3797$export$94195a47b94ed396), {
                    control: control,
                    name: "additionalServices.importCustomClearance",
                    label: t("additionalServicesField.importCustomsClearance.label"),
                    tooltip: t("additionalServicesField.importCustomsClearance.tooltip")
                })
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesCheckbox.CheckboxWithLabel), {
                        onChange: function() {
                            return setCheckedCustomBonds(function(prev) {
                                return !prev;
                            });
                        },
                        checked: checkedCustomBonds,
                        name: "customBonds",
                        label: t("additionalServicesField.customBonds.label"),
                        tooltip: t("additionalServicesField.customBonds.tooltip")
                    }),
                    checkedCustomBonds && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        container: true,
                        component: (0, $f6ff4336f8e71b26$export$9c63d5f99621b74f),
                        children: [
                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                item: true,
                                xs: 12,
                                children: [
                                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $9e333e2d715c0570$export$6be2e8bf8b1f51ed), {
                                        control: control,
                                        name: "additionalServices.customBond",
                                        label: t("additionalServicesField.customBondsField.singleBond.label"),
                                        value: "needsSingleBond",
                                        tooltip: t("additionalServicesField.customBondsField.singleBond.tooltip"),
                                        rules: {
                                            required: (0, $cc63c10aa22f3fc9$export$9114fa93825a83c4)({
                                                isChecked: checkedCustomBonds,
                                                t: t
                                            })
                                        }
                                    }),
                                    customBondValue === "needsSingleBond" && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f6ff4336f8e71b26$export$dd2171e2b7d3bc5b), {
                                        control: control,
                                        name: "additionalServices.cargoValue",
                                        label: t("additionalServicesField.customBondsField.cargoValue"),
                                        prefix: additionalServices === null || additionalServices === void 0 ? void 0 : additionalServices.cargoValueCurrency,
                                        rules: {
                                            required: (0, $cc63c10aa22f3fc9$export$9114fa93825a83c4)({
                                                isChecked: Boolean(customBondValue),
                                                t: t
                                            }),
                                            validate: (0, $cc63c10aa22f3fc9$export$412cb0cf6752ffce)({
                                                cargoValueCurrency: additionalServices === null || additionalServices === void 0 ? void 0 : additionalServices.cargoValueCurrency,
                                                t: t
                                            })
                                        },
                                        error: (_errors_additionalServices = errors.additionalServices) === null || _errors_additionalServices === void 0 ? void 0 : _errors_additionalServices.cargoValue,
                                        type: "text"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $9e333e2d715c0570$export$6be2e8bf8b1f51ed), {
                                    control: control,
                                    name: "additionalServices.customBond",
                                    label: t("additionalServicesField.customBondsField.aContinuousBond.label"),
                                    value: "needContinuesBond",
                                    tooltip: t("additionalServicesField.customBondsField.aContinuousBond.tooltip"),
                                    rules: {
                                        required: (0, $cc63c10aa22f3fc9$export$9114fa93825a83c4)({
                                            isChecked: checkedCustomBonds,
                                            t: t
                                        })
                                    }
                                })
                            }),
                            ((_errors_additionalServices1 = errors.additionalServices) === null || _errors_additionalServices1 === void 0 ? void 0 : _errors_additionalServices1.customBond) && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f6ff4336f8e71b26$export$7f714e6c560938e5), {
                                    children: errors.additionalServices.customBond.message
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f5ef803507eb3797$export$94195a47b94ed396), {
                    control: control,
                    name: "additionalServices.residencyDelivery",
                    label: t("additionalServicesField.residencyDelivery.label"),
                    tooltip: t("additionalServicesField.residencyDelivery.tooltip")
                })
            }),
            showLiftGate && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f5ef803507eb3797$export$94195a47b94ed396), {
                    control: control,
                    name: "additionalServices.liftGate",
                    label: t("additionalServicesField.liftGateAtDestination.label"),
                    tooltip: t("additionalServicesField.liftGateAtDestination.tooltip")
                })
            })
        ]
    });
};























var $a81590f7203e2308$export$d55b50a564d0b931 = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var name = props.name, defaultValue = props.defaultValue, control = props.control, rules = props.rules, label = props.label, options = props.options, error = props.error, _props_optional = props.optional, optional = _props_optional === void 0 ? false : _props_optional, className = props.className, classes = props.classes, maxMenuHeight = props.maxMenuHeight, helperText = props.helperText;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$reacthookform.Controller), {
        name: name,
        defaultValue: defaultValue,
        control: control,
        rules: rules,
        render: function(_param) {
            var ref = _param.field.ref, _param_fieldState = _param.fieldState, fieldError = _param_fieldState.error, field = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(_param.field, [
                "ref"
            ]);
            /*#__PURE__*/ return (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesSelect.Select), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, field), {
                label: label,
                options: options,
                error: !!error || !!fieldError,
                errorText: (error === null || error === void 0 ? void 0 : error.message) || (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message),
                ref: ref,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                noOptionsMessage: t("noResultsFound"),
                SelectLabelProps: {
                    required: !optional
                },
                className: className,
                classes: classes,
                maxMenuHeight: maxMenuHeight,
                helperText: helperText
            }));
        }
    });
};




var $de0c72a036a07041$export$a6b7c34d56975de0 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 30 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 25 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.p500;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 30 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("rect", {
                x: "0.65",
                y: "0.65",
                width: "28.7",
                height: "23.7",
                rx: "2.35",
                fill: "white",
                stroke: fillColor,
                strokeWidth: "1.3"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M8.4375 12.5H21.5625",
                stroke: fillColor,
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M15 6.40625V18.5938",
                stroke: fillColor,
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};




var $190b8b1072325b25$export$6382847193091a26 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 30 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 25 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.e600;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 30 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("rect", {
                x: "0.65",
                y: "0.65",
                width: "28.7",
                height: "23.7",
                rx: "2.35",
                fill: "white",
                stroke: fillColor,
                strokeWidth: "1.3"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M8.4375 12.5H21.5625",
                stroke: fillColor,
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};








function $83aeeaefadd710af$export$5f2601f258746c91(options, t, value) {
    var selectedOption = options.find(function(option) {
        return option.value === value;
    });
    if (!selectedOption) return;
    return {
        label: t(selectedOption.label),
        value: selectedOption.value
    };
}
var $83aeeaefadd710af$export$a27e99e9c54fb5b1 = function(options, t) {
    return options.map(function(option) {
        return {
            label: t(option.label),
            value: option.value,
            helperText: t(option.helperText),
            accept: option.accept
        };
    });
};
var $83aeeaefadd710af$export$56d29b7bdc61e703 = function(options, t) {
    options.splice(0, 1, {
        label: t(options[0].label),
        value: options[0].value
    });
    return options;
};


var $942284d646ad1acb$var$_findOptionByValue, $942284d646ad1acb$var$_findOptionByValue1;
var $942284d646ad1acb$export$c40d15b0b7beba46 = function(param) {
    var items = param.items, t = param.t;
    return items.map(function(item) {
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, item), {
            weightUnit: ($942284d646ad1acb$var$_findOptionByValue = (0, $83aeeaefadd710af$export$5f2601f258746c91)((0, $eaa2f94cbeae9674$export$5e5167c0772daa2), t, item.weightUnit)) !== null && $942284d646ad1acb$var$_findOptionByValue !== void 0 ? $942284d646ad1acb$var$_findOptionByValue : {
                label: t("cargoDetails.weightUnit.KG"),
                value: "KG"
            },
            lengthUnit: ($942284d646ad1acb$var$_findOptionByValue1 = (0, $83aeeaefadd710af$export$5f2601f258746c91)((0, $eaa2f94cbeae9674$export$aff720a9602337cd), t, item.lengthUnit)) !== null && $942284d646ad1acb$var$_findOptionByValue1 !== void 0 ? $942284d646ad1acb$var$_findOptionByValue1 : {
                label: t("cargoDetails.lengthUnit.CM"),
                value: "CM"
            }
        });
    });
};
var $942284d646ad1acb$var$_findOptionByValue2;
var $942284d646ad1acb$export$1d4c38911efb8d0 = function(param) {
    var containers = param.containers, t = param.t;
    return containers.map(function(item) {
        return {
            quantity: item.quantity,
            type: ($942284d646ad1acb$var$_findOptionByValue2 = (0, $83aeeaefadd710af$export$5f2601f258746c91)((0, $eaa2f94cbeae9674$export$e4abac893f36ee97), t, item.type)) !== null && $942284d646ad1acb$var$_findOptionByValue2 !== void 0 ? $942284d646ad1acb$var$_findOptionByValue2 : {
                label: "cargoDetails.containerTypes.DV20",
                value: "DV20"
            }
        };
    });
};
var $942284d646ad1acb$export$d68c4768adc93e96 = function(items) {
    return items.length > 0 && items.every(function(f) {
        return f.quantity > 0 && f.weight > 0 && f.length > 0 && f.height > 0 && f.width > 0;
    });
};
var $942284d646ad1acb$export$26ad4226e7d4106b = function(density) {
    return density <= (0, $f9f89a5c82b78d91$export$3704da88d06f7184);
};
var $942284d646ad1acb$export$b86acab1458a54b3 = function(item) {
    var weight = item.quantity * (item.weightUnit.value === "LB" ? (0, $aacba40b3ef80b2e$export$ba9f926cfed2060e)(item.weight) : item.weight);
    var cbm = (0, $8835a976e07ba158$export$69689a083948606a)({
        quantity: item.quantity,
        length: item.length,
        width: item.width,
        height: item.height,
        unit: item.lengthUnit.value,
        withRound: false
    });
    return weight / cbm;
};
var $942284d646ad1acb$export$5fe3d195c6c0f23f = function(items) {
    return items.every(function(item) {
        return $942284d646ad1acb$export$26ad4226e7d4106b($942284d646ad1acb$export$b86acab1458a54b3(item));
    });
};
var $942284d646ad1acb$export$fe9391c0fae85d5b = function(items, unitDimension, weightLimit) {
    return items.every(function(f) {
        var dimensionUnit = f.lengthUnit.value;
        var weightUnit = f.weightUnit.value;
        return f.length <= unitDimension[dimensionUnit].length && f.height <= unitDimension[dimensionUnit].height && f.width <= unitDimension[dimensionUnit].width && f.weight <= weightLimit[weightUnit];
    });
};
var $942284d646ad1acb$export$b8f20ad0f326cc23 = function(totalVolume, volumeUnit) {
    return totalVolume >= (0, $eaa2f94cbeae9674$export$f3b7d0d07fb5286c)[volumeUnit];
};
var $942284d646ad1acb$export$ade0d1d6a71534ac = function(totalVolume, volumeUnit) {
    return totalVolume <= (0, $eaa2f94cbeae9674$export$733799f508d9fb2f)[volumeUnit];
};
var $942284d646ad1acb$export$dcd325fe69cae6fb = function(totalWeight, weightUnit) {
    return totalWeight <= (0, $eaa2f94cbeae9674$export$8e337a6e8017f90f)[weightUnit];
};
var $942284d646ad1acb$export$810f5aa8a03cefdf = function(lclItem) {
    return lclItem.totalWeight > 0 && lclItem.totalVolume > 0;
};
var $942284d646ad1acb$export$5d923b038b8d3fde = function(lclItem) {
    if (lclItem.volumeUnit === "CIN") return (0, $aacba40b3ef80b2e$export$6b1ac9a7a2184942)(lclItem.totalVolume);
    if (lclItem.volumeUnit === "CFT") return (0, $aacba40b3ef80b2e$export$da5effc1351c84f7)(lclItem.totalVolume);
    return lclItem.totalVolume;
};
var $942284d646ad1acb$export$d2dee56c95d38623 = function(lclItem) {
    return lclItem.weightUnit === "LB" ? (0, $aacba40b3ef80b2e$export$ba9f926cfed2060e)(lclItem.totalWeight) : lclItem.totalWeight;
};
var $942284d646ad1acb$export$6a84ab2fa4616d71 = function(lclItem) {
    return $942284d646ad1acb$export$d2dee56c95d38623(lclItem) / $942284d646ad1acb$export$5d923b038b8d3fde(lclItem);
};
var $942284d646ad1acb$export$b5bd4e46a5271faa = function(containers) {
    return containers.reduce(function(r, a) {
        if (!a.type || !a.quantity) return r;
        var obj = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, r);
        obj[a.type.value] = r[a.type.value] ? Number(r[a.type.value]) + Number(a.quantity) : Number(a.quantity);
        return obj;
    }, {});
};
var $942284d646ad1acb$export$8b9d9a14b370f533 = function(totalVolume, volumeUnit) {
    return totalVolume <= (0, $f9f89a5c82b78d91$export$6c279875ca1a9388)[volumeUnit];
};
var $942284d646ad1acb$export$3083fdecff35bd7a = function(totalWeight, weightUnit) {
    return totalWeight <= (0, $f9f89a5c82b78d91$export$72b57fb2b65ee7b5)[weightUnit];
};







var $fb584bb570ddf491$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "DimensionsCargoDetailsstyled__Wrapper",
    componentId: "sc-1xhqyf0-0"
})([
    ""
]);
var $fb584bb570ddf491$export$32094dc47f9ea4e5 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "DimensionsCargoDetailsstyled__ContainerActions",
    componentId: "sc-1xhqyf0-1"
})([
    "display:flex;align-items:flex-end;justify-content:",
    ";flex-direction:column;@media ",
    "{justify-content:flex-end;}@media ",
    "{height:56px;margin-left:7px;}"
], function(props) {
    return props.$single ? "center" : "space-between";
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.theme.query.min.tablet;
});
var $fb584bb570ddf491$export$cfc7921d29ef7b80 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "DimensionsCargoDetailsstyled__ActionButton",
    componentId: "sc-1xhqyf0-2"
})([
    "@media ",
    "{cursor:pointer;width:30px;height:25px;display:flex;justify-content:",
    ";}@media ",
    "{margin-top:5px;}"
], function(props) {
    return props.theme.query.min.tablet;
}, function(props) {
    return props.$single ? "center" : "space-between";
}, function(props) {
    return props.theme.query.mobile;
});
var $fb584bb570ddf491$export$393edc798c47379d = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "DimensionsCargoDetailsstyled__Description",
    componentId: "sc-1xhqyf0-3"
})([
    "",
    " color:",
    ";@media ",
    "{display:none;}"
], function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.query.mobile;
});
var $fb584bb570ddf491$export$4e2e880d190f5abf = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "DimensionsCargoDetailsstyled__DescriptionMobile",
    componentId: "sc-1xhqyf0-4"
})([
    "",
    " color:",
    ";@media ",
    "{display:none;}"
], function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.query.min.tablet;
});
var $fb584bb570ddf491$export$bc7adc8ef74607f = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "DimensionsCargoDetailsstyled__RowWrapper",
    componentId: "sc-1xhqyf0-5"
})([
    "display:flex;margin-bottom:20px;&:last-child{margin-bottom:0;}@media ",
    "{flex-direction:column;}"
], function(props) {
    return props.theme.query.mobile;
});
var $fb584bb570ddf491$export$deafc66e4bed6a0c = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).span.withConfig({
    displayName: "DimensionsCargoDetailsstyled__MobileLabel",
    componentId: "sc-1xhqyf0-6"
})([
    "color:",
    ";",
    " text-transform:uppercase;@media ",
    "{display:none;}"
], function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.query.min.tablet;
});
var $fb584bb570ddf491$export$6d88ebe453be59d7 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesButton.Button)).withConfig({
    displayName: "DimensionsCargoDetailsstyled__AddButton",
    componentId: "sc-1xhqyf0-7"
})([
    "margin-bottom:10px;button.root{&:hover{background:",
    ";color:",
    ";}}"
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.p500;
});



var $4503b05492d55ed1$var$_RemoveIcon, $4503b05492d55ed1$var$_AddIcon;
var $4503b05492d55ed1$export$feae93fe8fedaeb3 = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), inIframe = _useContext.inIframe, isMobile = _useContext.isMobile, isDesktop = _useContext.isDesktop;
    var _useWidth = (0, $fZLIC$icontainersdesignsystemdistutils.useWidth)(), internalMobile = _useWidth.isMobile;
    var className = props.className, control = props.control, error = props.error, handleOnChange = props.handleOnChange, name = props.name, numberOfItemsLimit = props.numberOfItemsLimit, dimensionLimit = props.dimensionLimit, weightLimit = props.weightLimit, cargoType = props.cargoType;
    var _useFieldArray = (0, $fZLIC$reacthookform.useFieldArray)({
        control: control,
        name: name
    }), fields = _useFieldArray.fields, append = _useFieldArray.append, remove = _useFieldArray.remove;
    var items = fields;
    var cargoDetailItemsString = JSON.stringify(items);
    (0, $fZLIC$react.useEffect)(function() {
        if (!items.length) append({
            quantity: 1,
            weight: "",
            weightUnit: {
                label: "KG",
                value: "KG"
            },
            length: "",
            width: "",
            height: "",
            lengthUnit: {
                label: "CM",
                value: "CM"
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $fZLIC$react.useEffect)(function() {
        handleOnChange(items);
    }, [
        cargoDetailItemsString,
        items
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var lengthOptions = (0, $fZLIC$react.useMemo)(function() {
        return (0, $eaa2f94cbeae9674$export$aff720a9602337cd).map(function(type) {
            return {
                label: t(type.label),
                value: type.value
            };
        });
    }, [
        t
    ]);
    var weightOptions = (0, $fZLIC$react.useMemo)(function() {
        return (0, $eaa2f94cbeae9674$export$5e5167c0772daa2).map(function(type) {
            return {
                label: t(type.label),
                value: type.value
            };
        });
    }, [
        t
    ]);
    var chargeableWeight = (0, $fZLIC$react.useMemo)(function() {
        return (0, $8835a976e07ba158$export$1166235716d57e64)({
            items: items,
            chargeableWeightFactor: (0, $eaa2f94cbeae9674$export$bd9343c0e70bb103)
        });
    }, [
        cargoDetailItemsString
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    var totalWeight = (0, $fZLIC$react.useMemo)(function() {
        return (0, $8835a976e07ba158$export$167ceafb15c3e7b4)(items);
    }, [
        cargoDetailItemsString
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    var totalVolume = (0, $fZLIC$react.useMemo)(function() {
        return (0, $8835a976e07ba158$export$4ca74356a41f3701)(items);
    }, [
        cargoDetailItemsString
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    var totalUnits = (0, $fZLIC$react.useMemo)(function() {
        return (0, $8835a976e07ba158$export$b47858ac3291eb2a)(items);
    }, [
        cargoDetailItemsString
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var narrowSpace = inIframe && isDesktop && internalMobile;
    var showTotalWeightAndVolume = cargoType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).LCL || cargoType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).LTL;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$e6dfd72ab29f8598), {
        className: className,
        "data-testid": "DimensionsCargoDetails",
        children: [
            items.map(function(item, index) {
                /*#__PURE__*/ return (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$bc7adc8ef74607f), {
                    "data-testid": "ContainerRow",
                    children: [
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                            container: true,
                            children: [
                                /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                    item: true,
                                    xs: 12,
                                    sm: narrowSpace ? 12 : 5,
                                    children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                        container: true,
                                        children: [
                                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                item: true,
                                                xs: 4,
                                                spacingRight: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $dc8297a289248390$export$dd2171e2b7d3bc5b), {
                                                        control: control,
                                                        type: "number",
                                                        name: "".concat(name, "[").concat(index, "].quantity"),
                                                        label: t("cargoDetails.quantity"),
                                                        defaultValue: item.quantity,
                                                        error: (0, $8835a976e07ba158$export$a22775fa5e2eebd9)({
                                                            value: Number(item.quantity),
                                                            t: t,
                                                            error: error,
                                                            density: (0, $942284d646ad1acb$export$b86acab1458a54b3)(item)
                                                        })
                                                    }),
                                                    !isMobile && index === items.length - 1 && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fb584bb570ddf491$export$393edc798c47379d), {
                                                        children: "".concat(totalUnits, " ").concat(t("cargoDetails.unit", {
                                                            count: totalUnits
                                                        }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                container: true,
                                                item: true,
                                                xs: 8,
                                                children: [
                                                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                        item: true,
                                                        xs: 6,
                                                        xsSpacingRight: 2,
                                                        mdUpSpacingRight: 1,
                                                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $dc8297a289248390$export$dd2171e2b7d3bc5b), {
                                                            control: control,
                                                            type: "number",
                                                            name: "".concat(name, "[").concat(index, "].weight"),
                                                            label: t("cargoDetails.weight"),
                                                            defaultValue: item.weight,
                                                            error: (0, $8835a976e07ba158$export$a22775fa5e2eebd9)({
                                                                value: Number(item.weight),
                                                                density: (0, $942284d646ad1acb$export$b86acab1458a54b3)(item),
                                                                t: t,
                                                                error: error,
                                                                limit: weightLimit === null || weightLimit === void 0 ? void 0 : weightLimit[items[index].weightUnit.value]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                        item: true,
                                                        xs: 6,
                                                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $a81590f7203e2308$export$d55b50a564d0b931), {
                                                            control: control,
                                                            name: "".concat(name, "[").concat(index, "].weightUnit"),
                                                            label: t("cargoDetails.unit"),
                                                            options: weightOptions,
                                                            defaultValue: weightOptions.find(function(option) {
                                                                return option.value === items[index].weightUnit.value;
                                                            })
                                                        })
                                                    }),
                                                    !isMobile && index === items.length - 1 && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fb584bb570ddf491$export$393edc798c47379d), {
                                                        children: cargoType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR ? "".concat(t("cargoDetails.chargeableWeight"), ": ").concat(chargeableWeight, " ").concat(t("cargoDetails.weightUnit.KG")) : "".concat(t("cargoDetails.totalWeight"), ": ").concat(totalWeight, " ").concat(t("cargoDetails.weightUnit.KG"))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                    item: true,
                                    xs: 12,
                                    sm: narrowSpace ? 12 : 7,
                                    xsSpacingTop: 4,
                                    mdUpSpacingLeft: 2,
                                    children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                        container: true,
                                        children: [
                                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                item: true,
                                                xs: 3,
                                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $dc8297a289248390$export$dd2171e2b7d3bc5b), {
                                                    control: control,
                                                    type: "number",
                                                    name: "".concat(name, "[").concat(index, "].length"),
                                                    label: t("cargoDetails.length"),
                                                    defaultValue: item.length,
                                                    error: (0, $8835a976e07ba158$export$a22775fa5e2eebd9)({
                                                        value: Number(item.length),
                                                        density: (0, $942284d646ad1acb$export$b86acab1458a54b3)(item),
                                                        t: t,
                                                        error: error,
                                                        limit: dimensionLimit[items[index].lengthUnit.value].length
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                item: true,
                                                xs: 3,
                                                spacingLeft: 1,
                                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $dc8297a289248390$export$dd2171e2b7d3bc5b), {
                                                    control: control,
                                                    type: "number",
                                                    name: "".concat(name, "[").concat(index, "].width"),
                                                    label: t("cargoDetails.width"),
                                                    defaultValue: item.width,
                                                    error: (0, $8835a976e07ba158$export$a22775fa5e2eebd9)({
                                                        value: Number(item.width),
                                                        density: (0, $942284d646ad1acb$export$b86acab1458a54b3)(item),
                                                        t: t,
                                                        error: error,
                                                        limit: dimensionLimit[items[index].lengthUnit.value].width
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                item: true,
                                                xs: 3,
                                                spacingLeft: 1,
                                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $dc8297a289248390$export$dd2171e2b7d3bc5b), {
                                                    control: control,
                                                    type: "number",
                                                    name: "".concat(name, "[").concat(index, "].height"),
                                                    label: t("cargoDetails.height"),
                                                    defaultValue: item.height,
                                                    error: (0, $8835a976e07ba158$export$a22775fa5e2eebd9)({
                                                        value: Number(item.height),
                                                        density: (0, $942284d646ad1acb$export$b86acab1458a54b3)(item),
                                                        t: t,
                                                        error: error,
                                                        limit: dimensionLimit[items[index].lengthUnit.value].height
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                                item: true,
                                                xs: 3,
                                                spacingLeft: 1,
                                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $a81590f7203e2308$export$d55b50a564d0b931), {
                                                    control: control,
                                                    name: "".concat(name, "[").concat(index, "].lengthUnit"),
                                                    label: t("cargoDetails.unit"),
                                                    options: lengthOptions,
                                                    defaultValue: lengthOptions.find(function(option) {
                                                        return option.value === items[index].lengthUnit.value;
                                                    })
                                                })
                                            }),
                                            !isMobile && index === items.length - 1 && showTotalWeightAndVolume && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$393edc798c47379d), {
                                                children: [
                                                    t("cargoDetails.totalVolume"),
                                                    ": ",
                                                    totalVolume,
                                                    " ",
                                                    t("cargoDetails.volumeUnit.CBM")
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$32094dc47f9ea4e5), {
                            $single: items.length <= 1 || items.length === numberOfItemsLimit || index < items.length - 1,
                            children: [
                                items.length >= 2 && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$cfc7921d29ef7b80), {
                                    $single: items.length <= 1 || items.length === numberOfItemsLimit || index < items.length - 1,
                                    "data-testid": "RemoveContainerRowButton",
                                    onClick: (0, $8835a976e07ba158$export$fe2d9b4e03920b4c)({
                                        index: index,
                                        remove: remove,
                                        cargoType: cargoType
                                    }),
                                    children: [
                                        !isMobile && ($4503b05492d55ed1$var$_RemoveIcon || ($4503b05492d55ed1$var$_RemoveIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $190b8b1072325b25$export$6382847193091a26), {}))),
                                        isMobile && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fb584bb570ddf491$export$deafc66e4bed6a0c), {
                                            children: t("cargoDetails.remove")
                                        })
                                    ]
                                }, "remove".concat(index)),
                                !isMobile && index === items.length - 1 && index < numberOfItemsLimit - 1 && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fb584bb570ddf491$export$cfc7921d29ef7b80), {
                                    $single: items.length <= 1 || items.length === numberOfItemsLimit || index < items.length - 1,
                                    onClick: (0, $8835a976e07ba158$export$fb9705de59d96855)({
                                        append: append,
                                        cargoType: cargoType
                                    }),
                                    "data-testid": "AddMoreContainerButton",
                                    children: !isMobile && ($4503b05492d55ed1$var$_AddIcon || ($4503b05492d55ed1$var$_AddIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $de0c72a036a07041$export$a6b7c34d56975de0), {})))
                                }, "add".concat(index))
                            ]
                        })
                    ]
                }, "container".concat(item.id));
            }),
            isMobile && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                container: true,
                spacingBottom: 3,
                children: [
                    cargoType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        container: true,
                        xs: 12,
                        justifyContent: "flex-start",
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$4e2e880d190f5abf), {
                            children: [
                                t("cargoDetails.chargeableWeight"),
                                ": ",
                                chargeableWeight,
                                " ",
                                t("cargoDetails.weightUnit.KG")
                            ]
                        })
                    }),
                    showTotalWeightAndVolume && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        container: true,
                        xs: 6,
                        justifyContent: "flex-start",
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$4e2e880d190f5abf), {
                            children: [
                                t("cargoDetails.totalWeight"),
                                ": ",
                                totalWeight,
                                " ",
                                t("cargoDetails.weightUnit.KG")
                            ]
                        })
                    }),
                    showTotalWeightAndVolume && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        container: true,
                        xs: 6,
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fb584bb570ddf491$export$4e2e880d190f5abf), {
                            children: [
                                t("cargoDetails.totalVolume"),
                                ": ",
                                totalVolume,
                                " ",
                                t("cargoDetails.volumeUnit.CBM")
                            ]
                        })
                    })
                ]
            }),
            isMobile && items.length < numberOfItemsLimit && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fb584bb570ddf491$export$6d88ebe453be59d7), {
                onClick: (0, $8835a976e07ba158$export$fb9705de59d96855)({
                    append: append,
                    cargoType: cargoType
                }),
                colorStyle: "secondary",
                size: "small",
                fullWidth: true,
                label: t("cargoDetails.addMore")
            })
        ]
    });
};










var $6535b460e348cf17$export$2b77a92f1a5ad772 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistorganismsModal.Modal)).attrs(function() {
    return {
        classes: {
            footer: "footer"
        }
    };
}).withConfig({
    displayName: "KnownShipperModalstyled__Modal",
    componentId: "sc-195h18u-0"
})([
    ".footer{span{text-transform:uppercase;text-decoration:none;}}"
]);
var $6535b460e348cf17$export$393edc798c47379d = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "KnownShipperModalstyled__Description",
    componentId: "sc-195h18u-1"
})([
    "",
    " div{margin:15px 0px;}"
], function(props) {
    return props.theme.typo.bodyM;
});


var $d2caefc86ebc2a46$var$_Description;
var $d2caefc86ebc2a46$export$b20cab25e01587d9 = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6535b460e348cf17$export$2b77a92f1a5ad772), {
        size: (0, $fZLIC$icontainersdesignsystemdistorganismsModal.ModalSize).Small,
        title: t("cargoDetails.knownShipperModal.title"),
        isOpen: isOpen,
        onClose: onClose,
        onConfirm: onClose,
        confirmBtnText: t("cargoDetails.knownShipperModal.button"),
        hideCancelButton: true,
        children: $d2caefc86ebc2a46$var$_Description || ($d2caefc86ebc2a46$var$_Description = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6535b460e348cf17$export$393edc798c47379d), {
            children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $88150c5c731a6db0$export$8d6a9236f2e3f2ce), {
                i18nKey: "cargoDetails.knownShipperModal.description",
                children: [
                    "A Known Shipper, particularly in air freight, refers to an individual or organization that has been pre-screened and approved by a carrier or government agency as being a low-risk shipment source.",
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("div", {
                        children: "The known shipper designation allows the individual or organization to ship goods without additional security screenings on passenger and cargo planes."
                    }),
                    "Please note that ",
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("b", {
                        children: "you don’t need to be a Known Shipper to book through our platform."
                    })
                ]
            })
        }))
    });
};








var $47b95f3304fee7b7$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "KnownShipperstyled__Wrapper",
    componentId: "sc-113fgof-0"
})([
    "@media ",
    "{display:flex;align-items:center;}& > div.root{width:auto;}label{align-items:start;@media ",
    "{align-items:center;}@media ",
    "{.MuiCheckbox-root{margin-top:2px;}}}"
], function(props) {
    return props.theme.query.min.tablet;
}, function(props) {
    return props.theme.query.min.tablet;
}, function(props) {
    return props.theme.query.mobile;
});
var $47b95f3304fee7b7$export$4772a6b0d09e1d41 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistatomsLink.Link)).withConfig({
    displayName: "KnownShipperstyled__ModalAction",
    componentId: "sc-113fgof-1"
})([
    "margin:5px 0px 10px 27px;@media ",
    "{margin:0px;margin:0px;}"
], function(props) {
    return props.theme.query.min.tablet;
});


var $a20345782a086812$export$313c6d35f75fc0e = function(setIsOpen, isOpen) {
    return function() {
        setIsOpen(isOpen);
    };
};


var $60c8bb12836214b3$export$48be23ec4c0667f5 = function(props) {
    var control = props.control;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $47b95f3304fee7b7$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f5ef803507eb3797$export$94195a47b94ed396), {
                control: control,
                name: "knownShipper",
                label: t("cargoDetails.entitySendingGoods"),
                defaultValue: true
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $47b95f3304fee7b7$export$4772a6b0d09e1d41), {
                onClick: (0, $a20345782a086812$export$313c6d35f75fc0e)(setIsOpen, true),
                children: t("cargoDetails.whoIsKnownShipper")
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $d2caefc86ebc2a46$export$b20cab25e01587d9), {
                isOpen: isOpen,
                onClose: (0, $a20345782a086812$export$313c6d35f75fc0e)(setIsOpen, false)
            })
        ]
    });
};








var $24c7a71cd12612cd$export$a7fed597f4b8afd8 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).form.attrs({
    tabIndex: 0
}).withConfig({
    displayName: "RequestQuoteFormstyled__Form",
    componentId: "sc-14hdm1k-0"
})([
    "display:flex;align-items:start;",
    " ",
    " ",
    " label{overflow:unset;}.commodity-select-field{.commodity-select-menu-item{padding:8px;}.commodity-select-label{",
    "}.commodity-helper-text{color:",
    ";font-style:normal;}}.origin-location-input-wrapper{border-top-left-radius:7px;border-bottom-left-radius:7px;}",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.$showLeftMultiModeTabs && "flex: auto; max-width: 1042px; justify-content: flex-start;";
}, function(props) {
    return props.theme.typo.displayM;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.$inIframe && (props.$isTablet || props.$isDesktop) && !props.$isVertical && props.$isFocus && "z-index: ".concat(props.$layerIndex + 1, "; position: relative;");
}, function(props) {
    return !props.$inIframe && !props.$isVertical && props.$isFocus && "@media ".concat(props.theme.query.min.tablet, " {\n      z-index: ").concat(props.$layerIndex + 1, "; \n      position: relative;\n    }\n    ");
}, function(props) {
    return props.$isVertical && "gap: 20px;\n  flex-direction: column;";
}, function(props) {
    return props.$inIframe && props.$isMobile && "\n    gap: 20px;\n    flex-direction: column;\n    padding: 10px;\n    ";
}, function(props) {
    return !props.$inIframe && "@media ".concat(props.theme.query.mobile, " {\n        gap: 20px;\n        flex-direction: column;\n        padding: 10px;\n      }\n    ");
}, function(props) {
    return props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance && "\n    flex-direction:row;\n    flex-wrap: wrap;\n    gap: 0;\n    background-color: ".concat(props.theme.color.white, ";\n\n    @media ").concat(props.theme.query.mobile, " {\n      gap: 0;\n    }\n\n    > * {\n      flex: 1 0 100%;\n    }\n\n    .origin-location-wrapper {\n      padding-right: 8px;\n\n      @media ").concat(props.theme.query.mobile, " {\n        padding-right: 0px;\n      }\n    }\n    .origin-location-wrapper,\n    .destination-location-wrapper {\n      flex: 1 0 50%;\n      position:relative;\n\n      @media ").concat(props.theme.query.mobile, " {\n        margin-bottom: 16px;\n      }\n    }\n  ");
});
var $24c7a71cd12612cd$export$94ec63f36c20dec6 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesButton.Button)).withConfig({
    displayName: "RequestQuoteFormstyled__QuoteButton",
    componentId: "sc-14hdm1k-1"
})([
    ".root{background-color:",
    ";&:hover,&:active{background-color:",
    ";}height:75px;width:142px;border-radius:0 7px 7px 0;",
    " ",
    " ",
    "}",
    " ",
    " ",
    ""
], function(props) {
    return props.searchButtonColor ? props.theme.color[props.searchButtonColor] : props.theme.color.a500;
}, function(props) {
    return props.searchButtonHoverColor ? props.theme.color[props.searchButtonHoverColor] : props.theme.color.a600;
}, function(props) {
    return (props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance) && " border-radius: 3px;\n    width: 100%;\n    height: 48px;";
}, function(props) {
    return props.$inIframe && props.$isMobile && "\n      border-radius: 3px;\n      width: 100%;\n      height: 48px;\n      ";
}, function(props) {
    return !props.$inIframe && "@media ".concat(props.theme.query.mobile, " {\n          border-radius: 3px;\n          width: 100%;\n          height: 48px;\n        }\n      ");
}, function(props) {
    return (props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance) && "width: 100%;";
}, function(props) {
    return props.$inIframe && props.$isMobile && "\n    width: 100%;\n    ";
}, function(props) {
    return !props.$inIframe && "@media ".concat(props.theme.query.mobile, " {\n        width: 100%;\n      }\n    ");
});
var $24c7a71cd12612cd$export$1ff3c3f08ae963c0 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "RequestQuoteFormstyled__Separator",
    componentId: "sc-14hdm1k-2"
})([
    "background:",
    ";height:75px;&:after{content:' ';border-right:0.7px solid ",
    ";height:45px;margin-top:15px;display:block;}",
    " ",
    " ",
    ""
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g200;
}, function(props) {
    return (props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance) && "display:none;";
}, function(props) {
    return props.$inIframe && props.$isMobile && "\n    display: none;\n    ";
}, function(props) {
    return !props.$inIframe && "@media ".concat(props.theme.query.mobile, " {\n        display: none;\n      }\n    ");
});
var $24c7a71cd12612cd$export$451bf11a19917b08 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistorganismsSlideOut.SlideOut)).withConfig({
    displayName: "RequestQuoteFormstyled__SlideOut",
    componentId: "sc-14hdm1k-3"
})([
    "& > div{background-color:",
    ";}.location-slide-out-box{margin-top:20px;position:relative;}"
], function(props) {
    return props.theme.color.g100;
});
var $24c7a71cd12612cd$export$c3d67bc338dde5ad = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "RequestQuoteFormstyled__SlideOutInner",
    componentId: "sc-14hdm1k-4"
})([
    "padding-top:50px;"
]);
var $24c7a71cd12612cd$export$5d7f344c70fb427d = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesButton.Button)).withConfig({
    displayName: "RequestQuoteFormstyled__FindRateButton",
    componentId: "sc-14hdm1k-5"
})([
    ".root{background-color:",
    ";&:hover,&:active{background-color:",
    ";}}"
], function(props) {
    return props.searchButtonColor ? props.theme.color[props.searchButtonColor] : props.theme.color.a500;
}, function(props) {
    return props.searchButtonHoverColor ? props.theme.color[props.searchButtonHoverColor] : props.theme.color.a600;
});
var $24c7a71cd12612cd$export$449e05ff40298396 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "RequestQuoteFormstyled__IframeBackdrop",
    componentId: "sc-14hdm1k-6"
})([
    "position:absolute;z-index:-1;width:100%;height:100%;background:transparent;top:0px;left:0px;"
]);
var $24c7a71cd12612cd$export$f99233281efd08a0 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).h3.withConfig({
    displayName: "RequestQuoteFormstyled__Title",
    componentId: "sc-14hdm1k-7"
})([
    "",
    " ",
    " color:",
    ";text-transform:uppercase;margin-bottom:8px;margin-top:24px;&:first-child{margin-top:16px;}"
], function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.fontWeight.bold;
}, function(props) {
    return props.theme.color.p500;
});












var $f7be0e19be452f2e$export$d9781c7894a82487 = function(props) {
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$reacthookform.Controller), {
        name: props.name,
        defaultValue: props.defaultValue,
        control: props.control,
        rules: props.rules,
        render: function(_param) {
            var ref = _param.field.ref, _param_fieldState = _param.fieldState, fieldError = _param_fieldState.error, field = (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_without_propertiesjs)))(_param.field, [
                "ref"
            ]);
            var _props_error;
            /*#__PURE__*/ return (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesDatePicker.DatePicker), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, field), {
                PaperProps: {
                    className: "paper-date-field"
                },
                maxDate: props.maxDate,
                minDate: props.minDate,
                label: props.label,
                error: !!props.error || !!fieldError,
                errorText: ((_props_error = props.error) === null || _props_error === void 0 ? void 0 : _props_error.message) || (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message)
            }));
        }
    });
};



var $0ad027ed42da55a6$export$973dc8673c936db8 = function(props) {
    var control = props.control, name = props.name, maxDate = props.maxDate, defaultValue = props.defaultValue, error = props.error;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f7be0e19be452f2e$export$d9781c7894a82487), {
        name: name,
        defaultValue: defaultValue,
        control: control,
        rules: {
            required: {
                value: true,
                message: t("validation:required")
            }
        },
        maxDate: maxDate,
        minDate: new Date(),
        label: t("cargoReadyDate"),
        error: error
    });
};






var $7c4386e529c93c3b$export$eb747620ce9c5e16 = {
    regularCargo: "regularCargo",
    householdGoods: "householdGoods",
    hazardousMaterial: "hazardousMaterial",
    freshProduct: "freshProduct",
    tempControlled: "tempControlled",
    usedItems: "usedItems",
    liveAnimals: "liveAnimals",
    reeferCargo: "reeferCargo"
};


var $de661b7a1555db76$export$bc49a40b3c2eebb2 = [
    {
        label: "commodity.regularCargo.label",
        value: (0, $7c4386e529c93c3b$export$eb747620ce9c5e16).regularCargo,
        helperText: "commodity.regularCargo.description",
        accept: true
    },
    {
        label: "commodity.householdGoods.label",
        value: (0, $7c4386e529c93c3b$export$eb747620ce9c5e16).householdGoods,
        helperText: "commodity.householdGoods.description",
        accept: true
    },
    {
        label: "commodity.hazardousMaterial.label",
        value: (0, $7c4386e529c93c3b$export$eb747620ce9c5e16).hazardousMaterial,
        helperText: "commodity.hazardousMaterial.description",
        accept: true
    },
    {
        label: "commodity.freshProduct.label",
        value: (0, $7c4386e529c93c3b$export$eb747620ce9c5e16).freshProduct,
        helperText: "commodity.freshProduct.description",
        accept: true
    },
    {
        label: "commodity.tempControlled.label",
        value: (0, $7c4386e529c93c3b$export$eb747620ce9c5e16).tempControlled,
        helperText: "commodity.tempControlled.description",
        accept: true
    },
    {
        label: "commodity.usedItems.label",
        value: (0, $7c4386e529c93c3b$export$eb747620ce9c5e16).usedItems,
        helperText: "commodity.usedItems.description",
        accept: false
    },
    {
        label: "commodity.liveAnimals.label",
        value: (0, $7c4386e529c93c3b$export$eb747620ce9c5e16).liveAnimals,
        helperText: "commodity.liveAnimals.description",
        accept: false
    }
];
var $de661b7a1555db76$export$96fda7c02ce0cfdc = [
    {
        label: "dontKnow",
        value: undefined
    },
    {
        label: "50",
        value: "50"
    },
    {
        label: "55",
        value: "55"
    },
    {
        label: "60",
        value: "60"
    },
    {
        label: "65",
        value: "65"
    },
    {
        label: "70",
        value: "70"
    },
    {
        label: "77.5",
        value: "77.5"
    },
    {
        label: "85",
        value: "85"
    },
    {
        label: "92.5",
        value: "92.5"
    },
    {
        label: "100",
        value: "100"
    },
    {
        label: "110",
        value: "110"
    },
    {
        label: "125",
        value: "125"
    },
    {
        label: "150",
        value: "150"
    },
    {
        label: "175",
        value: "175"
    },
    {
        label: "200",
        value: "200"
    },
    {
        label: "250",
        value: "250"
    },
    {
        label: "300",
        value: "300"
    },
    {
        label: "400",
        value: "400"
    },
    {
        label: "500",
        value: "500"
    }
];



var $7cd13e70834b5770$export$e6f3370000441ca5 = function(param) {
    var t = param.t;
    return function(value) {
        if (!(value === null || value === void 0 ? void 0 : value.value)) return t("validation:required");
        if (!value.accept) return t("validation:cargo.commodityNotAccepted");
        return true;
    };
};


var $b105d9c138188b44$export$9c5b6790316e7872 = function(props) {
    var control = props.control, name = props.name, defaultValue = props.defaultValue, error = props.error;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var commodityOptions = (0, $fZLIC$react.useMemo)(function() {
        return (0, $83aeeaefadd710af$export$a27e99e9c54fb5b1)((0, $de661b7a1555db76$export$bc49a40b3c2eebb2), t);
    }, []);
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $a81590f7203e2308$export$d55b50a564d0b931), {
        name: name,
        defaultValue: defaultValue,
        control: control,
        error: error,
        options: commodityOptions,
        optional: false,
        className: "commodity-select-field",
        classes: {
            helperText: "commodity-helper-text",
            selectOptionLabel: "commodity-select-label",
            selectMenuItem: "commodity-select-menu-item"
        },
        maxMenuHeight: 180,
        label: t("commoditySelectLabel"),
        rules: {
            required: {
                value: true,
                message: t("validation:required")
            },
            validate: {
                commodity: (0, $7cd13e70834b5770$export$e6f3370000441ca5)({
                    t: t
                })
            }
        }
    });
};


var $a571894262ae33f7$export$41207ad329a776a2 = function() {
    var currentDate = new Date();
    var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    var difference = lastDayOfMonth.getTime() - currentDate.getTime();
    var differenceInDays = Math.ceil(difference / 86400000);
    if (differenceInDays < 15) {
        currentDate.setDate(currentDate.getDate() + 15);
        return currentDate;
    } else return lastDayOfMonth;
};
var $a571894262ae33f7$export$17029b467e4298ef = function(param) {
    var date = param.date, months = param.months;
    var newDate = new Date(date);
    var currentMonthNumber = newDate.getMonth();
    var nextMonthNumber = currentMonthNumber + months;
    newDate.setMonth(nextMonthNumber);
    return newDate;
};
var $a571894262ae33f7$export$7ab4638b6a8ab893 = function() {
    var currentDate = new Date();
    return $a571894262ae33f7$export$17029b467e4298ef({
        date: currentDate,
        months: 3
    });
};
var $a571894262ae33f7$export$d2f509aaed4644ff = function(dateString) {
    var time = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "00:00:00";
    return dateString.length > 10 ? dateString : "".concat(dateString, " ").concat(time);
};






var $6d697c1d67fd681d$export$5a7695a543d88fc6 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "AirCargoDetailsstyled__AirCargoDetailsWrapper",
    componentId: "sc-wcr5m4-0"
})([
    ""
]);


var $3db1d8d09bf8ce1c$export$f31a5f4e4c9d053a = function(param) {
    var value = param.value, t = param.t;
    if (!value) return {
        message: t("validation:required")
    };
    return undefined;
};


var $d733fe40fd812310$export$11ea7460d9721013 = function(props) {
    var className = props.className, control = props.control, name = props.name, loading = props.loading, isVertical = props.isVertical, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, error = props.error, dateError = props.dateError, commodityError = props.commodityError, onChange = props.onChange, _props_showSubmitButton = props.showSubmitButton, showSubmitButton = _props_showSubmitButton === void 0 ? false : _props_showSubmitButton;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), inIframe = _useContext.inIframe, isMobile = _useContext.isMobile, showCommodity = _useContext.showCommodity, showKnownShipper = _useContext.showKnownShipper, showCargoReadyDateForAir = _useContext.showCargoReadyDateForAir;
    var values = (0, $fZLIC$reacthookform.useWatch)({
        control: control
    });
    var todayPlus2Week = (0, $a571894262ae33f7$export$41207ad329a776a2)();
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $6d697c1d67fd681d$export$5a7695a543d88fc6), {
        className: className,
        $isVertical: isVertical || isMobile,
        $inIframe: inIframe,
        "data-testid": "AirCargoDetails",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $4503b05492d55ed1$export$feae93fe8fedaeb3), {
                cargoType: (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR,
                name: name,
                control: control,
                error: error,
                handleOnChange: onChange,
                numberOfItemsLimit: (0, $eaa2f94cbeae9674$export$d03ca40afb5afa22),
                dimensionLimit: (0, $f9f89a5c82b78d91$export$dabdc168ed3d84c6),
                weightLimit: (0, $f9f89a5c82b78d91$export$f237b4fe6260e0a4)
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                container: true,
                children: [
                    showCargoReadyDateForAir && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        sm: 4,
                        mdUpSpacingRight: 2,
                        spacingTop: 3,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $0ad027ed42da55a6$export$973dc8673c936db8), {
                            control: control,
                            name: "cargoReadyDate",
                            maxDate: todayPlus2Week,
                            defaultValue: null,
                            error: dateError ? (0, $3db1d8d09bf8ce1c$export$f31a5f4e4c9d053a)({
                                t: t,
                                value: values.cargoReadyDate
                            }) : undefined
                        })
                    }),
                    showCommodity && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        sm: 8,
                        spacingTop: 3,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b105d9c138188b44$export$9c5b6790316e7872), {
                            control: control,
                            name: "commodity",
                            error: commodityError
                        })
                    }),
                    showKnownShipper && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        spacingTop: 3,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $60c8bb12836214b3$export$48be23ec4c0667f5), {
                            control: control
                        })
                    }),
                    showSubmitButton && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        spacingTop: 3,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$5d7f344c70fb427d), {
                            type: "submit",
                            fullWidth: true,
                            disabled: loading,
                            searchButtonColor: searchButtonColor,
                            searchButtonHoverColor: searchButtonHoverColor,
                            children: t("cargoDetails.searchRates")
                        })
                    })
                ]
            })
        ]
    });
};












var $7ab5e98c8fcd3954$export$fa7d65e538cc6b4e = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "CargoWithInputstyled__CargoDetailsWrapper",
    componentId: "sc-1k11fn9-0"
})([
    "max-width:300px;width:100%;",
    " ",
    ""
], function(props) {
    return props.$isVertical && "\n    max-width: 100%;\n    width: 100%;\n    padding-right: 0px;";
}, function(props) {
    return !props.$inIframe && "\n        @media ".concat(props.theme.query.mobile, " {\n          max-width: 100%;\n          width: 100%;\n          padding-right: 0px;\n        }\n    ");
});
var $7ab5e98c8fcd3954$export$456a3c3c16d998e4 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "CargoWithInputstyled__CargoDetailsPopupWrapper",
    componentId: "sc-1k11fn9-1"
})([
    "max-width:100%;padding:20px;border-radius:7px;background-color:",
    ";@media ",
    "{",
    "}",
    " ",
    ""
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.query.min.tablet;
}, function(props) {
    return !props.$isVertical && (props.$wider ? "width: 620px" : "width: 400px");
}, function(props) {
    return props.$isVertical && "margin-top: 10px;";
}, function(props) {
    return !props.$inIframe && "\n        @media ".concat(props.theme.query.mobile, " {\n          margin-top: 10px;\n        }\n    ");
});
var $7ab5e98c8fcd3954$export$451bf11a19917b08 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistorganismsSlideOut.SlideOut)).withConfig({
    displayName: "CargoWithInputstyled__SlideOut",
    componentId: "sc-1k11fn9-2"
})([
    "& > div{background-color:",
    ";}"
], function(props) {
    return props.theme.color.g100;
});
var $7ab5e98c8fcd3954$export$c3d67bc338dde5ad = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "CargoWithInputstyled__SlideOutInner",
    componentId: "sc-1k11fn9-3"
})([
    "padding-top:50px;width:100%;"
]);
var $7ab5e98c8fcd3954$export$b48b6dd8c802c1 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "CargoWithInputstyled__CargoInputIconWithWrapper",
    componentId: "sc-1k11fn9-4"
})([
    "background-color:",
    ";",
    " ",
    " & .MuiOutlinedInput-notchedOutline{border-color:transparent !important;}.cargo-detail-input{background:",
    ";border:1px solid ",
    ";&:focus-within,&:hover,&.focused{border:1px solid ",
    ";.Input-root{border-radius:7px;}}&.error{.Input-root{background-color:",
    ";border:1px solid ",
    ";border-radius:0px;}}}"
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.$isVertical && "border-radius: 7px;";
}, function(props) {
    return !props.$inIframe && "\n        @media ".concat(props.theme.query.mobile, " {\n          border-radius: 7px;\n        }\n    ");
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g200;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.color.e100;
}, function(props) {
    return props.theme.color.e300;
});
var $7ab5e98c8fcd3954$export$e71c4d32a2263218 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistatomsBox.Box)).attrs(function(props) {
    return {
        className: [
            props.className,
            "-box"
        ].join("")
    };
}).withConfig({
    displayName: "CargoWithInputstyled__Box",
    componentId: "sc-1k11fn9-5"
})([
    "background-color:",
    ";padding:0px;border-radius:7px;",
    " max-height:380px;width:",
    ";",
    " box-sizing:content-box;z-index:1;@media ",
    "{width:250px;margin-left:0px;max-width:initial;}"
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return !props.$inIframe && "position: absolute;";
}, function(props) {
    return props.$wider ? "660px" : "440px";
}, function(props) {
    return props.$wider && "margin-left: -220px;";
}, function(props) {
    return props.theme.query.mobile;
});


var $1c2f87905f928709$export$9d4b902742acd3d2 = function(param) {
    var setIsOpen = param.setIsOpen, setBackdropVisible = param.setBackdropVisible, onFocus = param.onFocus;
    return function() {
        $1c2f87905f928709$export$41a2bf03e866e697(setIsOpen, true)();
        setBackdropVisible && setBackdropVisible(true);
        onFocus && onFocus();
    };
};
var $1c2f87905f928709$export$41a2bf03e866e697 = function(setOpen, open) {
    return function() {
        setOpen(open);
    };
};


var $3a075c6ee22e86b6$export$12bbc3c7bcd05fc0 = function(props) {
    var className = props.className, displayValue = props.displayValue, error = props.error, fieldComponent = props.fieldComponent, hasError = props.hasError, icon = props.icon, isOpen = props.isOpen, isSubmitSuccessful = props.isSubmitSuccessful, isVertical = props.isVertical, label = props.label, onBackdropClick = props.onBackdropClick, onFocus = props.onFocus, placeholder = props.placeholder, setBackdropVisible = props.setBackdropVisible, setIsOpen = props.setIsOpen, widerBox = props.widerBox;
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), inIframe = _useContext.inIframe, isMobile = _useContext.isMobile;
    var ref = (0, $fZLIC$react.useRef)(null);
    (0, $fZLIC$react.useEffect)(function() {
        if (hasError === false) setIsOpen(hasError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasError
    ]);
    (0, $fZLIC$react.useEffect)(function() {
        if (isSubmitSuccessful) {
            setIsOpen(false);
            onBackdropClick && onBackdropClick();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSubmitSuccessful
    ]);
    var getClassName = (0, $fZLIC$react.useMemo)(function() {
        var className = "cargo-detail-input ";
        if (isOpen) className += "focused ";
        if (error) className += "error ";
        return className;
    }, [
        isOpen,
        error
    ]);
    var isVerticalMode = isMobile || isVertical;
    var errorRoot = error === null || error === void 0 ? void 0 : error.root;
    var errorMessage = (error === null || error === void 0 ? void 0 : error.message) ? error.message : errorRoot === null || errorRoot === void 0 ? void 0 : errorRoot.message;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $7ab5e98c8fcd3954$export$fa7d65e538cc6b4e), {
        $isVertical: isVerticalMode,
        $inIframe: inIframe,
        ref: ref,
        className: className,
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $7ab5e98c8fcd3954$export$b48b6dd8c802c1), {
                $isVertical: isVerticalMode,
                $inIframe: inIframe,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $652e5e6e582599e2$export$1d04a355e3a12077), {
                    onFocus: (0, $1c2f87905f928709$export$9d4b902742acd3d2)({
                        setIsOpen: setIsOpen,
                        setBackdropVisible: setBackdropVisible,
                        onFocus: onFocus
                    }),
                    icon: icon,
                    placeholder: placeholder,
                    label: label,
                    value: displayValue,
                    className: getClassName,
                    "data-testid": "CargoDetailsInput",
                    $isVertical: isVerticalMode,
                    $inIframe: inIframe
                })
            }),
            errorMessage && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $626787f2265604a2$export$915e9e7bd4f0f96d), {
                children: errorMessage
            }),
            !isVerticalMode && isOpen && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $7ab5e98c8fcd3954$export$e71c4d32a2263218), {
                className: className,
                $inIframe: inIframe,
                $wider: widerBox,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $7ab5e98c8fcd3954$export$456a3c3c16d998e4), {
                    $isVertical: isVerticalMode,
                    $inIframe: inIframe,
                    $wider: widerBox,
                    children: fieldComponent
                })
            }),
            isVerticalMode && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $7ab5e98c8fcd3954$export$451bf11a19917b08), {
                withFooter: false,
                withHeader: false,
                isOpen: isOpen,
                disableRestoreFocus: true,
                onClose: (0, $1c2f87905f928709$export$41a2bf03e866e697)(setIsOpen, false),
                container: ref.current,
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $7ab5e98c8fcd3954$export$c3d67bc338dde5ad), {
                    "data-testid": "CargoDetailsInSlideOut",
                    children: [
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $652e5e6e582599e2$export$1d04a355e3a12077), {
                            icon: icon,
                            placeholder: placeholder,
                            label: label,
                            value: displayValue,
                            className: "cargo-detail-slide-out"
                        }),
                        /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $7ab5e98c8fcd3954$export$456a3c3c16d998e4), {
                            $isVertical: isVerticalMode,
                            $inIframe: inIframe,
                            $wider: widerBox,
                            children: fieldComponent
                        })
                    ]
                })
            })
        ]
    });
};







var $f3327b62443fe543$export$ff7c4941ebbab29b = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 12 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 12 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.g600;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.282152 2.39282L5.90715 0.142822L6 0.374941L6.09285 0.142822L11.7178 2.39282C11.8128 2.43079 11.875 2.52272 11.875 2.62494C11.875 2.72717 11.8128 2.81909 11.7178 2.85706L6.09285 5.10706C6.03325 5.1309 5.96675 5.1309 5.90715 5.10706L0.282152 2.85706C0.187238 2.81909 0.125 2.72717 0.125 2.62494C0.125 2.52272 0.187238 2.43079 0.282152 2.39282ZM6 0.6442L1.04815 2.62494L6 4.60568L10.9519 2.62494L6 0.6442Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.467848 2.39282L6.09285 4.64282C6.18776 4.68079 6.25 4.77272 6.25 4.87494V11.6249C6.25 11.7079 6.20885 11.7855 6.14016 11.832C6.07146 11.8785 5.98417 11.8879 5.90715 11.8571L0.282152 9.60706C0.187238 9.5691 0.125 9.47717 0.125 9.37494V2.62494H0.375L0.467848 2.39282ZM0.625 2.9942V9.20568L5.75 11.2557V5.0442L0.625 2.9942Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.25 5.0442V11.2557L11.375 9.20568V2.9942L6.25 5.0442ZM11.625 2.62494L11.5322 2.39282L5.90715 4.64282C5.81224 4.68079 5.75 4.77272 5.75 4.87494V11.6249C5.75 11.7079 5.79115 11.7855 5.85984 11.832C5.92854 11.8785 6.01583 11.8879 6.09285 11.8571L11.7178 9.60706C11.8128 9.5691 11.875 9.47717 11.875 9.37494V2.62494H11.625Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.23621 1.29467C3.28749 1.16647 3.43298 1.10412 3.56118 1.1554L9.18618 3.4054C9.31437 3.45668 9.37673 3.60217 9.32545 3.73037C9.27417 3.85856 9.12868 3.92092 9.00048 3.86964L3.37548 1.61964C3.24728 1.56836 3.18493 1.42287 3.23621 1.29467Z",
                fill: fillColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5447 8.15722C10.596 8.28541 10.5336 8.43091 10.4054 8.48219L9.46791 8.85719C9.33972 8.90846 9.19423 8.84611 9.14295 8.71791C9.09167 8.58972 9.15402 8.44423 9.28222 8.39295L10.2197 8.01795C10.3479 7.96667 10.4934 8.02902 10.5447 8.15722Z",
                fill: fillColor
            })
        ]
    });
};







var $5d8ffaf837e797b2$export$7e590622dacc66a3 = function(param) {
    var cargoDetail = param.cargoDetail, t = param.t, chargeableWeightFactor = param.chargeableWeightFactor;
    if (!cargoDetail) return "";
    var descriptionItems = [];
    if (cargoDetail.length === 1) {
        var _cargoDetail = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))(cargoDetail, 1), item = _cargoDetail[0];
        if (item.quantity) descriptionItems.push("".concat(item.quantity).concat(t("cargoDetails.pc", {
            count: +item.quantity
        })));
        if (item.weight) {
            var chargeableWeight = (0, $8835a976e07ba158$export$1166235716d57e64)({
                items: cargoDetail,
                chargeableWeightFactor: chargeableWeightFactor
            });
            descriptionItems.push("".concat(t("cargoDetails.chargWt"), " ").concat(chargeableWeight).concat(t("cargoDetails.weightUnit.KG").toLowerCase()));
        }
        if (item.length && item.width && item.height) descriptionItems.push("".concat(item.length, "x").concat(item.width, "x").concat(item.height).concat(item.lengthUnit.label.toLowerCase()));
        return descriptionItems.filter(function(i) {
            return !!i;
        }).join(" - ");
    }
    if (cargoDetail.length > 1) {
        var chargeableWeight1 = (0, $8835a976e07ba158$export$1166235716d57e64)({
            items: cargoDetail,
            chargeableWeightFactor: chargeableWeightFactor
        });
        return "".concat(t("cargoDetails.multipleTotalChargeableWt"), " ").concat(chargeableWeight1).concat(t("cargoDetails.weightUnit.KG").toLowerCase());
    }
    return "";
};


var $b7d49aea27b51ec8$var$_CargoIcon;
var $b7d49aea27b51ec8$export$d56fb91100813d6e = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var className = props.className, control = props.control, hasError = props.hasError, isOpen = props.isOpen, isVertical = props.isVertical, loading = props.loading, name = props.name, onBackdropClick = props.onBackdropClick, onFocus = props.onFocus, rules = props.rules, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, setBackdropVisible = props.setBackdropVisible, setIsOpen = props.setIsOpen;
    var type = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)).type;
    var _useController = (0, $fZLIC$reacthookform.useController)({
        control: control,
        name: name,
        rules: rules
    }), _useController_field = _useController.field, value = _useController_field.value, onChange = _useController_field.onChange, _useController_formState = _useController.formState, isSubmitSuccessful = _useController_formState.isSubmitSuccessful, errors = _useController_formState.errors, error = _useController.fieldState.error;
    var displayValue = (0, $5d8ffaf837e797b2$export$7e590622dacc66a3)({
        cargoDetail: value,
        t: t,
        chargeableWeightFactor: (0, $eaa2f94cbeae9674$export$bd9343c0e70bb103)
    });
    if (type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance) return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $d733fe40fd812310$export$11ea7460d9721013), {
        commodityError: errors.commodity,
        control: control,
        dateError: errors.cargoReadyDate,
        error: error,
        isVertical: isVertical,
        loading: loading,
        name: name,
        onChange: onChange,
        searchButtonColor: searchButtonColor,
        searchButtonHoverColor: searchButtonHoverColor
    });
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $3a075c6ee22e86b6$export$12bbc3c7bcd05fc0), {
        className: className,
        displayValue: displayValue,
        error: error,
        fieldComponent: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $d733fe40fd812310$export$11ea7460d9721013), {
            commodityError: errors.commodity,
            control: control,
            dateError: errors.cargoReadyDate,
            error: error,
            isVertical: isVertical,
            loading: loading,
            name: name,
            onChange: onChange,
            searchButtonColor: searchButtonColor,
            searchButtonHoverColor: searchButtonHoverColor,
            showSubmitButton: true
        }),
        hasError: hasError,
        icon: $b7d49aea27b51ec8$var$_CargoIcon || ($b7d49aea27b51ec8$var$_CargoIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f3327b62443fe543$export$ff7c4941ebbab29b), {})),
        isOpen: isOpen,
        isSubmitSuccessful: isSubmitSuccessful,
        isVertical: isVertical,
        label: t("cargoDetails.cargo"),
        onBackdropClick: onBackdropClick,
        onFocus: onFocus,
        placeholder: t("cargoDetails.cargoDetails"),
        setBackdropVisible: setBackdropVisible,
        setIsOpen: setIsOpen,
        widerBox: true
    });
};






















var $13564183cb56cab9$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "ContainerCargoDetailsstyled__Wrapper",
    componentId: "sc-1pddf42-0"
})([
    ""
]);
var $13564183cb56cab9$export$1b7b8a6748cfe530 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "ContainerCargoDetailsstyled__ContainerRow",
    componentId: "sc-1pddf42-1"
})([
    ".container-row{margin-bottom:20px;&:last-child{margin-bottom:0;}}"
]);
var $13564183cb56cab9$export$32094dc47f9ea4e5 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "ContainerCargoDetailsstyled__ContainerActions",
    componentId: "sc-1pddf42-2"
})([
    "display:flex;justify-content:",
    ";flex-direction:column;@media ",
    "{justify-content:flex-end;align-items:flex-end;}@media ",
    "{height:56px;align-items:flex-start;margin-left:15px;}"
], function(props) {
    return props.$single ? "center" : "space-between";
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.theme.query.min.tablet;
});
var $13564183cb56cab9$export$6d69558d1ba2fd23 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).span.withConfig({
    displayName: "ContainerCargoDetailsstyled__ContainerAction",
    componentId: "sc-1pddf42-3"
})([
    "@media ",
    "{cursor:pointer;width:30px;height:25px;display:flex;justify-content:",
    ";}@media ",
    "{margin-top:5px;}"
], function(props) {
    return props.theme.query.min.tablet;
}, function(props) {
    return props.$single ? "center" : "space-between";
}, function(props) {
    return props.theme.query.mobile;
});
var $13564183cb56cab9$export$deafc66e4bed6a0c = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).span.withConfig({
    displayName: "ContainerCargoDetailsstyled__MobileLabel",
    componentId: "sc-1pddf42-4"
})([
    "color:",
    ";",
    " text-transform:uppercase;@media ",
    "{display:none;}"
], function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.query.min.tablet;
});
var $13564183cb56cab9$export$1fbc342ec0371211 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesButton.Button)).withConfig({
    displayName: "ContainerCargoDetailsstyled__MobileAddButton",
    componentId: "sc-1pddf42-5"
})([
    "margin-bottom:10px;button.root{&:hover{background:",
    ";color:",
    ";}}@media ",
    "{display:none;}"
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.query.min.tablet;
});
var $13564183cb56cab9$export$6382847193091a26 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $190b8b1072325b25$export$6382847193091a26)).withConfig({
    displayName: "ContainerCargoDetailsstyled__RemoveIcon",
    componentId: "sc-1pddf42-6"
})([
    "@media ",
    "{display:none;}"
], function(props) {
    return props.theme.query.mobile;
});
var $13564183cb56cab9$export$a6b7c34d56975de0 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $de0c72a036a07041$export$a6b7c34d56975de0)).withConfig({
    displayName: "ContainerCargoDetailsstyled__AddIcon",
    componentId: "sc-1pddf42-7"
})([
    "@media ",
    "{display:none;}"
], function(props) {
    return props.theme.query.mobile;
});



var $4be1fe767864c663$export$534590f0a1312659 = function(param) {
    var append = param.append;
    return function() {
        append({
            type: undefined,
            quantity: 0
        });
    };
};
var $4be1fe767864c663$export$938251c9e8e2fcde = function(param) {
    var index = param.index, remove = param.remove;
    return function() {
        remove(index);
    };
};
var $4be1fe767864c663$export$a22775fa5e2eebd9 = function(param) {
    var value = param.value, t = param.t, error = param.error;
    var _error_root;
    if ((error === null || error === void 0 ? void 0 : error.type) === "container" || (error === null || error === void 0 ? void 0 : (_error_root = error.root) === null || _error_root === void 0 ? void 0 : _error_root.type) === "container") {
        if (value === 0) return {
            message: t("validation:required")
        };
    }
    if (value > (0, $eaa2f94cbeae9674$export$4a688500daf09f17)) return {
        message: t("validation:cargo.limitExceeded")
    };
    return undefined;
};


var $fcf9e7b625fa829a$var$_RemoveIcon, $fcf9e7b625fa829a$var$_AddIcon;
var $fcf9e7b625fa829a$export$e53ec48cf52ebf42 = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var className = props.className, control = props.control, onChange = props.onChange, error = props.error, name = props.name, showContainerHelperText = props.showContainerHelperText;
    var _useFieldArray = (0, $fZLIC$reacthookform.useFieldArray)({
        control: control,
        name: name
    }), fields = _useFieldArray.fields, append = _useFieldArray.append, remove = _useFieldArray.remove;
    var containers = fields;
    (0, $fZLIC$react.useEffect)(function() {
        if (!containers.length) append({
            type: {
                label: t("cargoDetails.containerTypes.DV20"),
                value: "DV20"
            },
            quantity: 1
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var values = (0, $fZLIC$reacthookform.useWatch)({
        control: control,
        name: [
            name
        ]
    });
    // to recognize change of the value in array
    var cargoDetailItemsString = JSON.stringify(values);
    (0, $fZLIC$react.useEffect)(function() {
        onChange(containers);
    }, [
        cargoDetailItemsString,
        containers,
        onChange
    ]);
    var containerOptions = (0, $fZLIC$react.useMemo)(function() {
        return (0, $eaa2f94cbeae9674$export$e4abac893f36ee97).map(function(type) {
            return {
                label: t(type.label),
                value: type.value
            };
        });
    }, [
        t
    ]);
    var isSingleButton = (0, $fZLIC$react.useCallback)(function() {
        return function(index) {
            return containers.length <= 1 || containers.length === (0, $eaa2f94cbeae9674$export$a93556c404966303) || index < containers.length - 1;
        };
    }, [
        containers.length
    ])();
    var _containerOptions_find;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $13564183cb56cab9$export$e6dfd72ab29f8598), {
        className: className,
        "data-testid": "ContainerCargoDetails",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $13564183cb56cab9$export$1b7b8a6748cfe530), {
                children: containers.map(function(container, index) {
                    var _error_root, _containers_index_type;
                    /*#__PURE__*/ return (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        className: "container-row",
                        container: true,
                        "data-testid": "ContainerRow",
                        children: [
                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                item: true,
                                xs: 9,
                                sm: 6,
                                md: 8,
                                spacingRight: 1,
                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $a81590f7203e2308$export$d55b50a564d0b931), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({
                                    control: control,
                                    name: "".concat(name, ".").concat(index, ".type"),
                                    label: t("cargoDetails.containerType"),
                                    options: containerOptions,
                                    defaultValue: (_containerOptions_find = containerOptions.find(function(option) {
                                        var _containers_index_type;
                                        return option.value === ((_containers_index_type = containers[index].type) === null || _containers_index_type === void 0 ? void 0 : _containers_index_type.value);
                                    })) !== null && _containerOptions_find !== void 0 ? _containerOptions_find : "",
                                    error: ((error === null || error === void 0 ? void 0 : error.type) === "container" || (error === null || error === void 0 ? void 0 : (_error_root = error.root) === null || _error_root === void 0 ? void 0 : _error_root.type) === "container") && !container.type ? {
                                        message: t("validation:required")
                                    } : undefined
                                }, showContainerHelperText && ((_containers_index_type = containers[index].type) === null || _containers_index_type === void 0 ? void 0 : _containers_index_type.value) ? {
                                    helperText: t("containerNotes", {
                                        context: containers[index].type.value
                                    })
                                } : {}))
                            }),
                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                item: true,
                                xs: 3,
                                sm: 2,
                                spacingLeft: 1,
                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $dc8297a289248390$export$dd2171e2b7d3bc5b), {
                                    control: control,
                                    type: "number",
                                    name: "".concat(name, ".").concat(index, ".quantity"),
                                    label: t("cargoDetails.quantity"),
                                    defaultValue: container.quantity,
                                    error: (0, $4be1fe767864c663$export$a22775fa5e2eebd9)({
                                        value: Number(container.quantity),
                                        t: t,
                                        error: error
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                                item: true,
                                xs: 12,
                                sm: 4,
                                md: 2,
                                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $13564183cb56cab9$export$32094dc47f9ea4e5), {
                                    $single: isSingleButton(index),
                                    children: [
                                        containers.length >= 2 && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $13564183cb56cab9$export$6d69558d1ba2fd23), {
                                            $single: isSingleButton(index),
                                            "data-testid": "RemoveContainerRowButton",
                                            onClick: (0, $4be1fe767864c663$export$938251c9e8e2fcde)({
                                                index: index,
                                                remove: remove
                                            }),
                                            children: [
                                                $fcf9e7b625fa829a$var$_RemoveIcon || ($fcf9e7b625fa829a$var$_RemoveIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $13564183cb56cab9$export$6382847193091a26), {})),
                                                /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $13564183cb56cab9$export$deafc66e4bed6a0c), {
                                                    children: t("cargoDetails.remove")
                                                })
                                            ]
                                        }, "remove".concat(container.id)),
                                        index === containers.length - 1 && index < 2 && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $13564183cb56cab9$export$6d69558d1ba2fd23), {
                                            $single: isSingleButton(index),
                                            onClick: (0, $4be1fe767864c663$export$534590f0a1312659)({
                                                append: append
                                            }),
                                            "data-testid": "AddMoreContainerButton",
                                            children: $fcf9e7b625fa829a$var$_AddIcon || ($fcf9e7b625fa829a$var$_AddIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $13564183cb56cab9$export$a6b7c34d56975de0), {}))
                                        }, "add".concat(container.id))
                                    ]
                                })
                            })
                        ]
                    }, "container".concat(container.id));
                })
            }),
            containers.length < (0, $eaa2f94cbeae9674$export$a93556c404966303) && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $13564183cb56cab9$export$1fbc342ec0371211), {
                onClick: (0, $4be1fe767864c663$export$534590f0a1312659)({
                    append: append
                }),
                colorStyle: "secondary",
                size: "small",
                fullWidth: true,
                label: t("cargoDetails.addMore")
            })
        ]
    });
};









var $f58436a5f932a46e$export$3ed9bc9237b6481b = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "FCLCargoDetailsstyled__FCLCargoDetailsWrapper",
    componentId: "sc-5qy59w-0"
})([
    "width:100%;"
]);


var $87014e9d71da28e4$export$f31a5f4e4c9d053a = function(param) {
    var value = param.value, t = param.t;
    if (!value) return {
        message: t("validation:required")
    };
    return undefined;
};


var $1e2881c68968ec94$export$8354d69c2463aa4c = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var className = props.className, control = props.control, name = props.name, onChange = props.onChange, error = props.error, commodityError = props.commodityError, loading = props.loading, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, cargoReadyDateError = props.cargoReadyDateError, showContainerHelperText = props.showContainerHelperText, _props_showSubmitButton = props.showSubmitButton, showSubmitButton = _props_showSubmitButton === void 0 ? false : _props_showSubmitButton, _props_fullWidthCargoReady = props.fullWidthCargoReady, fullWidthCargoReady = _props_fullWidthCargoReady === void 0 ? false : _props_fullWidthCargoReady, _props_fullWidthCommodity = props.fullWidthCommodity, fullWidthCommodity = _props_fullWidthCommodity === void 0 ? false : _props_fullWidthCommodity;
    var values = (0, $fZLIC$reacthookform.useWatch)({
        control: control
    });
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), showCommodity = _useContext.showCommodity, showCargoReadyDateForOcean = _useContext.showCargoReadyDateForOcean;
    var todayPlus3Months = (0, $a571894262ae33f7$export$7ab4638b6a8ab893)();
    var cargoReadyDateColumn = fullWidthCargoReady ? 12 : 4;
    var cargoReadyDateRightSpace = fullWidthCargoReady ? 0 : 2;
    var commodityColumn = fullWidthCommodity ? 12 : 8;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $f58436a5f932a46e$export$3ed9bc9237b6481b), {
        className: className,
        "data-testid": "FCLCargoDetails",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fcf9e7b625fa829a$export$e53ec48cf52ebf42), {
                control: control,
                onChange: onChange,
                error: error,
                name: name,
                showContainerHelperText: showContainerHelperText
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                container: true,
                children: [
                    showCargoReadyDateForOcean && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        sm: cargoReadyDateColumn,
                        mdUpSpacingRight: cargoReadyDateRightSpace,
                        spacingTop: 4,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $0ad027ed42da55a6$export$973dc8673c936db8), {
                            control: control,
                            name: "cargoReadyDate",
                            maxDate: todayPlus3Months,
                            defaultValue: null,
                            error: cargoReadyDateError ? (0, $87014e9d71da28e4$export$f31a5f4e4c9d053a)({
                                t: t,
                                value: values.cargoReadyDate
                            }) : undefined
                        })
                    }),
                    showCommodity && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        sm: commodityColumn,
                        spacingTop: 4,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b105d9c138188b44$export$9c5b6790316e7872), {
                            control: control,
                            name: "commodity",
                            error: commodityError
                        })
                    }),
                    showSubmitButton && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        spacingTop: 4,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$5d7f344c70fb427d), {
                            type: "submit",
                            fullWidth: true,
                            disabled: loading,
                            searchButtonColor: searchButtonColor,
                            searchButtonHoverColor: searchButtonHoverColor,
                            children: t("cargoDetails.searchRates")
                        })
                    })
                ]
            })
        ]
    });
};









var $ea2b7c76dac48ee1$export$49f5bf502122d4f7 = function(t, length) {
    return function(desc, container, index) {
        var containerType = (0, $eaa2f94cbeae9674$export$5d7643758adab567)[container.type];
        var comma = index === length - 1 ? "" : ", ";
        var containerDesc = "".concat(container.quantity, "x").concat(t(containerType));
        return "".concat(desc).concat(containerDesc).concat(comma);
    };
};
var $ea2b7c76dac48ee1$export$7b34eeb63093cea = function(params) {
    var cargoDetail = params.cargoDetail, t = params.t;
    if (!cargoDetail) return "";
    var descriptionItems = [];
    var container = (0, $942284d646ad1acb$export$b5bd4e46a5271faa)(cargoDetail);
    var containerArray = Object.keys(container);
    var containerDescription = containerArray.map(function(c) {
        return {
            type: c,
            quantity: container[c]
        };
    }).reduce($ea2b7c76dac48ee1$export$49f5bf502122d4f7(t, containerArray.length), "");
    descriptionItems = [
        containerDescription
    ];
    return descriptionItems.filter(function(i) {
        return !!i;
    }).join(", ");
};


var $dd15f068ad49aecd$var$_CargoIcon;
var $dd15f068ad49aecd$export$179847f1b4a8398c = function(props) {
    var control = props.control, hasError = props.hasError, isOpen = props.isOpen, isVertical = props.isVertical, loading = props.loading, name = props.name, onBackdropClick = props.onBackdropClick, onFocus = props.onFocus, rules = props.rules, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, setBackdropVisible = props.setBackdropVisible, setIsOpen = props.setIsOpen;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var type = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)).type;
    var _useController = (0, $fZLIC$reacthookform.useController)({
        control: control,
        name: name,
        rules: rules
    }), _useController_field = _useController.field, value = _useController_field.value, onChange = _useController_field.onChange, _useController_formState = _useController.formState, isSubmitSuccessful = _useController_formState.isSubmitSuccessful, errors = _useController_formState.errors, error = _useController.fieldState.error;
    var displayValue = (0, $ea2b7c76dac48ee1$export$7b34eeb63093cea)({
        cargoDetail: value,
        t: t
    });
    if (type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance) return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $1e2881c68968ec94$export$8354d69c2463aa4c), {
        cargoReadyDateError: errors.cargoReadyDate,
        commodityError: errors.commodity,
        control: control,
        error: error,
        loading: loading,
        name: name,
        onChange: onChange,
        searchButtonColor: searchButtonColor,
        searchButtonHoverColor: searchButtonHoverColor,
        showContainerHelperText: true
    });
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $3a075c6ee22e86b6$export$12bbc3c7bcd05fc0), {
        displayValue: displayValue,
        error: error,
        fieldComponent: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $1e2881c68968ec94$export$8354d69c2463aa4c), {
            cargoReadyDateError: errors.cargoReadyDate,
            commodityError: errors.commodity,
            control: control,
            error: error,
            fullWidthCargoReady: true,
            fullWidthCommodity: true,
            loading: loading,
            name: name,
            onChange: onChange,
            searchButtonColor: searchButtonColor,
            searchButtonHoverColor: searchButtonHoverColor,
            showSubmitButton: true
        }),
        hasError: hasError,
        icon: $dd15f068ad49aecd$var$_CargoIcon || ($dd15f068ad49aecd$var$_CargoIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f3327b62443fe543$export$ff7c4941ebbab29b), {})),
        isOpen: isOpen,
        isSubmitSuccessful: isSubmitSuccessful,
        isVertical: isVertical,
        label: t("cargoDetails.cargo"),
        onBackdropClick: onBackdropClick,
        onFocus: onFocus,
        placeholder: t("cargoDetails.cargoDetails"),
        setBackdropVisible: setBackdropVisible,
        setIsOpen: setIsOpen
    });
};























var $6c1e6444cc885b5b$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "TotalVolumeCargoDetailsstyled__Wrapper",
    componentId: "sc-1nh8p06-0"
})([
    ""
]);
var $6c1e6444cc885b5b$export$6c88bf799aca3d2b = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesNote.Note)).withConfig({
    displayName: "TotalVolumeCargoDetailsstyled__Note",
    componentId: "sc-1nh8p06-1"
})([
    "margin-top:10px;"
]);
var $6c1e6444cc885b5b$export$ef9b1a59e592288f = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistmoleculesSelect.Select)).withConfig({
    displayName: "TotalVolumeCargoDetailsstyled__Select",
    componentId: "sc-1nh8p06-2"
})([
    "border:none;"
]);





var $28419fa50e08087c$export$cb3ac7908904464f = function(quantity) {
    var quantityRegex = /^[0-9]*$/;
    return quantityRegex.test(quantity);
};
var $28419fa50e08087c$export$e596d9bf96923df7 = function(quantity) {
    var quantityRegex = /^[0-9]*(\.[0-9]{0,2})?$/;
    return quantityRegex.test(quantity);
};


var $cfbac48b629287ae$export$67848817465bf7e1 = function(param) {
    var setLclItem = param.setLclItem;
    return function(e) {
        if ((0, $28419fa50e08087c$export$e596d9bf96923df7)(e.target.value)) setLclItem(function(prev) {
            return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, prev), {
                totalWeight: e.target.value
            });
        });
    };
};
var $cfbac48b629287ae$export$400cc7c2f1277575 = function(param) {
    var setLclItem = param.setLclItem;
    return function(weightOption) {
        setLclItem(function(prev) {
            return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, prev), {
                weightUnit: weightOption.value
            });
        });
    };
};
var $cfbac48b629287ae$export$bcc95ab64c900f71 = function(param) {
    var setLclItem = param.setLclItem;
    return function(e) {
        if ((0, $28419fa50e08087c$export$e596d9bf96923df7)(e.target.value)) setLclItem(function(prev) {
            return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, prev), {
                totalVolume: e.target.value
            });
        });
    };
};
var $cfbac48b629287ae$export$de24c79de2e8ec7d = function(param) {
    var setLclItem = param.setLclItem;
    return function(volumeOption) {
        setLclItem(function(prev) {
            return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, prev), {
                volumeUnit: volumeOption.value
            });
        });
    };
};
var $cfbac48b629287ae$export$6083aea8aed8d73 = function(param) {
    var t = param.t, showRequiredError = param.showRequiredError, showMaxWeightLimitError = param.showMaxWeightLimitError;
    if (showRequiredError) return t("validation:required");
    if (showMaxWeightLimitError) return t("validation:cargo.limitExceeded");
    return "";
};
var $cfbac48b629287ae$export$fa0b64a926970cb1 = function(param) {
    var t = param.t, showRequiredError = param.showRequiredError, showMaxVolumeLimitError = param.showMaxVolumeLimitError, showMinVolumeLimitError = param.showMinVolumeLimitError, volumeUnit = param.volumeUnit;
    if (showRequiredError) return t("validation:required");
    if (showMaxVolumeLimitError) return t("validation:cargo.limitExceeded");
    if (showMinVolumeLimitError) return t("validation:cargo.minimumVolumeLimitShort", {
        volumeLimit: (0, $eaa2f94cbeae9674$export$f3b7d0d07fb5286c)[volumeUnit],
        volumeUnit: volumeUnit
    });
    return "";
};


var $6020ca571557b79f$export$6fb10738bf76f5f2 = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var defaultValue = props.defaultValue, onChange = props.onChange, error = props.error;
    var item = defaultValue;
    var _item_totalWeight, _item_weightUnit, _item_totalVolume, _item_volumeUnit;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)({
        totalWeight: (_item_totalWeight = item === null || item === void 0 ? void 0 : item.totalWeight) !== null && _item_totalWeight !== void 0 ? _item_totalWeight : 100,
        weightUnit: (_item_weightUnit = item === null || item === void 0 ? void 0 : item.weightUnit) !== null && _item_weightUnit !== void 0 ? _item_weightUnit : "KG",
        totalVolume: (_item_totalVolume = item === null || item === void 0 ? void 0 : item.totalVolume) !== null && _item_totalVolume !== void 0 ? _item_totalVolume : 1,
        volumeUnit: (_item_volumeUnit = item === null || item === void 0 ? void 0 : item.volumeUnit) !== null && _item_volumeUnit !== void 0 ? _item_volumeUnit : "CBM"
    }), 2), lclItem = _useState[0], setLclItem = _useState[1];
    (0, $fZLIC$react.useEffect)(function() {
        onChange(lclItem);
    }, [
        lclItem,
        onChange
    ]);
    var volumeOptions = (0, $fZLIC$react.useMemo)(function() {
        return (0, $eaa2f94cbeae9674$export$d3af23ed5f3d6d3e).map(function(option) {
            return {
                label: t(option.label),
                value: option.value
            };
        });
    }, [
        t
    ]);
    var weightOptions = (0, $fZLIC$react.useMemo)(function() {
        return (0, $eaa2f94cbeae9674$export$5e5167c0772daa2).map(function(option) {
            return {
                label: t(option.label),
                value: option.value
            };
        });
    }, [
        t
    ]);
    var showVolumeRequiredError = (error === null || error === void 0 ? void 0 : error.type) === "cargo" && !Number(lclItem.totalVolume);
    var showWeightRequiredError = (error === null || error === void 0 ? void 0 : error.type) === "cargo" && !Number(lclItem.totalWeight);
    var showVolumeMaxError = lclItem.totalVolume > (0, $eaa2f94cbeae9674$export$733799f508d9fb2f)[lclItem.volumeUnit];
    var showVolumeMinError = lclItem.totalVolume < (0, $eaa2f94cbeae9674$export$f3b7d0d07fb5286c)[lclItem.volumeUnit];
    var showWeightLimitError = lclItem.totalWeight > (0, $eaa2f94cbeae9674$export$8e337a6e8017f90f)[lclItem.weightUnit];
    var showDimensionsInLCL = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)).showDimensionsInLCL;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $6c1e6444cc885b5b$export$e6dfd72ab29f8598), {
        "data-testid": "TotalVolumeCargoDetails",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                container: true,
                children: [
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        md: 6,
                        mdUpSpacingRight: 1,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesComboInput.ComboInput), {
                            inputComponentProps: {
                                type: "number",
                                name: "totalWeight",
                                label: t("cargoDetails.totalWeight"),
                                value: lclItem.totalWeight,
                                onChange: (0, $cfbac48b629287ae$export$67848817465bf7e1)({
                                    setLclItem: setLclItem
                                }),
                                error: showWeightRequiredError || showWeightLimitError,
                                errorText: (0, $cfbac48b629287ae$export$6083aea8aed8d73)({
                                    t: t,
                                    showRequiredError: showWeightRequiredError,
                                    showMaxWeightLimitError: showWeightLimitError
                                })
                            },
                            SuffixComponent: (0, $6c1e6444cc885b5b$export$ef9b1a59e592288f),
                            andornmentProps: {
                                name: "weightUnit",
                                options: weightOptions,
                                value: weightOptions.find(function(option) {
                                    return option.value === lclItem.weightUnit;
                                }),
                                onChange: (0, $cfbac48b629287ae$export$400cc7c2f1277575)({
                                    setLclItem: setLclItem
                                }),
                                variant: "standard"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        md: 6,
                        mdDownSpacingTop: 3,
                        mdUpSpacingLeft: 1,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesComboInput.ComboInput), {
                            inputComponentProps: {
                                type: "number",
                                name: "totalVolume",
                                label: t("cargoDetails.totalVolume"),
                                value: lclItem.totalVolume,
                                onChange: (0, $cfbac48b629287ae$export$bcc95ab64c900f71)({
                                    setLclItem: setLclItem
                                }),
                                error: showVolumeRequiredError || showVolumeMaxError || showVolumeMinError,
                                errorText: (0, $cfbac48b629287ae$export$fa0b64a926970cb1)({
                                    t: t,
                                    showRequiredError: showVolumeRequiredError,
                                    showMaxVolumeLimitError: showVolumeMaxError,
                                    showMinVolumeLimitError: showVolumeMinError,
                                    volumeUnit: lclItem.volumeUnit
                                })
                            },
                            SuffixComponent: (0, $6c1e6444cc885b5b$export$ef9b1a59e592288f),
                            andornmentProps: {
                                name: "volumeUnit",
                                options: volumeOptions,
                                value: volumeOptions.find(function(option) {
                                    return option.value === lclItem.volumeUnit;
                                }),
                                onChange: (0, $cfbac48b629287ae$export$de24c79de2e8ec7d)({
                                    setLclItem: setLclItem
                                })
                            }
                        })
                    })
                ]
            }),
            showDimensionsInLCL && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6c1e6444cc885b5b$export$6c88bf799aca3d2b), {
                type: "warning",
                title: t("cargoDetails.usingTotalVolumeNoteMessage")
            })
        ]
    });
};












var $c431fb49bf214da9$export$7e8025888b285ddd = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LCLCargoDetailsstyled__LCLCargoDetailsWrapper",
    componentId: "sc-a5ddi8-0"
})([
    ""
]);


var $7de61f7b5fa39f74$export$2a32aea3500e4b43 = function(setChecked) {
    return function() {
        setChecked(function(prev) {
            return !prev;
        });
    };
};
var $7de61f7b5fa39f74$export$f31a5f4e4c9d053a = function(param) {
    var value = param.value, t = param.t;
    if (!value) return {
        message: t("validation:required")
    };
    return undefined;
};


var $3e8a32851572bf19$export$61f04548fdfb743a = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var className = props.className, cargoDetail = props.cargoDetail, control = props.control, onChange = props.onChange, error = props.error, commodityError = props.commodityError, cargoReadyDateError = props.cargoReadyDateError, loading = props.loading, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, _props_showSubmitButton = props.showSubmitButton, showSubmitButton = _props_showSubmitButton === void 0 ? false : _props_showSubmitButton, _props_fullWidthCargoReady = props.fullWidthCargoReady, fullWidthCargoReady = _props_fullWidthCargoReady === void 0 ? false : _props_fullWidthCargoReady, _props_fullWidthCommodity = props.fullWidthCommodity, fullWidthCommodity = _props_fullWidthCommodity === void 0 ? false : _props_fullWidthCommodity;
    var _ref;
    var isChecked = (_ref = cargoDetail && !!cargoDetail.totalWeightVolumeItem) !== null && _ref !== void 0 ? _ref : false;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(isChecked), 2), checked = _useState[0], setChecked = _useState[1];
    var values = (0, $fZLIC$reacthookform.useWatch)({
        control: control
    });
    var handleOnChange = (0, $fZLIC$react.useCallback)(function(items) {
        return onChange({
            dimension: items
        });
    }, [
        onChange
    ]);
    var handleOnChangeTotalVolume = (0, $fZLIC$react.useCallback)(function(items) {
        return onChange({
            totalWeightVolumeItem: items
        });
    }, [
        onChange
    ]);
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), showDimensionsInLCL = _useContext.showDimensionsInLCL, showCommodity = _useContext.showCommodity, showCargoReadyDateForOcean = _useContext.showCargoReadyDateForOcean;
    var showTotalVolumeCargoDetailsComponent = checked || !showDimensionsInLCL;
    var todayPlus3Months = (0, $a571894262ae33f7$export$7ab4638b6a8ab893)();
    var cargoReadyDateColumn = fullWidthCargoReady && showTotalVolumeCargoDetailsComponent ? 12 : 4;
    var cargoReadyDateRightSpace = fullWidthCargoReady && showTotalVolumeCargoDetailsComponent ? 0 : 2;
    var commodityColumn = fullWidthCommodity && showTotalVolumeCargoDetailsComponent ? 12 : 8;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $c431fb49bf214da9$export$7e8025888b285ddd), {
        className: className,
        "data-testid": "LCLCargoDetails",
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
            container: true,
            children: [
                showDimensionsInLCL && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                    item: true,
                    container: true,
                    xs: 12,
                    spacingBottom: 4,
                    children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistmoleculesCheckbox.CheckboxWithLabel), {
                        onChange: (0, $7de61f7b5fa39f74$export$2a32aea3500e4b43)(setChecked),
                        checked: checked,
                        name: "enterTotalVolume",
                        label: t("cargoDetails.enterTotalVolumeCheckLabel")
                    })
                }),
                /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                    item: true,
                    xs: 12,
                    children: showTotalVolumeCargoDetailsComponent ? /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6020ca571557b79f$export$6fb10738bf76f5f2), {
                        defaultValue: cargoDetail === null || cargoDetail === void 0 ? void 0 : cargoDetail.totalWeightVolumeItem,
                        error: error,
                        onChange: handleOnChangeTotalVolume
                    }) : /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $4503b05492d55ed1$export$feae93fe8fedaeb3), {
                        cargoType: (0, $dc0baf21ad530e3b$export$296c865296deffa2).LCL,
                        name: "cargoLclDetail.dimension",
                        control: control,
                        handleOnChange: handleOnChange,
                        numberOfItemsLimit: (0, $eaa2f94cbeae9674$export$d03ca40afb5afa22),
                        error: error,
                        dimensionLimit: (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6),
                        weightLimit: (0, $f9f89a5c82b78d91$export$35a1e7e6818ec128)
                    })
                }),
                showCargoReadyDateForOcean && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                    item: true,
                    xs: 12,
                    sm: cargoReadyDateColumn,
                    mdUpSpacingRight: cargoReadyDateRightSpace,
                    spacingTop: 3,
                    children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $0ad027ed42da55a6$export$973dc8673c936db8), {
                        control: control,
                        name: "cargoReadyDate",
                        maxDate: todayPlus3Months,
                        defaultValue: null,
                        error: cargoReadyDateError ? (0, $7de61f7b5fa39f74$export$f31a5f4e4c9d053a)({
                            t: t,
                            value: values.cargoReadyDate
                        }) : undefined
                    })
                }),
                showCommodity && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                    item: true,
                    xs: 12,
                    sm: commodityColumn,
                    spacingTop: 3,
                    children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b105d9c138188b44$export$9c5b6790316e7872), {
                        control: control,
                        name: "commodity",
                        error: commodityError
                    })
                }),
                showSubmitButton && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                    item: true,
                    xs: 12,
                    spacingTop: 3,
                    children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$5d7f344c70fb427d), {
                        type: "submit",
                        fullWidth: true,
                        disabled: loading,
                        searchButtonColor: searchButtonColor,
                        searchButtonHoverColor: searchButtonHoverColor,
                        children: t("cargoDetails.searchRates")
                    })
                })
            ]
        })
    });
};








var $6318f1ba8d958479$export$159be0693a530e77 = function(params) {
    var cargoDetail = params.cargoDetail, t = params.t;
    if (!cargoDetail) return "";
    var descriptionItems = [];
    if (cargoDetail.dimension) {
        var totalWeight = (0, $8835a976e07ba158$export$167ceafb15c3e7b4)(cargoDetail.dimension);
        var totalVolume = (0, $8835a976e07ba158$export$4ca74356a41f3701)(cargoDetail.dimension);
        descriptionItems = [
            totalWeight > 0 ? "".concat(totalWeight).concat(t("cargoDetails.weightUnit.KG")) : "",
            totalVolume > 0 ? "".concat(totalVolume).concat(t("cargoDetails.volumeUnit.CBM")) : ""
        ];
    }
    if (cargoDetail.totalWeightVolumeItem) {
        var lclItem = cargoDetail.totalWeightVolumeItem;
        descriptionItems = [
            lclItem.totalWeight > 0 ? "".concat(lclItem.totalWeight).concat(lclItem.weightUnit) : "",
            lclItem.totalVolume > 0 ? "".concat(lclItem.totalVolume).concat(lclItem.volumeUnit) : ""
        ];
    }
    return descriptionItems.filter(function(i) {
        return !!i;
    }).join(", ");
};


var $36a47dbbf64c26d7$var$_CargoIcon;
var $36a47dbbf64c26d7$export$9eab3921fc00c3e8 = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var className = props.className, control = props.control, hasError = props.hasError, isOpen = props.isOpen, isVertical = props.isVertical, loading = props.loading, name = props.name, onBackdropClick = props.onBackdropClick, onFocus = props.onFocus, rules = props.rules, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, setBackdropVisible = props.setBackdropVisible, setIsOpen = props.setIsOpen;
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), type = _useContext.type, showDimensionsInLCL = _useContext.showDimensionsInLCL;
    var _useController = (0, $fZLIC$reacthookform.useController)({
        control: control,
        name: name,
        rules: rules
    }), _useController_field = _useController.field, value = _useController_field.value, onChange = _useController_field.onChange, _useController_formState = _useController.formState, isSubmitSuccessful = _useController_formState.isSubmitSuccessful, errors = _useController_formState.errors, error = _useController.fieldState.error;
    var displayValue = (0, $6318f1ba8d958479$export$159be0693a530e77)({
        cargoDetail: value,
        t: t
    });
    var widerBox = showDimensionsInLCL && value && !value.totalWeightVolumeItem;
    if (type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance) return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $3e8a32851572bf19$export$61f04548fdfb743a), {
        cargoDetail: value,
        cargoReadyDateError: errors.cargoReadyDate,
        commodityError: errors.commodity,
        control: control,
        error: error,
        loading: loading,
        onChange: onChange,
        searchButtonColor: searchButtonColor,
        searchButtonHoverColor: searchButtonHoverColor
    });
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $3a075c6ee22e86b6$export$12bbc3c7bcd05fc0), {
        className: className,
        displayValue: displayValue,
        error: error,
        fieldComponent: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $3e8a32851572bf19$export$61f04548fdfb743a), {
            cargoDetail: value,
            control: control,
            onChange: onChange,
            error: error,
            commodityError: errors.commodity,
            loading: loading,
            searchButtonColor: searchButtonColor,
            searchButtonHoverColor: searchButtonHoverColor,
            cargoReadyDateError: errors.cargoReadyDate,
            showSubmitButton: true,
            fullWidthCargoReady: true,
            fullWidthCommodity: true
        }),
        hasError: hasError,
        icon: $36a47dbbf64c26d7$var$_CargoIcon || ($36a47dbbf64c26d7$var$_CargoIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f3327b62443fe543$export$ff7c4941ebbab29b), {})),
        isOpen: isOpen,
        isSubmitSuccessful: isSubmitSuccessful,
        isVertical: isVertical,
        label: t("cargoDetails.cargo"),
        onBackdropClick: onBackdropClick,
        onFocus: onFocus,
        placeholder: t("cargoDetails.cargoDetails"),
        setBackdropVisible: setBackdropVisible,
        setIsOpen: setIsOpen,
        widerBox: widerBox
    });
};





















var $208a9073892592a1$export$17095436867e33e3 = function(props) {
    var control = props.control, name = props.name, defaultValue = props.defaultValue, error = props.error;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var freightClassOptions = (0, $fZLIC$react.useMemo)(function() {
        return (0, $83aeeaefadd710af$export$56d29b7bdc61e703)((0, $de661b7a1555db76$export$96fda7c02ce0cfdc), t);
    }, []);
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $a81590f7203e2308$export$d55b50a564d0b931), {
        name: name,
        defaultValue: defaultValue,
        control: control,
        error: error,
        options: freightClassOptions,
        optional: false,
        className: "freightClass-select-field",
        maxMenuHeight: 180,
        label: t("freightClass"),
        rules: {
            required: {
                value: true,
                message: t("validation:required")
            }
        }
    });
};







var $814bb7b690eb85c4$export$a11a36f5b7200e77 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "LTLCargoDetailsstyled__LTLCargoDetailsWrapper",
    componentId: "sc-5rri10-0"
})([
    ""
]);


var $fa0ebf0a1870960a$export$f31a5f4e4c9d053a = function(param) {
    var value = param.value, t = param.t;
    if (!value) return {
        message: t("validation:required")
    };
    return undefined;
};


var $24ee2fcb646c568c$export$ef5cc6faed7211e5 = function(props) {
    var className = props.className, control = props.control, name = props.name, loading = props.loading, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, error = props.error, commodityError = props.commodityError, cargoReadyDateError = props.cargoReadyDateError, freightClassError = props.freightClassError, onChange = props.onChange;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var values = (0, $fZLIC$reacthookform.useWatch)({
        control: control
    });
    var todayPlus2Week = (0, $a571894262ae33f7$export$41207ad329a776a2)();
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), showCommodity = _useContext.showCommodity, showCargoReadyDateForLTL = _useContext.showCargoReadyDateForLTL;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $814bb7b690eb85c4$export$a11a36f5b7200e77), {
        className: className,
        "data-testid": "LTLCargoDetails",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $4503b05492d55ed1$export$feae93fe8fedaeb3), {
                cargoType: (0, $dc0baf21ad530e3b$export$296c865296deffa2).LTL,
                name: name,
                control: control,
                error: error,
                handleOnChange: onChange,
                numberOfItemsLimit: (0, $eaa2f94cbeae9674$export$d03ca40afb5afa22),
                dimensionLimit: (0, $f9f89a5c82b78d91$export$a104d8d48668662d),
                weightLimit: (0, $f9f89a5c82b78d91$export$72b57fb2b65ee7b5)
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                container: true,
                children: [
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        spacingTop: 3,
                        mdUpSpacingRight: 2,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $208a9073892592a1$export$17095436867e33e3), {
                            control: control,
                            name: "freightClass",
                            error: freightClassError
                        })
                    }),
                    showCommodity && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        spacingTop: 3,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b105d9c138188b44$export$9c5b6790316e7872), {
                            control: control,
                            name: "commodity",
                            error: commodityError
                        })
                    }),
                    showCargoReadyDateForLTL && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        sm: 6,
                        spacingTop: 3,
                        mdUpSpacingRight: 2,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $0ad027ed42da55a6$export$973dc8673c936db8), {
                            control: control,
                            name: "cargoReadyDate",
                            maxDate: todayPlus2Week,
                            defaultValue: null,
                            error: cargoReadyDateError ? (0, $fa0ebf0a1870960a$export$f31a5f4e4c9d053a)({
                                t: t,
                                value: values.cargoReadyDate
                            }) : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $fZLIC$icontainersdesignsystemdistatomsGrid.Grid), {
                        item: true,
                        xs: 12,
                        spacingTop: 3,
                        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$5d7f344c70fb427d), {
                            type: "submit",
                            fullWidth: true,
                            disabled: loading,
                            searchButtonColor: searchButtonColor,
                            searchButtonHoverColor: searchButtonHoverColor,
                            children: t("cargoDetails.searchRates")
                        })
                    })
                ]
            })
        ]
    });
};






var $f2cc92aa3f74aa1f$export$cce559c3964d9321 = function(params) {
    var cargoDetail = params.cargoDetail, t = params.t;
    if (!cargoDetail) return "";
    var descriptionItems = [];
    if (cargoDetail) {
        var totalWeight = (0, $8835a976e07ba158$export$167ceafb15c3e7b4)(cargoDetail);
        var totalVolume = (0, $8835a976e07ba158$export$4ca74356a41f3701)(cargoDetail);
        descriptionItems = [
            totalWeight > 0 ? "".concat(totalWeight).concat(t("cargoDetails.weightUnit.KG")) : "",
            totalVolume > 0 ? "".concat(totalVolume).concat(t("cargoDetails.volumeUnit.CBM")) : ""
        ];
    }
    return descriptionItems.filter(function(i) {
        return !!i;
    }).join(", ");
};


var $d609331e7518733c$var$_CargoIcon;
var $d609331e7518733c$export$f4aa2808f856b7da = function(props) {
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var className = props.className, control = props.control, hasError = props.hasError, isOpen = props.isOpen, isVertical = props.isVertical, loading = props.loading, name = props.name, onBackdropClick = props.onBackdropClick, onFocus = props.onFocus, rules = props.rules, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, setBackdropVisible = props.setBackdropVisible, setIsOpen = props.setIsOpen;
    var _useController = (0, $fZLIC$reacthookform.useController)({
        control: control,
        name: name,
        rules: rules
    }), _useController_field = _useController.field, value = _useController_field.value, onChange = _useController_field.onChange, _useController_formState = _useController.formState, isSubmitSuccessful = _useController_formState.isSubmitSuccessful, errors = _useController_formState.errors, error = _useController.fieldState.error;
    var displayValue = (0, $f2cc92aa3f74aa1f$export$cce559c3964d9321)({
        cargoDetail: value,
        t: t
    });
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $3a075c6ee22e86b6$export$12bbc3c7bcd05fc0), {
        className: className,
        displayValue: displayValue,
        error: error,
        fieldComponent: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24ee2fcb646c568c$export$ef5cc6faed7211e5), {
            name: name,
            control: control,
            onChange: onChange,
            error: error,
            loading: loading,
            searchButtonColor: searchButtonColor,
            searchButtonHoverColor: searchButtonHoverColor,
            commodityError: errors.commodity,
            cargoReadyDateError: errors.cargoReadyDate,
            freightClassError: errors.freightClass
        }),
        hasError: hasError,
        icon: $d609331e7518733c$var$_CargoIcon || ($d609331e7518733c$var$_CargoIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $f3327b62443fe543$export$ff7c4941ebbab29b), {})),
        isOpen: isOpen,
        isSubmitSuccessful: isSubmitSuccessful,
        isVertical: isVertical,
        label: t("cargoDetails.cargo"),
        onBackdropClick: onBackdropClick,
        onFocus: onFocus,
        placeholder: t("cargoDetails.cargoDetails"),
        setBackdropVisible: setBackdropVisible,
        setIsOpen: setIsOpen,
        widerBox: true
    });
};











var $3a64ffdc1767fcac$var$isDoor = function(location) {
    return location && [
        "CITY",
        "POSTAL_CODE"
    ].includes(location.location.type);
};
var $3a64ffdc1767fcac$var$getMatchOceanLocation = function(locations, name) {
    return locations === null || locations === void 0 ? void 0 : locations.find(function(location) {
        return location.portIsoCode === name;
    });
};
var $3a64ffdc1767fcac$export$b86bdaf431e41c12 = function(param) {
    var places = param.places, postalCode = param.postalCode, countryIsoCode = param.countryIsoCode;
    return (places === null || places === void 0 ? void 0 : places.cities.find(function(location) {
        return location.country.iso_code === countryIsoCode && location.defaultPostalCode === postalCode;
    })) || (places === null || places === void 0 ? void 0 : places.postalCodes.find(function(location) {
        return location.country.iso_code === countryIsoCode && location.postalCode === postalCode;
    }));
};
var $3a64ffdc1767fcac$var$isLclToAir = function(prev, current) {
    return prev === "LCL" && current === "AIR";
};
var $3a64ffdc1767fcac$var$isAirToLcl = function(prev, current) {
    return prev === "AIR" && current === "LCL";
};
var $3a64ffdc1767fcac$var$isLtlToAir = function(prev, current) {
    return prev === "LTL" && current === "AIR";
};
var $3a64ffdc1767fcac$var$isAirToLtl = function(prev, current) {
    return prev === "AIR" && current === "LTL";
};
var $3a64ffdc1767fcac$var$isLtlToLcl = function(prev, current) {
    return prev === "LTL" && current === "LCL";
};
var $3a64ffdc1767fcac$var$isLclToLtl = function(prev, current) {
    return prev === "LCL" && current === "LTL";
};
var $3a64ffdc1767fcac$var$isOceanShipment = function(prev, current) {
    return ![
        "AIR",
        "LTL"
    ].includes(current) && ![
        "AIR",
        "LTL"
    ].includes(prev);
};
var $3a64ffdc1767fcac$var$isNonOceanToOcean = function(prev, current) {
    return [
        "FCL",
        "LCL"
    ].includes(current) && [
        "AIR",
        "LTL"
    ].includes(prev);
};
var $3a64ffdc1767fcac$var$isNonAirToAir = function(prev, current) {
    return [
        "FCL",
        "LCL",
        "LTL"
    ].includes(prev) && current === "AIR";
};
var $3a64ffdc1767fcac$var$isNonLtlToLtl = function(prev, current) {
    return [
        "FCL",
        "LCL",
        "AIR"
    ].includes(prev) && current === "LTL";
};
var $3a64ffdc1767fcac$var$setValuesForDoor = function() {
    var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function(param) {
        var fieldName, location, setValue, getPlaces, postalCode, countryIsoCode, places, postalCodeMatched, _postalCodeMatched_postalCode;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    fieldName = param.fieldName, location = param.location, setValue = param.setValue, getPlaces = param.getPlaces;
                    if (!(location && $3a64ffdc1767fcac$var$isDoor(location))) return [
                        3,
                        2
                    ];
                    postalCode = location.postalCode;
                    countryIsoCode = location.location.country.iso_code;
                    return [
                        4,
                        getPlaces()
                    ];
                case 1:
                    places = _state.sent();
                    postalCodeMatched = $3a64ffdc1767fcac$export$b86bdaf431e41c12({
                        places: places.data,
                        postalCode: postalCode,
                        countryIsoCode: countryIsoCode
                    });
                    postalCodeMatched ? setValue(fieldName, {
                        location: postalCodeMatched,
                        postalCode: (_postalCodeMatched_postalCode = postalCodeMatched.postalCode) !== null && _postalCodeMatched_postalCode !== void 0 ? _postalCodeMatched_postalCode : postalCodeMatched.defaultPostalCode
                    }) : setValue(fieldName, null);
                    return [
                        3,
                        3
                    ];
                case 2:
                    setValue(fieldName, null);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function setValuesForDoor(_) {
        return _ref.apply(this, arguments);
    };
}();
var $3a64ffdc1767fcac$export$a896d9f742bb123b = function(param) {
    var originLocationFieldRef = param.originLocationFieldRef, canFocus = param.canFocus;
    var _originLocationFieldRef_current;
    if (canFocus) (_originLocationFieldRef_current = originLocationFieldRef.current) === null || _originLocationFieldRef_current === void 0 ? void 0 : _originLocationFieldRef_current.focusInput();
};
var $3a64ffdc1767fcac$export$1667fecdab10e4e8 = function(param) {
    var values = param.values, prevShipmentType = param.prevShipmentType, shipmentType = param.shipmentType, setValue = param.setValue;
    var _values_cargoLclDetail, _values_cargoLclDetail1;
    setValue("cargoAirDetail", undefined);
    setValue("cargoLclDetail", undefined);
    setValue("cargoFclDetail", undefined);
    setValue("cargoLtlDetail", undefined);
    if ($3a64ffdc1767fcac$var$isLclToAir(prevShipmentType, shipmentType) && ((_values_cargoLclDetail = values.cargoLclDetail) === null || _values_cargoLclDetail === void 0 ? void 0 : _values_cargoLclDetail.dimension)) setValue("cargoAirDetail", values.cargoLclDetail.dimension);
    if ($3a64ffdc1767fcac$var$isAirToLcl(prevShipmentType, shipmentType) && values.cargoAirDetail) setValue("cargoLclDetail", {
        dimension: values.cargoAirDetail
    });
    if ($3a64ffdc1767fcac$var$isLtlToAir(prevShipmentType, shipmentType) && values.cargoLtlDetail) setValue("cargoAirDetail", values.cargoLtlDetail);
    if ($3a64ffdc1767fcac$var$isAirToLtl(prevShipmentType, shipmentType) && values.cargoAirDetail) setValue("cargoLtlDetail", values.cargoAirDetail);
    if ($3a64ffdc1767fcac$var$isLclToLtl(prevShipmentType, shipmentType) && ((_values_cargoLclDetail1 = values.cargoLclDetail) === null || _values_cargoLclDetail1 === void 0 ? void 0 : _values_cargoLclDetail1.dimension)) setValue("cargoLtlDetail", values.cargoLclDetail.dimension);
    if ($3a64ffdc1767fcac$var$isLtlToLcl(prevShipmentType, shipmentType) && values.cargoLtlDetail) setValue("cargoLclDetail", {
        dimension: values.cargoLtlDetail
    });
};
var $3a64ffdc1767fcac$export$5b8f501824e3d81a = function() {
    var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function(param) {
        var location, prevShipmentType, shipmentType, fieldName, setValue, getOceanPlaces, getAerialPlaces, getInlandPlaces, _oceanPlaces_data, portValues, oceanPlaces, port;
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
            switch(_state.label){
                case 0:
                    location = param.location, prevShipmentType = param.prevShipmentType, shipmentType = param.shipmentType, fieldName = param.fieldName, setValue = param.setValue, getOceanPlaces = param.getOceanPlaces, getAerialPlaces = param.getAerialPlaces, getInlandPlaces = param.getInlandPlaces;
                    if (!$3a64ffdc1767fcac$var$isNonAirToAir(prevShipmentType, shipmentType)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $3a64ffdc1767fcac$var$setValuesForDoor({
                            fieldName: fieldName,
                            location: location,
                            setValue: setValue,
                            getPlaces: getAerialPlaces
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    if (!$3a64ffdc1767fcac$var$isNonOceanToOcean(prevShipmentType, shipmentType)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $3a64ffdc1767fcac$var$setValuesForDoor({
                            fieldName: fieldName,
                            location: location,
                            setValue: setValue,
                            getPlaces: getOceanPlaces
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    if (!$3a64ffdc1767fcac$var$isNonLtlToLtl(prevShipmentType, shipmentType)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        $3a64ffdc1767fcac$var$setValuesForDoor({
                            fieldName: fieldName,
                            location: location,
                            setValue: setValue,
                            getPlaces: getInlandPlaces
                        })
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    if (!$3a64ffdc1767fcac$var$isOceanShipment(prevShipmentType, shipmentType)) return [
                        3,
                        9
                    ];
                    if (!$3a64ffdc1767fcac$var$isDoor(location)) return [
                        3,
                        7
                    ];
                    setValue(fieldName, location);
                    return [
                        3,
                        9
                    ];
                case 7:
                    portValues = location === null || location === void 0 ? void 0 : location.location;
                    return [
                        4,
                        getOceanPlaces()
                    ];
                case 8:
                    oceanPlaces = _state.sent();
                    port = $3a64ffdc1767fcac$var$getMatchOceanLocation((_oceanPlaces_data = oceanPlaces.data) === null || _oceanPlaces_data === void 0 ? void 0 : _oceanPlaces_data.ports, portValues === null || portValues === void 0 ? void 0 : portValues.portIsoCode);
                    port ? setValue(fieldName, {
                        location: port
                    }) : setValue(fieldName, null);
                    _state.label = 9;
                case 9:
                    return [
                        2
                    ];
            }
        });
    });
    return function setLocationValues(_) {
        return _ref.apply(this, arguments);
    };
}();
var $3a64ffdc1767fcac$export$8c78c340de15bee6 = function(param) {
    var additionalServices = param.additionalServices, shipmentType = param.shipmentType, setValue = param.setValue;
    if (shipmentType === "FCL" && additionalServices) setValue("additionalServices", (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, additionalServices), {
        liftGate: undefined
    }));
};


var $7dd6993e2db39a4f$export$51aa9d0509a4e8ff = function(props) {
    var _ref, _currentValues_origin, _currentValues_origin1, _ref1, _currentValues_destination, _currentValues_destination1, _currentValues_origin2, _currentValues_destination2, _currentValues_origin3, _currentValues_destination3;
    var shipmentType = props.shipmentType, source = props.source, originLocationFieldRef = props.originLocationFieldRef, isVerticalMode = props.isVerticalMode, sendMixpanelEvents = props.sendMixpanelEvents, getValues = props.getValues, setValue = props.setValue, initialShipmentType = props.initialShipmentType, setInitialShipmentType = props.setInitialShipmentType, onChange = props.onChange;
    var currentValues = getValues();
    var _useGetOceanPlaces = (0, $2bf6ddfb6520c220$export$10ed7ad36718be02)({
        name: ((_ref = (_currentValues_origin = currentValues.origin) === null || _currentValues_origin === void 0 ? void 0 : _currentValues_origin.location) === null || _ref === void 0 ? void 0 : _ref.portIsoCode) || ((_currentValues_origin1 = currentValues.origin) === null || _currentValues_origin1 === void 0 ? void 0 : _currentValues_origin1.postalCode) || "",
        context: "default-PORT-".concat(shipmentType),
        shipmentType: shipmentType,
        source: source
    }), getOriginOceanPlaces = _useGetOceanPlaces.refetch;
    var _useGetOceanPlaces1 = (0, $2bf6ddfb6520c220$export$10ed7ad36718be02)({
        name: ((_ref1 = (_currentValues_destination = currentValues.destination) === null || _currentValues_destination === void 0 ? void 0 : _currentValues_destination.location) === null || _ref1 === void 0 ? void 0 : _ref1.portIsoCode) || ((_currentValues_destination1 = currentValues.destination) === null || _currentValues_destination1 === void 0 ? void 0 : _currentValues_destination1.postalCode) || "",
        context: "default-PORT-".concat(shipmentType),
        shipmentType: shipmentType,
        source: source
    }), getDestinationOceanPlaces = _useGetOceanPlaces1.refetch;
    var _useGetAerialPlaces = (0, $06c905d67e0a0a24$export$6326b64eef1a3bba)({
        name: ((_currentValues_origin2 = currentValues.origin) === null || _currentValues_origin2 === void 0 ? void 0 : _currentValues_origin2.postalCode) || "",
        context: "default-AIRPORT",
        source: source
    }), getOriginAerialPlaces = _useGetAerialPlaces.refetch;
    var _useGetAerialPlaces1 = (0, $06c905d67e0a0a24$export$6326b64eef1a3bba)({
        name: ((_currentValues_destination2 = currentValues.destination) === null || _currentValues_destination2 === void 0 ? void 0 : _currentValues_destination2.postalCode) || "",
        context: "default-AIRPORT",
        source: source
    }), getDestinationAerialPlaces = _useGetAerialPlaces1.refetch;
    var _useGetInlandPlaces = (0, $1b4b2ddcfd0a2258$export$880d25f907fb7e37)({
        name: ((_currentValues_origin3 = currentValues.origin) === null || _currentValues_origin3 === void 0 ? void 0 : _currentValues_origin3.postalCode) || "",
        context: "default-LTL"
    }), getOriginInlandPlaces = _useGetInlandPlaces.refetch;
    var _useGetInlandPlaces1 = (0, $1b4b2ddcfd0a2258$export$880d25f907fb7e37)({
        name: ((_currentValues_destination3 = currentValues.destination) === null || _currentValues_destination3 === void 0 ? void 0 : _currentValues_destination3.postalCode) || "",
        context: "default-LTL"
    }), getDestinationInlandPlaces = _useGetInlandPlaces1.refetch;
    (0, $fZLIC$react.useEffect)(function() {
        if (initialShipmentType !== shipmentType) {
            setInitialShipmentType(shipmentType);
            (0, $3a64ffdc1767fcac$export$1667fecdab10e4e8)({
                values: currentValues,
                prevShipmentType: initialShipmentType,
                shipmentType: shipmentType,
                setValue: setValue
            });
            (0, $3a64ffdc1767fcac$export$5b8f501824e3d81a)({
                location: currentValues.origin,
                prevShipmentType: initialShipmentType,
                shipmentType: shipmentType,
                fieldName: "origin",
                setValue: setValue,
                getOceanPlaces: getOriginOceanPlaces,
                getAerialPlaces: getOriginAerialPlaces,
                getInlandPlaces: getOriginInlandPlaces
            });
            (0, $3a64ffdc1767fcac$export$5b8f501824e3d81a)({
                location: currentValues.destination,
                prevShipmentType: initialShipmentType,
                shipmentType: shipmentType,
                fieldName: "destination",
                setValue: setValue,
                getOceanPlaces: getDestinationOceanPlaces,
                getAerialPlaces: getDestinationAerialPlaces,
                getInlandPlaces: getDestinationInlandPlaces
            });
            (0, $3a64ffdc1767fcac$export$8c78c340de15bee6)({
                additionalServices: currentValues.additionalServices,
                shipmentType: shipmentType,
                setValue: setValue
            });
            onChange === null || onChange === void 0 ? void 0 : onChange();
            (0, $3a64ffdc1767fcac$export$a896d9f742bb123b)({
                originLocationFieldRef: originLocationFieldRef,
                canFocus: !isVerticalMode
            });
            (0, $068a6aa0fda9c13f$export$5cc8059eba5fa908)({
                sendMixpanelEvents: sendMixpanelEvents,
                mode: shipmentType
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialShipmentType,
        shipmentType
    ]);
};







var $ed34b28a5e0daddb$export$c917018fe1fce6ad = function(param) {
    var setValue = param.setValue, cargo = param.cargo, knownShipper = param.knownShipper, cargoReadyDate = param.cargoReadyDate, shipmentType = param.shipmentType, t = param.t, commodity = param.commodity, freightClass = param.freightClass;
    (0, $fZLIC$react.useEffect)(function() {
        if (cargo) {
            if (cargo.type === "Container" && shipmentType === "FCL") {
                var containers = cargo.item;
                var cargoDetail = (0, $942284d646ad1acb$export$1d4c38911efb8d0)({
                    containers: containers,
                    t: t
                });
                setValue("cargoFclDetail", cargoDetail);
            }
            if (cargo.type === "Dimension" && shipmentType === "LCL") {
                var items = cargo.item;
                var cargoDetail1 = (0, $942284d646ad1acb$export$c40d15b0b7beba46)({
                    items: items,
                    t: t
                });
                setValue("cargoLclDetail", {
                    dimension: cargoDetail1
                });
            }
            if (cargo.type === "Dimension" && shipmentType === "AIR") {
                var items1 = cargo.item;
                var cargoDetail2 = (0, $942284d646ad1acb$export$c40d15b0b7beba46)({
                    items: items1,
                    t: t
                });
                setValue("cargoAirDetail", cargoDetail2);
                setValue("knownShipper", !!knownShipper);
            }
            if (cargo.type === "TotalWeightVolumeItem" && shipmentType === "LCL") {
                var cargoItem = cargo.item;
                setValue("cargoLclDetail", {
                    totalWeightVolumeItem: cargoItem
                });
            }
            if (cargo.type === "Dimension" && shipmentType === "LTL") {
                var items2 = cargo.item;
                var cargoDetail3 = (0, $942284d646ad1acb$export$c40d15b0b7beba46)({
                    items: items2,
                    t: t
                });
                setValue("cargoLtlDetail", cargoDetail3);
            }
        }
        cargoReadyDate && setValue("cargoReadyDate", new Date((0, $a571894262ae33f7$export$d2f509aaed4644ff)(cargoReadyDate)));
        if (commodity) {
            var commodityOption = (0, $83aeeaefadd710af$export$a27e99e9c54fb5b1)((0, $de661b7a1555db76$export$bc49a40b3c2eebb2), t).find(function(v) {
                return v.value === commodity;
            });
            commodityOption && setValue("commodity", commodityOption);
        }
        if (shipmentType === "LTL") {
            var freightClassOption = (0, $83aeeaefadd710af$export$56d29b7bdc61e703)((0, $de661b7a1555db76$export$96fda7c02ce0cfdc), t).find(function(v) {
                return v.value === freightClass;
            });
            freightClassOption && setValue("freightClass", freightClassOption);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cargo,
        setValue
    ]);
};









var $ebafe5173736b985$export$e358bd4e232f62e0 = function(locations, name) {
    return (locations === null || locations === void 0 ? void 0 : locations.find(function(location) {
        return location.portIsoCode === name;
    })) || (locations ? locations[0] : undefined);
};
var $ebafe5173736b985$export$69f61ba2c149a675 = function(locations, name) {
    return (locations === null || locations === void 0 ? void 0 : locations.find(function(location) {
        return location.iata === name;
    })) || (locations ? locations[0] : undefined);
};


var $f4b9458733f16ec2$export$b74efa06c7fcbe67 = function(param) {
    var location = param.location, setValue = param.setValue, context = param.context, source = param.source, shipmentType = param.shipmentType;
    var _useGetOceanPlaces = (0, $2bf6ddfb6520c220$export$10ed7ad36718be02)({
        name: (location === null || location === void 0 ? void 0 : location.code) || "",
        context: "default-PORT-".concat(context),
        shipmentType: shipmentType,
        source: source
    }), getOceanPlaces = _useGetOceanPlaces.refetch;
    var _useGetPostalCodes = (0, $16314276090ccdfc$export$47ed568571403a18)({
        country: (0, $34bfc6d8ae80c5eb$export$4d78c43b7fa734a7).find(function(c) {
            return c.iso_code.toLowerCase() === (location === null || location === void 0 ? void 0 : location.countryIsoCode.toLowerCase());
        }),
        term: (location === null || location === void 0 ? void 0 : location.code) || "",
        context: "default-POSTAL_CODE-".concat(context)
    }), getPostalCode = _useGetPostalCodes.refetch;
    var _useGetAerialPlaces = (0, $06c905d67e0a0a24$export$6326b64eef1a3bba)({
        name: (location === null || location === void 0 ? void 0 : location.iata) || (location === null || location === void 0 ? void 0 : location.code) || "",
        context: "default-AIRPORT-".concat(context),
        source: source
    }), getAerialPlaces = _useGetAerialPlaces.refetch;
    (0, $fZLIC$react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0, ($parcel$interopDefault($fZLIC$swchelperslib_async_to_generatorjs)))(function() {
                var _oceanPlaces_data, oceanPlaces, port, _postalCode_data, postalCode, postalCodeData, _aerialPlaces_data, aerialPlaces, airport;
                return (0, ($parcel$interopDefault($fZLIC$swchelperslib_ts_generatorjs)))(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!((location === null || location === void 0 ? void 0 : location.type) === "PORT")) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                getOceanPlaces()
                            ];
                        case 1:
                            oceanPlaces = _state.sent();
                            port = (0, $ebafe5173736b985$export$e358bd4e232f62e0)((_oceanPlaces_data = oceanPlaces.data) === null || _oceanPlaces_data === void 0 ? void 0 : _oceanPlaces_data.ports, location.code);
                            port && setValue(context, {
                                location: port
                            });
                            return [
                                3,
                                6
                            ];
                        case 2:
                            if (!((location === null || location === void 0 ? void 0 : location.type) === "POSTAL_CODE")) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                getPostalCode()
                            ];
                        case 3:
                            postalCode = _state.sent();
                            postalCodeData = (_postalCode_data = postalCode.data) === null || _postalCode_data === void 0 ? void 0 : _postalCode_data.data[0];
                            postalCodeData && setValue(context, {
                                location: postalCodeData,
                                postalCode: postalCodeData.postalCode
                            });
                            return [
                                3,
                                6
                            ];
                        case 4:
                            if (!((location === null || location === void 0 ? void 0 : location.type) === "AIRPORT")) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                getAerialPlaces()
                            ];
                        case 5:
                            aerialPlaces = _state.sent();
                            airport = (0, $ebafe5173736b985$export$69f61ba2c149a675)((_aerialPlaces_data = aerialPlaces.data) === null || _aerialPlaces_data === void 0 ? void 0 : _aerialPlaces_data.airports, location.iata);
                            airport && setValue(context, {
                                location: airport
                            });
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        //eslint-disable-next-line
        fetch();
    }, [
        context,
        getAerialPlaces,
        getOceanPlaces,
        getPostalCode,
        location,
        setValue
    ]);
};



var $69e90271a1fa706a$export$24dfb93f8c8c2763 = function(props) {
    var additionalServices = props.additionalServices, setValue = props.setValue;
    (0, $fZLIC$react.useEffect)(function() {
        if (additionalServices) {
            additionalServices.importCustomClearance && setValue("additionalServices.importCustomClearance", true);
            if (additionalServices.customBond) {
                setValue("additionalServices.customBond", additionalServices.customBond);
                additionalServices.customBond === "needsSingleBond" && additionalServices.cargoValue && setValue("additionalServices.cargoValue", additionalServices.cargoValue);
            }
            additionalServices.residencyDelivery && setValue("additionalServices.residencyDelivery", true);
            additionalServices.liftGate && setValue("additionalServices.liftGate", true);
        }
    }, [
        additionalServices,
        setValue
    ]);
};





var $acfafc2a30048c8b$export$7be94c4059be2ce8 = function(param) {
    var sendMixpanelEvents = param.sendMixpanelEvents, setValue = param.setValue, setShipmentType = param.setShipmentType, setInitialShipmentType = param.setInitialShipmentType, t = param.t, setIsFclCargoOpen = param.setIsFclCargoOpen, setIsLclCargoOpen = param.setIsLclCargoOpen, setIsAirCargoOpen = param.setIsAirCargoOpen, setIsLtlCargoOpen = param.setIsLtlCargoOpen;
    return function(tradelanes) {
        return function(index) {
            return function() {
                var data = tradelanes[index];
                var shipmentType = data.shipmentType;
                (0, $068a6aa0fda9c13f$export$141ac067c0f2cc6c)({
                    sendMixpanelEvents: sendMixpanelEvents
                });
                setShipmentType(shipmentType);
                setInitialShipmentType(shipmentType);
                if ("postalCode" in data.origin) setValue("origin", {
                    location: data.origin,
                    postalCode: data.origin.postalCode
                });
                else setValue("origin", {
                    location: data.origin
                });
                if ("postalCode" in data.destination) setValue("destination", {
                    location: data.destination,
                    postalCode: data.destination.postalCode
                });
                else setValue("destination", {
                    location: data.destination
                });
                if (shipmentType === "FCL") {
                    var cargoDetail = (0, $942284d646ad1acb$export$1d4c38911efb8d0)({
                        containers: data.items,
                        t: t
                    });
                    setValue("cargoFclDetail", cargoDetail);
                    setIsFclCargoOpen(true);
                }
                if (shipmentType === "LCL" && data.items.length > 0) {
                    if ((0, $84c96a688242bcfe$export$32aa3057966bf054)(data.items[0])) {
                        var cargoDetail1 = (0, $942284d646ad1acb$export$c40d15b0b7beba46)({
                            items: data.items,
                            t: t
                        });
                        setValue("cargoLclDetail", {
                            dimension: cargoDetail1
                        });
                    }
                    if ((0, $84c96a688242bcfe$export$5f03b9f28d71ed92)(data.items[0])) setValue("cargoLclDetail", {
                        totalWeightVolumeItem: data.items[0]
                    });
                    setIsLclCargoOpen(true);
                }
                if (shipmentType === "AIR" && data.items.length > 0) {
                    var cargoDetail2 = (0, $942284d646ad1acb$export$c40d15b0b7beba46)({
                        items: data.items,
                        t: t
                    });
                    setValue("cargoAirDetail", cargoDetail2);
                    setIsAirCargoOpen(true);
                }
                if (shipmentType === "LTL" && data.items.length > 0) {
                    var cargoDetail3 = (0, $942284d646ad1acb$export$c40d15b0b7beba46)({
                        items: data.items,
                        t: t
                    });
                    setValue("cargoLtlDetail", cargoDetail3);
                    setIsLtlCargoOpen(true);
                }
            };
        };
    };
};



var $928d54a7e96ade6a$var$_path, $928d54a7e96ade6a$var$_path2, $928d54a7e96ade6a$var$_path3;
var $928d54a7e96ade6a$export$a70e2e549144f66 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            $928d54a7e96ade6a$var$_path || ($928d54a7e96ade6a$var$_path = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6ZM6 0.679245C3.06143 0.679245 0.679245 3.06143 0.679245 6C0.679245 8.93857 3.06143 11.3208 6 11.3208C8.93857 11.3208 11.3208 8.93857 11.3208 6C11.3208 3.06143 8.93857 0.679245 6 0.679245Z",
                fill: "#13171C"
            })),
            $928d54a7e96ade6a$var$_path2 || ($928d54a7e96ade6a$var$_path2 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.61977 1.07325C2.72481 0.917853 2.93594 0.877035 3.09134 0.982079L6.25122 3.1181C6.66007 3.3911 6.90563 3.85024 6.90566 4.34191V5.63777C6.90566 5.63777 6.90566 5.63776 6.90566 5.63777C6.9057 6.33937 6.41047 6.94345 5.72248 7.081C5.72246 7.081 5.72251 7.08099 5.72248 7.081L4.15172 7.39527L4.47612 8.6929C4.60034 9.19553 4.45131 9.72646 4.08367 10.091L4.07676 10.0977L3.12959 10.9852C2.99272 11.1135 2.77779 11.1065 2.64954 10.9696C2.52129 10.8328 2.52827 10.6178 2.66514 10.4896L3.6085 9.60561C3.80409 9.4095 3.88317 9.12539 3.81682 8.85629C3.81678 8.85615 3.81685 8.85642 3.81682 8.85629L3.40637 7.2145C3.38385 7.1244 3.3992 7.029 3.44886 6.95052C3.49852 6.87204 3.57816 6.81732 3.66922 6.7991L5.58922 6.41495C5.9597 6.3409 6.22644 6.01561 6.22642 5.63781V4.34196C6.22642 4.34195 6.22642 4.34197 6.22642 4.34196C6.22639 4.07702 6.09396 3.8296 5.87351 3.68264L5.87169 3.68142L2.71094 1.54481C2.55554 1.43977 2.51472 1.22864 2.61977 1.07325Z",
                fill: "#13171C"
            })),
            $928d54a7e96ade6a$var$_path3 || ($928d54a7e96ade6a$var$_path3 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.9539 6.46852C12.0132 6.64648 11.917 6.83879 11.7391 6.89807L9.31943 7.70411L9.31876 7.70433C8.93921 7.8299 8.71267 8.21849 8.79029 8.61057C8.79034 8.61086 8.7904 8.61114 8.79046 8.61143L9.23687 10.7892C9.27454 10.9729 9.15611 11.1524 8.97237 11.1901C8.78862 11.2277 8.60913 11.1093 8.57146 10.9256L8.12428 8.74407C7.97922 8.01549 8.39989 7.29305 9.10509 7.05957C9.1052 7.05953 9.10498 7.05961 9.10509 7.05957L11.5244 6.25365C11.7023 6.19436 11.8946 6.29057 11.9539 6.46852Z",
                fill: "#13171C"
            }))
        ]
    });
};













var $2c98285c7b835c26$export$f9af5bb88b24fcb7 = "/:shipmentType/:originIsoCode/:originType/:originCity/:originCountryIsoCode/:destinationIsoCode/:destinationType/:destinationCity/:destinationCountryIsoCode/";
var $2c98285c7b835c26$export$503accc0ac85219c = "/AIR/:originIataCode/:originIsoCode/:originType/:originCity/:originCountryIsoCode/:destinationIataCode/:destinationIsoCode/:destinationType/:destinationCity/:destinationCountryIsoCode/";





var $4ddd004b6f6e4a18$export$e48589d9e4824227 = {
    AIR: "AIR",
    OCEAN: "OCEAN"
};
var $4ddd004b6f6e4a18$export$d64ceb12fef850aa = {
    TOP: "TOP",
    LEFT: "LEFT"
};






var $427948ace18edb6b$export$8212cabffbdcceb9 = {
    zipcode: function(message) {
        return function(v) {
            if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(v.location) || (0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(v.location)) return true;
            return !v.postalCode ? message : true;
        };
    },
    validZipcode: function(message, validZipcode) {
        return function(v) {
            if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(v.location) || (0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(v.location)) return true;
            return validZipcode ? true : message;
        };
    }
};
var $427948ace18edb6b$export$5580ca34efda26a1 = {
    container: function(t) {
        return function(v) {
            var hasContainer = v.length > 0 && v.every(function(f) {
                return f.quantity > 0 && Boolean(f.type);
            });
            var isWithinContainerLimits = v.length > 0 && v.every(function(f) {
                return f.quantity <= (0, $eaa2f94cbeae9674$export$4a688500daf09f17);
            });
            var isNotCargoRequiredMessage = !isWithinContainerLimits ? t("validation:cargo.containerLimit", {
                quantityLimit: (0, $eaa2f94cbeae9674$export$4a688500daf09f17)
            }) : true;
            return !hasContainer ? t("validation:cargo.required") : isNotCargoRequiredMessage;
        };
    }
};
var $427948ace18edb6b$export$d49747421a0a3947 = {
    required: function(t, getValues, showCargoReadyDate) {
        return function() {
            if (!showCargoReadyDate) return true;
            var cargoReadyDate = getValues().cargoReadyDate;
            if (!cargoReadyDate) return t("validation:cargo.required");
            return true;
        };
    }
};
var $427948ace18edb6b$export$e596cd7d950a0534 = {
    cargo: function(t) {
        return function(v) {
            if (!v.totalWeightVolumeItem) return true;
            var lclItem = v.totalWeightVolumeItem;
            var hasCargoDetails = (0, $942284d646ad1acb$export$810f5aa8a03cefdf)(lclItem);
            if (!hasCargoDetails) return t("validation:cargo.required");
            var isMinVolumeLimit = (0, $942284d646ad1acb$export$b8f20ad0f326cc23)(lclItem.totalVolume, lclItem.volumeUnit);
            var isMaxVolumeLimit = (0, $942284d646ad1acb$export$ade0d1d6a71534ac)(lclItem.totalVolume, lclItem.volumeUnit);
            var isMaxWeightLimit = (0, $942284d646ad1acb$export$dcd325fe69cae6fb)(lclItem.totalWeight, lclItem.weightUnit);
            var density = (0, $942284d646ad1acb$export$6a84ab2fa4616d71)(lclItem);
            var isMaxDensityLimit = (0, $942284d646ad1acb$export$26ad4226e7d4106b)(density);
            var isWithinCargoLimits = isMinVolumeLimit && isMaxVolumeLimit && isMaxWeightLimit && isMaxDensityLimit;
            if (!isWithinCargoLimits) {
                if (!isMaxVolumeLimit || !isMaxWeightLimit) return t("validation:cargo.cargoLimit", {
                    weightLimit: lclItem.weightUnit === "KG" ? (0, $eaa2f94cbeae9674$export$8e337a6e8017f90f)[lclItem.weightUnit] / 1000 : (0, $eaa2f94cbeae9674$export$8e337a6e8017f90f)[lclItem.weightUnit],
                    weightUnit: lclItem.weightUnit === "KG" ? "TON" : lclItem.weightUnit,
                    volumeLimit: (0, $eaa2f94cbeae9674$export$733799f508d9fb2f)[lclItem.volumeUnit],
                    volumeUnit: lclItem.volumeUnit,
                    lengthLimit: (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6)["CM"].length,
                    widthLimit: (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6)["CM"].width,
                    heightLimit: (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6)["CM"].height,
                    lengthUnit: "cm"
                });
                if (!isMinVolumeLimit) return t("validation:cargo.minimumVolumeLimit", {
                    volumeLimit: (0, $eaa2f94cbeae9674$export$f3b7d0d07fb5286c)[lclItem.volumeUnit],
                    volumeUnit: lclItem.volumeUnit
                });
                if (!isMaxDensityLimit) return t("validation:cargo.densityLimit");
            }
            return true;
        };
    },
    dimensions: function(t) {
        return function(v) {
            if (!v.dimension) return true;
            var lclItem = v.dimension;
            var hasCargoDetails = (0, $942284d646ad1acb$export$d68c4768adc93e96)(lclItem);
            if (!hasCargoDetails) return t("validation:cargo.required");
            var hasValidSize = (0, $942284d646ad1acb$export$fe9391c0fae85d5b)(lclItem, (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6), (0, $f9f89a5c82b78d91$export$35a1e7e6818ec128));
            if (!hasValidSize) return t("validation:cargo.limitExceeded");
            var totalWeight = (0, $8835a976e07ba158$export$167ceafb15c3e7b4)(lclItem);
            var totalVolume = (0, $8835a976e07ba158$export$4ca74356a41f3701)(lclItem);
            var isMinVolumeLimit = (0, $942284d646ad1acb$export$b8f20ad0f326cc23)(totalVolume, "CBM");
            var isMaxVolumeLimit = (0, $942284d646ad1acb$export$ade0d1d6a71534ac)(totalVolume, "CBM");
            var isMaxWeightLimit = (0, $942284d646ad1acb$export$dcd325fe69cae6fb)(totalWeight, "KG");
            var isMaxDensityLimit = (0, $942284d646ad1acb$export$5fe3d195c6c0f23f)(lclItem);
            var isWithinCargoLimits = isMinVolumeLimit && isMaxVolumeLimit && isMaxWeightLimit && isMaxDensityLimit;
            if (!isWithinCargoLimits) {
                if (!isMaxVolumeLimit || !isMaxWeightLimit) return t("validation:cargo.cargoLimit", {
                    weightLimit: (0, $eaa2f94cbeae9674$export$8e337a6e8017f90f)["KG"],
                    weightUnit: "KG",
                    volumeLimit: (0, $eaa2f94cbeae9674$export$733799f508d9fb2f)["CBM"],
                    volumeUnit: "CBM",
                    lengthLimit: (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6)[lclItem[0].lengthUnit.value].length,
                    widthLimit: (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6)[lclItem[0].lengthUnit.value].width,
                    heightLimit: (0, $f9f89a5c82b78d91$export$a3e86abff5ed10b6)[lclItem[0].lengthUnit.value].height,
                    lengthUnit: lclItem[0].lengthUnit.value.toLowerCase()
                });
                if (!isMinVolumeLimit) return t("validation:cargo.minimumVolumeLimit", {
                    volumeLimit: (0, $eaa2f94cbeae9674$export$f3b7d0d07fb5286c)["CBM"],
                    volumeUnit: "CBM"
                });
                if (!isMaxDensityLimit) return t("validation:cargo.densityLimit");
            }
            return true;
        };
    }
};
var $427948ace18edb6b$export$777a0987a97158f9 = {
    dimensions: function(t) {
        return function(v) {
            var hasCargoDetails = (0, $942284d646ad1acb$export$d68c4768adc93e96)(v);
            var isMaxDensityLimit = (0, $942284d646ad1acb$export$5fe3d195c6c0f23f)(v);
            if (!hasCargoDetails) return t("validation:cargo.required");
            var hasValidSize = (0, $942284d646ad1acb$export$fe9391c0fae85d5b)(v, (0, $f9f89a5c82b78d91$export$dabdc168ed3d84c6), (0, $f9f89a5c82b78d91$export$f237b4fe6260e0a4));
            if (!hasValidSize) return t("validation:cargo.limitExceeded");
            if (!isMaxDensityLimit) return t("validation:cargo.densityLimit");
            return true;
        };
    }
};
var $427948ace18edb6b$export$f32bb5747dd242fc = {
    dimensions: function(t) {
        return function(v) {
            var hasCargoDetails = (0, $942284d646ad1acb$export$d68c4768adc93e96)(v);
            var isMaxDensityLimit = (0, $942284d646ad1acb$export$5fe3d195c6c0f23f)(v);
            if (!hasCargoDetails) return t("validation:cargo.required");
            var hasValidSize = (0, $942284d646ad1acb$export$fe9391c0fae85d5b)(v, (0, $f9f89a5c82b78d91$export$a104d8d48668662d), (0, $f9f89a5c82b78d91$export$72b57fb2b65ee7b5));
            var totalWeight = (0, $8835a976e07ba158$export$167ceafb15c3e7b4)(v);
            var totalVolume = (0, $8835a976e07ba158$export$4ca74356a41f3701)(v);
            var isMaxWeightLimit = (0, $942284d646ad1acb$export$3083fdecff35bd7a)(totalWeight, "KG");
            var isMaxVolumeLimit = (0, $942284d646ad1acb$export$8b9d9a14b370f533)(totalVolume, "CBM");
            if (!isMaxVolumeLimit || !isMaxWeightLimit) return t("validation:cargo.ltlCargoLimit", {
                weightLimit: (0, $f9f89a5c82b78d91$export$72b57fb2b65ee7b5)["KG"],
                weightUnit: "KG",
                volumeLimit: (0, $f9f89a5c82b78d91$export$6c279875ca1a9388)["CBM"],
                volumeUnit: "CBM",
                lengthLimit: (0, $f9f89a5c82b78d91$export$a104d8d48668662d)[v[0].lengthUnit.value].length,
                widthLimit: (0, $f9f89a5c82b78d91$export$a104d8d48668662d)[v[0].lengthUnit.value].width,
                heightLimit: (0, $f9f89a5c82b78d91$export$a104d8d48668662d)[v[0].lengthUnit.value].height,
                lengthUnit: v[0].lengthUnit.value.toLowerCase()
            });
            if (!hasValidSize) return t("validation:cargo.limitExceeded");
            if (!isMaxDensityLimit) return t("validation:cargo.densityLimit");
            return true;
        };
    }
};
var $427948ace18edb6b$export$f0a682a726ea71de = {
    required: function(t, getValues, showCommodity) {
        return function() {
            if (!showCommodity) return true;
            var commodity = getValues().commodity;
            if (!commodity) return t("validation:cargo.required");
            if (!commodity.accept) return t("validation:cargo.invalidCommodity");
            return true;
        };
    }
};
var $427948ace18edb6b$export$f161c7cf27a15dae = {
    required: function(t, getValues) {
        return function() {
            var freightClass = getValues().freightClass;
            if (!freightClass) return t("validation:cargo.required");
            return true;
        };
    }
};
var $427948ace18edb6b$export$14fd889102c5c72c = function(setValidZipcode, setError, t) {
    return function(fieldName) {
        setError(fieldName, {
            type: "invalidZipcode",
            message: t("validation:".concat(fieldName, ".invalidZipcode"))
        });
        setValidZipcode(false);
    };
};
var $427948ace18edb6b$export$a3085c92315008f7 = function(setValidZipcode, clearErrors) {
    return function(fieldName) {
        setValidZipcode(true);
        clearErrors(fieldName);
    };
};
var $427948ace18edb6b$export$f81efaa51ef5f18b = function(setError, t, label) {
    return function(fieldName) {
        setError(fieldName, {
            type: "invalidLength",
            message: t("validation:location.maxLength", {
                label: label,
                count: (0, $f9f89a5c82b78d91$export$40659df21aafb739)
            })
        });
    };
};
var $427948ace18edb6b$export$6058502caada7531 = function(clearErrors) {
    return function(fieldName) {
        clearErrors(fieldName);
    };
};
var $427948ace18edb6b$export$bfb9486f574e5d79 = function(param) {
    var sendGA4Events = param.sendGA4Events, closeSlideOut = param.closeSlideOut, userType = param.userType, sendMixpanelEvents = param.sendMixpanelEvents;
    return function(location) {
        closeSlideOut();
        (0, $068a6aa0fda9c13f$export$e4848c75307210a3)({
            location: location,
            userType: userType,
            sendMixpanelEvents: sendMixpanelEvents,
            sendGA4Events: sendGA4Events
        });
    };
};
var $427948ace18edb6b$export$d582f4d05c03b97c = function(param) {
    var sendGA4Events = param.sendGA4Events, closeSlideOut = param.closeSlideOut, userType = param.userType, sendMixpanelEvents = param.sendMixpanelEvents;
    return function(location) {
        closeSlideOut();
        (0, $068a6aa0fda9c13f$export$d57c8e53ae8e0980)({
            location: location,
            userType: userType,
            sendMixpanelEvents: sendMixpanelEvents,
            sendGA4Events: sendGA4Events
        });
    };
};
var $427948ace18edb6b$var$MAP_LOCATION_TYPE = {
    CITY: "POSTAL_CODE",
    POSTAL_CODE: "POSTAL_CODE",
    PORT: "PORT",
    AIRPORT: "AIRPORT"
};
var $427948ace18edb6b$export$2228ae0f4710dfd7 = function(additionalServices) {
    // eslint-disable-next-line compat/compat
    var urlSearchParams = new URLSearchParams();
    urlSearchParams.append("importCustomClearance", "".concat(additionalServices.importCustomClearance ? 1 : 0));
    urlSearchParams.append("residencyDelivery", "".concat(additionalServices.residencyDelivery ? 1 : 0));
    if (additionalServices.customBond) {
        urlSearchParams.append("customBond", "".concat(additionalServices.customBond));
        if (additionalServices.customBond === "needsSingleBond" && additionalServices.cargoValue) urlSearchParams.append("cargoValue", "".concat(additionalServices.cargoValue));
    }
    urlSearchParams.append("liftGate", "".concat(additionalServices.liftGate ? 1 : 0));
    return urlSearchParams.toString();
};
var $427948ace18edb6b$export$2954982f41676626 = function(containerItems, commodity, cargoReadyDate, additionalServices) {
    // eslint-disable-next-line compat/compat
    var urlSearchParams = new URLSearchParams();
    var containers = (0, $942284d646ad1acb$export$b5bd4e46a5271faa)(containerItems);
    Object.keys(containers).forEach(function(type) {
        urlSearchParams.set(type.toLowerCase(), "".concat(containers[type]));
    });
    if (commodity !== undefined) urlSearchParams.append("commodity", commodity);
    if (cargoReadyDate) {
        var dateFns = new (0, $fZLIC$muixdatepickersAdapterDateFns.AdapterDateFns)();
        urlSearchParams.append("cargoReadyDate", dateFns.formatByString(new Date(cargoReadyDate), "yyyy-MM-dd"));
    }
    if (!additionalServices) return "?".concat(urlSearchParams.toString());
    var additionalServicesQueryParams = $427948ace18edb6b$export$2228ae0f4710dfd7(additionalServices);
    return "?".concat(urlSearchParams.toString(), "&").concat(additionalServicesQueryParams);
};
var $427948ace18edb6b$export$599309be1ee33256 = function(item, commodity, cargoReadyDate, additionalServices) {
    // eslint-disable-next-line compat/compat
    var urlSearchParams = new URLSearchParams();
    if (item.dimension) {
        urlSearchParams.append("totalRows", "".concat(item.dimension.length));
        item.dimension.forEach(function(detail) {
            urlSearchParams.append("qty", "".concat(detail.quantity));
            urlSearchParams.append("we", "".concat(detail.weight));
            urlSearchParams.append("wu", detail.weightUnit.value);
            urlSearchParams.append("l", "".concat(detail.length));
            urlSearchParams.append("wi", "".concat(detail.width));
            urlSearchParams.append("h", "".concat(detail.height));
            urlSearchParams.append("du", detail.lengthUnit.value);
        });
    }
    if (item.totalWeightVolumeItem) {
        var lclItem = item.totalWeightVolumeItem;
        urlSearchParams.append("w", "".concat(lclItem.totalWeight));
        urlSearchParams.append("wu", lclItem.weightUnit);
        urlSearchParams.append("v", "".concat(lclItem.totalVolume));
        urlSearchParams.append("vu", lclItem.volumeUnit);
    }
    if (commodity !== undefined) urlSearchParams.append("commodity", commodity);
    if (cargoReadyDate) {
        var dateFns = new (0, $fZLIC$muixdatepickersAdapterDateFns.AdapterDateFns)();
        urlSearchParams.append("cargoReadyDate", dateFns.formatByString(new Date(cargoReadyDate), "yyyy-MM-dd"));
    }
    if (!additionalServices) return "?".concat(urlSearchParams.toString());
    var additionalServicesQueryParams = $427948ace18edb6b$export$2228ae0f4710dfd7(additionalServices);
    return "?".concat(urlSearchParams.toString(), "&").concat(additionalServicesQueryParams);
};
var $427948ace18edb6b$export$63f7005fa45c9e66 = function(data) {
    var _data_commodity, _data_commodity1;
    if (data.cargoFclDetail) return $427948ace18edb6b$export$2954982f41676626(data.cargoFclDetail, (_data_commodity = data.commodity) === null || _data_commodity === void 0 ? void 0 : _data_commodity.value, data.cargoReadyDate, data.additionalServices);
    if (data.cargoLclDetail) return $427948ace18edb6b$export$599309be1ee33256(data.cargoLclDetail, (_data_commodity1 = data.commodity) === null || _data_commodity1 === void 0 ? void 0 : _data_commodity1.value, data.cargoReadyDate, data.additionalServices);
    else return "";
};
var $427948ace18edb6b$export$cea817dc8ae39e86 = function(data) {
    var origin = data.origin, destination = data.destination;
    if (!origin || !destination) return "";
    var cargoParams = $427948ace18edb6b$export$63f7005fa45c9e66(data);
    var shipmentType = data.cargoFclDetail ? (0, $dc0baf21ad530e3b$export$296c865296deffa2).FCL : (0, $dc0baf21ad530e3b$export$296c865296deffa2).LCL;
    var originCode = (0, $8c9f42573c05ba5d$export$f57fa9a373c251fe)(origin);
    var destinationCode = (0, $8c9f42573c05ba5d$export$f57fa9a373c251fe)(destination);
    var originCity = (0, $8c9f42573c05ba5d$export$252be1df97fdbc2d)(origin.location).toUpperCase();
    var destinationCity = (0, $8c9f42573c05ba5d$export$252be1df97fdbc2d)(destination.location).toUpperCase();
    var quotePath = (0, $2c98285c7b835c26$export$f9af5bb88b24fcb7).replace(":shipmentType", shipmentType).replace(":originIsoCode", originCode).replace(":originType", $427948ace18edb6b$var$MAP_LOCATION_TYPE[origin.location.type]).replace(":originCity", encodeURIComponent(originCity)).replace(":originCountryIsoCode", origin.location.country.iso_code).replace(":destinationIsoCode", destinationCode).replace(":destinationCity", encodeURIComponent(destinationCity)).replace(":destinationType", $427948ace18edb6b$var$MAP_LOCATION_TYPE[destination.location.type]).replace(":destinationCountryIsoCode", destination.location.country.iso_code);
    return "".concat(quotePath).concat(cargoParams);
};
var $427948ace18edb6b$export$fe85e84bf5e33e39 = function(data) {
    var _data_commodity, _data_freightClass;
    var origin = data.origin, destination = data.destination;
    if (!origin || !destination) return "";
    var cargoParams = $427948ace18edb6b$export$9c50bf85058d26aa({
        items: data.cargoLtlDetail,
        cargoReadyDate: data.cargoReadyDate,
        commodity: (_data_commodity = data.commodity) === null || _data_commodity === void 0 ? void 0 : _data_commodity.value,
        freightClass: (_data_freightClass = data.freightClass) === null || _data_freightClass === void 0 ? void 0 : _data_freightClass.value
    });
    var originCode = (0, $8c9f42573c05ba5d$export$f57fa9a373c251fe)(origin);
    var destinationCode = (0, $8c9f42573c05ba5d$export$f57fa9a373c251fe)(destination);
    var originCity = (0, $8c9f42573c05ba5d$export$252be1df97fdbc2d)(origin.location).toUpperCase();
    var destinationCity = (0, $8c9f42573c05ba5d$export$252be1df97fdbc2d)(destination.location).toUpperCase();
    var quotePath = (0, $2c98285c7b835c26$export$f9af5bb88b24fcb7).replace(":shipmentType", "LTL").replace(":originIsoCode", originCode).replace(":originType", $427948ace18edb6b$var$MAP_LOCATION_TYPE[origin.location.type]).replace(":originCity", encodeURIComponent(originCity)).replace(":originCountryIsoCode", origin.location.country.iso_code).replace(":destinationIsoCode", destinationCode).replace(":destinationCity", encodeURIComponent(destinationCity)).replace(":destinationType", $427948ace18edb6b$var$MAP_LOCATION_TYPE[destination.location.type]).replace(":destinationCountryIsoCode", destination.location.country.iso_code);
    return "".concat(quotePath).concat(cargoParams);
};
var $427948ace18edb6b$export$9c50bf85058d26aa = function(params) {
    var items = params.items, commodity = params.commodity, cargoReadyDate = params.cargoReadyDate, freightClass = params.freightClass;
    if (!items) return "";
    // eslint-disable-next-line compat/compat
    var urlSearchParams = new URLSearchParams();
    urlSearchParams.append("totalRows", "".concat(items.length));
    items.forEach(function(detail) {
        urlSearchParams.append("qty", "".concat(detail.quantity));
        urlSearchParams.append("we", "".concat(detail.weight));
        urlSearchParams.append("wu", detail.weightUnit.value);
        urlSearchParams.append("l", "".concat(detail.length));
        urlSearchParams.append("wi", "".concat(detail.width));
        urlSearchParams.append("h", "".concat(detail.height));
        urlSearchParams.append("du", detail.lengthUnit.value);
    });
    if (cargoReadyDate) {
        var dateFns = new (0, $fZLIC$muixdatepickersAdapterDateFns.AdapterDateFns)();
        urlSearchParams.append("cargoReadyDate", dateFns.formatByString(new Date(cargoReadyDate), "yyyy-MM-dd"));
    }
    if (commodity) urlSearchParams.append("commodity", commodity);
    if (freightClass) urlSearchParams.append("freightClass", freightClass);
    return "?".concat(urlSearchParams.toString());
};
var $427948ace18edb6b$export$e1f6fa51b91cf89 = function(params) {
    var items = params.items, knownShipper = params.knownShipper, commodity = params.commodity, cargoReadyDate = params.cargoReadyDate, additionalServices = params.additionalServices;
    if (!items) return "";
    // eslint-disable-next-line compat/compat
    var urlSearchParams = new URLSearchParams();
    urlSearchParams.append("totalRows", "".concat(items.length));
    items.forEach(function(detail) {
        urlSearchParams.append("qty", "".concat(detail.quantity));
        urlSearchParams.append("we", "".concat(detail.weight));
        urlSearchParams.append("wu", detail.weightUnit.value);
        urlSearchParams.append("l", "".concat(detail.length));
        urlSearchParams.append("wi", "".concat(detail.width));
        urlSearchParams.append("h", "".concat(detail.height));
        urlSearchParams.append("du", detail.lengthUnit.value);
    });
    if (knownShipper !== undefined) urlSearchParams.append("knownShipper", "".concat(knownShipper ? 1 : 0));
    if (cargoReadyDate) {
        var dateFns = new (0, $fZLIC$muixdatepickersAdapterDateFns.AdapterDateFns)();
        urlSearchParams.append("cargoReadyDate", dateFns.formatByString(new Date(cargoReadyDate), "yyyy-MM-dd"));
    }
    if (commodity) urlSearchParams.append("commodity", commodity);
    if (!additionalServices) return "?".concat(urlSearchParams.toString());
    var additionalServicesQueryParams = $427948ace18edb6b$export$2228ae0f4710dfd7(additionalServices);
    return "?".concat(urlSearchParams.toString(), "&").concat(additionalServicesQueryParams);
};
var $427948ace18edb6b$export$e83f3f4ca2b753f9 = function(data) {
    var _data_commodity;
    var origin = data.origin, destination = data.destination;
    if (!origin || !destination) return "";
    var cargoParams = $427948ace18edb6b$export$e1f6fa51b91cf89({
        items: data.cargoAirDetail,
        knownShipper: data.knownShipper,
        cargoReadyDate: data.cargoReadyDate,
        commodity: (_data_commodity = data.commodity) === null || _data_commodity === void 0 ? void 0 : _data_commodity.value,
        additionalServices: data.additionalServices
    });
    var originIataCode = (0, $8c9f42573c05ba5d$export$6801e921945a0207)(origin);
    var destinationIataCode = (0, $8c9f42573c05ba5d$export$6801e921945a0207)(destination);
    var originCode = (0, $8c9f42573c05ba5d$export$f57fa9a373c251fe)(origin);
    var destinationCode = (0, $8c9f42573c05ba5d$export$f57fa9a373c251fe)(destination);
    var originCity = (0, $8c9f42573c05ba5d$export$252be1df97fdbc2d)(origin.location).toUpperCase();
    var destinationCity = (0, $8c9f42573c05ba5d$export$252be1df97fdbc2d)(destination.location).toUpperCase();
    var quotePath = (0, $2c98285c7b835c26$export$503accc0ac85219c).replace(":originIataCode", originIataCode).replace(":originIsoCode", originCode).replace(":originType", $427948ace18edb6b$var$MAP_LOCATION_TYPE[origin.location.type]).replace(":originCity", encodeURIComponent(originCity)).replace(":destinationIataCode", destinationIataCode).replace(":originCountryIsoCode", origin.location.country.iso_code).replace(":destinationIsoCode", destinationCode).replace(":destinationCity", encodeURIComponent(destinationCity)).replace(":destinationType", $427948ace18edb6b$var$MAP_LOCATION_TYPE[destination.location.type]).replace(":destinationCountryIsoCode", destination.location.country.iso_code);
    return "".concat(quotePath).concat(cargoParams);
};
var $427948ace18edb6b$export$7539231345432c7d = function(data) {
    if (data.cargoAirDetail) return $427948ace18edb6b$export$e83f3f4ca2b753f9(data);
    if (data.cargoLtlDetail) return $427948ace18edb6b$export$fe85e84bf5e33e39(data);
    return $427948ace18edb6b$export$cea817dc8ae39e86(data);
};
var $427948ace18edb6b$export$642576f8935df945 = function(param) {
    var onSearch = param.onSearch, onBackdropClick = param.onBackdropClick, sendGA4Events = param.sendGA4Events, userType = param.userType, isFetching = param.isFetching, setSubmitFormClick = param.setSubmitFormClick;
    return function(data) {
        if (!isFetching) {
            setSubmitFormClick(false);
            (0, $068a6aa0fda9c13f$export$3e822338bed59a9a)({
                data: data,
                userType: userType,
                sendGA4Events: sendGA4Events
            });
            var quoteURL = $427948ace18edb6b$export$7539231345432c7d(data);
            onSearch(quoteURL, data);
            onBackdropClick();
        } else setSubmitFormClick(true);
    };
};
var $427948ace18edb6b$export$deabe298d4a07c61 = function(param) {
    var setHasFclCargoError = param.setHasFclCargoError, setHasLclCargoError = param.setHasLclCargoError, setHasAirCargoError = param.setHasAirCargoError, setHasLtlCargoError = param.setHasLtlCargoError;
    return function(error) {
        setHasFclCargoError(Boolean(error.cargoFclDetail));
        setHasLclCargoError(Boolean(error.cargoLclDetail));
        setHasAirCargoError(Boolean(error.cargoAirDetail));
        setHasLtlCargoError(Boolean(error.cargoLtlDetail));
    };
};
var $427948ace18edb6b$export$77dfc21160b11f8b = function(param) {
    var setIsSlideOutOpen = param.setIsSlideOutOpen, setShowOriginSlideOut = param.setShowOriginSlideOut, open = param.open, destinationLocationFieldRef = param.destinationLocationFieldRef, setIsAirCargoOpen = param.setIsAirCargoOpen, setIsFclCargoOpen = param.setIsFclCargoOpen, setIsLclCargoOpen = param.setIsLclCargoOpen, setIsLtlCargoOpen = param.setIsLtlCargoOpen;
    return function() {
        var _destinationLocationFieldRef_current;
        setIsSlideOutOpen(open);
        setShowOriginSlideOut(open);
        destinationLocationFieldRef === null || destinationLocationFieldRef === void 0 ? void 0 : (_destinationLocationFieldRef_current = destinationLocationFieldRef.current) === null || _destinationLocationFieldRef_current === void 0 ? void 0 : _destinationLocationFieldRef_current.closePopup();
        setIsAirCargoOpen(false);
        setIsFclCargoOpen(false);
        setIsLclCargoOpen(false);
        setIsLtlCargoOpen(false);
    };
};
var $427948ace18edb6b$export$285566c1c1f37a0a = function(param) {
    var setIsSlideOutOpen = param.setIsSlideOutOpen, setShowDestinationSlideOut = param.setShowDestinationSlideOut, open = param.open, originLocationFieldRef = param.originLocationFieldRef, setIsAirCargoOpen = param.setIsAirCargoOpen, setIsFclCargoOpen = param.setIsFclCargoOpen, setIsLclCargoOpen = param.setIsLclCargoOpen, setIsLtlCargoOpen = param.setIsLtlCargoOpen;
    return function() {
        var _originLocationFieldRef_current;
        setIsSlideOutOpen(open);
        setShowDestinationSlideOut(open);
        originLocationFieldRef === null || originLocationFieldRef === void 0 ? void 0 : (_originLocationFieldRef_current = originLocationFieldRef.current) === null || _originLocationFieldRef_current === void 0 ? void 0 : _originLocationFieldRef_current.closePopup();
        setIsAirCargoOpen(false);
        setIsFclCargoOpen(false);
        setIsLclCargoOpen(false);
        setIsLtlCargoOpen(false);
    };
};
var $427948ace18edb6b$export$62aa1559cc3b7d73 = function(param) {
    var originLocationFieldRef = param.originLocationFieldRef, destinationLocationFieldRef = param.destinationLocationFieldRef;
    return function() {
        var _originLocationFieldRef_current, _destinationLocationFieldRef_current;
        originLocationFieldRef === null || originLocationFieldRef === void 0 ? void 0 : (_originLocationFieldRef_current = originLocationFieldRef.current) === null || _originLocationFieldRef_current === void 0 ? void 0 : _originLocationFieldRef_current.closePopup();
        destinationLocationFieldRef === null || destinationLocationFieldRef === void 0 ? void 0 : (_destinationLocationFieldRef_current = destinationLocationFieldRef.current) === null || _destinationLocationFieldRef_current === void 0 ? void 0 : _destinationLocationFieldRef_current.closePopup();
    };
};
var $427948ace18edb6b$export$1abb8e0a0ff76886 = function(param) {
    var setIsSlideOutOpen = param.setIsSlideOutOpen, setShowDestinationSlideOut = param.setShowDestinationSlideOut, setShowOriginSlideOut = param.setShowOriginSlideOut;
    return function() {
        setIsSlideOutOpen(false);
        setShowDestinationSlideOut(false);
        setShowOriginSlideOut(false);
    };
};
var $427948ace18edb6b$export$faf4657c5d040010 = function(param) {
    var formRef = param.formRef, fieldNo = param.fieldNo;
    return function(location) {
        if ((0, $3180d1e7f238f266$export$bf27ad191565d194)(location) || (0, $3180d1e7f238f266$export$1fb21e0e5ee2e8a3)(location) || location.country.iso_code === "AE") {
            var _formRef_current;
            var element = (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current[fieldNo];
            element && element.focus();
        }
    };
};
var $427948ace18edb6b$export$8037e2fb296fb151 = function(param) {
    var focusNextField = param.focusNextField, isMobile = param.isMobile, formRef = param.formRef, sendGA4Events = param.sendGA4Events, userType = param.userType, sendMixpanelEvents = param.sendMixpanelEvents;
    return function(location) {
        if (!isMobile) focusNextField({
            formRef: formRef,
            fieldNo: 1
        })(location);
        (0, $068a6aa0fda9c13f$export$e4848c75307210a3)({
            sendMixpanelEvents: sendMixpanelEvents,
            sendGA4Events: sendGA4Events,
            userType: userType,
            location: location
        });
    };
};
var $427948ace18edb6b$export$372408f41398b261 = function(param) {
    var focusNextField = param.focusNextField, isMobile = param.isMobile, formRef = param.formRef, sendGA4Events = param.sendGA4Events, userType = param.userType, sendMixpanelEvents = param.sendMixpanelEvents;
    return function(location) {
        if (!isMobile) focusNextField({
            formRef: formRef,
            fieldNo: 2
        })(location);
        (0, $068a6aa0fda9c13f$export$d57c8e53ae8e0980)({
            location: location,
            userType: userType,
            sendMixpanelEvents: sendMixpanelEvents,
            sendGA4Events: sendGA4Events
        });
    };
};
var $427948ace18edb6b$export$aabeb5e9384bd92 = function(param) {
    var isVerticalMode = param.isVerticalMode, inIframe = param.inIframe, visible = param.visible;
    return function() {
        if ((isVerticalMode || !visible) && inIframe) window.parent.postMessage({
            type: "slideout",
            visible: visible
        }, "*");
    };
};
var $427948ace18edb6b$export$e2198ef1949270d6 = function(param) {
    var isFetching = param.isFetching, submitFormClick = param.submitFormClick, onSubmit = param.onSubmit;
    return function() {
        if (isFetching === 0 && submitFormClick) onSubmit();
    };
};
var $427948ace18edb6b$export$f6e39248344880b4 = function(param) {
    var originLocationFieldRef = param.originLocationFieldRef, destinationLocationFieldRef = param.destinationLocationFieldRef, setIsAirCargoOpen = param.setIsAirCargoOpen, setIsFclCargoOpen = param.setIsFclCargoOpen, setIsLclCargoOpen = param.setIsLclCargoOpen, setIsLtlCargoOpen = param.setIsLtlCargoOpen;
    return function() {
        var _originLocationFieldRef_current, _destinationLocationFieldRef_current;
        originLocationFieldRef === null || originLocationFieldRef === void 0 ? void 0 : (_originLocationFieldRef_current = originLocationFieldRef.current) === null || _originLocationFieldRef_current === void 0 ? void 0 : _originLocationFieldRef_current.closePopup();
        destinationLocationFieldRef === null || destinationLocationFieldRef === void 0 ? void 0 : (_destinationLocationFieldRef_current = destinationLocationFieldRef.current) === null || _destinationLocationFieldRef_current === void 0 ? void 0 : _destinationLocationFieldRef_current.closePopup();
        setIsAirCargoOpen(false);
        setIsFclCargoOpen(false);
        setIsLclCargoOpen(false);
        setIsLtlCargoOpen(false);
    };
};
var $427948ace18edb6b$export$9f4018f687e3a160 = function(data) {
    return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, data), {
        cities: [],
        postalCodes: []
    });
};
var $427948ace18edb6b$export$5fa2ec5b922b62be = function(shipmentType) {
    return function(data) {
        if (shipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR) return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, data), {
            airports: []
        });
        return (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spread_propsjs)))((0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({}, data), {
            ports: []
        });
    };
};
var $427948ace18edb6b$export$c5827b88db395588 = function(param) {
    var isAdvancedTypeWidget = param.isAdvancedTypeWidget, shipmentType = param.shipmentType;
    if (isAdvancedTypeWidget) return {
        filterData: $427948ace18edb6b$export$9f4018f687e3a160,
        filterLocationCountryIsoCode: "US"
    };
    if (shipmentType === "LTL") return {
        filterData: $427948ace18edb6b$export$5fa2ec5b922b62be(shipmentType),
        filterLocationCountryIsoCode: "US"
    };
    return {};
};
var $427948ace18edb6b$export$6d682668d71d6eec = function(param) {
    var isAdvancedTypeWidget = param.isAdvancedTypeWidget, shipmentType = param.shipmentType;
    if (isAdvancedTypeWidget) return {
        filterData: $427948ace18edb6b$export$5fa2ec5b922b62be(shipmentType),
        filterLocationCountryIsoCode: "US"
    };
    if (shipmentType === "LTL") return {
        filterData: $427948ace18edb6b$export$5fa2ec5b922b62be(shipmentType),
        filterLocationCountryIsoCode: "US"
    };
    return {};
};
var $427948ace18edb6b$export$a077249a0df5fcab = function(param) {
    var isAdvancedTypeWidget = param.isAdvancedTypeWidget, shipmentType = param.shipmentType, t = param.t;
    if (isAdvancedTypeWidget) return t("enterPort");
    if (shipmentType === "LTL") return t("pickupLocationUS");
    var mode = shipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR ? (0, $4ddd004b6f6e4a18$export$e48589d9e4824227).AIR : (0, $4ddd004b6f6e4a18$export$e48589d9e4824227).OCEAN;
    return t("quoteForm.placeholder.".concat(mode));
};
var $427948ace18edb6b$export$6545c919d93261f5 = function(param) {
    var isAdvancedTypeWidget = param.isAdvancedTypeWidget, shipmentType = param.shipmentType, t = param.t;
    if (isAdvancedTypeWidget) return t("enterLocation");
    if (shipmentType === "LTL") return t("deliveryLocationUS");
    var mode = shipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR ? (0, $4ddd004b6f6e4a18$export$e48589d9e4824227).AIR : (0, $4ddd004b6f6e4a18$export$e48589d9e4824227).OCEAN;
    return t("quoteForm.placeholder.".concat(mode));
};


var $286bae1aa5e77428$var$_GlobeIcon, $286bae1aa5e77428$var$_GlobeIcon2, $286bae1aa5e77428$var$_GlobeIcon3, $286bae1aa5e77428$var$_GlobeIcon4;
var $286bae1aa5e77428$export$d76764c0f676706 = function(props) {
    var shipmentType = props.shipmentType, _props_showLeftMultiModeTabs = props.showLeftMultiModeTabs, showLeftMultiModeTabs = _props_showLeftMultiModeTabs === void 0 ? false : _props_showLeftMultiModeTabs, onSearch = props.onSearch, details = props.details, _props_layerIndex = props.layerIndex, layerIndex = _props_layerIndex === void 0 ? 9999 : _props_layerIndex, _props_isVertical = props.isVertical, isVertical = _props_isVertical === void 0 ? false : _props_isVertical, backdropVisible = props.backdropVisible, setBackdropVisible = props.setBackdropVisible, isFclCargoOpen = props.isFclCargoOpen, isLclCargoOpen = props.isLclCargoOpen, isAirCargoOpen = props.isAirCargoOpen, isLtlCargoOpen = props.isLtlCargoOpen, setIsFclCargoOpen = props.setIsFclCargoOpen, setIsLclCargoOpen = props.setIsLclCargoOpen, setIsAirCargoOpen = props.setIsAirCargoOpen, setIsLtlCargoOpen = props.setIsLtlCargoOpen, searchButtonColor = props.searchButtonColor, searchButtonHoverColor = props.searchButtonHoverColor, sendGA4Events = props.sendGA4Events, userType = props.userType, onBackdropClick = props.onBackdropClick, setShipmentType = props.setShipmentType;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(shipmentType), 2), initialShipmentType = _useState[0], setInitialShipmentType = _useState[1];
    var _useState1 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)("js"), 2), source = _useState1[0], setSource = _useState1[1];
    var formRef = (0, $fZLIC$react.useRef)(null);
    var originLocationFieldRef = (0, $fZLIC$react.useRef)(null);
    var destinationLocationFieldRef = (0, $fZLIC$react.useRef)(null);
    var origin, destination, cargo, knownShipper, cargoReadyDate, commodity, additionalServices, freightClass;
    if (details) {
        origin = details.origin;
        destination = details.destination;
        cargo = details.cargo;
        knownShipper = Boolean(details.knownShipper);
        cargoReadyDate = details.cargoReadyDate;
        commodity = details.commodity;
        additionalServices = details.additionalServices;
        freightClass = details.freightClass;
    }
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), isMobile = _useContext.isMobile, isTablet = _useContext.isTablet, isDesktop = _useContext.isDesktop, showCommodity = _useContext.showCommodity, showCargoReadyDateForOcean = _useContext.showCargoReadyDateForOcean, showCargoReadyDateForAir = _useContext.showCargoReadyDateForAir, showCargoReadyDateForLTL = _useContext.showCargoReadyDateForLTL, inIframe = _useContext.inIframe, sendMixpanelEvents = _useContext.sendMixpanelEvents, type = _useContext.type;
    var _useState2 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), isSlideOutOpen = _useState2[0], setIsSlideOutOpen = _useState2[1];
    var _useState3 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), showOriginSlideOut = _useState3[0], setShowOriginSlideOut = _useState3[1];
    var _useState4 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), showDestinationSlideOut = _useState4[0], setShowDestinationSlideOut = _useState4[1];
    var _useForm = (0, $fZLIC$reacthookform.useForm)(), control = _useForm.control, handleSubmit = _useForm.handleSubmit, setValue = _useForm.setValue, setError = _useForm.setError, clearErrors = _useForm.clearErrors, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isDirty = _useForm_formState.isDirty, getValues = _useForm.getValues;
    (0, $fZLIC$react.useEffect)(function() {
        setSource(isDirty ? "manual" : "js");
    }, [
        isDirty,
        setSource
    ]);
    var _useState5 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), loading = _useState5[0], setLoading = _useState5[1];
    var _useState6 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), hasFclCargoError = _useState6[0], setHasFclCargoError = _useState6[1];
    var _useState7 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), hasLclCargoError = _useState7[0], setHasLclCargoError = _useState7[1];
    var _useState8 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), hasAirCargoError = _useState8[0], setHasAirCargoError = _useState8[1];
    var _useState9 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(), 2), hasLtlCargoError = _useState9[0], setHasLtlCargoError = _useState9[1];
    var _useState10 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(true), 2), originValidZipcode = _useState10[0], setOriginValidZipcode = _useState10[1];
    var _useState11 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(true), 2), destinationValidZipcode = _useState11[0], setDestinationValidZipcode = _useState11[1];
    (0, $f4b9458733f16ec2$export$b74efa06c7fcbe67)({
        location: origin,
        setValue: setValue,
        context: "origin",
        shipmentType: shipmentType,
        source: source
    });
    (0, $f4b9458733f16ec2$export$b74efa06c7fcbe67)({
        location: destination,
        setValue: setValue,
        context: "destination",
        shipmentType: shipmentType,
        source: source
    });
    (0, $ed34b28a5e0daddb$export$c917018fe1fce6ad)({
        cargo: cargo,
        setValue: setValue,
        knownShipper: knownShipper,
        cargoReadyDate: cargoReadyDate,
        shipmentType: shipmentType,
        t: t,
        commodity: commodity,
        freightClass: freightClass
    });
    (0, $69e90271a1fa706a$export$24dfb93f8c8c2763)({
        setValue: setValue,
        additionalServices: additionalServices
    });
    var isVerticalMode = isMobile || isVertical;
    (0, $fZLIC$react.useEffect)((0, $427948ace18edb6b$export$aabeb5e9384bd92)({
        isVerticalMode: isVerticalMode,
        inIframe: inIframe,
        visible: showOriginSlideOut || showDestinationSlideOut || isFclCargoOpen || isLclCargoOpen || isAirCargoOpen
    }), [
        showOriginSlideOut,
        showDestinationSlideOut,
        isFclCargoOpen,
        isLclCargoOpen,
        isAirCargoOpen
    ]);
    (0, $7dd6993e2db39a4f$export$51aa9d0509a4e8ff)({
        getValues: getValues,
        setValue: setValue,
        shipmentType: shipmentType,
        source: source,
        originLocationFieldRef: originLocationFieldRef,
        isVerticalMode: isVerticalMode,
        sendMixpanelEvents: sendMixpanelEvents,
        initialShipmentType: initialShipmentType,
        setInitialShipmentType: setInitialShipmentType,
        onChange: (0, $427948ace18edb6b$export$f6e39248344880b4)({
            originLocationFieldRef: originLocationFieldRef,
            destinationLocationFieldRef: destinationLocationFieldRef,
            setIsFclCargoOpen: setIsFclCargoOpen,
            setIsLclCargoOpen: setIsLclCargoOpen,
            setIsAirCargoOpen: setIsAirCargoOpen,
            setIsLtlCargoOpen: setIsLtlCargoOpen
        })
    });
    var setRecentSearch = (0, $acfafc2a30048c8b$export$7be94c4059be2ce8)({
        setValue: setValue,
        sendMixpanelEvents: sendMixpanelEvents,
        setShipmentType: setShipmentType,
        setInitialShipmentType: setInitialShipmentType,
        t: t,
        setIsAirCargoOpen: setIsAirCargoOpen,
        setIsFclCargoOpen: setIsFclCargoOpen,
        setIsLclCargoOpen: setIsLclCargoOpen,
        setIsLtlCargoOpen: setIsLtlCargoOpen
    });
    var _useState12 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), submitFormClick = _useState12[0], setSubmitFormClick = _useState12[1];
    var isFetching = (0, $fZLIC$reactquery.useIsFetching)();
    var onSubmit = handleSubmit((0, $427948ace18edb6b$export$642576f8935df945)({
        onSearch: onSearch,
        sendGA4Events: sendGA4Events,
        onBackdropClick: onBackdropClick,
        userType: userType,
        isFetching: isFetching,
        setSubmitFormClick: setSubmitFormClick
    }), (0, $427948ace18edb6b$export$deabe298d4a07c61)({
        setHasFclCargoError: setHasFclCargoError,
        setHasLclCargoError: setHasLclCargoError,
        setHasAirCargoError: setHasAirCargoError,
        setHasLtlCargoError: setHasLtlCargoError
    }));
    (0, $fZLIC$react.useEffect)((0, $427948ace18edb6b$export$e2198ef1949270d6)({
        isFetching: isFetching,
        submitFormClick: submitFormClick,
        onSubmit: onSubmit
    }), [
        isFetching
    ]);
    var isAdvancedTypeWidget = type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance;
    var showSectionTitle = isAdvancedTypeWidget;
    var showAdditionalServices = isAdvancedTypeWidget;
    var originLabel = isAdvancedTypeWidget ? t("advanceWidget.origin") : t("quoteForm.origin");
    var originLocationPlaceholder = (0, $427948ace18edb6b$export$a077249a0df5fcab)({
        isAdvancedTypeWidget: isAdvancedTypeWidget,
        shipmentType: shipmentType,
        t: t
    });
    var destinationLocationPlaceholder = (0, $427948ace18edb6b$export$6545c919d93261f5)({
        isAdvancedTypeWidget: isAdvancedTypeWidget,
        shipmentType: shipmentType,
        t: t
    });
    var originLocationProps = (0, $427948ace18edb6b$export$c5827b88db395588)({
        isAdvancedTypeWidget: isAdvancedTypeWidget,
        shipmentType: shipmentType
    });
    var destinationLabel = isAdvancedTypeWidget ? t("advanceWidget.destination") : t("quoteForm.destination");
    var destinationLocationProps = (0, $427948ace18edb6b$export$6d682668d71d6eec)({
        isAdvancedTypeWidget: isAdvancedTypeWidget,
        shipmentType: shipmentType
    });
    var allowRecentSearchInDesktop = !isVerticalMode && !isAdvancedTypeWidget;
    var allowRecentSearchInSlideout = !isAdvancedTypeWidget;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $24c7a71cd12612cd$export$a7fed597f4b8afd8), {
        onSubmit: onSubmit,
        autoComplete: "off",
        noValidate: true,
        ref: formRef,
        $showLeftMultiModeTabs: showLeftMultiModeTabs,
        $isVertical: isVertical,
        $isFocus: backdropVisible,
        $layerIndex: layerIndex,
        $isMobile: isMobile,
        $isTablet: isTablet,
        $isDesktop: isDesktop,
        $inIframe: inIframe,
        $type: type,
        children: [
            inIframe && backdropVisible && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$449e05ff40298396), {
                onClick: onBackdropClick
            }),
            showSectionTitle && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$f99233281efd08a0), {
                children: t("locations")
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6f8dba4147330b62$export$f8f9ea2bcdb95c32), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({
                ref: originLocationFieldRef,
                name: "origin",
                type: "pickup",
                isVertical: isVertical,
                label: originLabel,
                placeholder: originLocationPlaceholder,
                control: control,
                icon: $286bae1aa5e77428$var$_GlobeIcon || ($286bae1aa5e77428$var$_GlobeIcon = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $928d54a7e96ade6a$export$a70e2e549144f66), {})),
                shipmentType: shipmentType,
                initialShipmentType: initialShipmentType,
                onFocus: (0, $427948ace18edb6b$export$77dfc21160b11f8b)({
                    setIsSlideOutOpen: setIsSlideOutOpen,
                    setShowOriginSlideOut: setShowOriginSlideOut,
                    open: isVerticalMode,
                    destinationLocationFieldRef: destinationLocationFieldRef,
                    setIsFclCargoOpen: setIsFclCargoOpen,
                    setIsLclCargoOpen: setIsLclCargoOpen,
                    setIsAirCargoOpen: setIsAirCargoOpen,
                    setIsLtlCargoOpen: setIsLtlCargoOpen
                }),
                "data-testid": "OriginLocationInput",
                className: "origin-location",
                onSelect: (0, $427948ace18edb6b$export$8037e2fb296fb151)({
                    focusNextField: (0, $427948ace18edb6b$export$faf4657c5d040010),
                    sendGA4Events: sendGA4Events,
                    isMobile: isVerticalMode,
                    formRef: formRef,
                    userType: userType,
                    sendMixpanelEvents: sendMixpanelEvents
                }),
                rules: {
                    required: {
                        value: true,
                        message: t("validation:origin.required")
                    },
                    validate: {
                        zipcode: (0, $427948ace18edb6b$export$8212cabffbdcceb9).zipcode(t("validation:origin.zipcode")),
                        invalidZipcode: (0, $427948ace18edb6b$export$8212cabffbdcceb9).validZipcode(t("validation:origin.invalidZipcode"), originValidZipcode)
                    }
                },
                error: errors.origin,
                setInvalidZipcodeError: (0, $427948ace18edb6b$export$14fd889102c5c72c)(setOriginValidZipcode, setError, t),
                clearInvalidZipcodeError: (0, $427948ace18edb6b$export$a3085c92315008f7)(setOriginValidZipcode, clearErrors),
                setLengthError: (0, $427948ace18edb6b$export$f81efaa51ef5f18b)(setError, t, t("validation:location.origin")),
                clearLengthErrors: (0, $427948ace18edb6b$export$6058502caada7531)(clearErrors),
                setLoading: setLoading,
                setBackdropVisible: setBackdropVisible,
                backdropVisible: backdropVisible,
                onBackdropClick: onBackdropClick,
                sendGA4Events: sendGA4Events,
                allowRecentsDropdown: allowRecentSearchInDesktop,
                source: source,
                setRecentSearch: setRecentSearch,
                sendMixpanelEvents: sendMixpanelEvents
            }, originLocationProps)),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$1ff3c3f08ae963c0), {
                $isVertical: isVertical,
                $isMobile: isMobile,
                $inIframe: inIframe,
                $type: type
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6f8dba4147330b62$export$f8f9ea2bcdb95c32), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({
                ref: destinationLocationFieldRef,
                name: "destination",
                type: "delivery",
                isVertical: isVertical,
                label: destinationLabel,
                placeholder: destinationLocationPlaceholder,
                control: control,
                icon: $286bae1aa5e77428$var$_GlobeIcon2 || ($286bae1aa5e77428$var$_GlobeIcon2 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $928d54a7e96ade6a$export$a70e2e549144f66), {})),
                shipmentType: shipmentType,
                initialShipmentType: initialShipmentType,
                onFocus: (0, $427948ace18edb6b$export$285566c1c1f37a0a)({
                    setIsSlideOutOpen: setIsSlideOutOpen,
                    setShowDestinationSlideOut: setShowDestinationSlideOut,
                    open: isVerticalMode,
                    originLocationFieldRef: originLocationFieldRef,
                    setIsFclCargoOpen: setIsFclCargoOpen,
                    setIsLclCargoOpen: setIsLclCargoOpen,
                    setIsAirCargoOpen: setIsAirCargoOpen,
                    setIsLtlCargoOpen: setIsLtlCargoOpen
                }),
                "data-testid": "DestinationLocationInput",
                className: "destination-location",
                onSelect: (0, $427948ace18edb6b$export$372408f41398b261)({
                    focusNextField: (0, $427948ace18edb6b$export$faf4657c5d040010),
                    sendGA4Events: sendGA4Events,
                    isMobile: isVerticalMode,
                    formRef: formRef,
                    userType: userType,
                    sendMixpanelEvents: sendMixpanelEvents
                }),
                rules: {
                    required: {
                        value: true,
                        message: t("validation:destination.required")
                    },
                    validate: {
                        zipcode: (0, $427948ace18edb6b$export$8212cabffbdcceb9).zipcode(t("validation:destination.zipcode")),
                        invalidZipcode: (0, $427948ace18edb6b$export$8212cabffbdcceb9).validZipcode(t("validation:destination.invalidZipcode"), destinationValidZipcode)
                    }
                },
                error: errors.destination,
                setInvalidZipcodeError: (0, $427948ace18edb6b$export$14fd889102c5c72c)(setDestinationValidZipcode, setError, t),
                clearInvalidZipcodeError: (0, $427948ace18edb6b$export$a3085c92315008f7)(setDestinationValidZipcode, clearErrors),
                setLengthError: (0, $427948ace18edb6b$export$f81efaa51ef5f18b)(setError, t, t("validation:location.destination")),
                clearLengthErrors: (0, $427948ace18edb6b$export$6058502caada7531)(clearErrors),
                setLoading: setLoading,
                setBackdropVisible: setBackdropVisible,
                backdropVisible: backdropVisible,
                onBackdropClick: onBackdropClick,
                sendGA4Events: sendGA4Events,
                source: source,
                sendMixpanelEvents: sendMixpanelEvents
            }, destinationLocationProps)),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$1ff3c3f08ae963c0), {
                $isVertical: isVertical,
                $isMobile: isMobile,
                $inIframe: inIframe,
                $type: type
            }),
            showSectionTitle && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$f99233281efd08a0), {
                children: t("cargoDetails.cargoDetails")
            }),
            initialShipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).FCL && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $dd15f068ad49aecd$export$179847f1b4a8398c), {
                name: "cargoFclDetail",
                control: control,
                isVertical: isVertical,
                isOpen: isFclCargoOpen,
                setIsOpen: setIsFclCargoOpen,
                searchButtonColor: searchButtonColor,
                searchButtonHoverColor: searchButtonHoverColor,
                hasError: hasFclCargoError,
                rules: {
                    required: {
                        value: true,
                        message: t("validation:cargo.required")
                    },
                    validate: {
                        container: (0, $427948ace18edb6b$export$5580ca34efda26a1).container(t),
                        cargoReadyDate: (0, $427948ace18edb6b$export$d49747421a0a3947).required(t, getValues, showCargoReadyDateForOcean),
                        commodity: (0, $427948ace18edb6b$export$f0a682a726ea71de).required(t, getValues, showCommodity)
                    }
                },
                loading: loading,
                setBackdropVisible: setBackdropVisible,
                onBackdropClick: onBackdropClick,
                onFocus: (0, $427948ace18edb6b$export$62aa1559cc3b7d73)({
                    originLocationFieldRef: originLocationFieldRef,
                    destinationLocationFieldRef: destinationLocationFieldRef
                })
            }),
            initialShipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).LCL && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $36a47dbbf64c26d7$export$9eab3921fc00c3e8), {
                name: "cargoLclDetail",
                control: control,
                isVertical: isVertical,
                isOpen: isLclCargoOpen,
                setIsOpen: setIsLclCargoOpen,
                searchButtonColor: searchButtonColor,
                searchButtonHoverColor: searchButtonHoverColor,
                hasError: hasLclCargoError,
                rules: {
                    required: {
                        value: true,
                        message: t("validation:cargo.required")
                    },
                    validate: {
                        cargo: (0, $427948ace18edb6b$export$e596cd7d950a0534).cargo(t),
                        dimensions: (0, $427948ace18edb6b$export$e596cd7d950a0534).dimensions(t),
                        cargoReadyDate: (0, $427948ace18edb6b$export$d49747421a0a3947).required(t, getValues, showCargoReadyDateForOcean),
                        commodity: (0, $427948ace18edb6b$export$f0a682a726ea71de).required(t, getValues, showCommodity)
                    }
                },
                loading: loading,
                setBackdropVisible: setBackdropVisible,
                onBackdropClick: onBackdropClick,
                onFocus: (0, $427948ace18edb6b$export$62aa1559cc3b7d73)({
                    originLocationFieldRef: originLocationFieldRef,
                    destinationLocationFieldRef: destinationLocationFieldRef
                })
            }),
            initialShipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).AIR && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b7d49aea27b51ec8$export$d56fb91100813d6e), {
                name: "cargoAirDetail",
                control: control,
                isVertical: isVertical,
                searchButtonColor: searchButtonColor,
                searchButtonHoverColor: searchButtonHoverColor,
                hasError: hasAirCargoError,
                rules: {
                    required: {
                        value: true,
                        message: t("validation:cargo.required")
                    },
                    validate: {
                        dimensions: (0, $427948ace18edb6b$export$777a0987a97158f9).dimensions(t),
                        cargoReadyDate: (0, $427948ace18edb6b$export$d49747421a0a3947).required(t, getValues, showCargoReadyDateForAir),
                        commodity: (0, $427948ace18edb6b$export$f0a682a726ea71de).required(t, getValues, showCommodity)
                    }
                },
                loading: loading,
                setBackdropVisible: setBackdropVisible,
                onBackdropClick: onBackdropClick,
                onFocus: (0, $427948ace18edb6b$export$62aa1559cc3b7d73)({
                    originLocationFieldRef: originLocationFieldRef,
                    destinationLocationFieldRef: destinationLocationFieldRef
                }),
                isOpen: isAirCargoOpen,
                setIsOpen: setIsAirCargoOpen
            }),
            initialShipmentType === (0, $dc0baf21ad530e3b$export$296c865296deffa2).LTL && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $d609331e7518733c$export$f4aa2808f856b7da), {
                name: "cargoLtlDetail",
                control: control,
                isVertical: isVertical,
                isOpen: isLtlCargoOpen,
                setIsOpen: setIsLtlCargoOpen,
                searchButtonColor: searchButtonColor,
                searchButtonHoverColor: searchButtonHoverColor,
                hasError: hasLtlCargoError,
                rules: {
                    required: {
                        value: true,
                        message: t("validation:cargo.required")
                    },
                    validate: {
                        dimensions: (0, $427948ace18edb6b$export$f32bb5747dd242fc).dimensions(t),
                        cargoReadyDate: (0, $427948ace18edb6b$export$d49747421a0a3947).required(t, getValues, showCargoReadyDateForLTL),
                        commodity: (0, $427948ace18edb6b$export$f0a682a726ea71de).required(t, getValues, showCommodity),
                        freightClass: (0, $427948ace18edb6b$export$f161c7cf27a15dae).required(t, getValues)
                    }
                },
                loading: loading,
                setBackdropVisible: setBackdropVisible,
                onBackdropClick: onBackdropClick,
                onFocus: (0, $427948ace18edb6b$export$62aa1559cc3b7d73)({
                    originLocationFieldRef: originLocationFieldRef,
                    destinationLocationFieldRef: destinationLocationFieldRef
                })
            }),
            showSectionTitle && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$f99233281efd08a0), {
                children: t("additionalServices")
            }),
            showAdditionalServices && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $15e851c9bf86d900$export$293fdcc611d2e8e2), {
                control: control,
                additionalServices: additionalServices,
                errors: errors,
                showLiftGate: shipmentType !== "FCL"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$94ec63f36c20dec6), {
                type: "submit",
                disabled: loading,
                $isVertical: isVerticalMode,
                searchButtonColor: searchButtonColor,
                searchButtonHoverColor: searchButtonHoverColor,
                $isMobile: isMobile,
                $inIframe: inIframe,
                $type: type,
                children: t("quoteForm.searchRates")
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $24c7a71cd12612cd$export$451bf11a19917b08), {
                withFooter: false,
                withHeader: false,
                isOpen: isSlideOutOpen,
                container: formRef.current,
                disableRestoreFocus: true,
                onClose: (0, $427948ace18edb6b$export$1abb8e0a0ff76886)({
                    setIsSlideOutOpen: setIsSlideOutOpen,
                    setShowOriginSlideOut: setShowOriginSlideOut,
                    setShowDestinationSlideOut: setShowDestinationSlideOut
                }),
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $24c7a71cd12612cd$export$c3d67bc338dde5ad), {
                    "data-testid": "LocationInSlideOut",
                    children: [
                        showOriginSlideOut && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6f8dba4147330b62$export$f8f9ea2bcdb95c32), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({
                            name: "origin",
                            isVertical: isVerticalMode,
                            label: originLabel,
                            placeholder: originLocationPlaceholder,
                            shipmentType: shipmentType,
                            initialShipmentType: initialShipmentType,
                            control: control,
                            onSelect: (0, $427948ace18edb6b$export$bfb9486f574e5d79)({
                                sendGA4Events: sendGA4Events,
                                closeSlideOut: (0, $427948ace18edb6b$export$1abb8e0a0ff76886)({
                                    setIsSlideOutOpen: setIsSlideOutOpen,
                                    setShowOriginSlideOut: setShowOriginSlideOut,
                                    setShowDestinationSlideOut: setShowDestinationSlideOut
                                }),
                                userType: userType,
                                sendMixpanelEvents: sendMixpanelEvents
                            }),
                            icon: $286bae1aa5e77428$var$_GlobeIcon3 || ($286bae1aa5e77428$var$_GlobeIcon3 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $928d54a7e96ade6a$export$a70e2e549144f66), {})),
                            autoFocus: true,
                            className: "location-slide-out",
                            error: errors.origin,
                            setLengthError: (0, $427948ace18edb6b$export$f81efaa51ef5f18b)(setError, t, t("validation:location.origin")),
                            clearLengthErrors: (0, $427948ace18edb6b$export$6058502caada7531)(clearErrors),
                            setInvalidZipcodeError: (0, $427948ace18edb6b$export$14fd889102c5c72c)(setOriginValidZipcode, setError, t),
                            clearInvalidZipcodeError: (0, $427948ace18edb6b$export$a3085c92315008f7)(setOriginValidZipcode, clearErrors),
                            setLoading: setLoading,
                            sendGA4Events: sendGA4Events,
                            allowRecentsDropdown: allowRecentSearchInSlideout,
                            setRecentSearch: setRecentSearch,
                            source: source
                        }, originLocationProps)),
                        showDestinationSlideOut && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $6f8dba4147330b62$export$f8f9ea2bcdb95c32), (0, ($parcel$interopDefault($fZLIC$swchelperslib_object_spreadjs)))({
                            name: "destination",
                            isVertical: isVerticalMode,
                            label: destinationLabel,
                            placeholder: destinationLocationPlaceholder,
                            control: control,
                            shipmentType: shipmentType,
                            initialShipmentType: initialShipmentType,
                            onSelect: (0, $427948ace18edb6b$export$d582f4d05c03b97c)({
                                sendGA4Events: sendGA4Events,
                                closeSlideOut: (0, $427948ace18edb6b$export$1abb8e0a0ff76886)({
                                    setIsSlideOutOpen: setIsSlideOutOpen,
                                    setShowOriginSlideOut: setShowOriginSlideOut,
                                    setShowDestinationSlideOut: setShowDestinationSlideOut
                                }),
                                userType: userType,
                                sendMixpanelEvents: sendMixpanelEvents
                            }),
                            icon: $286bae1aa5e77428$var$_GlobeIcon4 || ($286bae1aa5e77428$var$_GlobeIcon4 = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $928d54a7e96ade6a$export$a70e2e549144f66), {})),
                            autoFocus: true,
                            className: "location-slide-out",
                            error: errors.destination,
                            setInvalidZipcodeError: (0, $427948ace18edb6b$export$14fd889102c5c72c)(setDestinationValidZipcode, setError, t),
                            clearInvalidZipcodeError: (0, $427948ace18edb6b$export$a3085c92315008f7)(setDestinationValidZipcode, clearErrors),
                            setLengthError: (0, $427948ace18edb6b$export$f81efaa51ef5f18b)(setError, t, t("validation:location.destination")),
                            clearLengthErrors: (0, $427948ace18edb6b$export$6058502caada7531)(clearErrors),
                            setLoading: setLoading,
                            sendGA4Events: sendGA4Events,
                            source: source
                        }, destinationLocationProps))
                    ]
                })
            })
        ]
    });
};









var $1c44f812c4711b7c$var$MAP_TRANSFORMS_WITH_DEGREE = {
    down: 0,
    right: -90,
    up: -180,
    left: -270
};
var $1c44f812c4711b7c$export$13f4b12aafeba5d6 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).svg.withConfig({
    displayName: "CaretIcon__SVG",
    componentId: "sc-1pkarwd-0"
})([
    "transform:rotate(",
    "deg);transition:transform cubic-bezier(0.4,0,0.6,1) 225ms;"
], function(props) {
    return $1c44f812c4711b7c$var$MAP_TRANSFORMS_WITH_DEGREE[props.direction];
});
var $1c44f812c4711b7c$export$b11d8ce5a0fb8536 = function(props) {
    var className = props.className, _props_width = props.width, width = _props_width === void 0 ? 11 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 7 : _props_height, _props_colorCode = props.colorCode, colorCode = _props_colorCode === void 0 ? "black" : _props_colorCode, _props_direction = props.direction, direction = _props_direction === void 0 ? "down" : _props_direction;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)($1c44f812c4711b7c$export$13f4b12aafeba5d6, {
        className: className,
        width: width,
        height: height,
        direction: direction,
        viewBox: "0 0 11 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
            d: "M10.2446 0.630886C10.4175 0.456371 10.6975 0.456371 10.8704 0.630886C11.0431 0.805139 11.0433 1.08817 10.8704 1.26268L5.81303 6.36911C5.6401 6.54363 5.35986 6.54363 5.18694 6.36911L0.129696 1.26281C-0.0432319 1.0883 -0.0432319 0.805531 0.129696 0.631016C0.302624 0.456502 0.582736 0.456502 0.755536 0.630625L5.50005 5.28773L10.2446 0.630886Z",
            fill: color
        })
    });
};


var $8e6b65451279e48f$export$353f5b6fc5456de1 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).button.withConfig({
    displayName: "DropdownButtonstyled__Button",
    componentId: "sc-6bjxgr-0"
})([
    "height:100%;border:0;box-shadow:none;background-color:transparent;display:flex;align-items:center;justify-content:center;padding:8px;",
    " color:",
    ";"
], function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.color.g500;
});
var $8e6b65451279e48f$export$f99233281efd08a0 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).span.withConfig({
    displayName: "DropdownButtonstyled__Title",
    componentId: "sc-6bjxgr-1"
})([
    "margin-left:4px;margin-right:8px;"
]);
var $8e6b65451279e48f$export$b11d8ce5a0fb8536 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $1c44f812c4711b7c$export$b11d8ce5a0fb8536)).withConfig({
    displayName: "DropdownButtonstyled__CaretIcon",
    componentId: "sc-6bjxgr-2"
})([
    "margin-left:auto;flex-shrink:0;"
]);


var $f6690025683ba751$export$df0d1bc998a4783b = function(isOpen) {
    return function() {
        var _document_body = document.body, width = _document_body.clientWidth, clientHeight = _document_body.clientHeight;
        var height = clientHeight;
        if (isOpen) document.querySelectorAll(".dropdown-menu-wrapper").forEach(function(el) {
            var bottom = el.getBoundingClientRect().bottom;
            height = Math.max(height, bottom);
        });
        window.parent.postMessage({
            type: "size",
            width: width,
            height: height
        }, "*");
    };
};


var $04e20e772a22e71b$export$181f40ec41159e56 = function(props) {
    var className = props.className, title = props.title, onClick = props.onClick, icon = props.icon, isOpen = props.isOpen;
    (0, $fZLIC$react.useEffect)((0, $f6690025683ba751$export$df0d1bc998a4783b)(isOpen), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $8e6b65451279e48f$export$353f5b6fc5456de1), {
        className: className,
        onClick: onClick,
        children: [
            icon,
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $8e6b65451279e48f$export$f99233281efd08a0), {
                children: title
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $8e6b65451279e48f$export$b11d8ce5a0fb8536), {
                direction: isOpen ? "up" : "down"
            })
        ]
    });
};









var $246014089bca9349$export$fec93b5f1e2bccb4 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 25 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, _param_colorCode = param.colorCode, colorCode = _param_colorCode === void 0 ? "white" : _param_colorCode;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 25 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M1 7.5H23.5338",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M17.0059 14.0625L23.5329 7.5L17.0059 0.9375",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};




var $cf19deb90ba08fa5$export$b2539bed5023c21c = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.attrs({
    id: "request-quote-tabs",
    tabIndex: 0
}).withConfig({
    displayName: "RequestQuoteTabsstyled__Tabs",
    componentId: "sc-vd2hj9-0"
})([
    "display:flex;position:relative;",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.$inIframe && (props.$isTablet || props.$isDesktop) && props.$isFocus && "z-index: ".concat(props.$layerIndex + 1, ";");
}, function(props) {
    return !props.$inIframe && props.$isFocus && "@media ".concat(props.theme.query.min.tablet, " {\n      z-index: ").concat(props.$layerIndex + 1, ";\n      }\n    ");
}, function(props) {
    return props.$multiModeTabsPosition === (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP && "\n      padding-bottom: 8px;\n    ";
}, function(props) {
    return props.$inIframe && props.$isMobile && "padding: 0px 10px;";
}, function(props) {
    return !props.$inIframe && "@media ".concat(props.theme.query.mobile, " {\n      padding: 0px 10px;\n    }\n  ");
}, function(props) {
    return props.$multiModeTabsPosition === (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP && props.$tabDesign === (0, $639d1ffa47c33698$export$5a9669dc14be119).Circular && "\n      @media ".concat(props.theme.query.mobile, " {\n        justify-content: center;\n      }\n    ");
});
var $cf19deb90ba08fa5$var$moveArrow = (0, $fZLIC$styledcomponents.keyframes)([
    "0%{left:-37px;}100%{left:-32px;}"
]);
var $cf19deb90ba08fa5$export$fec93b5f1e2bccb4 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $246014089bca9349$export$fec93b5f1e2bccb4)).withConfig({
    displayName: "RequestQuoteTabsstyled__RightArrowIcon",
    componentId: "sc-vd2hj9-1"
})([
    "position:absolute;top:35px;left:-37px;display:none;",
    " ",
    ";@media ",
    "{display:none;}"
], function(props) {
    return props.$show && "display:block;";
}, function(props) {
    return props.$animate && (0, $fZLIC$styledcomponents.css)([
        "animation-name:",
        ";animation-duration:0.8s;animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:ease-in;"
    ], $cf19deb90ba08fa5$var$moveArrow);
}, function(props) {
    return props.theme.query.max.tablet;
});
var $cf19deb90ba08fa5$export$e44a253a59704894 = (0, ($parcel$interopDefault($fZLIC$styledcomponents)))((0, $fZLIC$icontainersdesignsystemdistorganismsDropdownMenu.DropdownMenu)).withConfig({
    displayName: "RequestQuoteTabsstyled__DropdownMenu",
    componentId: "sc-vd2hj9-2"
})([
    "height:75px;min-width:75px;background-color:",
    ";border-radius:7px 0 0 7px;border:1px solid ",
    ";[role='menu']{position:relative;left:0;margin-left:0;border:0px;margin-top:0;::after,::before{content:unset;}}",
    " ",
    ""
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g200;
}, function(props) {
    return props.$inIframe && (props.$isTablet || props.$isDesktop) && props.$isFocus && "z-index: ".concat(props.$layerIndex + 1, ";");
}, function(props) {
    return !props.$inIframe && props.$isFocus && "@media ".concat(props.theme.query.min.tablet, " {\n      z-index: ").concat(props.$layerIndex + 1, ";\n      }\n    ");
});









var $b4a27f7d70692e60$export$3e41faf802a29e71 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "SingleTabstyled__Tab",
    componentId: "sc-1jo4pbb-0"
})([
    "cursor:pointer;display:flex;align-items:center;text-wrap:nowrap;&.top{color:",
    ";",
    " ",
    ";@media ",
    "{",
    "}",
    ";",
    " ",
    " padding:4px 8px;background:",
    ";border:1px solid ",
    ";border-radius:4px;:not(:last-child){margin-right:8px;}span{display:inline-block;margin-left:5px;}",
    " ",
    " ",
    "}&.left{color:",
    ";",
    " padding:10px;height:100%;box-sizing:border-box;background-color:",
    ";",
    " span{display:inline-block;margin-left:5px;}}"
], function(props) {
    return props.theme.color.g600;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.$inIframe && props.$isMobile && props.theme.typo.bodyS;
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return !props.$inIframe && props.theme.typo.bodyS;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return !props.$selected && "\n        &&& {\n        &:hover,\n        &:active {\n          background: ".concat(props.theme.color[props.$buttonHoverColor || "a200"], ";\n          border: 1px solid ").concat(props.theme.color[props.$buttonHoverColor || "a200"], ";\n        }}\n    ");
}, function(props) {
    return props.$selected && "\n        &&& {\n          background: ".concat(props.theme.color[props.$buttonColor || "a500"], ";\n          color: ").concat(props.theme.color.white, ";\n          border: 1px solid ").concat(props.theme.color[props.$buttonColor || "a500"], ";\n        }\n    ");
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g200;
}, function(props) {
    return props.$inIframe && props.$isMobile && " \n        flex: 1;\n        justify-content: center;\n        text-wrap: wrap;\n        text-align: center;\n        svg {\n          display: none;\n        }\n        span {\n          margin-left: 0px;\n        }\n      ";
}, function(props) {
    return !props.$inIframe && "@media ".concat(props.theme.query.mobile, " {\n          flex: 1;\n          justify-content: center;\n          text-wrap: wrap;\n          text-align: center;\n          svg {\n            display: none;\n          }\n          span {\n            margin-left: 0px;\n          }\n        }\n      ");
}, function(props) {
    return props.$stretch && "\n        flex: 1;\n        justify-content: center;\n      ";
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.color.g100;
}, function(props) {
    return props.$selected && "&&& {\n        background: ".concat(props.theme.color[props.$buttonColor || "a500"], ";\n        color: ").concat(props.theme.color.white, ";\n      }\n    ");
});
var $b4a27f7d70692e60$export$5ec9c08905a3c07b = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "SingleTabstyled__NewTag",
    componentId: "sc-1jo4pbb-1"
})([
    "box-sizing:border-box;min-width:38px;border-radius:20px;padding:2px 6px;height:16px;display:flex;align-items:center;justify-content:center;",
    " color:",
    ";background-color:",
    ";margin-left:5px;"
], function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.b600;
});
var $b4a27f7d70692e60$export$be58b4326e23250f = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "SingleTabstyled__IconWrapper",
    componentId: "sc-1jo4pbb-2"
})([
    "background-color:",
    ";border-radius:80px;height:80px;width:80px;display:flex;justify-content:center;align-items:center;margin-bottom:5px;"
], function(props) {
    return props.theme.color.white;
});
var $b4a27f7d70692e60$export$5f1af8db9871e1d6 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).span.withConfig({
    displayName: "SingleTabstyled__Text",
    componentId: "sc-1jo4pbb-3"
})([
    "color:",
    ";",
    ";",
    ";padding:0 8px;margin-bottom:4px;"
], function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.fontWeight.medium;
});
var $b4a27f7d70692e60$export$4805d0348798e8cd = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "SingleTabstyled__CircleTab",
    componentId: "sc-1jo4pbb-4"
})([
    "display:flex;flex-direction:column;justify-content:center;margin-left:8px;margin-right:8px;",
    ""
], function(props) {
    return props.$selected && "\n      ".concat($b4a27f7d70692e60$export$be58b4326e23250f, " {\n        background-color: ").concat(props.theme.color[props.$buttonColor || "a600"], ";\n      }\n      \n      ").concat($b4a27f7d70692e60$export$5f1af8db9871e1d6, "{\n        color: ").concat(props.theme.color[props.$buttonColor || "a500"], ";\n      }\n    ");
});


var $39ed37d0a1e587cb$var$SingleTabComponent = function(param) {
    var tab = param.tab, buttonColor = param.buttonColor, buttonHoverColor = param.buttonHoverColor, isMobile = param.isMobile, inIframe = param.inIframe, className = param.className, multiModeTabsPosition = param.multiModeTabsPosition, tabDesign = param.tabDesign, stretch = param.stretch, onClick = param.onClick;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var ShipmentTypeIcon = tab.shipmentTypeIcon;
    var CircleIcon = tab.circleIcon;
    if (tabDesign === (0, $639d1ffa47c33698$export$5a9669dc14be119).Circular && multiModeTabsPosition === (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP) return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $b4a27f7d70692e60$export$4805d0348798e8cd), {
        onClick: onClick,
        $selected: tab.selected,
        $buttonColor: buttonColor,
        $buttonHoverColor: buttonHoverColor,
        children: [
            ShipmentTypeIcon && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b4a27f7d70692e60$export$be58b4326e23250f), {
                children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)(ShipmentTypeIcon, {
                    fill: tab.selected ? theme.color.white : theme.color.p600
                })
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b4a27f7d70692e60$export$5f1af8db9871e1d6), {
                children: t(tab.title)
            })
        ]
    });
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $b4a27f7d70692e60$export$3e41faf802a29e71), {
        className: "".concat(className, "-item ").concat(multiModeTabsPosition.toLowerCase()),
        $selected: tab.selected,
        onClick: onClick,
        $buttonColor: buttonColor,
        $buttonHoverColor: buttonHoverColor,
        $isMobile: isMobile,
        $inIframe: inIframe,
        $stretch: stretch,
        children: [
            ShipmentTypeIcon && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)(ShipmentTypeIcon, {
                fill: tab.selected ? theme.color.white : theme.color.g500
            }),
            CircleIcon && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)(CircleIcon, {
                fillPath: buttonColor
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("span", {
                children: t(tab.title)
            }),
            tab.isNew && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $b4a27f7d70692e60$export$5ec9c08905a3c07b), {
                children: t("new")
            })
        ]
    });
};
var $39ed37d0a1e587cb$export$1343ea94bc98cab9 = /*#__PURE__*/ (0, $fZLIC$react.memo)($39ed37d0a1e587cb$var$SingleTabComponent);






var $e94524cc3de7c996$export$6f9ea195534f9938 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 15 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.g500;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.765 12.8565L13.1925 12.429C13.4282 12.1933 13.521 11.8502 13.4363 11.5278L11.9156 5.74965L13.9263 3.73903C14.6076 3.08817 14.7238 2.0423 14.2019 1.25778C13.8824 0.806944 13.3804 0.519961 12.8298 0.473457C12.2792 0.426953 11.7362 0.625663 11.3456 1.01653L9.26439 3.0984L3.48751 1.5784C3.16493 1.49341 2.82148 1.58623 2.58564 1.82215L2.15814 2.24965C1.95398 2.4538 1.85527 2.74062 1.89056 3.02716C1.92584 3.31371 2.09118 3.56801 2.33876 3.71653L6.28126 6.08215L3.28126 9.48215L2.34376 9.4959C2.05351 9.44622 1.75679 9.53579 1.54251 9.73778L0.60626 10.5953C0.496172 10.7051 0.44784 10.8625 0.477282 11.0152C0.506724 11.168 0.610094 11.2961 0.753135 11.3572L2.56251 12.3778L3.75001 14.2497C3.81148 14.3925 3.93969 14.4956 4.09237 14.525C4.24505 14.5544 4.40239 14.5063 4.51251 14.3965L5.33064 13.6165C5.56168 13.3988 5.66682 13.0789 5.61001 12.7665L5.62501 11.8259L8.93251 8.7334L11.2981 12.6759C11.4467 12.9235 11.701 13.0888 11.9875 13.1241C12.274 13.1594 12.5609 13.0607 12.765 12.8565Z",
            stroke: fillColor,
            strokeWidth: "0.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};




var $8b2e11bcd3e86f6f$export$9c1c3f5a4a271817 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 15 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, _param_colorCode = param.colorCode, colorCode = _param_colorCode === void 0 ? "g600" : _param_colorCode;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("rect", {
            x: "0.85",
            y: "0.85",
            width: "13.3",
            height: "13.3",
            rx: "6.65",
            stroke: color,
            strokeWidth: "1.7"
        })
    });
};




var $220c54b0113b9314$export$3d858f007f53b846 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 15 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.g500;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M14.5315 14.5312C13.5006 14.6588 12.4672 14.3144 11.719 13.5938C11.1802 14.1906 10.4137 14.5312 9.60963 14.5312C8.80555 14.5312 8.0391 14.1906 7.50026 13.5938C6.96142 14.1906 6.19497 14.5312 5.39088 14.5312C4.5868 14.5312 3.82035 14.1906 3.28151 13.5938C2.53334 14.3144 1.49991 14.6588 0.469009 14.5312",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M0.69936 12.6246L0.53436 11.3052C0.517888 11.1717 0.559443 11.0376 0.648489 10.9369C0.737535 10.8361 0.865518 10.7784 0.999986 10.7783H14.0625C14.1943 10.7783 14.32 10.8337 14.4089 10.9309C14.4978 11.0282 14.5417 11.1583 14.53 11.2896C14.4863 11.7753 14.3731 12.2523 14.1937 12.7058",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.40625 10.7812H5.15625V3.28125C5.15625 2.76348 4.73652 2.34375 4.21875 2.34375H2.34375C1.82598 2.34375 1.40625 2.76348 1.40625 3.28125V10.7812Z",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.5938 8.4375H9.84375V10.7812H13.5938V8.4375Z",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M5.15625 8.4375H9.84375V10.7812",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.84375 6.09375H12.6562C13.174 6.09375 13.5938 6.51348 13.5938 7.03125V8.4375H9.84375V6.09375Z",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M5.15625 6.09375H9.84375V8.4375H5.15625",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M3.28125 4.21875H5.15625",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M2.8125 2.34375V0.46875",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};




var $3d6ba3fa1a32a78b$export$5eb4ca56863b8777 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 25 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 25 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.white;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
            d: "M24.2347 18.1126H23.4694V10.2044C23.4694 9.78175 23.1267 9.43909 22.7041 9.43909H18.3673V1.53093C18.3673 1.10828 18.0247 0.765625 17.602 0.765625H7.39796C6.97531 0.765625 6.63265 1.10828 6.63265 1.53093V9.43909H2.29592C1.87327 9.43909 1.53061 9.78175 1.53061 10.2044V18.1126H0.765306C0.342653 18.1126 0 18.4552 0 18.8779V23.4697C0 23.8924 0.342653 24.235 0.765306 24.235H3.82653C4.24918 24.235 4.59184 23.8924 4.59184 23.4697V22.7044H10.2041V23.4697C10.2041 23.8924 10.5467 24.235 10.9694 24.235H14.0306C14.4533 24.235 14.7959 23.8924 14.7959 23.4697V22.7044H20.4082V23.4697C20.4082 23.8924 20.7508 24.235 21.1735 24.235H24.2347C24.6573 24.235 25 23.8924 25 23.4697V18.8779C25 18.4552 24.6573 18.1126 24.2347 18.1126ZM21.9388 10.9697V18.1126H13.2653V10.9697H21.9388ZM8.16327 2.29624H16.8367V9.43909H8.16327V2.29624ZM3.06122 10.9697H11.7347V18.1126H3.06122V10.9697ZM23.4694 22.7044H21.9388V21.9391C21.9388 21.5164 21.5961 21.1738 21.1735 21.1738H14.0306C13.608 21.1738 13.2653 21.5164 13.2653 21.9391V22.7044H11.7347V21.9391C11.7347 21.5164 11.392 21.1738 10.9694 21.1738H3.82653C3.40388 21.1738 3.06122 21.5164 3.06122 21.9391V22.7044H1.53061V19.6432H23.4694V22.7044Z",
            fill: fillColor
        })
    });
};




var $9186412a2904c580$export$fef5be5f8179eba8 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 25 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 25 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var color = fill || theme.color.white;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.5763 0H8.42348V3.57143H4.34709V11.4049L0.976799 12.1924L3.38006 20.6146L5.31366 19.8616L3.64052 13.9981L11.4808 12.1663V17.8571H13.519V12.1665L21.3588 13.9981L19.6856 19.8616L21.6192 20.6146L24.0225 12.1924L20.6527 11.4051V3.57143H16.5763V0ZM14.5381 3.57143V2.38095H10.4617V3.57143H14.5381ZM18.6145 5.95238V10.9289L12.4996 9.50024L6.38529 10.9287V5.95238H18.6145ZM0.270849 23.8095C0.541888 24.9571 0.541766 24.9571 0.541766 24.9571L0.543261 24.9567L0.549919 24.9546L0.578562 24.9454C0.604325 24.9373 0.643214 24.9252 0.694006 24.9095C0.79563 24.8783 0.944772 24.8332 1.1318 24.7787C1.50627 24.67 2.03042 24.5248 2.62767 24.3798C3.8417 24.0851 5.28504 23.8095 6.38543 23.8095C7.44412 23.8095 8.24893 24.0644 9.17168 24.3619L9.19907 24.3706C10.1164 24.6663 11.1513 25 12.5 25C13.8488 25 14.8836 24.6663 15.8009 24.3706L15.8284 24.3619C16.7511 24.0644 17.556 23.8095 18.6146 23.8095C19.715 23.8095 21.1584 24.0851 22.3724 24.3798C22.9697 24.5248 23.4938 24.67 23.8683 24.7787C24.0552 24.8332 24.2044 24.8783 24.3061 24.9095C24.3569 24.9252 24.3957 24.9373 24.4214 24.9454L24.4501 24.9546L24.4568 24.9567L24.4582 24.9571L24.7292 23.8095C25.0003 22.6619 25 22.6619 25 22.6619L24.987 22.6576L24.9527 22.6468C24.9232 22.6375 24.8804 22.6241 24.8255 22.6071C24.7156 22.5733 24.5573 22.5256 24.3601 22.4683C23.9665 22.3538 23.4159 22.2014 22.7871 22.0487C21.5491 21.7483 19.9351 21.4286 18.6146 21.4286C17.2659 21.4286 16.231 21.7622 15.3137 22.0579L15.2862 22.0667C14.3635 22.3641 13.5587 22.619 12.5 22.619C11.4414 22.619 10.6366 22.3641 9.71377 22.0667L9.68638 22.0579C8.76906 21.7622 7.73414 21.4286 6.38543 21.4286C5.06499 21.4286 3.45103 21.7483 2.21298 22.0487C1.58418 22.2014 1.0336 22.3538 0.639831 22.4683C0.442737 22.5256 0.284396 22.5733 0.174565 22.6071C0.119628 22.6241 0.0767993 22.6375 0.0472726 22.6468L0.0131124 22.6576L0.00379101 22.6606L4.60957e-10 22.6619C4.60957e-10 22.6619 -0.000204019 22.6619 0.270849 23.8095Z",
            fill: color
        })
    });
};




var $8a79efcbca1edf48$export$f346e867ebfde7ae = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 30 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 30 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.g500;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 23 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M7.3922 15.7698H13.9235V6.70625C13.9235 5.83312 13.2967 5.125 12.5255 5.125H3.27408C2.50293 5.125 1.87616 5.83312 1.87616 6.70625V14.1885C1.87616 15.0617 2.50293 15.7698 3.27408 15.7698H3.70835",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M5.67115 17.4919C6.62165 17.4919 7.39219 16.7214 7.39219 15.7708C7.39219 14.8203 6.62165 14.0498 5.67115 14.0498C4.72064 14.0498 3.9501 14.8203 3.9501 15.7708C3.9501 16.7214 4.72064 17.4919 5.67115 17.4919Z",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M16.7456 7.61426H18.1917L20.8489 11.1549C21.0022 11.3594 21.0865 11.6074 21.0895 11.863L21.1239 14.5362C21.1277 14.6969 21.0993 14.8568 21.0405 15.0063C20.9816 15.1559 20.8934 15.2922 20.7811 15.4072C20.6688 15.5222 20.5346 15.6135 20.3865 15.6759C20.2383 15.7382 20.0792 15.7703 19.9184 15.7703H19.2447",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M15.8026 15.7705H13.9234",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M17.5237 17.4919C18.4742 17.4919 19.2447 16.7214 19.2447 15.7708C19.2447 14.8203 18.4742 14.0498 17.5237 14.0498C16.5731 14.0498 15.8026 14.8203 15.8026 15.7708C15.8026 16.7214 16.5731 17.4919 17.5237 17.4919Z",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};




var $516176290ad8b2d6$export$f6bfb987b5bda915 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 15 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.g500;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M0.46875 13.9492H14.5312",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M0.46875 7.64844H14.5312",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M3.75 9.44922V12.1492",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M5.625 9.44922V12.1492",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M7.5 9.44922V12.1492",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M1.40625 7.64922L5.15625 4.94922",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M13.5938 7.64922L9.84375 4.94922",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M7.5 2.36682V0.449219",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.5 4.20625C8.01777 4.20625 8.4375 3.80331 8.4375 3.30625C8.4375 2.80919 8.01777 2.40625 7.5 2.40625C6.98223 2.40625 6.5625 2.80919 6.5625 3.30625C6.5625 3.80331 6.98223 4.20625 7.5 4.20625Z",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.40625 7.64844H13.5938V13.9484H1.40625V7.64844Z",
                stroke: fillColor,
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};




var $8289a909dd4e87dd$export$9df2e089a0931474 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 25 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 25 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var strokeColor = fill !== null && fill !== void 0 ? fill : theme.color.white;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
            d: "M21.3362 21.4892L21.3361 21.4892C21.1365 21.6887 20.8558 21.7853 20.5753 21.7508C20.2948 21.7163 20.046 21.5546 19.9008 21.3126L19.9008 21.3126L15.694 14.3058C15.5774 14.1116 15.3794 13.9805 15.1551 13.9491C14.9309 13.9176 14.7044 13.9892 14.5389 14.1438L8.6572 19.64C8.50846 19.779 8.42261 19.9725 8.41936 20.176L8.39269 21.8477C8.3919 21.8968 8.39593 21.9457 8.40471 21.994C8.46022 22.299 8.35751 22.6116 8.13154 22.8244L8.12841 22.8274L6.67354 24.2136L6.66159 24.2253C6.64176 24.245 6.61328 24.2538 6.58555 24.2485L6.44377 24.9849L6.58555 24.2484C6.55784 24.2431 6.53479 24.2245 6.52379 24.1989C6.50807 24.1624 6.48947 24.1272 6.46816 24.0936L4.35643 20.7669C4.29019 20.6625 4.1992 20.5761 4.09154 20.5155L0.873926 18.7015C0.849956 18.688 0.825261 18.6759 0.799952 18.6651C0.774669 18.6543 0.756616 18.6317 0.751488 18.6052C0.746849 18.5811 0.753279 18.5563 0.768879 18.5375L2.41576 17.0301L2.41581 17.0301L2.42365 17.0227C2.63325 16.8253 2.92363 16.7376 3.20775 16.7862C3.25314 16.794 3.29916 16.7976 3.34521 16.7969L5.01237 16.7725C5.22363 16.7694 5.42378 16.6773 5.56361 16.5189L10.8985 10.4763C11.046 10.3092 11.1115 10.0853 11.0774 9.86509C11.0433 9.6449 10.9131 9.45127 10.722 9.33668L3.71105 5.13237L3.71098 5.13233C3.46874 4.98711 3.30714 4.73856 3.27266 4.45869C3.23818 4.17884 3.33462 3.89862 3.53428 3.69909L3.5343 3.69907L4.29452 2.9393L4.2946 2.93921C4.5253 2.70858 4.8614 2.61773 5.17717 2.70088L5.17741 2.70095L15.4504 5.40236C15.7083 5.47018 15.9828 5.39596 16.1714 5.20743L19.8725 1.50742L19.8726 1.50728C20.4109 0.9689 21.1595 0.695107 21.9185 0.759179C22.6738 0.822941 23.3628 1.21482 23.8033 1.83056C24.5227 2.92086 24.3593 4.37012 23.4135 5.27311L23.4012 5.28509L19.8257 8.85847C19.6369 9.04712 19.5626 9.32187 19.6306 9.57994L22.3347 19.8489C22.3347 19.849 22.3347 19.849 22.3347 19.8491C22.4175 20.1639 22.3268 20.499 22.0964 20.7294C22.0964 20.7294 22.0964 20.7294 22.0964 20.7294L21.3362 21.4892Z",
            stroke: strokeColor,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};




var $5b13ff00753d9cc0$export$b5cbf0598307213c = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 15 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 15 : _param_height, _param_fillCircle = param.fillCircle, fillCircle = _param_fillCircle === void 0 ? "white" : _param_fillCircle, _param_fillPath = param.fillPath, fillPath = _param_fillPath === void 0 ? "a500" : _param_fillPath;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var colorCircle = theme.color[fillCircle];
    var colorPath = theme.color[fillPath];
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("circle", {
                cx: "7.5",
                cy: "7.5",
                r: "7.5",
                fill: colorCircle
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M3.42965 8.10807C3.36555 8.04141 3.3335 7.94141 3.3335 7.87474C3.3335 7.80807 3.36555 7.70807 3.42965 7.64141L3.87837 7.17474C4.00657 7.04141 4.19888 7.04141 4.32709 7.17474L4.35914 7.20807L6.12196 9.17474C6.18606 9.24141 6.28221 9.24141 6.34632 9.17474L10.6412 4.54141H10.6732C10.8014 4.40807 10.9938 4.40807 11.122 4.54141L11.5707 5.00807C11.6989 5.14141 11.6989 5.34141 11.5707 5.47474L6.44247 11.0081C6.37837 11.0747 6.31427 11.1081 6.21811 11.1081C6.12196 11.1081 6.05785 11.0747 5.99375 11.0081L3.49375 8.20807L3.42965 8.10807Z",
                fill: colorPath
            })
        ]
    });
};




var $3426077d467d94ad$export$e3534c3b39a723c6 = function(param) {
    var className = param.className, _param_width = param.width, width = _param_width === void 0 ? 23 : _param_width, _param_height = param.height, height = _param_height === void 0 ? 22 : _param_height, fill = param.fill;
    var theme = (0, $fZLIC$styledcomponents.useTheme)();
    var fillColor = fill !== null && fill !== void 0 ? fill : theme.color.g500;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 23 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M7.3922 15.7698H13.9235V6.70625C13.9235 5.83312 13.2967 5.125 12.5255 5.125H3.27408C2.50293 5.125 1.87616 5.83312 1.87616 6.70625V14.1885C1.87616 15.0617 2.50293 15.7698 3.27408 15.7698H3.70835",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M5.67115 17.4919C6.62165 17.4919 7.39219 16.7214 7.39219 15.7708C7.39219 14.8203 6.62165 14.0498 5.67115 14.0498C4.72064 14.0498 3.9501 14.8203 3.9501 15.7708C3.9501 16.7214 4.72064 17.4919 5.67115 17.4919Z",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M16.7456 7.61426H18.1917L20.8489 11.1549C21.0022 11.3594 21.0865 11.6074 21.0895 11.863L21.1239 14.5362C21.1277 14.6969 21.0993 14.8568 21.0405 15.0063C20.9816 15.1559 20.8934 15.2922 20.7811 15.4072C20.6688 15.5222 20.5346 15.6135 20.3865 15.6759C20.2383 15.7382 20.0792 15.7703 19.9184 15.7703H19.2447",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M15.8026 15.7705H13.9234",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)("path", {
                d: "M17.5237 17.4919C18.4742 17.4919 19.2447 16.7214 19.2447 15.7708C19.2447 14.8203 18.4742 14.0498 17.5237 14.0498C16.5731 14.0498 15.8026 14.8203 15.8026 15.7708C15.8026 16.7214 16.5731 17.4919 17.5237 17.4919Z",
                stroke: fillColor,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


var $74a12e1a379abcf4$export$9a6babd483003baf = function(isSelected) {
    return isSelected ? (0, $5b13ff00753d9cc0$export$b5cbf0598307213c) : (0, $8b2e11bcd3e86f6f$export$9c1c3f5a4a271817);
};
var $74a12e1a379abcf4$var$SHIPMENT_ICON = {
    Circular: {
        TOP: {
            FCL: (0, $9186412a2904c580$export$fef5be5f8179eba8),
            LCL: (0, $3d6ba3fa1a32a78b$export$5eb4ca56863b8777),
            AIR: (0, $8289a909dd4e87dd$export$9df2e089a0931474),
            LTL: (0, $8a79efcbca1edf48$export$f346e867ebfde7ae)
        },
        LEFT: {
            FCL: (0, $220c54b0113b9314$export$3d858f007f53b846),
            LCL: (0, $516176290ad8b2d6$export$f6bfb987b5bda915),
            AIR: (0, $e94524cc3de7c996$export$6f9ea195534f9938),
            LTL: (0, $3426077d467d94ad$export$e3534c3b39a723c6)
        }
    },
    Default: {
        LEFT: {
            FCL: (0, $220c54b0113b9314$export$3d858f007f53b846),
            LCL: (0, $516176290ad8b2d6$export$f6bfb987b5bda915),
            AIR: (0, $e94524cc3de7c996$export$6f9ea195534f9938),
            LTL: (0, $3426077d467d94ad$export$e3534c3b39a723c6)
        }
    }
};
var $74a12e1a379abcf4$export$540ebb3e19318265 = {
    TOP: {
        FCL: "oceanFCL",
        LCL: "oceanLCL",
        AIR: "airFreight",
        LTL: "roadLTL"
    },
    LEFT: {
        FCL: "oceanFCL",
        LCL: "oceanLCL",
        AIR: "airFreight",
        LTL: "roadLTL"
    }
};
var $74a12e1a379abcf4$export$5fe25a0110cd374a = function(param) {
    var showMultiMode = param.showMultiMode, shipmentType = param.shipmentType, orderTabs = param.orderTabs, multiModeTabsPosition = param.multiModeTabsPosition, tabDesign = param.tabDesign;
    return orderTabs.map(function(tab) {
        var _SHIPMENT_ICON_tabDesign_multiModeTabsPosition;
        return {
            title: $74a12e1a379abcf4$export$540ebb3e19318265[multiModeTabsPosition][tab],
            shipmentTypeIcon: (_SHIPMENT_ICON_tabDesign_multiModeTabsPosition = $74a12e1a379abcf4$var$SHIPMENT_ICON[tabDesign][multiModeTabsPosition]) === null || _SHIPMENT_ICON_tabDesign_multiModeTabsPosition === void 0 ? void 0 : _SHIPMENT_ICON_tabDesign_multiModeTabsPosition[tab],
            circleIcon: multiModeTabsPosition === "TOP" ? $74a12e1a379abcf4$export$9a6babd483003baf(shipmentType === tab) : undefined,
            shipmentType: tab,
            selected: shipmentType === tab,
            isNew: false
        };
    }).filter(function(tab) {
        return tab.shipmentType === "AIR" ? showMultiMode : true;
    });
};
var $74a12e1a379abcf4$export$8a8c31b4804b4114 = function(setShipmentType, shipmentType) {
    return function() {
        setShipmentType(shipmentType);
    };
};


var $d0ee8d8d1a964c6c$export$24fa474a76a2c519 = function(param) {
    var shipmentType = param.shipmentType, setShipmentType = param.setShipmentType, _param_layerIndex = param.layerIndex, layerIndex = _param_layerIndex === void 0 ? 9999 : _param_layerIndex, backdropVisible = param.backdropVisible, _param_multiModeTabsPosition = param.multiModeTabsPosition, multiModeTabsPosition = _param_multiModeTabsPosition === void 0 ? (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP : _param_multiModeTabsPosition, buttonColor = param.buttonColor, buttonHoverColor = param.buttonHoverColor, showMultiMode = param.showMultiMode, orderTabs = param.orderTabs, tabDesign = param.tabDesign, showIndicator = param.showIndicator, _param_stretch = param.stretch, stretch = _param_stretch === void 0 ? false : _param_stretch;
    var _useContext = (0, $fZLIC$react.useContext)((0, $48a0275552d0228c$export$a0936c9989b92d74)), inIframe = _useContext.inIframe, isMobile = _useContext.isMobile, isTablet = _useContext.isTablet, isDesktop = _useContext.isDesktop;
    var t = (0, $88150c5c731a6db0$export$9fc83ad70ead8663)().t;
    var tabs = (0, $fZLIC$react.useMemo)(function() {
        return (0, $74a12e1a379abcf4$export$5fe25a0110cd374a)({
            showMultiMode: showMultiMode,
            shipmentType: shipmentType,
            orderTabs: orderTabs,
            multiModeTabsPosition: multiModeTabsPosition,
            tabDesign: tabDesign
        });
    }, [
        orderTabs,
        shipmentType,
        showMultiMode,
        multiModeTabsPosition,
        tabDesign
    ]);
    var activeTab = tabs.find(function(tab) {
        return tab.selected;
    });
    var showArrowIndicator = showIndicator && multiModeTabsPosition == (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP;
    var items = tabs.map(function(tab, index) {
        return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $39ed37d0a1e587cb$export$1343ea94bc98cab9), {
            className: "single-tab",
            tab: tab,
            buttonColor: buttonColor,
            buttonHoverColor: buttonHoverColor,
            isMobile: isMobile,
            inIframe: inIframe,
            multiModeTabsPosition: multiModeTabsPosition,
            tabDesign: tabDesign,
            stretch: stretch,
            onClick: (0, $74a12e1a379abcf4$export$8a8c31b4804b4114)(setShipmentType, tab.shipmentType)
        }, index);
    });
    if (multiModeTabsPosition == (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).LEFT) {
        var ShipmentTypeIcon = activeTab === null || activeTab === void 0 ? void 0 : activeTab.shipmentTypeIcon;
        var title = activeTab === null || activeTab === void 0 ? void 0 : activeTab.title;
        return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $cf19deb90ba08fa5$export$e44a253a59704894), {
            $layerIndex: layerIndex,
            $isFocus: backdropVisible,
            $isMobile: isMobile,
            $isTablet: isTablet,
            $isDesktop: isDesktop,
            $inIframe: inIframe,
            menuButton: (0, $04e20e772a22e71b$export$181f40ec41159e56),
            menuButtonProps: {
                title: title ? t(title) : undefined,
                icon: ShipmentTypeIcon ? /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)(ShipmentTypeIcon, {}) : undefined
            },
            classes: {
                menuWrapper: "dropdown-menu-wrapper"
            },
            children: items
        });
    }
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $fZLIC$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $cf19deb90ba08fa5$export$b2539bed5023c21c), {
                $layerIndex: layerIndex,
                $isFocus: backdropVisible,
                $multiModeTabsPosition: multiModeTabsPosition,
                $isMobile: isMobile,
                $isTablet: isTablet,
                $isDesktop: isDesktop,
                $inIframe: inIframe,
                $tabDesign: tabDesign,
                children: items
            }),
            /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $cf19deb90ba08fa5$export$fec93b5f1e2bccb4), {
                $animate: !backdropVisible,
                $show: showArrowIndicator
            })
        ]
    });
};




var $2db117e4e97df04c$export$4e1875a4b2b1434f = function() {
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(typeof window !== "undefined" ? document.activeElement : null), 2), active = _useState[0], setActive = _useState[1];
    var handleFocus = function() {
        setActive(document.activeElement);
    };
    (0, $fZLIC$react.useEffect)(function() {
        document.addEventListener("focusin", handleFocus);
        return function() {
            document.removeEventListener("focusin", handleFocus);
        };
    }, []);
    return [
        active,
        setActive
    ];
};






var $70b13f55bee93496$export$52e883bf52d978b3 = function(param) {
    var sendMixpanelEvents = param.sendMixpanelEvents, mixpanelKey = param.mixpanelKey;
    (0, $fZLIC$react.useEffect)(function() {
        (0, $572732a31feb62d3$export$e614f62ab9abde9d)(sendMixpanelEvents, mixpanelKey);
    }, []);
    (0, $fZLIC$react.useEffect)(function() {
        (0, $572732a31feb62d3$export$553848366fc135e2)(sendMixpanelEvents);
    }, [
        sendMixpanelEvents
    ]);
    return null;
};




var $61aeb730072a8c06$export$29ac8f00d0f8fe39 = function(url) {
    var newTab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return window.open(url, newTab ? "_blank" : "_self");
};
var $61aeb730072a8c06$export$9f140ed41af5108c = function() {
    if (typeof window === "undefined") return false;
    return window === window.parent ? false : true;
};
var $61aeb730072a8c06$export$7405982c43617ae0 = function(url) {
    // Check if the URL starts with "http://" or "https://"
    if (url.startsWith("http://") || url.startsWith("https://")) {
        var domain = new URL(url).hostname;
        return domain === "cdn.icontainers.com";
    } else return false;
};
var $61aeb730072a8c06$export$9ab9bca59d7cb3f6 = function(src) {
    var production = $61aeb730072a8c06$export$7405982c43617ae0(src);
    if (production) return "production";
    return "sandbox";
};







var $29416d0cbb4ba5b5$export$415fa1a54d52a833 = {
    sandbox: "sandbox",
    production: "production"
};


var $5af75863158cf8a8$export$21e7b9f4635e7aa6 = function(param) {
    var setBackdropVisible = param.setBackdropVisible, setActiveElement = param.setActiveElement, setIsAirCargoOpen = param.setIsAirCargoOpen, setIsFclCargoOpen = param.setIsFclCargoOpen, setIsLclCargoOpen = param.setIsLclCargoOpen, setIsLtlCargoOpen = param.setIsLtlCargoOpen;
    return function() {
        setBackdropVisible(false);
        setActiveElement(null);
        setIsAirCargoOpen(false);
        setIsFclCargoOpen(false);
        setIsLclCargoOpen(false);
        setIsLtlCargoOpen(false);
    };
};
var $5af75863158cf8a8$export$45b39e67d4ce4921 = function(entry) {
    if (entry === null || entry === void 0 ? void 0 : entry.contentBoxSize) {
        var _entry_contentBoxSize_ = entry.contentBoxSize[0], width = _entry_contentBoxSize_.inlineSize, blockSize = _entry_contentBoxSize_.blockSize;
        var height = blockSize;
        document.querySelectorAll(".MuiPaper-root").forEach(function(el) {
            var bottom = el.getBoundingClientRect().bottom;
            height = Math.max(height, bottom);
        });
        window.parent.postMessage({
            type: "size",
            width: width,
            height: height
        }, "*");
    }
};
var $5af75863158cf8a8$export$7275a8dcb77dc20d = function(param) {
    var setBackdropVisible = param.setBackdropVisible, setIsAirCargoOpen = param.setIsAirCargoOpen, setIsFclCargoOpen = param.setIsFclCargoOpen, setIsLclCargoOpen = param.setIsLclCargoOpen, setIsLtlCargoOpen = param.setIsLtlCargoOpen, setOuterWindowSize = param.setOuterWindowSize;
    return function(event) {
        // Verify the message sender
        if (event.source !== parent) return;
        // Process the received message
        var message = event.data;
        switch(message.type){
            case "backdrop":
                setBackdropVisible(Boolean(message.visible));
                setIsAirCargoOpen(false);
                setIsFclCargoOpen(false);
                setIsLclCargoOpen(false);
                setIsLtlCargoOpen(false);
                break;
            case "resize":
                setOuterWindowSize({
                    isMobile: message.isMobile,
                    isTablet: message.isTablet,
                    isDesktop: message.isDesktop
                });
                break;
        }
    };
};
var $5af75863158cf8a8$export$89e12c5b50f7529d = function(path, searchResultsInNewTab) {
    if ((0, $61aeb730072a8c06$export$9f140ed41af5108c)()) {
        window.parent.postMessage({
            type: "redirect",
            redirectUrl: path
        }, "*");
        return;
    }
    (0, $61aeb730072a8c06$export$29ac8f00d0f8fe39)(path, searchResultsInNewTab);
};
var $5af75863158cf8a8$export$90ae94aafce9420e = function(param) {
    var _param_domain = param.domain, domain = _param_domain === void 0 ? "" : _param_domain, _param_searchResultsInNewTab = param.searchResultsInNewTab, searchResultsInNewTab = _param_searchResultsInNewTab === void 0 ? false : _param_searchResultsInNewTab;
    return function(quoteURL) {
        var path = "".concat(domain, "/quotes").concat(quoteURL);
        $5af75863158cf8a8$export$89e12c5b50f7529d(path, searchResultsInNewTab);
    };
};
var $5af75863158cf8a8$export$29cc411fb67711bc = function(param) {
    var backdropVisible = param.backdropVisible, inIframe = param.inIframe;
    return function() {
        inIframe && window.parent.postMessage({
            type: "backdrop",
            visible: backdropVisible
        }, "*");
    };
};
var $5af75863158cf8a8$export$28551806f2fd0630 = function(inIframe) {
    return function() {
        if (inIframe) window.parent.postMessage({
            type: "orientation",
            height: document.body.clientHeight
        }, "*");
    };
};
var $5af75863158cf8a8$export$68e0b4739b2cd688 = function() {
    return typeof document !== "undefined" ? document.body : null;
};
var $5af75863158cf8a8$export$3cbb4a0ac1f0c633 = function(buildEnvironment) {
    if (buildEnvironment === (0, $29416d0cbb4ba5b5$export$415fa1a54d52a833).production) return "23a44d6715c1eb88979cd0bbc12d66ac";
    return "9479a3104cd13310ffd2b06e07cfe089";
};





var $e5d84ead675cfa2d$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($fZLIC$styledcomponents))).div.withConfig({
    displayName: "Widgetstyled__Wrapper",
    componentId: "sc-1v5ggw-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    "}"
], function(props) {
    return props.$inIframe && props.$minTablet && props.$multiModeTabsPosition === (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP && "\n        .origin-location-input-wrapper {\n            border-top-left-radius: 7px;\n            border-bottom-left-radius: 7px;\n    \n            & > div,\n            .MuiFormControl-root,\n            .Input-root {\n              border-top-left-radius: 7px;\n              border-bottom-left-radius: 7px;\n            }\n        }\n      ";
}, function(props) {
    return !props.$inIframe && props.$multiModeTabsPosition === (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP && "@media ".concat(props.theme.query.min.tablet, " {\n          .origin-location-input-wrapper {\n            border-top-left-radius: 7px;\n            border-bottom-left-radius: 7px;\n\n          & > div,\n          .MuiFormControl-root,\n          .Input-root {\n            border-top-left-radius: 7px;\n            border-bottom-left-radius: 7px;\n          }\n        }\n      }\n    ");
}, function(props) {
    return (props.$isVertical || props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance) && "\n    .origin-location-input-wrapper {\n      border-radius: 7px;\n\n      & > div {\n        border-radius: 7px;\n      }\n      .Input-root {\n        border-radius: 7px;\n      }\n    }\n\n    .destination-location-input-wrapper {\n      border-radius: 7px;\n\n      & > div {\n        border-radius: 7px;\n      }\n      .Input-root {\n        border-radius: 7px;\n      }\n    }\n  ";
}, function(props) {
    return props.$type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance && "\n      padding: 20px;\n      background-color: ".concat(props.theme.color.white, ";\n    ");
}, function(props) {
    return props.$minTablet && props.$multiModeTabsPosition === (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).LEFT && "\n        display: flex;\n        justify-content: center;\n\n        .origin-location-input-wrapper {\n          border-top-left-radius: 0px;\n          border-bottom-left-radius: 0px;\n        }\n      ";
});



var $b9961f6ec706fd95$var$_MutationObserver;
var $b9961f6ec706fd95$export$53583fe269fa7d3 = function(props, ref) {
    var language = props.language, _props_onSearch = props.onSearch, onSearch = _props_onSearch === void 0 ? (0, $5af75863158cf8a8$export$90ae94aafce9420e)({
        domain: props.domain,
        searchResultsInNewTab: props.searchResultsInNewTab
    }) : _props_onSearch, details = props.details, _props_orderTabs = props.orderTabs, orderTabs = _props_orderTabs === void 0 ? [
        "FCL",
        "LCL",
        "AIR",
        "LTL"
    ] : _props_orderTabs, _props_defaultShipmentType = props.defaultShipmentType, defaultShipmentType = _props_defaultShipmentType === void 0 ? orderTabs[0] : _props_defaultShipmentType, _props_customerType = props.customerType, customerType = _props_customerType === void 0 ? null : _props_customerType, _props_showDimensionsInLCL = props.showDimensionsInLCL, showDimensionsInLCL = _props_showDimensionsInLCL === void 0 ? true : _props_showDimensionsInLCL, _props_showMultiMode = props.showMultiMode, showMultiMode = _props_showMultiMode === void 0 ? false : _props_showMultiMode, _props_multiModeTabsPosition = props.multiModeTabsPosition, multiModeTabsPosition = _props_multiModeTabsPosition === void 0 ? (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP : _props_multiModeTabsPosition, _props_layerIndex = props.layerIndex, layerIndex = _props_layerIndex === void 0 ? 9999 : _props_layerIndex, buttonColor = props.buttonColor, buttonHoverColor = props.buttonHoverColor, _props_sendGA4Events = props.sendGA4Events, sendGA4Events = _props_sendGA4Events === void 0 ? false : _props_sendGA4Events, className = props.className, baseApiUrl = props.baseApiUrl, authCookie = props.authCookie, defaultDevice = props.defaultDevice, _props_userType = props.userType, userType = _props_userType === void 0 ? "Ghost User" : _props_userType, _props_sendMixpanelEvents = props.sendMixpanelEvents, sendMixpanelEvents = _props_sendMixpanelEvents === void 0 ? false : _props_sendMixpanelEvents, _props_showCommodity = props.showCommodity, showCommodity = _props_showCommodity === void 0 ? false : _props_showCommodity, _props_showCargoReadyDateForOcean = props.showCargoReadyDateForOcean, showCargoReadyDateForOcean = _props_showCargoReadyDateForOcean === void 0 ? false : _props_showCargoReadyDateForOcean, _props_showCargoReadyDateForLTL = props.showCargoReadyDateForLTL, showCargoReadyDateForLTL = _props_showCargoReadyDateForLTL === void 0 ? false : _props_showCargoReadyDateForLTL, _props_tabDesign = props.tabDesign, tabDesign = _props_tabDesign === void 0 ? "Default" : _props_tabDesign, _props_showIndicator = props.showIndicator, showIndicator = _props_showIndicator === void 0 ? false : _props_showIndicator, buildEnvironment = props.buildEnvironment, _props_type = props.type, type = _props_type === void 0 ? "Regular" : _props_type;
    var isVertical = props.isVertical;
    var i18n = (0, $12e046acd71f8b2f$export$920091e3d72d80ee)(language);
    var mixpanelKey = (0, $5af75863158cf8a8$export$3cbb4a0ac1f0c633)(buildEnvironment);
    (0, $70b13f55bee93496$export$52e883bf52d978b3)({
        sendMixpanelEvents: sendMixpanelEvents,
        mixpanelKey: mixpanelKey
    });
    var _useWidth = (0, $fZLIC$icontainersdesignsystemdistutils.useWidth)(), isMobile = _useWidth.isMobile, isTablet = _useWidth.isTablet, isDesktop = _useWidth.isDesktop;
    var _useState = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(defaultShipmentType), 2), shipmentType = _useState[0], setShipmentType = _useState[1];
    var _useState1 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), backdropVisible = _useState1[0], setBackdropVisible = _useState1[1];
    var _useActiveElement = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $2db117e4e97df04c$export$4e1875a4b2b1434f)(), 2), activeElement = _useActiveElement[0], setActiveElement = _useActiveElement[1];
    var _useState2 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(defaultDevice || {
        isMobile: isMobile,
        isTablet: isTablet,
        isDesktop: isDesktop
    }), 2), outerWindowSize = _useState2[0], setOuterWindowSize = _useState2[1];
    var _useState3 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), isFclCargoOpen = _useState3[0], setIsFclCargoOpen = _useState3[1];
    var _useState4 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), isLclCargoOpen = _useState4[0], setIsLclCargoOpen = _useState4[1];
    var _useState5 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), isAirCargoOpen = _useState5[0], setIsAirCargoOpen = _useState5[1];
    var _useState6 = (0, ($parcel$interopDefault($fZLIC$swchelperslib_sliced_to_arrayjs)))((0, $fZLIC$react.useState)(false), 2), isLtlCargoOpen = _useState6[0], setIsLtlCargoOpen = _useState6[1];
    var inIframe = (0, $61aeb730072a8c06$export$9f140ed41af5108c)();
    if (outerWindowSize.isTablet && inIframe) isVertical = true;
    (0, $fZLIC$react.useEffect)((0, $5af75863158cf8a8$export$29cc411fb67711bc)({
        backdropVisible: backdropVisible,
        inIframe: inIframe
    }), [
        backdropVisible
    ]);
    (0, $fZLIC$react.useEffect)((0, $5af75863158cf8a8$export$28551806f2fd0630)(inIframe), [
        isVertical,
        isMobile
    ]);
    (0, ($parcel$interopDefault($fZLIC$reacthookresizeobserver)))((0, $5af75863158cf8a8$export$68e0b4739b2cd688)(), (0, $5af75863158cf8a8$export$45b39e67d4ce4921));
    if (typeof window !== "undefined") window.addEventListener("message", (0, $5af75863158cf8a8$export$7275a8dcb77dc20d)({
        setBackdropVisible: setBackdropVisible,
        setIsAirCargoOpen: setIsAirCargoOpen,
        setIsFclCargoOpen: setIsFclCargoOpen,
        setIsLclCargoOpen: setIsLclCargoOpen,
        setIsLtlCargoOpen: setIsLtlCargoOpen,
        setOuterWindowSize: setOuterWindowSize
    }));
    (0, $fZLIC$react.useEffect)(function() {
        if (!inIframe) setOuterWindowSize({
            isMobile: isMobile,
            isTablet: isTablet,
            isDesktop: isDesktop
        });
    }, [
        isMobile,
        isTablet,
        isDesktop
    ]);
    var REACT_APP_PRODUCTION_OLIVIA_API_CLIENT = "https://olivia.icontainers.com/", REACT_APP_SANDBOX_OLIVIA_API_CLIENT = "https://olivia-cdn-sandbox.public.icontainers.com/";
    var innerRef = (0, $fZLIC$react.useRef)(null);
    var wrapperRef = ref || innerRef;
    //fallbackurl for iframe
    var fallbackUrl = buildEnvironment === "sandbox" ? REACT_APP_SANDBOX_OLIVIA_API_CLIENT : REACT_APP_PRODUCTION_OLIVIA_API_CLIENT;
    (0, ($parcel$interopDefault($fZLIC$axios))).defaults.baseURL = baseApiUrl !== null && baseApiUrl !== void 0 ? baseApiUrl : fallbackUrl;
    (0, ($parcel$interopDefault($fZLIC$axios))).defaults.headers.common = (0, $97441b62ecb6ed2c$export$11a51455c5740ca6)(authCookie);
    var tabStretch = isMobile || isVertical || type === (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance;
    var requestQuoteTabsPosition = tabStretch ? (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).TOP : multiModeTabsPosition;
    var showLeftMultiModeTabs = requestQuoteTabsPosition === (0, $4ddd004b6f6e4a18$export$d64ceb12fef850aa).LEFT;
    return /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $48a0275552d0228c$export$a0936c9989b92d74).Provider, {
        value: {
            showDimensionsInLCL: showDimensionsInLCL,
            inIframe: inIframe,
            isMobile: outerWindowSize.isMobile,
            isTablet: outerWindowSize.isTablet,
            isDesktop: outerWindowSize.isDesktop,
            sendMixpanelEvents: sendMixpanelEvents,
            showCommodity: showCommodity,
            customerType: customerType,
            showCargoReadyDateForOcean: type === "Advance" ? false : showCargoReadyDateForOcean,
            showCargoReadyDateForAir: type !== "Advance",
            showCargoReadyDateForLTL: showCargoReadyDateForLTL,
            showKnownShipper: type !== "Advance",
            type: type
        },
        children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $88150c5c731a6db0$export$1325e8699caa160f), {
            i18n: i18n,
            children: /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsxs)((0, $e5d84ead675cfa2d$export$e6dfd72ab29f8598), {
                className: className,
                ref: wrapperRef,
                $multiModeTabsPosition: requestQuoteTabsPosition,
                $inIframe: inIframe,
                $minTablet: outerWindowSize.isTablet || outerWindowSize.isDesktop || isTablet || isDesktop,
                $isVertical: isMobile || Boolean(isVertical),
                $type: type,
                children: [
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $d0ee8d8d1a964c6c$export$24fa474a76a2c519), {
                        multiModeTabsPosition: requestQuoteTabsPosition,
                        shipmentType: shipmentType,
                        setShipmentType: setShipmentType,
                        layerIndex: layerIndex,
                        backdropVisible: backdropVisible,
                        buttonColor: buttonColor,
                        buttonHoverColor: buttonHoverColor,
                        showMultiMode: showMultiMode,
                        orderTabs: orderTabs,
                        tabDesign: tabDesign,
                        showIndicator: showIndicator,
                        stretch: tabStretch
                    }),
                    /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $286bae1aa5e77428$export$d76764c0f676706), {
                        shipmentType: shipmentType,
                        isFclCargoOpen: isFclCargoOpen,
                        isLclCargoOpen: isLclCargoOpen,
                        isAirCargoOpen: isAirCargoOpen,
                        isLtlCargoOpen: isLtlCargoOpen,
                        setIsFclCargoOpen: setIsFclCargoOpen,
                        setIsLclCargoOpen: setIsLclCargoOpen,
                        setIsAirCargoOpen: setIsAirCargoOpen,
                        setIsLtlCargoOpen: setIsLtlCargoOpen,
                        setShipmentType: setShipmentType,
                        showLeftMultiModeTabs: showLeftMultiModeTabs,
                        onSearch: onSearch,
                        details: details,
                        backdropVisible: backdropVisible,
                        setBackdropVisible: setBackdropVisible,
                        isVertical: isVertical,
                        layerIndex: layerIndex,
                        searchButtonColor: buttonColor,
                        searchButtonHoverColor: buttonHoverColor,
                        sendGA4Events: sendGA4Events,
                        userType: userType,
                        onBackdropClick: (0, $5af75863158cf8a8$export$21e7b9f4635e7aa6)({
                            setBackdropVisible: setBackdropVisible,
                            setActiveElement: setActiveElement,
                            setIsAirCargoOpen: setIsAirCargoOpen,
                            setIsFclCargoOpen: setIsFclCargoOpen,
                            setIsLtlCargoOpen: setIsLtlCargoOpen,
                            setIsLclCargoOpen: setIsLclCargoOpen
                        })
                    }),
                    !isVertical && !isMobile && !inIframe && type !== (0, $639d1ffa47c33698$export$62c84cc33d8ed735).Advance && /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $88abc1f36ada2e72$export$698223c589197ab7), {
                        backdropVisible: backdropVisible,
                        setBackdropVisible: setBackdropVisible,
                        activeElement: activeElement,
                        layerIndex: layerIndex,
                        wrapperRef: wrapperRef,
                        isVertical: isVertical,
                        onBackdropClick: (0, $5af75863158cf8a8$export$21e7b9f4635e7aa6)({
                            setBackdropVisible: setBackdropVisible,
                            setActiveElement: setActiveElement,
                            setIsAirCargoOpen: setIsAirCargoOpen,
                            setIsFclCargoOpen: setIsFclCargoOpen,
                            setIsLclCargoOpen: setIsLclCargoOpen,
                            setIsLtlCargoOpen: setIsLtlCargoOpen
                        })
                    }),
                    $b9961f6ec706fd95$var$_MutationObserver || ($b9961f6ec706fd95$var$_MutationObserver = /*#__PURE__*/ (0, $fZLIC$reactjsxruntime.jsx)((0, $26f8e683f710da3a$export$d3c1860ee66f291a), {}))
                ]
            })
        })
    });
};
var $b9961f6ec706fd95$export$a829527ff4e4114a = /*#__PURE__*/ (0, $fZLIC$react.forwardRef)($b9961f6ec706fd95$export$53583fe269fa7d3);





//# sourceMappingURL=index.js.map
